export const DR_ISRAR_VIDEOS = [
  {
    "id": "israr-1",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 114 Ayat 6 Surah Nas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PHNOPt6aua4",
    "youtubeId": "PHNOPt6aua4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 114 Ayat 5 Surah Nas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IJlnbJCAi3M",
    "youtubeId": "IJlnbJCAi3M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 114 Ayat 4 Surah Nas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kVnAv5CW-YY",
    "youtubeId": "kVnAv5CW-YY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 114 Ayat 3 Surah Nas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cuUzI6sNlgk",
    "youtubeId": "cuUzI6sNlgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 114 Ayat 2 Surah Nas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dcvBJ1clHo4",
    "youtubeId": "dcvBJ1clHo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 114 Ayat 1 Surah Nas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/31ZD18wjhUY",
    "youtubeId": "31ZD18wjhUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-7",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 113 Introduction Surah Falaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WSHN9NImuew",
    "youtubeId": "WSHN9NImuew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-8",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 113 Ayat 5 Surah Falaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I4RmnmOsK04",
    "youtubeId": "I4RmnmOsK04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-9",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 113 Ayat 4 Surah Falaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/96AA-on8Iko",
    "youtubeId": "96AA-on8Iko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-10",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 113 Ayat 3 Surah Falaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RxknARxP2IY",
    "youtubeId": "RxknARxP2IY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-11",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 113 Ayat 2 Surah Falaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i1DBTdXZS20",
    "youtubeId": "i1DBTdXZS20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-12",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 113 Ayat 1 Surah Falaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lGG8hcqgiQQ",
    "youtubeId": "lGG8hcqgiQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-13",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 112 Ayat 4 Surah Ikhlas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CtUcBiDkOMY",
    "youtubeId": "CtUcBiDkOMY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-14",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 112 Ayat 3 Surah Ikhlas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AskcOIooQsM",
    "youtubeId": "AskcOIooQsM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-15",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 112 Ayat 2 Surah Ikhlas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JEfsSUrug8k",
    "youtubeId": "JEfsSUrug8k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-16",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 112 Ayat 1 Surah Ikhlas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FJgk8cDiAW4",
    "youtubeId": "FJgk8cDiAW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-17",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 111 Ayat 5 Surah Masad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zf_jJBk9RvU",
    "youtubeId": "Zf_jJBk9RvU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-18",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 111 Ayat 4 Surah Masad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/scddnmrjjW4",
    "youtubeId": "scddnmrjjW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-19",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 111 Ayat 3 Surah Masad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6Y3CkrjwrnA",
    "youtubeId": "6Y3CkrjwrnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-20",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 111 Ayat 2 Surah Masad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RaksrNNNSY4",
    "youtubeId": "RaksrNNNSY4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-21",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 111 Ayat 1 Surah Masad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DEn-G2ckMb4",
    "youtubeId": "DEn-G2ckMb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-22",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 110 Ayat 3 Surah Nasr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ta1wkdhSr6Y",
    "youtubeId": "Ta1wkdhSr6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-23",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 110 Ayat 2 Surah Nasr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M3F9ER_sItA",
    "youtubeId": "M3F9ER_sItA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-24",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 110 Ayat 1 Surah Nasr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BbenwqPKJjo",
    "youtubeId": "BbenwqPKJjo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-25",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 109 Ayat 6 Surah Kafirun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/20QBGd2Mv0E",
    "youtubeId": "20QBGd2Mv0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-26",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 109 Ayat 5 Surah Kafirun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T7nRvYGDWjc",
    "youtubeId": "T7nRvYGDWjc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-27",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 109 Ayat 4 Surah Kafirun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v4BLzpL9b9k",
    "youtubeId": "v4BLzpL9b9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-28",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 109 Ayat 3 Surah Kafirun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gqZUV7K0FGo",
    "youtubeId": "gqZUV7K0FGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-29",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 109 Ayat 2 Surah Kafirun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cCJQ6XhMIeo",
    "youtubeId": "cCJQ6XhMIeo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-30",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 109 Ayat 1 Surah Kafirun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_wxlYN-Ppfc",
    "youtubeId": "_wxlYN-Ppfc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-31",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 108 Ayat 3 Surah Kauser Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GPaTFiiMVas",
    "youtubeId": "GPaTFiiMVas",
    "date": "2026-04-14"
  },
  {
    "id": "israr-32",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 108 Ayat 2 Surah Kauser Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wiRWW71CuyQ",
    "youtubeId": "wiRWW71CuyQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-33",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 108 Ayat 1 Surah Kauser Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l_wa9yIWCI4",
    "youtubeId": "l_wa9yIWCI4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-34",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 7 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tLMOM_MhaIY",
    "youtubeId": "tLMOM_MhaIY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-35",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 6 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RIxoomFQs2c",
    "youtubeId": "RIxoomFQs2c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-36",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 5 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hiANN_odIXY",
    "youtubeId": "hiANN_odIXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-37",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 4 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SPf2Rh65AgA",
    "youtubeId": "SPf2Rh65AgA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-38",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 3 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/21b8l-mH9BM",
    "youtubeId": "21b8l-mH9BM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-39",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 2 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O1ALp9F-oLQ",
    "youtubeId": "O1ALp9F-oLQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-40",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 107 Ayat 1 Surah Maun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0uY9BLh_tJY",
    "youtubeId": "0uY9BLh_tJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-41",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 106 Ayat 4 Surah Quraysh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8GLLajzgttU",
    "youtubeId": "8GLLajzgttU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-42",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 106 Ayat 3 Surah Quraysh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mlDblmVIDuY",
    "youtubeId": "mlDblmVIDuY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-43",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 106 Ayat 2 Surah Quraysh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oNfsAMPVGEA",
    "youtubeId": "oNfsAMPVGEA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-44",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 106 Ayat 1 Surah Quraysh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ti0SJyDSwuA",
    "youtubeId": "Ti0SJyDSwuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-45",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 105 Introduction Surah Fil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TrwzrsYKoUM",
    "youtubeId": "TrwzrsYKoUM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-46",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 105 Ayat 5 Surah Fil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t4h8C7XZlBw",
    "youtubeId": "t4h8C7XZlBw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-47",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 105 Ayat 4 Surah Fil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/imKkJ1GcYrI",
    "youtubeId": "imKkJ1GcYrI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-48",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 105 Ayat 3 Surah Fil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ASmDzQ1OULU",
    "youtubeId": "ASmDzQ1OULU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-49",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 105 Ayat 2 Surah Fil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Otq8EFcWFVU",
    "youtubeId": "Otq8EFcWFVU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-50",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 105 Ayat 1 Surah Fil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Eodt1iS1Qo",
    "youtubeId": "9Eodt1iS1Qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-51",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 9 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LyfXcs_5QRY",
    "youtubeId": "LyfXcs_5QRY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-52",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 8 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_LDVtObswi0",
    "youtubeId": "_LDVtObswi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-53",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 7 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OY2Ytw0kCP4",
    "youtubeId": "OY2Ytw0kCP4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-54",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 6 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O-H82grAwdY",
    "youtubeId": "O-H82grAwdY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-55",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 5 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GIWv4LvJQ9Y",
    "youtubeId": "GIWv4LvJQ9Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-56",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 4 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LiFtuCX5PEY",
    "youtubeId": "LiFtuCX5PEY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-57",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 3 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2XtPfXjI6so",
    "youtubeId": "2XtPfXjI6so",
    "date": "2026-04-14"
  },
  {
    "id": "israr-58",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 2 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nkJKPZJtH2Y",
    "youtubeId": "nkJKPZJtH2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-59",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 104 Ayat 1 Surah Humazah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X_lthKvOf60",
    "youtubeId": "X_lthKvOf60",
    "date": "2026-04-14"
  },
  {
    "id": "israr-60",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 103 Ayat 3 Surah Asr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/01yc6ovumxs",
    "youtubeId": "01yc6ovumxs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-61",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 103 Ayat 2 Surah Asr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jbZ1RXq933E",
    "youtubeId": "jbZ1RXq933E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-62",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 103 Ayat 1 Surah Asr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0zVM-MPkrTg",
    "youtubeId": "0zVM-MPkrTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-63",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 8 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/czqnPr3wjV0",
    "youtubeId": "czqnPr3wjV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-64",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 7 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rg20VkwCMvs",
    "youtubeId": "rg20VkwCMvs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-65",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 6 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qo4Bt0-D9sU",
    "youtubeId": "Qo4Bt0-D9sU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-66",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 5 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VojTv-Hy8wM",
    "youtubeId": "VojTv-Hy8wM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-67",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 4 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SLei4MOyNXE",
    "youtubeId": "SLei4MOyNXE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-68",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 3 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yTbul0iaROI",
    "youtubeId": "yTbul0iaROI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-69",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 2 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a6Y8xKOpF0M",
    "youtubeId": "a6Y8xKOpF0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-70",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 102 Ayat 1 Surah Takathur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yiy5h8VkYAo",
    "youtubeId": "yiy5h8VkYAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-71",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 11 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8nYVAdRNJYk",
    "youtubeId": "8nYVAdRNJYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-72",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 10 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SrN9ZhiebI0",
    "youtubeId": "SrN9ZhiebI0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-73",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 9 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wBkUKdX0cwk",
    "youtubeId": "wBkUKdX0cwk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-74",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 8 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eVl-rwFurvE",
    "youtubeId": "eVl-rwFurvE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-75",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 7 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2I9FizlydVI",
    "youtubeId": "2I9FizlydVI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-76",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 6 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8WskcQcCKeA",
    "youtubeId": "8WskcQcCKeA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-77",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 5 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zQ87L09ciAo",
    "youtubeId": "zQ87L09ciAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-78",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 4 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D74Tq1YM4fo",
    "youtubeId": "D74Tq1YM4fo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-79",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 101 Ayat 1-3 Surah Qariah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_GWul4iu1Fk",
    "youtubeId": "_GWul4iu1Fk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-80",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 11 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZqJNBHE8DBU",
    "youtubeId": "ZqJNBHE8DBU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-81",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 10 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v0VmnymGBWg",
    "youtubeId": "v0VmnymGBWg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-82",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 9 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Tk8z4S9eVw",
    "youtubeId": "0Tk8z4S9eVw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-83",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 8 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K0LK2Qg50Gc",
    "youtubeId": "K0LK2Qg50Gc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-84",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 7 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OjgPieMFm-E",
    "youtubeId": "OjgPieMFm-E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-85",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 6 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dt4L4CdINc0",
    "youtubeId": "dt4L4CdINc0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-86",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 5 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u1cdewyEOCE",
    "youtubeId": "u1cdewyEOCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-87",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 4 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eN1whccAhBg",
    "youtubeId": "eN1whccAhBg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-88",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 3 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gj4ELJEM0xw",
    "youtubeId": "Gj4ELJEM0xw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-89",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 2 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PvssCtzCkzA",
    "youtubeId": "PvssCtzCkzA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-90",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 100 Ayat 1 Surah Adiyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y6AJaZvetqY",
    "youtubeId": "Y6AJaZvetqY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-91",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 8 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gIbvRdxWI-o",
    "youtubeId": "gIbvRdxWI-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-92",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 7 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/65OijcqI-ZQ",
    "youtubeId": "65OijcqI-ZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-93",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 6 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dkjUiSUk9nM",
    "youtubeId": "dkjUiSUk9nM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-94",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 5 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bpGMU8ukFbw",
    "youtubeId": "bpGMU8ukFbw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-95",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 4 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iNlxAGs4NAo",
    "youtubeId": "iNlxAGs4NAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-96",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 3 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wjOeVWjRdDk",
    "youtubeId": "wjOeVWjRdDk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-97",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 2 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/STmMKrg-mz0",
    "youtubeId": "STmMKrg-mz0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-98",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 99 Ayat 1 Surah Zalzalah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SjHML6v1Nzw",
    "youtubeId": "SjHML6v1Nzw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-99",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 8 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I-TWbuKyNWQ",
    "youtubeId": "I-TWbuKyNWQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 7 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mnu9eVdWjcI",
    "youtubeId": "mnu9eVdWjcI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 6 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c7EATC4l8f8",
    "youtubeId": "c7EATC4l8f8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 5 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KYNjTY0PXEQ",
    "youtubeId": "KYNjTY0PXEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 4 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JCzgqQ7G8q0",
    "youtubeId": "JCzgqQ7G8q0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 3 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/heQlEP6Z5iI",
    "youtubeId": "heQlEP6Z5iI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 2 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3XAITBd4MS4",
    "youtubeId": "3XAITBd4MS4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 98 Ayat 1 Surah Bayyinah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HY9aOXHwI28",
    "youtubeId": "HY9aOXHwI28",
    "date": "2026-04-14"
  },
  {
    "id": "israr-107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 97 Ayat 5 Surah Qadr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gWJEV6dhw6w",
    "youtubeId": "gWJEV6dhw6w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 97 Ayat 4 Surah Qadr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mbmA0lfwh4E",
    "youtubeId": "mbmA0lfwh4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 97 Ayat 3 Surah Qadr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9uE3khS8gFg",
    "youtubeId": "9uE3khS8gFg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 97 Ayat 2 Surah Qadr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v0_ClJ1MkXM",
    "youtubeId": "v0_ClJ1MkXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 97 Ayat 1 Surah Qadr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8W7Q5Lc7fnA",
    "youtubeId": "8W7Q5Lc7fnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Introduction Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zPcvgmN9Y3Q",
    "youtubeId": "zPcvgmN9Y3Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 19 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kXO3IqrAapU",
    "youtubeId": "kXO3IqrAapU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 18 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WmePVZVS8HA",
    "youtubeId": "WmePVZVS8HA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 17 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pmeaPD4umOk",
    "youtubeId": "pmeaPD4umOk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 16 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YHVmzwOkXhY",
    "youtubeId": "YHVmzwOkXhY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 15 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a8X9qdXuRWk",
    "youtubeId": "a8X9qdXuRWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 14 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qDKA7RL0AGQ",
    "youtubeId": "qDKA7RL0AGQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 13 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oyI5KmYW6Ig",
    "youtubeId": "oyI5KmYW6Ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 12 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w4FXWDEiFlo",
    "youtubeId": "w4FXWDEiFlo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 11 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yaal8Bij-WU",
    "youtubeId": "Yaal8Bij-WU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-122",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 10 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WEA3PWCXfPg",
    "youtubeId": "WEA3PWCXfPg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-123",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 9 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vt-Ils0UsT0",
    "youtubeId": "vt-Ils0UsT0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-124",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 8 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T3zo-INo51g",
    "youtubeId": "T3zo-INo51g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-125",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 7 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lz3pdqaGPVc",
    "youtubeId": "Lz3pdqaGPVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-126",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 6 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m3wuIdAxjYE",
    "youtubeId": "m3wuIdAxjYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-127",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 5 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UXPeyXUdYdU",
    "youtubeId": "UXPeyXUdYdU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-128",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 4 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TTQ07QjgZ_Y",
    "youtubeId": "TTQ07QjgZ_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-129",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 3 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U0-GE-WaNQ0",
    "youtubeId": "U0-GE-WaNQ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-130",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 2 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Sz9GQMKDXY",
    "youtubeId": "9Sz9GQMKDXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-131",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 96 Ayat 1 Surah Alaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TrJlsNHYr70",
    "youtubeId": "TrJlsNHYr70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-132",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Introduction Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oD_SMbEUVFs",
    "youtubeId": "oD_SMbEUVFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-133",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 8 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IbtpT_x9_fs",
    "youtubeId": "IbtpT_x9_fs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-134",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 7 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ppqa37ozmbg",
    "youtubeId": "Ppqa37ozmbg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-135",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 6 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sBhYQUXuy0g",
    "youtubeId": "sBhYQUXuy0g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-136",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 5 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/myKdv1ciXdE",
    "youtubeId": "myKdv1ciXdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-137",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 4 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pNFCzR0rWNM",
    "youtubeId": "pNFCzR0rWNM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-138",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 3 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vxpStx3Ohmc",
    "youtubeId": "vxpStx3Ohmc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-139",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 2 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NfIw5jRsUYE",
    "youtubeId": "NfIw5jRsUYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-140",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 95 Ayat 1 Surah Teen Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RbIz8ElUwJ0",
    "youtubeId": "RbIz8ElUwJ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-141",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 94 Ayat 7 & 8 Surah Inshirah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DSSY16dkUcs",
    "youtubeId": "DSSY16dkUcs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-142",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 94 Ayat 5 & 6 Surah Inshirah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jc28tbyH3UI",
    "youtubeId": "Jc28tbyH3UI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-143",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 94 Ayat 4 Surah Inshirah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vlbrvv1RvjA",
    "youtubeId": "vlbrvv1RvjA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-144",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 94 Ayat 3 Surah Inshirah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gnOC79BwS8Q",
    "youtubeId": "gnOC79BwS8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-145",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 94 Ayat 1 & 2 Surah Inshirah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mmNCpu7Tnos",
    "youtubeId": "mmNCpu7Tnos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-146",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Introduction Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ndzxNoZZwrE",
    "youtubeId": "ndzxNoZZwrE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-147",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 11 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0vrtX108ixk",
    "youtubeId": "0vrtX108ixk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-148",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 10 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vt1EpYA_M0c",
    "youtubeId": "vt1EpYA_M0c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-149",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 9 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/93RksIcgMHc",
    "youtubeId": "93RksIcgMHc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-150",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 8 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5dDS1ZIgRJs",
    "youtubeId": "5dDS1ZIgRJs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-151",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 7 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wXfz4q4KcAc",
    "youtubeId": "wXfz4q4KcAc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-152",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 6 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mFqyxaG50rw",
    "youtubeId": "mFqyxaG50rw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-153",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 5 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GZLLA1GFv30",
    "youtubeId": "GZLLA1GFv30",
    "date": "2026-04-14"
  },
  {
    "id": "israr-154",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 4 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2Nk_i6Azh5o",
    "youtubeId": "2Nk_i6Azh5o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-155",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 3 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d8SsA7MHGj4",
    "youtubeId": "d8SsA7MHGj4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-156",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 2 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ISxKYoJzLxU",
    "youtubeId": "ISxKYoJzLxU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-157",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 93 Ayat 1 Surah Dhuha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iThBL61CLW0",
    "youtubeId": "iThBL61CLW0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-158",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 21 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cla4KxKvj8Q",
    "youtubeId": "cla4KxKvj8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-159",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 20 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bLNQML0LG8o",
    "youtubeId": "bLNQML0LG8o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-160",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 19 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G5Jbu5oKr24",
    "youtubeId": "G5Jbu5oKr24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-161",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 18 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o0V0Cjf7Vm4",
    "youtubeId": "o0V0Cjf7Vm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-162",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 17 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oJjNoyJVQpI",
    "youtubeId": "oJjNoyJVQpI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-163",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 16 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZqbUooBsUDY",
    "youtubeId": "ZqbUooBsUDY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-164",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 15 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uE58Z-GP64A",
    "youtubeId": "uE58Z-GP64A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-165",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 14 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9V5d3_yT0os",
    "youtubeId": "9V5d3_yT0os",
    "date": "2026-04-14"
  },
  {
    "id": "israr-166",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 13 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rq59RYfQkEw",
    "youtubeId": "Rq59RYfQkEw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-167",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 12 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i7bmpa-ZE0o",
    "youtubeId": "i7bmpa-ZE0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-168",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 11 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s4zaZuUeIkA",
    "youtubeId": "s4zaZuUeIkA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-169",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 10 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-BZQ2gICIzU",
    "youtubeId": "-BZQ2gICIzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-170",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 9 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d9VrMerywUc",
    "youtubeId": "d9VrMerywUc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-171",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 8 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-lW088y1qZI",
    "youtubeId": "-lW088y1qZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-172",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 7 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Pn1gZd3TdMs",
    "youtubeId": "Pn1gZd3TdMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-173",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 6 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JT11xFYr5XY",
    "youtubeId": "JT11xFYr5XY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-174",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 5 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CVd_6g3yHwg",
    "youtubeId": "CVd_6g3yHwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-175",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 4 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/087FJ0UJm-Y",
    "youtubeId": "087FJ0UJm-Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-176",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 3 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NojBn1zpO6A",
    "youtubeId": "NojBn1zpO6A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-177",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 2 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fhIP2a4K2Tw",
    "youtubeId": "fhIP2a4K2Tw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-178",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 92 Ayat 1 Surah Layl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Aq8pkkO3SiY",
    "youtubeId": "Aq8pkkO3SiY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-179",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 15 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5jKXSdOjf_c",
    "youtubeId": "5jKXSdOjf_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-180",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 14 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HzQXutLZc9w",
    "youtubeId": "HzQXutLZc9w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-181",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 13 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rTKAUgTPJRU",
    "youtubeId": "rTKAUgTPJRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-182",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 12 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aJG41QySF8w",
    "youtubeId": "aJG41QySF8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-183",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 11 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W2LQJc9ayO4",
    "youtubeId": "W2LQJc9ayO4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-184",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 9 & 10 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rbg11oZUqnk",
    "youtubeId": "Rbg11oZUqnk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-185",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 8 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j1ZL6Nra2Ig",
    "youtubeId": "j1ZL6Nra2Ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-186",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 7 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-YzyITOiJUw",
    "youtubeId": "-YzyITOiJUw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-187",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 6 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ONkM0WDDI9s",
    "youtubeId": "ONkM0WDDI9s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-188",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 5 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7aCAt2HRQQM",
    "youtubeId": "7aCAt2HRQQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-189",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 4 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oUGXhk83-lk",
    "youtubeId": "oUGXhk83-lk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-190",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 3 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gGhJAFF1MM4",
    "youtubeId": "gGhJAFF1MM4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-191",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 2 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/isWg_9nC5y0",
    "youtubeId": "isWg_9nC5y0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-192",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 91 Ayat 1 Surah Shams Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Unsg2dmjQAE",
    "youtubeId": "Unsg2dmjQAE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-193",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 20 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YyXSK4XRI3Y",
    "youtubeId": "YyXSK4XRI3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-194",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 19 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3M6Zxhgcfxk",
    "youtubeId": "3M6Zxhgcfxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-195",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 18 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z1FyvRx_lN8",
    "youtubeId": "z1FyvRx_lN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-196",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 17 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fu-FcwyEwx0",
    "youtubeId": "Fu-FcwyEwx0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-197",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 16 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GWV_ciOpPQY",
    "youtubeId": "GWV_ciOpPQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-198",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 15 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QM9uauNWi0M",
    "youtubeId": "QM9uauNWi0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-199",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 14 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4iVZmRm2v4I",
    "youtubeId": "4iVZmRm2v4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-200",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 13 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T9qRLYiJMpM",
    "youtubeId": "T9qRLYiJMpM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-201",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 12 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6OM1EbPCns8",
    "youtubeId": "6OM1EbPCns8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-202",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 11 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O0imiLUmqNM",
    "youtubeId": "O0imiLUmqNM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-203",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 10 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XypRZB3ByeY",
    "youtubeId": "XypRZB3ByeY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-204",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 9 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n50LnE0vSa0",
    "youtubeId": "n50LnE0vSa0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-205",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 8 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2cgCVKDxvIA",
    "youtubeId": "2cgCVKDxvIA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-206",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 7 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yh8wwGHraC8",
    "youtubeId": "Yh8wwGHraC8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-207",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 6 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LQG2warDSL0",
    "youtubeId": "LQG2warDSL0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-208",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 5 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fRA321KEMKQ",
    "youtubeId": "fRA321KEMKQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-209",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 4 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/clyJaCJ5f4Y",
    "youtubeId": "clyJaCJ5f4Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-210",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 3 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FTTwY8onk_k",
    "youtubeId": "FTTwY8onk_k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-211",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 2 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xOGQgBSuYSE",
    "youtubeId": "xOGQgBSuYSE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-212",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 90 Ayat 1 Surah Balad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XpEJpttcpN8",
    "youtubeId": "XpEJpttcpN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-213",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 30 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bCUAmd2_cQ4",
    "youtubeId": "bCUAmd2_cQ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-214",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 29 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mhV-AL7ELjY",
    "youtubeId": "mhV-AL7ELjY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-215",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 28 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4lvagDnnDtM",
    "youtubeId": "4lvagDnnDtM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-216",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 27 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kd7GMAHhKUo",
    "youtubeId": "Kd7GMAHhKUo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-217",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 26 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ib0jCOHogiU",
    "youtubeId": "Ib0jCOHogiU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-218",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 25 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bm3f9DEBAnU",
    "youtubeId": "Bm3f9DEBAnU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-219",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 24 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r1Oh403jgG4",
    "youtubeId": "r1Oh403jgG4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-220",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 22 & 23 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tnurcGXhSPo",
    "youtubeId": "tnurcGXhSPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-221",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 21 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dG5uWBvQXo4",
    "youtubeId": "dG5uWBvQXo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-222",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 20 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0q-yW_u8D5E",
    "youtubeId": "0q-yW_u8D5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-223",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 19 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xZjdWdv8T6E",
    "youtubeId": "xZjdWdv8T6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-224",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 18 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6hO0jTEIGZ4",
    "youtubeId": "6hO0jTEIGZ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-225",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 17 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v31CCIh3DoM",
    "youtubeId": "v31CCIh3DoM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-226",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 15 & 16 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QBMDBQFi9Lc",
    "youtubeId": "QBMDBQFi9Lc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-227",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 14 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4QqENJh3OCg",
    "youtubeId": "4QqENJh3OCg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-228",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 13 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h2ccUWDFSZU",
    "youtubeId": "h2ccUWDFSZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-229",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 12 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u1GQj0Db_Ls",
    "youtubeId": "u1GQj0Db_Ls",
    "date": "2026-04-14"
  },
  {
    "id": "israr-230",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 11 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IVuoANVq1J0",
    "youtubeId": "IVuoANVq1J0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-231",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 10 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pld9INzL-XA",
    "youtubeId": "pld9INzL-XA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-232",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 9 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rXYEYptkxkU",
    "youtubeId": "rXYEYptkxkU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-233",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 8 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0UPqx5ehoQo",
    "youtubeId": "0UPqx5ehoQo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-234",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 7 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rC3EeEOQsek",
    "youtubeId": "rC3EeEOQsek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-235",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 6 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BKOrMCdF5YI",
    "youtubeId": "BKOrMCdF5YI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-236",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 5 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hRCWxtKP5cg",
    "youtubeId": "hRCWxtKP5cg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-237",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 4 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RKtPcNMMQM0",
    "youtubeId": "RKtPcNMMQM0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-238",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 3 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g5fABA9C5WM",
    "youtubeId": "g5fABA9C5WM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-239",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 2 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RNyeFMIQVT8",
    "youtubeId": "RNyeFMIQVT8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-240",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 89 Ayat 1 Surah Fajr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4XIphjMynEU",
    "youtubeId": "4XIphjMynEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-241",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 26 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UotqNfhVatA",
    "youtubeId": "UotqNfhVatA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-242",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 25 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T1Wz_tzU-Ok",
    "youtubeId": "T1Wz_tzU-Ok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-243",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 24 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BAkMy5GwhfM",
    "youtubeId": "BAkMy5GwhfM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-244",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 23 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/siCltJCC_jY",
    "youtubeId": "siCltJCC_jY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-245",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 22 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Xy3x7PvntE",
    "youtubeId": "7Xy3x7PvntE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-246",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 21 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kz_NHad-B0E",
    "youtubeId": "Kz_NHad-B0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-247",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 20 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9a0UBmXeWlA",
    "youtubeId": "9a0UBmXeWlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-248",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 19 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/75_fJsCBtdQ",
    "youtubeId": "75_fJsCBtdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-249",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 18 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7LaBbl5V8U8",
    "youtubeId": "7LaBbl5V8U8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-250",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 17 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RvEmEQKbloQ",
    "youtubeId": "RvEmEQKbloQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-251",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 16 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KEXP7olAr70",
    "youtubeId": "KEXP7olAr70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-252",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 15 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hTlzx_kL2jc",
    "youtubeId": "hTlzx_kL2jc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-253",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 14 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KE7gAtu9YWc",
    "youtubeId": "KE7gAtu9YWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-254",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 13 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A2Sya8JTt9I",
    "youtubeId": "A2Sya8JTt9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-255",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 12 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FVGwO3lb4Ng",
    "youtubeId": "FVGwO3lb4Ng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-256",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 11 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q08atm1wZpY",
    "youtubeId": "Q08atm1wZpY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-257",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 10 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B6IUsEsuB7Q",
    "youtubeId": "B6IUsEsuB7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-258",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 9 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hAlwLK_7hrg",
    "youtubeId": "hAlwLK_7hrg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-259",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 8 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ejQAv44xzmQ",
    "youtubeId": "ejQAv44xzmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-260",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 7 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rnB2iw79QbM",
    "youtubeId": "rnB2iw79QbM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-261",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 6 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XnmD6ZUVj6E",
    "youtubeId": "XnmD6ZUVj6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-262",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 5 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/taG7FDxoRLk",
    "youtubeId": "taG7FDxoRLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-263",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 4 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ySLl6Q1VWs8",
    "youtubeId": "ySLl6Q1VWs8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-264",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 3 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jJ_nt7bD0UE",
    "youtubeId": "jJ_nt7bD0UE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-265",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 2 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2S8vDA8vXSw",
    "youtubeId": "2S8vDA8vXSw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-266",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 88 Ayat 1 Surah Ghashiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SKm2TO8ZR2I",
    "youtubeId": "SKm2TO8ZR2I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-267",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 19 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9x49U_L-HIU",
    "youtubeId": "9x49U_L-HIU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-268",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 18 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rFgHHzM3eAs",
    "youtubeId": "rFgHHzM3eAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-269",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 17 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j1-jJPug2BE",
    "youtubeId": "j1-jJPug2BE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-270",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 16 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2k8RqY3M6xk",
    "youtubeId": "2k8RqY3M6xk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-271",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 15 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ah3rDXgIC88",
    "youtubeId": "ah3rDXgIC88",
    "date": "2026-04-14"
  },
  {
    "id": "israr-272",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 14 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BCmFrL0bYyU",
    "youtubeId": "BCmFrL0bYyU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-273",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 13 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OwrmOdQhISI",
    "youtubeId": "OwrmOdQhISI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-274",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 12 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xRqJ7xnM9pA",
    "youtubeId": "xRqJ7xnM9pA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-275",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 11 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t3GPMeOJXWA",
    "youtubeId": "t3GPMeOJXWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-276",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 10 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ExqiGFEATUw",
    "youtubeId": "ExqiGFEATUw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-277",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 9 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q4nY_XXWiAk",
    "youtubeId": "Q4nY_XXWiAk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-278",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 8 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PkIKoauSK64",
    "youtubeId": "PkIKoauSK64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-279",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 7 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rTMBMPcZ5kA",
    "youtubeId": "rTMBMPcZ5kA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-280",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 6 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wghzA5gCXXo",
    "youtubeId": "wghzA5gCXXo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-281",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 5 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wajB5CPUTro",
    "youtubeId": "wajB5CPUTro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-282",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 4 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mnnkk4qd76Q",
    "youtubeId": "mnnkk4qd76Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-283",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 3 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O3c2u9qZ80c",
    "youtubeId": "O3c2u9qZ80c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-284",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 2 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pj_m8p_lmaM",
    "youtubeId": "pj_m8p_lmaM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-285",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 87 Ayat 1 Surah Ala Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gwfNlgM8Spc",
    "youtubeId": "gwfNlgM8Spc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-286",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 17 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kba4-qBJ_8Q",
    "youtubeId": "kba4-qBJ_8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-287",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 15 & 16 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w8DuYbz4kaQ",
    "youtubeId": "w8DuYbz4kaQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-288",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 14 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kjer9NgHcKg",
    "youtubeId": "kjer9NgHcKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-289",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 13 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9KP9CfOE9BM",
    "youtubeId": "9KP9CfOE9BM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-290",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 12 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/csZ7IZhH6KY",
    "youtubeId": "csZ7IZhH6KY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-291",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 11 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7K7wRHsCCco",
    "youtubeId": "7K7wRHsCCco",
    "date": "2026-04-14"
  },
  {
    "id": "israr-292",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 10 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nXC8jgAKn_k",
    "youtubeId": "nXC8jgAKn_k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-293",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 9 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9BN5tXP-9sE",
    "youtubeId": "9BN5tXP-9sE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-294",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 8 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/axXvWASSkUc",
    "youtubeId": "axXvWASSkUc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-295",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 7 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7wmwtaXH8Cg",
    "youtubeId": "7wmwtaXH8Cg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-296",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 6 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O9tO7JGdEFQ",
    "youtubeId": "O9tO7JGdEFQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-297",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 5 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Acrua21u3r0",
    "youtubeId": "Acrua21u3r0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-298",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 4 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EfAWnYfGwbQ",
    "youtubeId": "EfAWnYfGwbQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-299",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 3 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WJUSk9i4Rzo",
    "youtubeId": "WJUSk9i4Rzo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-300",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 2 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fu0hIEkxLBE",
    "youtubeId": "fu0hIEkxLBE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-301",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 86 Ayat 1 Surah Tariq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fhzU-HZy4ow",
    "youtubeId": "fhzU-HZy4ow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-302",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 21 & 22 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T7dIO_4wH04",
    "youtubeId": "T7dIO_4wH04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-303",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 20 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X7StPuk3gbo",
    "youtubeId": "X7StPuk3gbo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-304",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 19 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vVk-d4Wen0w",
    "youtubeId": "vVk-d4Wen0w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-305",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 18 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nO3Zg43lRPw",
    "youtubeId": "nO3Zg43lRPw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-306",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 17 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wDxg6mLScXA",
    "youtubeId": "wDxg6mLScXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-307",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 16 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DC9LMyliqYs",
    "youtubeId": "DC9LMyliqYs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-308",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 15 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NaGjDDpmwKw",
    "youtubeId": "NaGjDDpmwKw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-309",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 14 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8nIelxwzl4k",
    "youtubeId": "8nIelxwzl4k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-310",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 13 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dou0KDvsRBM",
    "youtubeId": "dou0KDvsRBM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-311",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 12 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_CwLcEE1G0I",
    "youtubeId": "_CwLcEE1G0I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-312",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 11 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SEEbWifCFqA",
    "youtubeId": "SEEbWifCFqA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-313",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 10 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wJt-Y3e11iQ",
    "youtubeId": "wJt-Y3e11iQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-314",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 9 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0nW_n_R9230",
    "youtubeId": "0nW_n_R9230",
    "date": "2026-04-14"
  },
  {
    "id": "israr-315",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 8 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IiOKsc_WNM4",
    "youtubeId": "IiOKsc_WNM4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-316",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 7 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mq8VDssaEXk",
    "youtubeId": "Mq8VDssaEXk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-317",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 6 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XlOJMSjWCgk",
    "youtubeId": "XlOJMSjWCgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-318",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 5 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oLj3WD3N6tg",
    "youtubeId": "oLj3WD3N6tg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-319",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 4 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/irr5mNEtXjg",
    "youtubeId": "irr5mNEtXjg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-320",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 3 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r7odfWTJuVo",
    "youtubeId": "r7odfWTJuVo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-321",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 2 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OTgfejnF4Ls",
    "youtubeId": "OTgfejnF4Ls",
    "date": "2026-04-14"
  },
  {
    "id": "israr-322",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 85 Ayat 1 Surah Burooj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pXo8Pj2n7nY",
    "youtubeId": "pXo8Pj2n7nY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-323",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 25 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1jJyAMpFYow",
    "youtubeId": "1jJyAMpFYow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-324",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 24 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZAyzrPxc2bY",
    "youtubeId": "ZAyzrPxc2bY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-325",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 23 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yWu2Ic5Nv9o",
    "youtubeId": "yWu2Ic5Nv9o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-326",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 22 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E2RLBeXonhc",
    "youtubeId": "E2RLBeXonhc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-327",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 21 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0COEpLFqEcc",
    "youtubeId": "0COEpLFqEcc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-328",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 20 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xb9KgGx0T7Y",
    "youtubeId": "xb9KgGx0T7Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-329",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 19 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GKPNe3Izn2Y",
    "youtubeId": "GKPNe3Izn2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-330",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 18 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/drIn0cFxaEM",
    "youtubeId": "drIn0cFxaEM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-331",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 17 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y5_UQqsSxIo",
    "youtubeId": "Y5_UQqsSxIo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-332",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 16 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gbn_lLR1dlA",
    "youtubeId": "gbn_lLR1dlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-333",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 15 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8rBVOIVzOeI",
    "youtubeId": "8rBVOIVzOeI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-334",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 14 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D6oe5MCLtX4",
    "youtubeId": "D6oe5MCLtX4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-335",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 13 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AWAmsvVs-0Q",
    "youtubeId": "AWAmsvVs-0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-336",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 12 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3kO6iJY6SCw",
    "youtubeId": "3kO6iJY6SCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-337",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 11 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hTQLcygIwFw",
    "youtubeId": "hTQLcygIwFw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-338",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 10 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pNtj4UPbazU",
    "youtubeId": "pNtj4UPbazU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-339",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 9 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/taYs8WTH5dM",
    "youtubeId": "taYs8WTH5dM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-340",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 8 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0onl_uxj1AA",
    "youtubeId": "0onl_uxj1AA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-341",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 7 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KA2a34fFnP4",
    "youtubeId": "KA2a34fFnP4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-342",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 6 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rQB6_MuLREI",
    "youtubeId": "rQB6_MuLREI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-343",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 5 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HMqzCqXp0uc",
    "youtubeId": "HMqzCqXp0uc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-344",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 4 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iukbiiRER2A",
    "youtubeId": "iukbiiRER2A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-345",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 3 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-JhHdAfM8aA",
    "youtubeId": "-JhHdAfM8aA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-346",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 2 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zMtUu87n8ik",
    "youtubeId": "zMtUu87n8ik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-347",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 84 Ayat 1 Surah Inshiqaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NGA5XfNq820",
    "youtubeId": "NGA5XfNq820",
    "date": "2026-04-14"
  },
  {
    "id": "israr-348",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 36 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_SZOnqbFeEE",
    "youtubeId": "_SZOnqbFeEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-349",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 35 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tdcg3g5L1do",
    "youtubeId": "Tdcg3g5L1do",
    "date": "2026-04-14"
  },
  {
    "id": "israr-350",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 34 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Y7MFw1dRX0",
    "youtubeId": "_Y7MFw1dRX0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-351",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 33 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4LRUSFpBs04",
    "youtubeId": "4LRUSFpBs04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-352",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 32 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UIzG_mf9-S0",
    "youtubeId": "UIzG_mf9-S0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-353",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 31 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RAiv9PxpTOA",
    "youtubeId": "RAiv9PxpTOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-354",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 30 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CRQ-x9S9fFY",
    "youtubeId": "CRQ-x9S9fFY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-355",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 29 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lQRzE-jHRo4",
    "youtubeId": "lQRzE-jHRo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-356",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 28 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CFCMTVMCSko",
    "youtubeId": "CFCMTVMCSko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-357",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 27 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VT9EaXUWZHQ",
    "youtubeId": "VT9EaXUWZHQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-358",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 26 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cKqrdGlfJf0",
    "youtubeId": "cKqrdGlfJf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-359",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 25 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fv7-CspbdIs",
    "youtubeId": "Fv7-CspbdIs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-360",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 24 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0yJj1P4Pzvo",
    "youtubeId": "0yJj1P4Pzvo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-361",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 23 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0oGRs5iTP0E",
    "youtubeId": "0oGRs5iTP0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-362",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 22 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GdIMaHiAqi8",
    "youtubeId": "GdIMaHiAqi8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-363",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 20 & 21 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8fh2n5lbyEE",
    "youtubeId": "8fh2n5lbyEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-364",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 19 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aeYk-XNwJfw",
    "youtubeId": "aeYk-XNwJfw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-365",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 18 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wPTGwnHqcpA",
    "youtubeId": "wPTGwnHqcpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-366",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 17 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cATG2rMb9EM",
    "youtubeId": "cATG2rMb9EM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-367",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 16 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9TuYXdFyao4",
    "youtubeId": "9TuYXdFyao4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-368",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 15 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0iuAZJNK2Ak",
    "youtubeId": "0iuAZJNK2Ak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-369",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 14 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kPrnbU3Tq9g",
    "youtubeId": "kPrnbU3Tq9g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-370",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 13 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/alI-piOlLuM",
    "youtubeId": "alI-piOlLuM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-371",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 12 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/89QCejxUglM",
    "youtubeId": "89QCejxUglM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-372",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 11 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UZ4BMu0KYZY",
    "youtubeId": "UZ4BMu0KYZY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-373",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 10 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uksxgqkls4M",
    "youtubeId": "Uksxgqkls4M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-374",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 9 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cLhRuusvU8c",
    "youtubeId": "cLhRuusvU8c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-375",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 8 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KD85ROvVfas",
    "youtubeId": "KD85ROvVfas",
    "date": "2026-04-14"
  },
  {
    "id": "israr-376",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 7 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LqA8LZhSd-8",
    "youtubeId": "LqA8LZhSd-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-377",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 6 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ffjRAvKkKhQ",
    "youtubeId": "ffjRAvKkKhQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-378",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 5 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-0MMI3c3rxQ",
    "youtubeId": "-0MMI3c3rxQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-379",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 4 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LHDQ2UgrsJ0",
    "youtubeId": "LHDQ2UgrsJ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-380",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 3 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JOpo1qVxgsI",
    "youtubeId": "JOpo1qVxgsI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-381",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 2 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S-N3lqaVh5w",
    "youtubeId": "S-N3lqaVh5w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-382",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 83 Ayat 1 Surah Mutaffifin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uJK6wL6OekM",
    "youtubeId": "uJK6wL6OekM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-383",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 19 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kx0SEj3vELE",
    "youtubeId": "kx0SEj3vELE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-384",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 18 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EC2ShMOLq_4",
    "youtubeId": "EC2ShMOLq_4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-385",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 17 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aQwYdCKh5ns",
    "youtubeId": "aQwYdCKh5ns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-386",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 16 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nq1scFktxAY",
    "youtubeId": "nq1scFktxAY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-387",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 15 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VA4THZEdAZ4",
    "youtubeId": "VA4THZEdAZ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-388",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 14 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lop_JXdZN-8",
    "youtubeId": "Lop_JXdZN-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-389",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 13 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Clgd7q4rw0o",
    "youtubeId": "Clgd7q4rw0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-390",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 12 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TJ3cT9J0oyI",
    "youtubeId": "TJ3cT9J0oyI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-391",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 11 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/azIZN_VGSFE",
    "youtubeId": "azIZN_VGSFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-392",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 10 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OfHdgJg0ohQ",
    "youtubeId": "OfHdgJg0ohQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-393",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 9 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4wnFesKP0uE",
    "youtubeId": "4wnFesKP0uE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-394",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 8 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A0k1cCV7SO4",
    "youtubeId": "A0k1cCV7SO4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-395",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 7 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NrJFR-vAjFs",
    "youtubeId": "NrJFR-vAjFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-396",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 6 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z6stwQTko8A",
    "youtubeId": "z6stwQTko8A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-397",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 5 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DkszZBQNCEQ",
    "youtubeId": "DkszZBQNCEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-398",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 4 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pCM87m_LrO8",
    "youtubeId": "pCM87m_LrO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-399",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 3 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2TeWSpxEAns",
    "youtubeId": "2TeWSpxEAns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-400",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 2 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zxZkWiAGGv4",
    "youtubeId": "zxZkWiAGGv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-401",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 82 Ayat 1 Surah Infitar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mh1ETo_TVHE",
    "youtubeId": "mh1ETo_TVHE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-402",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 29 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vhKtrbsycfo",
    "youtubeId": "vhKtrbsycfo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-403",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 28 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-TapLmYsMfw",
    "youtubeId": "-TapLmYsMfw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-404",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 27 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LLNIQZZ2OJ8",
    "youtubeId": "LLNIQZZ2OJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-405",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 26 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/djrRUeU6TDs",
    "youtubeId": "djrRUeU6TDs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-406",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 25 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LRNm_rGGdiw",
    "youtubeId": "LRNm_rGGdiw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-407",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 24 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KLmqQ7_yTQ4",
    "youtubeId": "KLmqQ7_yTQ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-408",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 23 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Yuwhtj1sRY",
    "youtubeId": "3Yuwhtj1sRY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-409",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 22 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Ok1qcGcQgY",
    "youtubeId": "_Ok1qcGcQgY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-410",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 21 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q4x61GOr4gI",
    "youtubeId": "q4x61GOr4gI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-411",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 20 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DjmRLjiVtO8",
    "youtubeId": "DjmRLjiVtO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-412",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 19 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hRwh0kTMw0U",
    "youtubeId": "hRwh0kTMw0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-413",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 18 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8xXgqAPJGTg",
    "youtubeId": "8xXgqAPJGTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-414",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 17 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CJLVFpm7DNo",
    "youtubeId": "CJLVFpm7DNo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-415",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 16 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sENmiD4HGY4",
    "youtubeId": "sENmiD4HGY4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-416",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 15 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-02H6xLzH68",
    "youtubeId": "-02H6xLzH68",
    "date": "2026-04-14"
  },
  {
    "id": "israr-417",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 14 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WRXFGV5s2lM",
    "youtubeId": "WRXFGV5s2lM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-418",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 13 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MwCQOIgGzPg",
    "youtubeId": "MwCQOIgGzPg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-419",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 12 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dFMERdDjNbE",
    "youtubeId": "dFMERdDjNbE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-420",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 11 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vZMwZx0CVFc",
    "youtubeId": "vZMwZx0CVFc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-421",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 10 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a1JgCNNbM14",
    "youtubeId": "a1JgCNNbM14",
    "date": "2026-04-14"
  },
  {
    "id": "israr-422",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 9 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xkkQVy7L9Kw",
    "youtubeId": "xkkQVy7L9Kw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-423",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 8 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G8x81B9onNk",
    "youtubeId": "G8x81B9onNk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-424",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 7 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gRl9waHdvGo",
    "youtubeId": "gRl9waHdvGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-425",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 6 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BhuFgIKzWLc",
    "youtubeId": "BhuFgIKzWLc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-426",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 5 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RMpY41CzQIM",
    "youtubeId": "RMpY41CzQIM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-427",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 4 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O6k409z4J_U",
    "youtubeId": "O6k409z4J_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-428",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 3 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X6CwjEFm_RQ",
    "youtubeId": "X6CwjEFm_RQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-429",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 2 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nj8p6ckMhNw",
    "youtubeId": "nj8p6ckMhNw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-430",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 81 Ayat 1 Surah Takwir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bX-rFQ-cSrQ",
    "youtubeId": "bX-rFQ-cSrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-431",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 42 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dSVCCQfR4fM",
    "youtubeId": "dSVCCQfR4fM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-432",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 41 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Eih0kmUa_zw",
    "youtubeId": "Eih0kmUa_zw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-433",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 40 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9wivqwZUo8M",
    "youtubeId": "9wivqwZUo8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-434",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 39 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k23pBNWgFGc",
    "youtubeId": "k23pBNWgFGc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-435",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 38 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VtUdPealeU0",
    "youtubeId": "VtUdPealeU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-436",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 37 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1GyNzg_-FjY",
    "youtubeId": "1GyNzg_-FjY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-437",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 36 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ACiBC19HXm0",
    "youtubeId": "ACiBC19HXm0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-438",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 35 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hquRXAjRWtM",
    "youtubeId": "hquRXAjRWtM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-439",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 33 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3ImM3xZ64kg",
    "youtubeId": "3ImM3xZ64kg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-440",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 34 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kPOspC50uEw",
    "youtubeId": "kPOspC50uEw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-441",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 32 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zL85KlAZ9xE",
    "youtubeId": "zL85KlAZ9xE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-442",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 31 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0FetHHVdaTo",
    "youtubeId": "0FetHHVdaTo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-443",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 30 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RFP6v93_Q_M",
    "youtubeId": "RFP6v93_Q_M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-444",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 29 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gHku1soi-Fk",
    "youtubeId": "gHku1soi-Fk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-445",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 28 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G1kC1Iutes0",
    "youtubeId": "G1kC1Iutes0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-446",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 27 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZuSqryL2xuo",
    "youtubeId": "ZuSqryL2xuo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-447",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 26 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YFVfihoDfNo",
    "youtubeId": "YFVfihoDfNo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-448",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 25 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6EjiJiB1Wvk",
    "youtubeId": "6EjiJiB1Wvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-449",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 24 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/njhl7D_DUpU",
    "youtubeId": "njhl7D_DUpU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-450",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 23 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vZsluUjWp0I",
    "youtubeId": "vZsluUjWp0I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-451",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 22 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a27MOK7gd8w",
    "youtubeId": "a27MOK7gd8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-452",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 21 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AWrkdW9nt7g",
    "youtubeId": "AWrkdW9nt7g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-453",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 20 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sr47MPJrxfk",
    "youtubeId": "Sr47MPJrxfk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-454",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 19 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gI4_MVMPITQ",
    "youtubeId": "gI4_MVMPITQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-455",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 18 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kaTfbNKCig8",
    "youtubeId": "kaTfbNKCig8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-456",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 17 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w6avM6YShYQ",
    "youtubeId": "w6avM6YShYQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-457",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 16 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CUpv-twzE54",
    "youtubeId": "CUpv-twzE54",
    "date": "2026-04-14"
  },
  {
    "id": "israr-458",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 15 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yZpm9pZFLJ0",
    "youtubeId": "yZpm9pZFLJ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-459",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 14 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/op3d6C3h84g",
    "youtubeId": "op3d6C3h84g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-460",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 13 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hertdOJ4Kqo",
    "youtubeId": "hertdOJ4Kqo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-461",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 12 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yt5vETPjETA",
    "youtubeId": "Yt5vETPjETA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-462",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 11 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9YD8NjCSYeo",
    "youtubeId": "9YD8NjCSYeo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-463",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 10 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8_JqlYfFDIA",
    "youtubeId": "8_JqlYfFDIA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-464",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 9 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ot2QHzBSCCI",
    "youtubeId": "Ot2QHzBSCCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-465",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 8 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BypbSF_1M_A",
    "youtubeId": "BypbSF_1M_A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-466",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 7 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/spj0XHAVa54",
    "youtubeId": "spj0XHAVa54",
    "date": "2026-04-14"
  },
  {
    "id": "israr-467",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 6 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_iu0xEm6lj8",
    "youtubeId": "_iu0xEm6lj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-468",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 5 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hE3R3oyKQds",
    "youtubeId": "hE3R3oyKQds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-469",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 4 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OVIxfXe4k5g",
    "youtubeId": "OVIxfXe4k5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-470",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 3 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6oLEqGSmO9I",
    "youtubeId": "6oLEqGSmO9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-471",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 2 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OmJFibk2szw",
    "youtubeId": "OmJFibk2szw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-472",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 80 Ayat 1 Surah Abasa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qXHxTebJzZo",
    "youtubeId": "qXHxTebJzZo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-473",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 46 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iub4k6ms5u8",
    "youtubeId": "iub4k6ms5u8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-474",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 45 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IenFq7bzqhA",
    "youtubeId": "IenFq7bzqhA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-475",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 44 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ax8qKHOmj14",
    "youtubeId": "ax8qKHOmj14",
    "date": "2026-04-14"
  },
  {
    "id": "israr-476",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 43 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mp0I3j3WQi0",
    "youtubeId": "Mp0I3j3WQi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-477",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 42 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c-J8ykM_rzM",
    "youtubeId": "c-J8ykM_rzM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-478",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 41 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pAemI0ZEEsw",
    "youtubeId": "pAemI0ZEEsw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-479",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 40 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gdqHqAX4roI",
    "youtubeId": "gdqHqAX4roI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-480",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 39 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c6Puce6mIZM",
    "youtubeId": "c6Puce6mIZM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-481",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 38 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nzvh2IG47jI",
    "youtubeId": "Nzvh2IG47jI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-482",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 37 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2HYWl8JbRBs",
    "youtubeId": "2HYWl8JbRBs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-483",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 36 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hAHEy62XDCU",
    "youtubeId": "hAHEy62XDCU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-484",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 35 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/10nOLAs36uk",
    "youtubeId": "10nOLAs36uk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-485",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 34 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1-i3Xhgj0L0",
    "youtubeId": "1-i3Xhgj0L0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-486",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 33 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GDuyTzcQDeY",
    "youtubeId": "GDuyTzcQDeY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-487",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 32 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/inyDKIc57h8",
    "youtubeId": "inyDKIc57h8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-488",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 31 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y0-ns0npThA",
    "youtubeId": "Y0-ns0npThA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-489",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 30 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yblRJJ1mw48",
    "youtubeId": "yblRJJ1mw48",
    "date": "2026-04-14"
  },
  {
    "id": "israr-490",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 29 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G4PqLthFokE",
    "youtubeId": "G4PqLthFokE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-491",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 28 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7RXYCUu6YR8",
    "youtubeId": "7RXYCUu6YR8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-492",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 27 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vy2d2CHBwQc",
    "youtubeId": "vy2d2CHBwQc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-493",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 26 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UD9g-bhuLFo",
    "youtubeId": "UD9g-bhuLFo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-494",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 25 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UEFY8V_vdBk",
    "youtubeId": "UEFY8V_vdBk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-495",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 24 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oIcAd23H9EM",
    "youtubeId": "oIcAd23H9EM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-496",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 23 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HOUW7LO2Xow",
    "youtubeId": "HOUW7LO2Xow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-497",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 22 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hZOIsaNODLo",
    "youtubeId": "hZOIsaNODLo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-498",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 21 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qdcbc_bgR4U",
    "youtubeId": "qdcbc_bgR4U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-499",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 20 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XIKydjg39ZQ",
    "youtubeId": "XIKydjg39ZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-500",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 19 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WXJ-M-KEIbU",
    "youtubeId": "WXJ-M-KEIbU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-501",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 18 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0MdAqZ2A5CA",
    "youtubeId": "0MdAqZ2A5CA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-502",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 17 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LOkbuMAMjRA",
    "youtubeId": "LOkbuMAMjRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-503",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 16 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TFQG4ziw6Dg",
    "youtubeId": "TFQG4ziw6Dg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-504",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 15 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yKDMGeoJNfM",
    "youtubeId": "yKDMGeoJNfM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-505",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 14 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pKNakFScN64",
    "youtubeId": "pKNakFScN64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-506",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 13 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a23ojv7buMA",
    "youtubeId": "a23ojv7buMA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-507",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 12 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MHcPB0x8Y10",
    "youtubeId": "MHcPB0x8Y10",
    "date": "2026-04-14"
  },
  {
    "id": "israr-508",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 11 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xNW-TG0wwEU",
    "youtubeId": "xNW-TG0wwEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-509",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 10 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JoGwzPXbMp0",
    "youtubeId": "JoGwzPXbMp0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-510",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 9 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/25ezOssWjjU",
    "youtubeId": "25ezOssWjjU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-511",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 8 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pCaVWbO96qE",
    "youtubeId": "pCaVWbO96qE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-512",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 7 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RLH1vPKcnCc",
    "youtubeId": "RLH1vPKcnCc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-513",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 6 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oxhArSGmeDY",
    "youtubeId": "oxhArSGmeDY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-514",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 5 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rrzDuONcWPY",
    "youtubeId": "rrzDuONcWPY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-515",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 4 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rq4vgG8VWWk",
    "youtubeId": "Rq4vgG8VWWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-516",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 3 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ccC9ehLrGKA",
    "youtubeId": "ccC9ehLrGKA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-517",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 2 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VQIPhWqiFmE",
    "youtubeId": "VQIPhWqiFmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-518",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 79 Ayat 1 Surah Naziat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/evMZvRcINoE",
    "youtubeId": "evMZvRcINoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-519",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 40 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zrwSf-vCRzA",
    "youtubeId": "zrwSf-vCRzA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-520",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 39 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tNvauLHrgSA",
    "youtubeId": "tNvauLHrgSA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-521",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 38 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kn_vBK1XXU4",
    "youtubeId": "kn_vBK1XXU4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-522",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 37 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-t_a6nnWuo",
    "youtubeId": "F-t_a6nnWuo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-523",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 36 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hkl1W2LjNqI",
    "youtubeId": "hkl1W2LjNqI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-524",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 35 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zzZ_SWsia7Q",
    "youtubeId": "zzZ_SWsia7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-525",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 34 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IsoA5DAnIxY",
    "youtubeId": "IsoA5DAnIxY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-526",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 33 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Z5WJtWHUBY",
    "youtubeId": "9Z5WJtWHUBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-527",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 32 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wgbBFhnEWfI",
    "youtubeId": "wgbBFhnEWfI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-528",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 31 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jEEwky_yMIg",
    "youtubeId": "jEEwky_yMIg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-529",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 30 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kuQkGcK6Vd0",
    "youtubeId": "kuQkGcK6Vd0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-530",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 29 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vR4GzcNX4L0",
    "youtubeId": "vR4GzcNX4L0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-531",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 28 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OH4rGaGE-7U",
    "youtubeId": "OH4rGaGE-7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-532",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 27 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4HK-qdC2Zxc",
    "youtubeId": "4HK-qdC2Zxc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-533",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 26 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FnFQby3TrQ0",
    "youtubeId": "FnFQby3TrQ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-534",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 25 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JIlpC7mCam8",
    "youtubeId": "JIlpC7mCam8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-535",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 24 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/esnEzD6kiQI",
    "youtubeId": "esnEzD6kiQI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-536",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 23 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5ehTfuxoduQ",
    "youtubeId": "5ehTfuxoduQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-537",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 22 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oeMnKwKvFuI",
    "youtubeId": "oeMnKwKvFuI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-538",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 21 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hZ173FpdgLE",
    "youtubeId": "hZ173FpdgLE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-539",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 20 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wsgGSFl8YmM",
    "youtubeId": "wsgGSFl8YmM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-540",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 19 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ftuIaY22xxc",
    "youtubeId": "ftuIaY22xxc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-541",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 18 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vi1kI4Tb1Zc",
    "youtubeId": "vi1kI4Tb1Zc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-542",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 17 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/elt6C2UMEIU",
    "youtubeId": "elt6C2UMEIU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-543",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 16 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D7-Y-yDexww",
    "youtubeId": "D7-Y-yDexww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-544",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 15 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qu8JwPMlGuY",
    "youtubeId": "qu8JwPMlGuY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-545",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 14 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/syvkgr_f2GY",
    "youtubeId": "syvkgr_f2GY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-546",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 13 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dU7nPB5dX5E",
    "youtubeId": "dU7nPB5dX5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-547",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 12 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dR08Zv1_lxE",
    "youtubeId": "dR08Zv1_lxE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-548",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 11 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cBgM6r_-b8o",
    "youtubeId": "cBgM6r_-b8o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-549",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 10 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/05p_IDbK-jw",
    "youtubeId": "05p_IDbK-jw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-550",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 9 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kqIky1yMFBg",
    "youtubeId": "kqIky1yMFBg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-551",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 8 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gj2mlvhsn3c",
    "youtubeId": "gj2mlvhsn3c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-552",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 7 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MWNED1aetcQ",
    "youtubeId": "MWNED1aetcQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-553",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 6 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZvnMUknvAao",
    "youtubeId": "ZvnMUknvAao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-554",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 4 & 5 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r0QjTow6l7A",
    "youtubeId": "r0QjTow6l7A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-555",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 3 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J4pM57ORArI",
    "youtubeId": "J4pM57ORArI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-556",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 2 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VOHJTX6jPLo",
    "youtubeId": "VOHJTX6jPLo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-557",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 78 Ayat 1 Surah Naba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rz3dFP6WPXI",
    "youtubeId": "rz3dFP6WPXI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-558",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 50 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZdtsXekjvn4",
    "youtubeId": "ZdtsXekjvn4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-559",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 49 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rC9UGSMeFC4",
    "youtubeId": "rC9UGSMeFC4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-560",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 48 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QGof0V5nRj8",
    "youtubeId": "QGof0V5nRj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-561",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 47 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UPBeoeIzPq0",
    "youtubeId": "UPBeoeIzPq0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-562",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 46 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RhWT_yvU7Po",
    "youtubeId": "RhWT_yvU7Po",
    "date": "2026-04-14"
  },
  {
    "id": "israr-563",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 45 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8SZVyiAfts8",
    "youtubeId": "8SZVyiAfts8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-564",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 44 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qzFg4h-AL1U",
    "youtubeId": "qzFg4h-AL1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-565",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 43 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xak93tIuSTI",
    "youtubeId": "Xak93tIuSTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-566",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 42 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ecPlobnYxsI",
    "youtubeId": "ecPlobnYxsI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-567",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 41 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f0RvekXgAXo",
    "youtubeId": "f0RvekXgAXo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-568",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 40 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kCZj2msli2c",
    "youtubeId": "kCZj2msli2c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-569",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 39 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kZhG53acks4",
    "youtubeId": "kZhG53acks4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-570",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 38 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wz5rjRd9bD8",
    "youtubeId": "wz5rjRd9bD8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-571",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 37 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PmtYcpIPLGk",
    "youtubeId": "PmtYcpIPLGk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-572",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 36 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/05XwsdvEyKs",
    "youtubeId": "05XwsdvEyKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-573",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 35 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BnZbWDwEh8I",
    "youtubeId": "BnZbWDwEh8I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-574",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 34 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Smtp6X1Or4E",
    "youtubeId": "Smtp6X1Or4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-575",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 33 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kC9YL39gfDQ",
    "youtubeId": "kC9YL39gfDQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-576",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 32 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TeJu8g7ppl4",
    "youtubeId": "TeJu8g7ppl4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-577",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 31 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YVmn4BK-CHc",
    "youtubeId": "YVmn4BK-CHc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-578",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 30 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mDDRKWu2i1M",
    "youtubeId": "mDDRKWu2i1M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-579",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 29 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NfaAw0YR234",
    "youtubeId": "NfaAw0YR234",
    "date": "2026-04-14"
  },
  {
    "id": "israr-580",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 28 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q-Ia1YQnff0",
    "youtubeId": "q-Ia1YQnff0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-581",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 27 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ARd05BM9onM",
    "youtubeId": "ARd05BM9onM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-582",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 26 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jR8wqVUajbA",
    "youtubeId": "jR8wqVUajbA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-583",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 25 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8FiwhLiwRzY",
    "youtubeId": "8FiwhLiwRzY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-584",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 24 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/645u9zgaE3Q",
    "youtubeId": "645u9zgaE3Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-585",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 23 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9iwCVhN7P9U",
    "youtubeId": "9iwCVhN7P9U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-586",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 22 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bBGEjq4yvpo",
    "youtubeId": "bBGEjq4yvpo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-587",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 21 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GLgyVohjRX4",
    "youtubeId": "GLgyVohjRX4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-588",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 20 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mcntCkNZzAY",
    "youtubeId": "mcntCkNZzAY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-589",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 19 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vkj3DTyej0U",
    "youtubeId": "vkj3DTyej0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-590",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 18 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/on1ZiI54n64",
    "youtubeId": "on1ZiI54n64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-591",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 17 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SDxbH8FOEMU",
    "youtubeId": "SDxbH8FOEMU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-592",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 16 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lCPmNoS_qQA",
    "youtubeId": "lCPmNoS_qQA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-593",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 15 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jS6j76eML-k",
    "youtubeId": "jS6j76eML-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-594",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 14 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BEtMMAH2UWM",
    "youtubeId": "BEtMMAH2UWM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-595",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 13 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8EV9BBohtlo",
    "youtubeId": "8EV9BBohtlo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-596",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 12 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mQmBjfTjfRY",
    "youtubeId": "mQmBjfTjfRY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-597",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 11 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N0hu8Ktjg8k",
    "youtubeId": "N0hu8Ktjg8k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-598",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 10 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hS3RRX_PLxQ",
    "youtubeId": "hS3RRX_PLxQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-599",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 9 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/34bZSZfTnnE",
    "youtubeId": "34bZSZfTnnE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-600",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 8 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cf8BpiP_leA",
    "youtubeId": "cf8BpiP_leA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-601",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 7 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B1G3BAfQkuE",
    "youtubeId": "B1G3BAfQkuE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-602",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 6 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WJ5wCfaNLWo",
    "youtubeId": "WJ5wCfaNLWo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-603",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 5 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4H-eVtPNTvk",
    "youtubeId": "4H-eVtPNTvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-604",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 4 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Czxxx6e24vQ",
    "youtubeId": "Czxxx6e24vQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-605",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 3 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5CT9zpsSmAo",
    "youtubeId": "5CT9zpsSmAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-606",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 2 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SZeb_JGQsMk",
    "youtubeId": "SZeb_JGQsMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-607",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 77 Ayat 1 Surah Mursalat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ff9E1bVXGCs",
    "youtubeId": "ff9E1bVXGCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-608",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 31 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qeJAQie2nxo",
    "youtubeId": "qeJAQie2nxo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-609",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 30 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tjxaTC6QBLQ",
    "youtubeId": "tjxaTC6QBLQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-610",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 29 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KGcFdch7k48",
    "youtubeId": "KGcFdch7k48",
    "date": "2026-04-14"
  },
  {
    "id": "israr-611",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 28 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iZIi04gy5is",
    "youtubeId": "iZIi04gy5is",
    "date": "2026-04-14"
  },
  {
    "id": "israr-612",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 27 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_co1aNQk3n4",
    "youtubeId": "_co1aNQk3n4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-613",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 26 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wb_yy8sEVJU",
    "youtubeId": "Wb_yy8sEVJU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-614",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 25 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jFrgaeuJsig",
    "youtubeId": "jFrgaeuJsig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-615",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 24 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AXCz-uGPfKU",
    "youtubeId": "AXCz-uGPfKU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-616",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 23 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FR8a_FlYRe0",
    "youtubeId": "FR8a_FlYRe0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-617",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 22 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QxgUip4Uikc",
    "youtubeId": "QxgUip4Uikc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-618",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 21 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oGsdgM2Nb-U",
    "youtubeId": "oGsdgM2Nb-U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-619",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 20 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H8oXiZZl9wo",
    "youtubeId": "H8oXiZZl9wo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-620",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 19 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X4jNvQ_BiV0",
    "youtubeId": "X4jNvQ_BiV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-621",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 18 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aGLB-h7kFUQ",
    "youtubeId": "aGLB-h7kFUQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-622",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 17 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/woNYheOgsmk",
    "youtubeId": "woNYheOgsmk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-623",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 16 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FBCZo-kyHps",
    "youtubeId": "FBCZo-kyHps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-624",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 15 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mIob7_f9Sl8",
    "youtubeId": "mIob7_f9Sl8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-625",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 14 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0A7lhp1k2dQ",
    "youtubeId": "0A7lhp1k2dQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-626",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 13 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XJOm9dJfHO8",
    "youtubeId": "XJOm9dJfHO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-627",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 12 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YO9r7V6KnV8",
    "youtubeId": "YO9r7V6KnV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-628",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 11 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y00kHVFrBvo",
    "youtubeId": "Y00kHVFrBvo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-629",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 10 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z-z9XgLzIck",
    "youtubeId": "Z-z9XgLzIck",
    "date": "2026-04-14"
  },
  {
    "id": "israr-630",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 9 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dy_cm8zv2TQ",
    "youtubeId": "dy_cm8zv2TQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-631",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 8 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dHZduFhPtrc",
    "youtubeId": "dHZduFhPtrc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-632",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 7 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yq1pJMP7KPQ",
    "youtubeId": "Yq1pJMP7KPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-633",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 6 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IrO-E1HBGwc",
    "youtubeId": "IrO-E1HBGwc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-634",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 5 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CXawSQRPcaQ",
    "youtubeId": "CXawSQRPcaQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-635",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 4 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZaIFW8-A5XA",
    "youtubeId": "ZaIFW8-A5XA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-636",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 3 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UTqFGChpuos",
    "youtubeId": "UTqFGChpuos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-637",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 2 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/StKugZh_WvA",
    "youtubeId": "StKugZh_WvA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-638",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 76 Ayat 1 Surah Insan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y46c2dnbatk",
    "youtubeId": "Y46c2dnbatk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-639",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 40 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OofF3C02Stc",
    "youtubeId": "OofF3C02Stc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-640",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 39 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GrMsGZ6GTYk",
    "youtubeId": "GrMsGZ6GTYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-641",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 38 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HkyfB55yTZo",
    "youtubeId": "HkyfB55yTZo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-642",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 37 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SkA7X1-N__I",
    "youtubeId": "SkA7X1-N__I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-643",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 36 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EJRrNfGlgcU",
    "youtubeId": "EJRrNfGlgcU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-644",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 34 & 35 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CRn2v6JqLV8",
    "youtubeId": "CRn2v6JqLV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-645",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 33 Surah Qiyamah Dr Israr Ahmed Urdu 2",
    "type": "video",
    "url": "https://www.youtube.com/embed/8WXdtzYt0u0",
    "youtubeId": "8WXdtzYt0u0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-646",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 32 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x6OUj9dfkak",
    "youtubeId": "x6OUj9dfkak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-647",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 31 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UfJ1Beh6KZg",
    "youtubeId": "UfJ1Beh6KZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-648",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 30 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0U7pLlVynlE",
    "youtubeId": "0U7pLlVynlE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-649",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 29 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aa3CjBCkXLk",
    "youtubeId": "aa3CjBCkXLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-650",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 28 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i-8C26Ai_WM",
    "youtubeId": "i-8C26Ai_WM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-651",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 27 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I1zRDqpWpl8",
    "youtubeId": "I1zRDqpWpl8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-652",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 26 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uYMqDx8zGsk",
    "youtubeId": "uYMqDx8zGsk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-653",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 25 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V29_SDmKxoU",
    "youtubeId": "V29_SDmKxoU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-654",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 24 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g3CFq9iWaYE",
    "youtubeId": "g3CFq9iWaYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-655",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 23 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i19E_MSHaNg",
    "youtubeId": "i19E_MSHaNg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-656",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 22 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KuQ2hqaCe78",
    "youtubeId": "KuQ2hqaCe78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-657",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 21 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vp6vLbv0p4c",
    "youtubeId": "vp6vLbv0p4c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-658",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 20 Surah Qiyama Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g8LJC0PQ5-s",
    "youtubeId": "g8LJC0PQ5-s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-659",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 19 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qmy5HiWAOjw",
    "youtubeId": "qmy5HiWAOjw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-660",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 18 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cAAenc5Pi7M",
    "youtubeId": "cAAenc5Pi7M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-661",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 17 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2dmd0sBoJpM",
    "youtubeId": "2dmd0sBoJpM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-662",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 16 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xsiFwMqGxqE",
    "youtubeId": "xsiFwMqGxqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-663",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 15 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A8LcGrPDlgY",
    "youtubeId": "A8LcGrPDlgY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-664",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 14 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vX1mWLCnLJI",
    "youtubeId": "vX1mWLCnLJI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-665",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 13 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3G8ybbREFnI",
    "youtubeId": "3G8ybbREFnI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-666",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 12 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AF25uExvT-0",
    "youtubeId": "AF25uExvT-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-667",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 11 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1t7H1EB3UAs",
    "youtubeId": "1t7H1EB3UAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-668",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 10 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8qRGM8yZmD8",
    "youtubeId": "8qRGM8yZmD8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-669",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 9 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jwVZ5bXM8V0",
    "youtubeId": "jwVZ5bXM8V0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-670",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 8 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m5y-Y5ad_M0",
    "youtubeId": "m5y-Y5ad_M0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-671",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 7 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5AqkjcTodj4",
    "youtubeId": "5AqkjcTodj4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-672",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 6 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rYKaA0es3JQ",
    "youtubeId": "rYKaA0es3JQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-673",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 5 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YraltNHlDBk",
    "youtubeId": "YraltNHlDBk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-674",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 4 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2oxsbzXoKmo",
    "youtubeId": "2oxsbzXoKmo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-675",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 3 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gPu-IrvdD5Y",
    "youtubeId": "gPu-IrvdD5Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-676",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 2 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fwR5M5hdhqY",
    "youtubeId": "fwR5M5hdhqY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-677",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 75 Ayat 1 Surah Qiyamah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fk1h6r1g_Xk",
    "youtubeId": "Fk1h6r1g_Xk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-678",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 56 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JDU6oknUWfE",
    "youtubeId": "JDU6oknUWfE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-679",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 55 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f_cc-vAnz2o",
    "youtubeId": "f_cc-vAnz2o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-680",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 54 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v_LFONv5s8w",
    "youtubeId": "v_LFONv5s8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-681",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 53 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cGZLaNARzmQ",
    "youtubeId": "cGZLaNARzmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-682",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 52 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pAG28NSy-OQ",
    "youtubeId": "pAG28NSy-OQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-683",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 51 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mcu7BmDywmk",
    "youtubeId": "Mcu7BmDywmk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-684",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 50 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MK18KNgLW2g",
    "youtubeId": "MK18KNgLW2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-685",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 49 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wY5mVVy2yys",
    "youtubeId": "wY5mVVy2yys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-686",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 48 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j3mId43RC3I",
    "youtubeId": "j3mId43RC3I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-687",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 47 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vHE3Xdx8QaI",
    "youtubeId": "vHE3Xdx8QaI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-688",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 46 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vL8TKAYOoa8",
    "youtubeId": "vL8TKAYOoa8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-689",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 45 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uyP-YtXHyFU",
    "youtubeId": "uyP-YtXHyFU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-690",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 44 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zadfNiM56Pk",
    "youtubeId": "zadfNiM56Pk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-691",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 43 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XiIcFFKZbuY",
    "youtubeId": "XiIcFFKZbuY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-692",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 42 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A7O-DDp4jlk",
    "youtubeId": "A7O-DDp4jlk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-693",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 41 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gIWaGMoIsQk",
    "youtubeId": "gIWaGMoIsQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-694",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 40 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fz_9uZLOP70",
    "youtubeId": "Fz_9uZLOP70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-695",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 39 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/INsXR2OESyo",
    "youtubeId": "INsXR2OESyo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-696",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 38 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zoenJaxQKEc",
    "youtubeId": "zoenJaxQKEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-697",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 37 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XvHlnpO4xhg",
    "youtubeId": "XvHlnpO4xhg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-698",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 36 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XOTPzA9XDg0",
    "youtubeId": "XOTPzA9XDg0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-699",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 35 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OjJzs8ezDvE",
    "youtubeId": "OjJzs8ezDvE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-700",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 32 - 34 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vMk5n6ai4TA",
    "youtubeId": "vMk5n6ai4TA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-701",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 31 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FgsmZ5ugjXY",
    "youtubeId": "FgsmZ5ugjXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-702",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 30 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GUvlGLDOcZk",
    "youtubeId": "GUvlGLDOcZk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-703",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 29 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GFqKtFot-Tc",
    "youtubeId": "GFqKtFot-Tc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-704",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 28 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rQYi7xxb1ks",
    "youtubeId": "rQYi7xxb1ks",
    "date": "2026-04-14"
  },
  {
    "id": "israr-705",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 27 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b7g3d1VCxaA",
    "youtubeId": "b7g3d1VCxaA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-706",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 26 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lNBtahkgJ1k",
    "youtubeId": "lNBtahkgJ1k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-707",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 25 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0GycWg2no1k",
    "youtubeId": "0GycWg2no1k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-708",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 24 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/occR1dO9y_c",
    "youtubeId": "occR1dO9y_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-709",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 23 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kyD5_PKQW_o",
    "youtubeId": "kyD5_PKQW_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-710",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 22 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3ebMi3YYzcY",
    "youtubeId": "3ebMi3YYzcY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-711",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 21 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/07cvtpxbFZA",
    "youtubeId": "07cvtpxbFZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-712",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 20 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NId0fJm6Vuw",
    "youtubeId": "NId0fJm6Vuw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-713",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 19 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wDN5gaUatZw",
    "youtubeId": "wDN5gaUatZw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-714",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 18 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rb4xJG2VFmA",
    "youtubeId": "rb4xJG2VFmA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-715",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 17 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PTgplNot30k",
    "youtubeId": "PTgplNot30k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-716",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 16 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b4bg33ixtRA",
    "youtubeId": "b4bg33ixtRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-717",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 15 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Q99IcJf_24",
    "youtubeId": "5Q99IcJf_24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-718",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 14 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/70HDObghNWA",
    "youtubeId": "70HDObghNWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-719",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 13 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zrshQ6zeSSk",
    "youtubeId": "zrshQ6zeSSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-720",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 12 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LJOsgUSF7pk",
    "youtubeId": "LJOsgUSF7pk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-721",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 11 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZzPH4sNEMbg",
    "youtubeId": "ZzPH4sNEMbg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-722",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 10 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q2sY-qySKUU",
    "youtubeId": "q2sY-qySKUU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-723",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 9 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3B_y42RaAw8",
    "youtubeId": "3B_y42RaAw8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-724",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 8 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DR7Bs70Vklc",
    "youtubeId": "DR7Bs70Vklc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-725",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 7 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yGiYlGNguns",
    "youtubeId": "yGiYlGNguns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-726",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 6 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/meyEkpn3cGQ",
    "youtubeId": "meyEkpn3cGQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-727",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 5 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EbrPUQQW9nM",
    "youtubeId": "EbrPUQQW9nM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-728",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 4 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cQiBuog0MfM",
    "youtubeId": "cQiBuog0MfM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-729",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 3 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AySyGej0rQA",
    "youtubeId": "AySyGej0rQA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-730",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 2 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W2KnAK7JuTc",
    "youtubeId": "W2KnAK7JuTc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-731",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 74 Ayat 1 Surah Muddassir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/El86Mlg6KIs",
    "youtubeId": "El86Mlg6KIs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-732",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 20 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K7E4rAL5x_U",
    "youtubeId": "K7E4rAL5x_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-733",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 19 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QRN6MJpVXu0",
    "youtubeId": "QRN6MJpVXu0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-734",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 18 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JoYR8o4kIBs",
    "youtubeId": "JoYR8o4kIBs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-735",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 17 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/21WAQsC2Jr8",
    "youtubeId": "21WAQsC2Jr8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-736",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 16 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ou9SPbgT8iU",
    "youtubeId": "ou9SPbgT8iU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-737",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 15 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yfC3mwI_zrQ",
    "youtubeId": "yfC3mwI_zrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-738",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 14 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ppR-yzD1hkE",
    "youtubeId": "ppR-yzD1hkE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-739",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 13 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BOA_a9Lqfeg",
    "youtubeId": "BOA_a9Lqfeg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-740",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 12 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kf7K2SKG4ZQ",
    "youtubeId": "kf7K2SKG4ZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-741",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 11 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6vuoDax7DLw",
    "youtubeId": "6vuoDax7DLw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-742",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 10 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yX4UQa_27PM",
    "youtubeId": "yX4UQa_27PM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-743",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 9 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zolrf_4wGhM",
    "youtubeId": "zolrf_4wGhM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-744",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 8 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nT_c4hbU47c",
    "youtubeId": "nT_c4hbU47c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-745",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 7 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GxLP-5iG3ok",
    "youtubeId": "GxLP-5iG3ok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-746",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 6 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JVLsAlT5F4o",
    "youtubeId": "JVLsAlT5F4o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-747",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 5 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IxE3uZ0puUU",
    "youtubeId": "IxE3uZ0puUU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-748",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 4 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9zk5RaGTT0o",
    "youtubeId": "9zk5RaGTT0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-749",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 3 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cjc8DWFxtuc",
    "youtubeId": "Cjc8DWFxtuc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-750",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 2 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WfSTgzggahA",
    "youtubeId": "WfSTgzggahA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-751",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 73 Ayat 1 Surah Muzzammil Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sPG6bNbJCTw",
    "youtubeId": "sPG6bNbJCTw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-752",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 28 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BkupHOLCt84",
    "youtubeId": "BkupHOLCt84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-753",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 27 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N-A77Zo3iYc",
    "youtubeId": "N-A77Zo3iYc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-754",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 26 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P9IgLeX13wA",
    "youtubeId": "P9IgLeX13wA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-755",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 25 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WpN8x2wR4rA",
    "youtubeId": "WpN8x2wR4rA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-756",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 24 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sNjpPsVYPHA",
    "youtubeId": "sNjpPsVYPHA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-757",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 23 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QCfZ0fi21f8",
    "youtubeId": "QCfZ0fi21f8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-758",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 22 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rfN5oMrLpGQ",
    "youtubeId": "rfN5oMrLpGQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-759",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 21 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xFBzMT8o_MQ",
    "youtubeId": "xFBzMT8o_MQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-760",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 20 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X5o96MGtJTM",
    "youtubeId": "X5o96MGtJTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-761",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 19 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MM_d43FKux8",
    "youtubeId": "MM_d43FKux8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-762",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 18 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jtIkR0Ky5vc",
    "youtubeId": "jtIkR0Ky5vc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-763",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 17 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sAuWciTERQ0",
    "youtubeId": "sAuWciTERQ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-764",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 16 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hn30p1C0UGE",
    "youtubeId": "hn30p1C0UGE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-765",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 15 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aKiyGJcz9Dc",
    "youtubeId": "aKiyGJcz9Dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-766",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 14 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q5HqY9_eTVo",
    "youtubeId": "Q5HqY9_eTVo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-767",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 13 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wrQt2uMw6Tk",
    "youtubeId": "wrQt2uMw6Tk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-768",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 12 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Eo1MXsOMAug",
    "youtubeId": "Eo1MXsOMAug",
    "date": "2026-04-14"
  },
  {
    "id": "israr-769",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 11 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0NQphw4Hj0U",
    "youtubeId": "0NQphw4Hj0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-770",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 10 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1o8oMBbl1_w",
    "youtubeId": "1o8oMBbl1_w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-771",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 9 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dvj2VZM8GOI",
    "youtubeId": "Dvj2VZM8GOI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-772",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 8 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NW4pE4Ef4SY",
    "youtubeId": "NW4pE4Ef4SY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-773",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 7 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZDR9WJTHGco",
    "youtubeId": "ZDR9WJTHGco",
    "date": "2026-04-14"
  },
  {
    "id": "israr-774",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 6 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6UdTYwdlEew",
    "youtubeId": "6UdTYwdlEew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-775",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 5 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NvPsZydUBFQ",
    "youtubeId": "NvPsZydUBFQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-776",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 4 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LYq2vmNQaYU",
    "youtubeId": "LYq2vmNQaYU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-777",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 3 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x8Rsryyq-RY",
    "youtubeId": "x8Rsryyq-RY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-778",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 2 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JFezFnka67c",
    "youtubeId": "JFezFnka67c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-779",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 72 Ayat 1 Surah Jinn Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oqJybFv8irs",
    "youtubeId": "oqJybFv8irs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-780",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 28 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H16i-vUusXw",
    "youtubeId": "H16i-vUusXw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-781",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 27 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IqybXHm4i5c",
    "youtubeId": "IqybXHm4i5c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-782",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 26 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nxg6TvY9NNc",
    "youtubeId": "Nxg6TvY9NNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-783",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 25 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IDaFPmwDaJY",
    "youtubeId": "IDaFPmwDaJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-784",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 24 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yG7-rneWA2U",
    "youtubeId": "yG7-rneWA2U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-785",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 23 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7-2Wpxe22o0",
    "youtubeId": "7-2Wpxe22o0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-786",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 22 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MLOOj-7Kmu0",
    "youtubeId": "MLOOj-7Kmu0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-787",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 21 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l-_scTcQLH0",
    "youtubeId": "l-_scTcQLH0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-788",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 20 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bynwL73A7iA",
    "youtubeId": "bynwL73A7iA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-789",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 19 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OoA4-d0WxHU",
    "youtubeId": "OoA4-d0WxHU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-790",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 18 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IqtbXAmJAP8",
    "youtubeId": "IqtbXAmJAP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-791",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 17 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WNiZTH2yrnI",
    "youtubeId": "WNiZTH2yrnI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-792",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 16 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4NVkSMWDXwA",
    "youtubeId": "4NVkSMWDXwA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-793",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 15 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aqDFJDDZIcw",
    "youtubeId": "aqDFJDDZIcw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-794",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 14 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dTbjNQSEmcY",
    "youtubeId": "dTbjNQSEmcY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-795",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 13 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KkWhApKgAS8",
    "youtubeId": "KkWhApKgAS8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-796",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 12 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B9NWNyj5LQY",
    "youtubeId": "B9NWNyj5LQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-797",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 11 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XgH-SViZUVg",
    "youtubeId": "XgH-SViZUVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-798",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 10 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bWJ-dBqruD4",
    "youtubeId": "bWJ-dBqruD4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-799",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 9 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QK3MalYfbpg",
    "youtubeId": "QK3MalYfbpg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-800",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 8 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0FiXAEMQCCs",
    "youtubeId": "0FiXAEMQCCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-801",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 7 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W8bN7ielqX0",
    "youtubeId": "W8bN7ielqX0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-802",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 6 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DcuYpT-lA48",
    "youtubeId": "DcuYpT-lA48",
    "date": "2026-04-14"
  },
  {
    "id": "israr-803",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 5 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KUUz4ebwteU",
    "youtubeId": "KUUz4ebwteU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-804",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 4 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sOfI5fDpILU",
    "youtubeId": "sOfI5fDpILU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-805",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 3 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wZ7S9x60sVw",
    "youtubeId": "wZ7S9x60sVw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-806",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 2 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MD_J_nTwU2s",
    "youtubeId": "MD_J_nTwU2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-807",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 71 Ayat 1 Surah Nooh Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yDuE8sEdP-8",
    "youtubeId": "yDuE8sEdP-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-808",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 44 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WkNMuQAQgp4",
    "youtubeId": "WkNMuQAQgp4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-809",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 43 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8FSP_CvH1t8",
    "youtubeId": "8FSP_CvH1t8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-810",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 42 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yG1k9aNZaVc",
    "youtubeId": "yG1k9aNZaVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-811",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 41 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_kv98LufesM",
    "youtubeId": "_kv98LufesM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-812",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 40 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e4JvjWaDwk0",
    "youtubeId": "e4JvjWaDwk0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-813",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 39 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2lWx2NekY5E",
    "youtubeId": "2lWx2NekY5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-814",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 38 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MAf3c07AH-E",
    "youtubeId": "MAf3c07AH-E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-815",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 37 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lV0M7lGZgbk",
    "youtubeId": "lV0M7lGZgbk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-816",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 36 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bQA5XHkh6Gc",
    "youtubeId": "bQA5XHkh6Gc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-817",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 35 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AK1W5DfYG6o",
    "youtubeId": "AK1W5DfYG6o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-818",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 34 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Vcsxjz1RRI",
    "youtubeId": "0Vcsxjz1RRI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-819",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 33 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gBqtCmrT6fQ",
    "youtubeId": "gBqtCmrT6fQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-820",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 29-32 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/blCCJpAq2vE",
    "youtubeId": "blCCJpAq2vE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-821",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 28 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EimjmD4DDKs",
    "youtubeId": "EimjmD4DDKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-822",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 27 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OO5-2LjbONQ",
    "youtubeId": "OO5-2LjbONQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-823",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 26 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bg3YotZuf-U",
    "youtubeId": "Bg3YotZuf-U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-824",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 24 & 25 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CGKxbn4qhYs",
    "youtubeId": "CGKxbn4qhYs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-825",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 23 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMYYErk-T2o",
    "youtubeId": "cMYYErk-T2o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-826",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 22 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dv0vxW7KbnI",
    "youtubeId": "Dv0vxW7KbnI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-827",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 21 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TbOYZneewlA",
    "youtubeId": "TbOYZneewlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-828",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 20 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ntIbK-Ka0Gg",
    "youtubeId": "ntIbK-Ka0Gg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-829",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 19 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0_x3zR2_6R8",
    "youtubeId": "0_x3zR2_6R8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-830",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 18 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PxNK7uFJGxM",
    "youtubeId": "PxNK7uFJGxM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-831",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 17 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wn0BUnbsBxg",
    "youtubeId": "wn0BUnbsBxg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-832",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 16 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VgWzayGZKYk",
    "youtubeId": "VgWzayGZKYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-833",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 15 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DQJOoian86I",
    "youtubeId": "DQJOoian86I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-834",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 11-14 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sHMFhYBmGUE",
    "youtubeId": "sHMFhYBmGUE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-835",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 10 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q5V8ke2aARM",
    "youtubeId": "Q5V8ke2aARM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-836",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 9 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MZNBTpoJ0Cw",
    "youtubeId": "MZNBTpoJ0Cw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-837",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 8 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2bCXNQxAff8",
    "youtubeId": "2bCXNQxAff8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-838",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 6 & 7 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y6dLsOkT-ns",
    "youtubeId": "y6dLsOkT-ns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-839",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 5 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lCNTPEk6XR4",
    "youtubeId": "lCNTPEk6XR4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-840",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 4 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dj3yOiJ3-NE",
    "youtubeId": "dj3yOiJ3-NE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-841",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 3 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FQRE4b6nT04",
    "youtubeId": "FQRE4b6nT04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-842",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 2 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tY9daFCRT4E",
    "youtubeId": "tY9daFCRT4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-843",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 70 Ayat 1 Surah Maarij Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0tFmxuDjvfo",
    "youtubeId": "0tFmxuDjvfo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-844",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 52 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bXP90dAdHr4",
    "youtubeId": "bXP90dAdHr4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-845",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 51 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IQyALguhpSw",
    "youtubeId": "IQyALguhpSw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-846",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 50 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ASfnxEdV6JI",
    "youtubeId": "ASfnxEdV6JI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-847",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 49 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cOu9jmU_NJ0",
    "youtubeId": "cOu9jmU_NJ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-848",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 48 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5ko1gE0bRoU",
    "youtubeId": "5ko1gE0bRoU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-849",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 47 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ylohwft8B3Q",
    "youtubeId": "ylohwft8B3Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-850",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 46 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sUa5cE7KNHA",
    "youtubeId": "sUa5cE7KNHA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-851",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 45 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4zmBZie1F-c",
    "youtubeId": "4zmBZie1F-c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-852",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 44 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d6PNG1VSbxs",
    "youtubeId": "d6PNG1VSbxs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-853",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 43 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fh7yuIJhvLs",
    "youtubeId": "Fh7yuIJhvLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-854",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 42 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q8kY9HJl-So",
    "youtubeId": "q8kY9HJl-So",
    "date": "2026-04-14"
  },
  {
    "id": "israr-855",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 41 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iPkAmpXUZ0w",
    "youtubeId": "iPkAmpXUZ0w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-856",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 40 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_om2kIAVKuk",
    "youtubeId": "_om2kIAVKuk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-857",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 39 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gDWkaERTp18",
    "youtubeId": "gDWkaERTp18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-858",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 38 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4iSih4tFPOo",
    "youtubeId": "4iSih4tFPOo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-859",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 37 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PB665g_GCZE",
    "youtubeId": "PB665g_GCZE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-860",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 36 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xi01qXQMkvw",
    "youtubeId": "xi01qXQMkvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-861",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 35 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N_Fmx20RzJw",
    "youtubeId": "N_Fmx20RzJw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-862",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 34 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-dvV_Z2RB54",
    "youtubeId": "-dvV_Z2RB54",
    "date": "2026-04-14"
  },
  {
    "id": "israr-863",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 33 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KeTkKfbymEk",
    "youtubeId": "KeTkKfbymEk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-864",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 32 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5sHOSbDI2aw",
    "youtubeId": "5sHOSbDI2aw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-865",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 31 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tkltwaBFT8I",
    "youtubeId": "tkltwaBFT8I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-866",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 30 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/440mrfH6u5s",
    "youtubeId": "440mrfH6u5s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-867",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 29 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JVRXaEfAvyQ",
    "youtubeId": "JVRXaEfAvyQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-868",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 28 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/spuIkLynGKo",
    "youtubeId": "spuIkLynGKo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-869",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 27 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RfUnSsFGAq0",
    "youtubeId": "RfUnSsFGAq0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-870",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 26 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FOFqDDz1pNM",
    "youtubeId": "FOFqDDz1pNM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-871",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 25 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_4PFAbGoFZo",
    "youtubeId": "_4PFAbGoFZo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-872",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 24 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SNz86xQPGnA",
    "youtubeId": "SNz86xQPGnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-873",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 23 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5XF8mK_M3fw",
    "youtubeId": "5XF8mK_M3fw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-874",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 22 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aH9xAYtkN1k",
    "youtubeId": "aH9xAYtkN1k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-875",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 21 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lBJZfVy7gUY",
    "youtubeId": "lBJZfVy7gUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-876",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 20 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VS0GlEG3qC4",
    "youtubeId": "VS0GlEG3qC4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-877",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 19 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6HCRtZ0V_rU",
    "youtubeId": "6HCRtZ0V_rU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-878",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 18 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MOHDIcQfLKs",
    "youtubeId": "MOHDIcQfLKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-879",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 17 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jm-K7AJgiEw",
    "youtubeId": "jm-K7AJgiEw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-880",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 16 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H5hzfxbmGXo",
    "youtubeId": "H5hzfxbmGXo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-881",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 15 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/okwsM8tfsyg",
    "youtubeId": "okwsM8tfsyg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-882",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 14 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3oeapJr9dow",
    "youtubeId": "3oeapJr9dow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-883",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 13 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sr1WrniBrPQ",
    "youtubeId": "sr1WrniBrPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-884",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 12 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jv5HEp0v6OQ",
    "youtubeId": "jv5HEp0v6OQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-885",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 11 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Djd12Aiwskw",
    "youtubeId": "Djd12Aiwskw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-886",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 10 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2jzRP2hdR94",
    "youtubeId": "2jzRP2hdR94",
    "date": "2026-04-14"
  },
  {
    "id": "israr-887",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 9 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QN1pTielyzQ",
    "youtubeId": "QN1pTielyzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-888",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 8 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IpMAC-lc2fQ",
    "youtubeId": "IpMAC-lc2fQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-889",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 7 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pAaQ6NNJBXg",
    "youtubeId": "pAaQ6NNJBXg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-890",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 6 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WPYe01QtX1k",
    "youtubeId": "WPYe01QtX1k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-891",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 5 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LCfiv1jEYV4",
    "youtubeId": "LCfiv1jEYV4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-892",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 4 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RbJNkJhqRJQ",
    "youtubeId": "RbJNkJhqRJQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-893",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 3 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mvEevUYYr2U",
    "youtubeId": "mvEevUYYr2U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-894",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 2 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GdAS_N2Y6qs",
    "youtubeId": "GdAS_N2Y6qs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-895",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 69 Ayat 1 Surah Haqqah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pYO4fLcHfh0",
    "youtubeId": "pYO4fLcHfh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-896",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 4 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FDvLXU-wDqY",
    "youtubeId": "FDvLXU-wDqY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-897",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 52 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Wdhr2LMosY",
    "youtubeId": "9Wdhr2LMosY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-898",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 51 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B5oVbX30QHg",
    "youtubeId": "B5oVbX30QHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-899",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 50 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O1M6FVVT0bI",
    "youtubeId": "O1M6FVVT0bI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-900",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 49 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YCpsIdmSvgw",
    "youtubeId": "YCpsIdmSvgw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-901",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 48 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hzIIrKMCGZI",
    "youtubeId": "hzIIrKMCGZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-902",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 47 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cfDtvda0_mc",
    "youtubeId": "cfDtvda0_mc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-903",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 46 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZOZ28su6FSQ",
    "youtubeId": "ZOZ28su6FSQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-904",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 45 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wUDzTSGtrVY",
    "youtubeId": "wUDzTSGtrVY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-905",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 44 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bS_J2LzwkcI",
    "youtubeId": "bS_J2LzwkcI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-906",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 43 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6NwxhXrFFqs",
    "youtubeId": "6NwxhXrFFqs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-907",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 42 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GZiTTQf_QPQ",
    "youtubeId": "GZiTTQf_QPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-908",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 41 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Chv8_I9tgMI",
    "youtubeId": "Chv8_I9tgMI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-909",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 40 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C5HFvWB2O0c",
    "youtubeId": "C5HFvWB2O0c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-910",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 39 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ey4S4Ni-IM4",
    "youtubeId": "Ey4S4Ni-IM4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-911",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 38 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SSnHDlqbBbA",
    "youtubeId": "SSnHDlqbBbA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-912",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 37 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OQOebDWV9XU",
    "youtubeId": "OQOebDWV9XU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-913",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 36 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nRxBaix3sBs",
    "youtubeId": "nRxBaix3sBs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-914",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 35 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WZF1yep1r5o",
    "youtubeId": "WZF1yep1r5o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-915",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 34 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xpQF_NMJIBE",
    "youtubeId": "xpQF_NMJIBE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-916",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 33 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bTqmhliYcdI",
    "youtubeId": "bTqmhliYcdI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-917",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 32 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4kYBdspQGeY",
    "youtubeId": "4kYBdspQGeY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-918",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 31 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7sx3EkiVbWA",
    "youtubeId": "7sx3EkiVbWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-919",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 30 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UOQAMLhwNJc",
    "youtubeId": "UOQAMLhwNJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-920",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 29 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mk_18Q-9C6o",
    "youtubeId": "mk_18Q-9C6o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-921",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 28 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GKbltMl2X8A",
    "youtubeId": "GKbltMl2X8A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-922",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 27 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k7wKWjLFui8",
    "youtubeId": "k7wKWjLFui8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-923",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 26 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9fAr5afNGAo",
    "youtubeId": "9fAr5afNGAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-924",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 25 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BHEmjLO_iqI",
    "youtubeId": "BHEmjLO_iqI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-925",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 24 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0yodll04Vxo",
    "youtubeId": "0yodll04Vxo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-926",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 23 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ht-onhAW9dE",
    "youtubeId": "Ht-onhAW9dE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-927",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 22 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qz03WbCQle8",
    "youtubeId": "qz03WbCQle8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-928",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 21 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/43nDHjES_x4",
    "youtubeId": "43nDHjES_x4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-929",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 20 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rQHX4jw4ygo",
    "youtubeId": "rQHX4jw4ygo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-930",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 19 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cOthhZujGlU",
    "youtubeId": "cOthhZujGlU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-931",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 18 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KLFix7hYY7o",
    "youtubeId": "KLFix7hYY7o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-932",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 17 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3RyXbiTDjsw",
    "youtubeId": "3RyXbiTDjsw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-933",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 16 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fZJRyxSzXns",
    "youtubeId": "fZJRyxSzXns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-934",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 15 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2sq-Jp-AKN0",
    "youtubeId": "2sq-Jp-AKN0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-935",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 14 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c9IPuZVVM-E",
    "youtubeId": "c9IPuZVVM-E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-936",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 13 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xrUsb7oJ39Q",
    "youtubeId": "xrUsb7oJ39Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-937",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 12 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C1s0O7uwsKk",
    "youtubeId": "C1s0O7uwsKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-938",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 11 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3kQBMbBVdqQ",
    "youtubeId": "3kQBMbBVdqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-939",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 10 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5xOvFh7Z-64",
    "youtubeId": "5xOvFh7Z-64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-940",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 9 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cT2hRHDWoSU",
    "youtubeId": "cT2hRHDWoSU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-941",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 8 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jaLYulwqFbA",
    "youtubeId": "jaLYulwqFbA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-942",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 7 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DQbe8UtjBNo",
    "youtubeId": "DQbe8UtjBNo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-943",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 6 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2hoKCSBvBhA",
    "youtubeId": "2hoKCSBvBhA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-944",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 5 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FHnUNpPexsk",
    "youtubeId": "FHnUNpPexsk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-945",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 4 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ucrdhnCA97w",
    "youtubeId": "ucrdhnCA97w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-946",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 3 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4w5OoqEBWmE",
    "youtubeId": "4w5OoqEBWmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-947",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 2 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UlTStAyVV80",
    "youtubeId": "UlTStAyVV80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-948",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 68 Ayat 1 Surah Qalam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/df81o1RtmLs",
    "youtubeId": "df81o1RtmLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-949",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 30 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wEECq9FaUho",
    "youtubeId": "wEECq9FaUho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-950",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 29 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qaew616lwhk",
    "youtubeId": "qaew616lwhk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-951",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 28 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8kBOU62ack4",
    "youtubeId": "8kBOU62ack4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-952",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 27 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4KXw39yV75Y",
    "youtubeId": "4KXw39yV75Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-953",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 26 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5FmuVcPeGvc",
    "youtubeId": "5FmuVcPeGvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-954",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 25 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6Q-J1bCTAh8",
    "youtubeId": "6Q-J1bCTAh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-955",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 24 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4YE9Q68yczs",
    "youtubeId": "4YE9Q68yczs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-956",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 23 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b7mAMVVM5bk",
    "youtubeId": "b7mAMVVM5bk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-957",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 22 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6Bcb2PlJe7E",
    "youtubeId": "6Bcb2PlJe7E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-958",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 21 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r_01QMRoI18",
    "youtubeId": "r_01QMRoI18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-959",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 20 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nTNIBkVtc1E",
    "youtubeId": "nTNIBkVtc1E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-960",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 19 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gl4snct8fVk",
    "youtubeId": "gl4snct8fVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-961",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 18 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qjR21HqHBwE",
    "youtubeId": "qjR21HqHBwE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-962",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 17 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hj9AqGciPXw",
    "youtubeId": "Hj9AqGciPXw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-963",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 16 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UDgjWYgfqBw",
    "youtubeId": "UDgjWYgfqBw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-964",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 15 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6da1Obh9BNQ",
    "youtubeId": "6da1Obh9BNQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-965",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 14 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eS6r6i3HV18",
    "youtubeId": "eS6r6i3HV18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-966",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 13 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c1tXJWQCs1M",
    "youtubeId": "c1tXJWQCs1M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-967",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 12 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oGu0t7q4SOw",
    "youtubeId": "oGu0t7q4SOw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-968",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 11 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DgnuPioR5c4",
    "youtubeId": "DgnuPioR5c4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-969",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 10 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KbQcDDW7q0c",
    "youtubeId": "KbQcDDW7q0c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-970",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 9 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HuMtW-f3SGw",
    "youtubeId": "HuMtW-f3SGw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-971",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 8 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yf-8Y6dRs0M",
    "youtubeId": "yf-8Y6dRs0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-972",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 7 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dyc42sO_Uy8",
    "youtubeId": "Dyc42sO_Uy8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-973",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 6 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ot7whBDyJfY",
    "youtubeId": "ot7whBDyJfY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-974",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 5 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9H3sOatNfOo",
    "youtubeId": "9H3sOatNfOo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-975",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 4 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TiUlkTQMLeM",
    "youtubeId": "TiUlkTQMLeM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-976",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 3 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eWSKyNXhvJ4",
    "youtubeId": "eWSKyNXhvJ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-977",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 2 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2WAI6CsWINk",
    "youtubeId": "2WAI6CsWINk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-978",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 67 Ayat 1 Surah Mulk Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G0LDl6rwFaE",
    "youtubeId": "G0LDl6rwFaE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-979",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 12 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-IpcWnbjlYY",
    "youtubeId": "-IpcWnbjlYY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-980",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 11 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G6cNqVCRtxM",
    "youtubeId": "G6cNqVCRtxM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-981",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 10 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wXI7JTEZx94",
    "youtubeId": "wXI7JTEZx94",
    "date": "2026-04-14"
  },
  {
    "id": "israr-982",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 9 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e_okpvEtPI4",
    "youtubeId": "e_okpvEtPI4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-983",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 8 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-VhHuOdo-4A",
    "youtubeId": "-VhHuOdo-4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-984",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 7 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EWF0xQprPwQ",
    "youtubeId": "EWF0xQprPwQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-985",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 6 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eZtz9nWqw_M",
    "youtubeId": "eZtz9nWqw_M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-986",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 5 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-FntppAIys",
    "youtubeId": "F-FntppAIys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-987",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 4 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8ACce73mG3U",
    "youtubeId": "8ACce73mG3U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-988",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 3 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bg35TWkHx0Y",
    "youtubeId": "Bg35TWkHx0Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-989",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 2 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SO-eX1Bbrgc",
    "youtubeId": "SO-eX1Bbrgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-990",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Ayat 1 Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MqTn1o2QmKE",
    "youtubeId": "MqTn1o2QmKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-991",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 66 Introduction Surah Tahrim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mYVfkxmAfpY",
    "youtubeId": "mYVfkxmAfpY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-992",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 12 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T0iuKoJVhnM",
    "youtubeId": "T0iuKoJVhnM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-993",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 11 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yG35co0NYLo",
    "youtubeId": "yG35co0NYLo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-994",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 10 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wgHSkMouU70",
    "youtubeId": "wgHSkMouU70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-995",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 9 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D59l7n3EloY",
    "youtubeId": "D59l7n3EloY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-996",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 8 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_6keDY9X47c",
    "youtubeId": "_6keDY9X47c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-997",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 7 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6stojdqp1f8",
    "youtubeId": "6stojdqp1f8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-998",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 6 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fWpC2yVlH_4",
    "youtubeId": "fWpC2yVlH_4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-999",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 5 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/db4jYpFmYW0",
    "youtubeId": "db4jYpFmYW0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1000",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 4 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j2ZzF_ox_3s",
    "youtubeId": "j2ZzF_ox_3s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1001",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 3 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rqhp2IFf04Y",
    "youtubeId": "rqhp2IFf04Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1002",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 2 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vDOzAFxAItc",
    "youtubeId": "vDOzAFxAItc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1003",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Ayat 1 Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TJXxxAXHJcI",
    "youtubeId": "TJXxxAXHJcI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1004",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 65 Introduction Surah Talaq Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0AIGqT7XH_c",
    "youtubeId": "0AIGqT7XH_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1005",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 18 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LnUzi17CaJo",
    "youtubeId": "LnUzi17CaJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1006",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 17 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NG5BVdfOnnQ",
    "youtubeId": "NG5BVdfOnnQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1007",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 16 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2N8B2dAKyTc",
    "youtubeId": "2N8B2dAKyTc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1008",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 15 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XUG-RS4nqqk",
    "youtubeId": "XUG-RS4nqqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1009",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 14 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bvFuGaRI4h0",
    "youtubeId": "bvFuGaRI4h0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1010",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 13 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GqNJttexwCg",
    "youtubeId": "GqNJttexwCg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1011",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 12 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6n380WSRYY0",
    "youtubeId": "6n380WSRYY0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1012",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 11 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jwBCsV3DXKE",
    "youtubeId": "jwBCsV3DXKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1013",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 10 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rmbSUPzTeTg",
    "youtubeId": "rmbSUPzTeTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1014",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 9 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8AMfEngDBbs",
    "youtubeId": "8AMfEngDBbs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1015",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 8 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fQzuYo6kTio",
    "youtubeId": "fQzuYo6kTio",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1016",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 7 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l6mCGQtMTbQ",
    "youtubeId": "l6mCGQtMTbQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1017",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 6 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S_KdE8CrJFo",
    "youtubeId": "S_KdE8CrJFo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1018",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 5 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PRR0w-gMxO8",
    "youtubeId": "PRR0w-gMxO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1019",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 4 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xjl6L3ZCzF8",
    "youtubeId": "Xjl6L3ZCzF8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1020",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 3 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/idGMNK7Fr2I",
    "youtubeId": "idGMNK7Fr2I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1021",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 2 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TSYn1xZscfY",
    "youtubeId": "TSYn1xZscfY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1022",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 64 Ayat 1 Surah Taghabun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HVwY6JIb0oE",
    "youtubeId": "HVwY6JIb0oE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1023",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 11 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e0ADf6T9jic",
    "youtubeId": "e0ADf6T9jic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1024",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 10 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pLxoctEkHNU",
    "youtubeId": "pLxoctEkHNU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1025",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 9 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ugxMoQZSvS8",
    "youtubeId": "ugxMoQZSvS8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1026",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 8 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D2XN0tXW9Qw",
    "youtubeId": "D2XN0tXW9Qw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1027",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 7 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6snXj9O9YiU",
    "youtubeId": "6snXj9O9YiU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1028",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 6 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tf3I1ZrDB7k",
    "youtubeId": "tf3I1ZrDB7k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1029",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 5 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-GsaAQphSOs",
    "youtubeId": "-GsaAQphSOs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1030",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 4 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x_6DgjirExk",
    "youtubeId": "x_6DgjirExk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1031",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 3 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZqfDoVrS4X4",
    "youtubeId": "ZqfDoVrS4X4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1032",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 2 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B5WuVn8ypvs",
    "youtubeId": "B5WuVn8ypvs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1033",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 63 Ayat 1 Surah Munafiqun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u3UC22pEY60",
    "youtubeId": "u3UC22pEY60",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1034",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 11 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ebTDsl6L46M",
    "youtubeId": "ebTDsl6L46M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1035",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 10 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jhw9Hhri5NE",
    "youtubeId": "Jhw9Hhri5NE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1036",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 9 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1EJNq97Ozt4",
    "youtubeId": "1EJNq97Ozt4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1037",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 8 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XEKgmNZQpAs",
    "youtubeId": "XEKgmNZQpAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1038",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 7 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_wJZ-9eBVoo",
    "youtubeId": "_wJZ-9eBVoo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1039",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 6 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nEsEGl3Clak",
    "youtubeId": "nEsEGl3Clak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1040",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 5 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IA6-gPT8pyo",
    "youtubeId": "IA6-gPT8pyo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1041",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 4 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j3ZBtLWi-m4",
    "youtubeId": "j3ZBtLWi-m4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1042",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 3 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WUJRdOVghp8",
    "youtubeId": "WUJRdOVghp8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1043",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 2 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E4z-SCAZt8U",
    "youtubeId": "E4z-SCAZt8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1044",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 62 Ayat 1 Surah Jumuah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rXfzyfai7Qg",
    "youtubeId": "rXfzyfai7Qg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1045",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 14 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lHR6Czow20Q",
    "youtubeId": "lHR6Czow20Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1046",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 13 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/41uo6iUg4TE",
    "youtubeId": "41uo6iUg4TE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1047",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 12 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NB_5Nccuwxg",
    "youtubeId": "NB_5Nccuwxg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1048",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 11 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cuYV6nequS4",
    "youtubeId": "cuYV6nequS4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1049",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 9 & 10 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z_NAnQIh-28",
    "youtubeId": "z_NAnQIh-28",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1050",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 8 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bLmuX3203PE",
    "youtubeId": "bLmuX3203PE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1051",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 7 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Rgkx5qKBTg",
    "youtubeId": "7Rgkx5qKBTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1052",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 6 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Dgi7yikqNc",
    "youtubeId": "5Dgi7yikqNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1053",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 5 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q2gvC94cBA8",
    "youtubeId": "Q2gvC94cBA8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1054",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 4 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SxjAy5F97h8",
    "youtubeId": "SxjAy5F97h8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1055",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 3 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XBNO_xnDzeM",
    "youtubeId": "XBNO_xnDzeM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1056",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 2 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Mmw6O-Ycgo",
    "youtubeId": "9Mmw6O-Ycgo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1057",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Ayat 1 Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/udUTsG9-0hU",
    "youtubeId": "udUTsG9-0hU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1058",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 61 Introduction Surah Saff Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Suu5uBFXaXU",
    "youtubeId": "Suu5uBFXaXU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1059",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 13 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qJZZimPkIIg",
    "youtubeId": "qJZZimPkIIg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1060",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 12 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nPNnPlqD4C0",
    "youtubeId": "nPNnPlqD4C0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1061",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 11 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lckjm6moe4k",
    "youtubeId": "lckjm6moe4k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1062",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 10 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FDO6Zm9-UO4",
    "youtubeId": "FDO6Zm9-UO4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1063",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 9 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jJNmOiolbnU",
    "youtubeId": "jJNmOiolbnU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1064",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 8 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5IzeFxeFtMQ",
    "youtubeId": "5IzeFxeFtMQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1065",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 7 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l_29OBiMW7A",
    "youtubeId": "l_29OBiMW7A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1066",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 6 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AhPCGndXYHs",
    "youtubeId": "AhPCGndXYHs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1067",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 5 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KhqjSIw_Eo8",
    "youtubeId": "KhqjSIw_Eo8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1068",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 4 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uR9cyfAtzVg",
    "youtubeId": "uR9cyfAtzVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1069",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 3 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_3SpDOfgjQM",
    "youtubeId": "_3SpDOfgjQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1070",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 2 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zGmqpPROYUc",
    "youtubeId": "zGmqpPROYUc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1071",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Introduction Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V2O44CboNt4",
    "youtubeId": "V2O44CboNt4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1072",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 60 Ayat 1 Surah Mumtahanah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BVhlLGey_VA",
    "youtubeId": "BVhlLGey_VA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1073",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 24 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eMDRcYH2fpE",
    "youtubeId": "eMDRcYH2fpE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1074",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 23 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z0Q-mEocUxc",
    "youtubeId": "Z0Q-mEocUxc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1075",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 22 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fPGhRpsqfjU",
    "youtubeId": "fPGhRpsqfjU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1076",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 21 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FJj-Ep0M9UY",
    "youtubeId": "FJj-Ep0M9UY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1077",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 20 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b36LkCBFlbc",
    "youtubeId": "b36LkCBFlbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1078",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 19 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mFz7-fLPJ28",
    "youtubeId": "mFz7-fLPJ28",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1079",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 18 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_4bZ8EwJGCw",
    "youtubeId": "_4bZ8EwJGCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1080",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 17 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wlGWqpX54eM",
    "youtubeId": "wlGWqpX54eM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1081",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 16 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6-BINbJ4bos",
    "youtubeId": "6-BINbJ4bos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1082",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 15 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3v4-R5FYGgM",
    "youtubeId": "3v4-R5FYGgM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1083",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 14 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0TvB69lCzks",
    "youtubeId": "0TvB69lCzks",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1084",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 13 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_z9f6_aCOGw",
    "youtubeId": "_z9f6_aCOGw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1085",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 12 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xsHaIs_25ao",
    "youtubeId": "xsHaIs_25ao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1086",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 11 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wU0oPhSS97U",
    "youtubeId": "wU0oPhSS97U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1087",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 10 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u_tYXdKYzrE",
    "youtubeId": "u_tYXdKYzrE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1088",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 9 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/crVQkVi70J0",
    "youtubeId": "crVQkVi70J0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1089",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 8 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q8N8B-fLJYY",
    "youtubeId": "q8N8B-fLJYY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1090",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 7 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ch-ol8WhEC8",
    "youtubeId": "Ch-ol8WhEC8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1091",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 6 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sPfibb10qVs",
    "youtubeId": "sPfibb10qVs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1092",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 5 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qkIKnxkLHIg",
    "youtubeId": "qkIKnxkLHIg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1093",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 4 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0eLbgbNr5WM",
    "youtubeId": "0eLbgbNr5WM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1094",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 3 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ti_T44VbtVE",
    "youtubeId": "ti_T44VbtVE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1095",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 2 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3DYjzBA1aSo",
    "youtubeId": "3DYjzBA1aSo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1096",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 59 Ayat 1 Surah Hashr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mM8hV-Rr7Dw",
    "youtubeId": "mM8hV-Rr7Dw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1097",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 22 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nultWdkcG5M",
    "youtubeId": "nultWdkcG5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1098",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 21 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L28M9Y0RamE",
    "youtubeId": "L28M9Y0RamE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1099",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 20 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ot3-X3wiPpk",
    "youtubeId": "ot3-X3wiPpk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 19 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KwESWXJXRzM",
    "youtubeId": "KwESWXJXRzM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 18 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jJsqHgtG1V4",
    "youtubeId": "jJsqHgtG1V4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 17 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T7iz0AsLFKo",
    "youtubeId": "T7iz0AsLFKo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 16 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m38_6xQM9BE",
    "youtubeId": "m38_6xQM9BE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 15 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RZDIuXhl1Kg",
    "youtubeId": "RZDIuXhl1Kg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 14 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t7RvRhZ1Uq4",
    "youtubeId": "t7RvRhZ1Uq4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 13 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZY4NfZjOvLo",
    "youtubeId": "ZY4NfZjOvLo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 12 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MRCApljhdFY",
    "youtubeId": "MRCApljhdFY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 11 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TFNefUSEIR0",
    "youtubeId": "TFNefUSEIR0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 10 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aZf7Hw-2_TM",
    "youtubeId": "aZf7Hw-2_TM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 9 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_3XDMC54CXw",
    "youtubeId": "_3XDMC54CXw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 8 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cJigSIJWNoo",
    "youtubeId": "cJigSIJWNoo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 7 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mu37sATbGNk",
    "youtubeId": "mu37sATbGNk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 6 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BvQqjlTMLp0",
    "youtubeId": "BvQqjlTMLp0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 5 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K6JqfEp47Ao",
    "youtubeId": "K6JqfEp47Ao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 4 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-sqKJAzHLfY",
    "youtubeId": "-sqKJAzHLfY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 3 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2tV25jRACew",
    "youtubeId": "2tV25jRACew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 2 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d_J4HLcr_B8",
    "youtubeId": "d_J4HLcr_B8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 58 Ayat 1 Surah Mujadilah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7-IT0WoiIMc",
    "youtubeId": "7-IT0WoiIMc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 29 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Um71VYKgjtQ",
    "youtubeId": "Um71VYKgjtQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 28 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uvpHp0PklCY",
    "youtubeId": "uvpHp0PklCY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 27 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bFZRBVSAIHo",
    "youtubeId": "bFZRBVSAIHo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1122",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 26 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qhASelZO9FY",
    "youtubeId": "qhASelZO9FY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1123",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 25 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h51cN7yI-uI",
    "youtubeId": "h51cN7yI-uI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1124",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 24 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XJi5o8yC6ss",
    "youtubeId": "XJi5o8yC6ss",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1125",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 23 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bNNJ-Dd7vXM",
    "youtubeId": "bNNJ-Dd7vXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1126",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 22 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bUubpURgluE",
    "youtubeId": "bUubpURgluE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1127",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 21 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kx5C76iPWqU",
    "youtubeId": "kx5C76iPWqU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1128",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 20 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u22o296Qhmc",
    "youtubeId": "u22o296Qhmc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1129",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 19 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5a6mdbcA5ig",
    "youtubeId": "5a6mdbcA5ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1130",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 18 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y8q52aO49VE",
    "youtubeId": "y8q52aO49VE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1131",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 17 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QDSHsMev94I",
    "youtubeId": "QDSHsMev94I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1132",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 16 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zSdAXdg9TiQ",
    "youtubeId": "zSdAXdg9TiQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1133",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 15 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kiTgMm5-n18",
    "youtubeId": "kiTgMm5-n18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1134",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 14 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YIKT6RtBGGw",
    "youtubeId": "YIKT6RtBGGw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1135",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 13 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ucbgU2iSZ5E",
    "youtubeId": "ucbgU2iSZ5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1136",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 12 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XvAWAH6vs20",
    "youtubeId": "XvAWAH6vs20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1137",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 11 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_I1HkJ_xxKQ",
    "youtubeId": "_I1HkJ_xxKQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1138",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 10 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/buGNP5yR2SI",
    "youtubeId": "buGNP5yR2SI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1139",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 9 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n_Zlq0WToaw",
    "youtubeId": "n_Zlq0WToaw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1140",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 8 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zi2HnT5a9eI",
    "youtubeId": "zi2HnT5a9eI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1141",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 7 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XUsdwC2bCLs",
    "youtubeId": "XUsdwC2bCLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1142",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 6 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vJ7_SMVwXjE",
    "youtubeId": "vJ7_SMVwXjE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1143",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 5 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y6XGFzDO7iw",
    "youtubeId": "y6XGFzDO7iw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1144",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 4 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PRVu31K5u3Q",
    "youtubeId": "PRVu31K5u3Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1145",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 3 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JvpWipvBBfk",
    "youtubeId": "JvpWipvBBfk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1146",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 2 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VIq8IQi2v-g",
    "youtubeId": "VIq8IQi2v-g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1147",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 57 Ayat 1 Surah Hadid Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AkRvCoUVdgA",
    "youtubeId": "AkRvCoUVdgA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1148",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 96 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iaPVSOLqGlQ",
    "youtubeId": "iaPVSOLqGlQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1149",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 95 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LIcbTrAO4Zw",
    "youtubeId": "LIcbTrAO4Zw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1150",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 94 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3dOW9jxXLFA",
    "youtubeId": "3dOW9jxXLFA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1151",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 92 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yZXCQYSnOeI",
    "youtubeId": "yZXCQYSnOeI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1152",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 91 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z0KyTsfy6mQ",
    "youtubeId": "Z0KyTsfy6mQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1153",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 90 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sqJNaGQfY7Q",
    "youtubeId": "sqJNaGQfY7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1154",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 88 & 89 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_qiieGiXiKk",
    "youtubeId": "_qiieGiXiKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1155",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 86 & 87 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X9l3Yr9iLP4",
    "youtubeId": "X9l3Yr9iLP4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1156",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 85 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/chogFBl0ox4",
    "youtubeId": "chogFBl0ox4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1157",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 84 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z4k-kHiV3Uk",
    "youtubeId": "z4k-kHiV3Uk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1158",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 83 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mB-mQx0XRT4",
    "youtubeId": "mB-mQx0XRT4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1159",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 82 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3zmCTF2kE0w",
    "youtubeId": "3zmCTF2kE0w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1160",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 80 & 81 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4_1oAF9BMMc",
    "youtubeId": "4_1oAF9BMMc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1161",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 79 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dcHUVTopMrg",
    "youtubeId": "dcHUVTopMrg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1162",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 78 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kFKJadZqOm0",
    "youtubeId": "kFKJadZqOm0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1163",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 77 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IZr0xZpdey8",
    "youtubeId": "IZr0xZpdey8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1164",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 76 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PVC7OnPjRfA",
    "youtubeId": "PVC7OnPjRfA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1165",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 75 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z5eSktCRFQw",
    "youtubeId": "Z5eSktCRFQw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1166",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 74 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IIaA1VrOavs",
    "youtubeId": "IIaA1VrOavs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1167",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 73 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B-C3CC3lRl0",
    "youtubeId": "B-C3CC3lRl0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1168",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 72 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZTylChbYL04",
    "youtubeId": "ZTylChbYL04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1169",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 71 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IE8T1dyFke8",
    "youtubeId": "IE8T1dyFke8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1170",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 70 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/osm-BaX_568",
    "youtubeId": "osm-BaX_568",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1171",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 69 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M7q1jeBZWYA",
    "youtubeId": "M7q1jeBZWYA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1172",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 68 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PiHFVALs3-M",
    "youtubeId": "PiHFVALs3-M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1173",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 67 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xoP1oeza6Bo",
    "youtubeId": "xoP1oeza6Bo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1174",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 66 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l2Xo7MLG10A",
    "youtubeId": "l2Xo7MLG10A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1175",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 65 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eiYT6d9yjlM",
    "youtubeId": "eiYT6d9yjlM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1176",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 64 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fUjbMqy9t1Q",
    "youtubeId": "fUjbMqy9t1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1177",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 63 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DCtTNnqiQ64",
    "youtubeId": "DCtTNnqiQ64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1178",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 62 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iHwiPa8z5XI",
    "youtubeId": "iHwiPa8z5XI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1179",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 61 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pGpQcDepYac",
    "youtubeId": "pGpQcDepYac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1180",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 60 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MaDpKHzd_ZY",
    "youtubeId": "MaDpKHzd_ZY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1181",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 59 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q6cXWnLQBt4",
    "youtubeId": "q6cXWnLQBt4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1182",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 58 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JXMtLsmlGeA",
    "youtubeId": "JXMtLsmlGeA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1183",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 57 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ghn1zNXraSs",
    "youtubeId": "Ghn1zNXraSs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1184",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 56 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5D60fU2-ydA",
    "youtubeId": "5D60fU2-ydA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1185",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 55 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LHA_6hwN7y4",
    "youtubeId": "LHA_6hwN7y4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1186",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 54 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NIV6xJbDOnQ",
    "youtubeId": "NIV6xJbDOnQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1187",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 53 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yeUYT04SDzs",
    "youtubeId": "yeUYT04SDzs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1188",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 52 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3jRx9MR8YWI",
    "youtubeId": "3jRx9MR8YWI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1189",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 51 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p70UdKH0ihM",
    "youtubeId": "p70UdKH0ihM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1190",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 50 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P-ty_8dX77Q",
    "youtubeId": "P-ty_8dX77Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1191",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 49 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m21nSpvjaf8",
    "youtubeId": "m21nSpvjaf8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1192",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 48 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/16YbTh6r8YY",
    "youtubeId": "16YbTh6r8YY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1193",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 47 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FnWzFfv9N9Q",
    "youtubeId": "FnWzFfv9N9Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1194",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 46 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CjSlgevBt2E",
    "youtubeId": "CjSlgevBt2E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1195",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 45 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bCLxVLgahXs",
    "youtubeId": "bCLxVLgahXs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1196",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 44 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p7f2mhNQdTA",
    "youtubeId": "p7f2mhNQdTA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1197",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 43 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nvPhD43JG7E",
    "youtubeId": "nvPhD43JG7E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1198",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 42 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D_a8FurNIyM",
    "youtubeId": "D_a8FurNIyM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1199",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 41 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i9DsZDYw1uI",
    "youtubeId": "i9DsZDYw1uI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1200",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 39 & 40 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0C6xuN7jji0",
    "youtubeId": "0C6xuN7jji0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1201",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 38 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UGVoNNvDTPY",
    "youtubeId": "UGVoNNvDTPY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1202",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 37 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-wTMbVHuS80",
    "youtubeId": "-wTMbVHuS80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1203",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 36 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kq_pUXyvcCA",
    "youtubeId": "Kq_pUXyvcCA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1204",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 35 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SKOeNR2pajM",
    "youtubeId": "SKOeNR2pajM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1205",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 34 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l1I7n7cPsVA",
    "youtubeId": "l1I7n7cPsVA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1206",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 33 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YIH3XLtfSQM",
    "youtubeId": "YIH3XLtfSQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1207",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 32 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G2l0zv8BdJA",
    "youtubeId": "G2l0zv8BdJA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1208",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 31 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h-1MvLVmumc",
    "youtubeId": "h-1MvLVmumc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1209",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 30 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fQ5Pvi5RYLs",
    "youtubeId": "fQ5Pvi5RYLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1210",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 29 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uWAOLuc0ek0",
    "youtubeId": "uWAOLuc0ek0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1211",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 28 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TlMIbx7Qm_Y",
    "youtubeId": "TlMIbx7Qm_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1212",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 27 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u4QjfnwjSSY",
    "youtubeId": "u4QjfnwjSSY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1213",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 26 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q1lu8KS5NQ4",
    "youtubeId": "q1lu8KS5NQ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1214",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 25 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-6IdBjlebDE",
    "youtubeId": "-6IdBjlebDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1215",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 24 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C2zwEeB_Eig",
    "youtubeId": "C2zwEeB_Eig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1216",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 23 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l_QUQs7M7Ps",
    "youtubeId": "l_QUQs7M7Ps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1217",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 22 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4KtheAWhGe0",
    "youtubeId": "4KtheAWhGe0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1218",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 21 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QVoCDPle4Xo",
    "youtubeId": "QVoCDPle4Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1219",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 20 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hR_1Ld-eX-I",
    "youtubeId": "hR_1Ld-eX-I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1220",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 19 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8v_za_aqj0M",
    "youtubeId": "8v_za_aqj0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1221",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 18 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8v61AcA0Ks4",
    "youtubeId": "8v61AcA0Ks4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1222",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 17 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9dkkM2KK6LQ",
    "youtubeId": "9dkkM2KK6LQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1223",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 15 & 16 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZCSyCqUm2DQ",
    "youtubeId": "ZCSyCqUm2DQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1224",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 13 & 14 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xmoiof_4oJY",
    "youtubeId": "Xmoiof_4oJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1225",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 12 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xpp6WTZCMyA",
    "youtubeId": "xpp6WTZCMyA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1226",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 11 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rCBylHUJOic",
    "youtubeId": "rCBylHUJOic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1227",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 10 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s1CNAN-MNaM",
    "youtubeId": "s1CNAN-MNaM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1228",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 9 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZDyKbPr9kVQ",
    "youtubeId": "ZDyKbPr9kVQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1229",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 8 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FBMMKlFyRIQ",
    "youtubeId": "FBMMKlFyRIQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1230",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 7 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IMu4v1h-8OE",
    "youtubeId": "IMu4v1h-8OE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1231",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 6 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jmc_9gG-Uao",
    "youtubeId": "Jmc_9gG-Uao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1232",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 5 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RMIAn_oe4Ew",
    "youtubeId": "RMIAn_oe4Ew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1233",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 3 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cge8rQAcPFM",
    "youtubeId": "Cge8rQAcPFM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1234",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 2 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZtRJKNXhnI0",
    "youtubeId": "ZtRJKNXhnI0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1235",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 56 Ayat 1 Surah Waqiah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wFSlriUr0y4",
    "youtubeId": "wFSlriUr0y4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1236",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 78 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Seu_X8KcPm0",
    "youtubeId": "Seu_X8KcPm0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1237",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 76 & 77 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vJ3Zc2cb4gQ",
    "youtubeId": "vJ3Zc2cb4gQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1238",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 74 & 75 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wkh0ToZVTpA",
    "youtubeId": "wkh0ToZVTpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1239",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 72 & 73 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iM-nrszk5ik",
    "youtubeId": "iM-nrszk5ik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1240",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 70 & 71 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wpWfH2EkMYs",
    "youtubeId": "wpWfH2EkMYs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1241",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 68 & 69 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rn13NiusFBY",
    "youtubeId": "rn13NiusFBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1242",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 66 & 67 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cPxnvBm7h-s",
    "youtubeId": "cPxnvBm7h-s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1243",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 64 & 65 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XmY3wXc8E3o",
    "youtubeId": "XmY3wXc8E3o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1244",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 62 & 63 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2erTUzNjJ3E",
    "youtubeId": "2erTUzNjJ3E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1245",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 60 & 61 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GNkPfI3WZds",
    "youtubeId": "GNkPfI3WZds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1246",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 58 & 59 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7VJvKhktKhA",
    "youtubeId": "7VJvKhktKhA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1247",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 56 & 57 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jj512x2tN-c",
    "youtubeId": "jj512x2tN-c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1248",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 54 & 55 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Aqt-6SadOW4",
    "youtubeId": "Aqt-6SadOW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1249",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 52 & 53 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R8bbkEyPdbY",
    "youtubeId": "R8bbkEyPdbY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1250",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 50 & 51 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XnZY3MpFn5Q",
    "youtubeId": "XnZY3MpFn5Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1251",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 48 & 49 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4X8NlXGw0ts",
    "youtubeId": "4X8NlXGw0ts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1252",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 46 & 47 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D3CdgqdXrUA",
    "youtubeId": "D3CdgqdXrUA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1253",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 44 & 45 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DzNZwWXw66Q",
    "youtubeId": "DzNZwWXw66Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1254",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 43 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hneyrBU3Alk",
    "youtubeId": "hneyrBU3Alk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1255",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 41 & 42 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GWc-ga-512Y",
    "youtubeId": "GWc-ga-512Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1256",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 39 & 40 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-mssdqXGn1A",
    "youtubeId": "-mssdqXGn1A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1257",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 37 & 38 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3WJcgKBwxgE",
    "youtubeId": "3WJcgKBwxgE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1258",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 35 & 36 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_iXnjH0x2lU",
    "youtubeId": "_iXnjH0x2lU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1259",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 33 & 34 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RstO5lMpWUU",
    "youtubeId": "RstO5lMpWUU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1260",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 31 & 32 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GSj7fgjLgC0",
    "youtubeId": "GSj7fgjLgC0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1261",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 29 & 30 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YOdHEuKug_E",
    "youtubeId": "YOdHEuKug_E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1262",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 27 & 28 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q22c4j6Q7Gs",
    "youtubeId": "Q22c4j6Q7Gs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1263",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 26 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dYgoXSOgm1o",
    "youtubeId": "dYgoXSOgm1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1264",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 24 & 25 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-X5R2qs-dqs",
    "youtubeId": "-X5R2qs-dqs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1265",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 22 & 23 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Px00bgX3e0A",
    "youtubeId": "Px00bgX3e0A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1266",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 20 & 21 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SOnDk7G-6uE",
    "youtubeId": "SOnDk7G-6uE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1267",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 19 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pbYnIud1Qgk",
    "youtubeId": "pbYnIud1Qgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1268",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 17 & 18 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UIg2PZONKqg",
    "youtubeId": "UIg2PZONKqg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1269",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 15 & 16 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WIvH4oPscxU",
    "youtubeId": "WIvH4oPscxU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1270",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 14 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-6fEsEjJGKw",
    "youtubeId": "-6fEsEjJGKw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1271",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 13 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PdVCnQ5u6qc",
    "youtubeId": "PdVCnQ5u6qc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1272",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 12 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X9zBN_gjzTY",
    "youtubeId": "X9zBN_gjzTY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1273",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 11 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lNfPLuPAiIs",
    "youtubeId": "lNfPLuPAiIs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1274",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 10 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WaQWvyThw18",
    "youtubeId": "WaQWvyThw18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1275",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 9 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vtgNFaDDAb4",
    "youtubeId": "vtgNFaDDAb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1276",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 8 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-s_Z64lnoPc",
    "youtubeId": "-s_Z64lnoPc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1277",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 7 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VibLfzOYpAA",
    "youtubeId": "VibLfzOYpAA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1278",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 6 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RVYaUg5BhmM",
    "youtubeId": "RVYaUg5BhmM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1279",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 5 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sj6ac2De1dY",
    "youtubeId": "Sj6ac2De1dY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1280",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 4 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xzjaeSmBUPk",
    "youtubeId": "xzjaeSmBUPk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1281",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 3 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kg9Xsc-jN6E",
    "youtubeId": "kg9Xsc-jN6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1282",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 2 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X-KvksjCR_s",
    "youtubeId": "X-KvksjCR_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1283",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 55 Ayat 1 Surah Rahman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ArIOpOZPPpM",
    "youtubeId": "ArIOpOZPPpM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1284",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 55 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bWDyZOghKBc",
    "youtubeId": "bWDyZOghKBc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1285",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 54 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i2okGlGIg1o",
    "youtubeId": "i2okGlGIg1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1286",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 53 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rmTqKqL8HTc",
    "youtubeId": "rmTqKqL8HTc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1287",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 52 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XcG0iXYd6Bs",
    "youtubeId": "XcG0iXYd6Bs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1288",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 51 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6e8Dl5IEZ_s",
    "youtubeId": "6e8Dl5IEZ_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1289",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 50 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J2mMedXW98o",
    "youtubeId": "J2mMedXW98o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1290",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 49 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nIEr8hgNhIA",
    "youtubeId": "nIEr8hgNhIA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1291",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 48 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dqBzFKoxjdM",
    "youtubeId": "dqBzFKoxjdM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1292",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 47 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IBEf1xWYTQ8",
    "youtubeId": "IBEf1xWYTQ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1293",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 46 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L2V2K3QUvkk",
    "youtubeId": "L2V2K3QUvkk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1294",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 45 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dyZohvcP0a0",
    "youtubeId": "dyZohvcP0a0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1295",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 44 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BCPW4v_kIL0",
    "youtubeId": "BCPW4v_kIL0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1296",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 43 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D1BqJ7TgsWM",
    "youtubeId": "D1BqJ7TgsWM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1297",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 42 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4lgOtSNQgWw",
    "youtubeId": "4lgOtSNQgWw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1298",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 41 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/znFyozLv74E",
    "youtubeId": "znFyozLv74E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1299",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 40 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yzIBEdPGX2Q",
    "youtubeId": "yzIBEdPGX2Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1300",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 39 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TDSY8iAdJ8U",
    "youtubeId": "TDSY8iAdJ8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1301",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 38 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tqNZp4ZQs4A",
    "youtubeId": "tqNZp4ZQs4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1302",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 37 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xN61a4TcRbc",
    "youtubeId": "xN61a4TcRbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1303",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 36 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cfYH-8Vq-5g",
    "youtubeId": "cfYH-8Vq-5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1304",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 35 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YveIg3lmjqM",
    "youtubeId": "YveIg3lmjqM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1305",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 34 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iB9GK0HLVik",
    "youtubeId": "iB9GK0HLVik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1306",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 33 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QGGB2aFEPiY",
    "youtubeId": "QGGB2aFEPiY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1307",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 32 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1mA6vYdAfOo",
    "youtubeId": "1mA6vYdAfOo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1308",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 31 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-R9uK-OusBA",
    "youtubeId": "-R9uK-OusBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1309",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 30 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HwQ9JYRLjZw",
    "youtubeId": "HwQ9JYRLjZw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1310",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 29 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LXRfcahdFm4",
    "youtubeId": "LXRfcahdFm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1311",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 28 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yRN5qGf1xfU",
    "youtubeId": "yRN5qGf1xfU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1312",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 27 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e1UZpkzpdg8",
    "youtubeId": "e1UZpkzpdg8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1313",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 26 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h51_9yPthLE",
    "youtubeId": "h51_9yPthLE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1314",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 25 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ka3S4ANSh20",
    "youtubeId": "Ka3S4ANSh20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1315",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 24 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g1djzEaZSAo",
    "youtubeId": "g1djzEaZSAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1316",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 23 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5EoVcdOb1zQ",
    "youtubeId": "5EoVcdOb1zQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1317",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 22 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5dlmUCybNxU",
    "youtubeId": "5dlmUCybNxU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1318",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 21 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GH5pWYaoN38",
    "youtubeId": "GH5pWYaoN38",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1319",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 20 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mTX-KEtGb18",
    "youtubeId": "mTX-KEtGb18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1320",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 19 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fqiiYwjjufI",
    "youtubeId": "fqiiYwjjufI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1321",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 18 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WB6hhuD9ylg",
    "youtubeId": "WB6hhuD9ylg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1322",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 17 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J09oyXQULkM",
    "youtubeId": "J09oyXQULkM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1323",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 16 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y6MWU8fsG3M",
    "youtubeId": "Y6MWU8fsG3M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1324",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 15 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T1GZbYH1w2s",
    "youtubeId": "T1GZbYH1w2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1325",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 14 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ebbtQ0VvXtQ",
    "youtubeId": "ebbtQ0VvXtQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1326",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 13 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9zZ5e5OC98A",
    "youtubeId": "9zZ5e5OC98A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1327",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 12 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/atB-D0da2Yg",
    "youtubeId": "atB-D0da2Yg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1328",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 11 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qvoguB-sBzU",
    "youtubeId": "qvoguB-sBzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1329",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 10 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BceXykztE2g",
    "youtubeId": "BceXykztE2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1330",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 9 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oJzpgSFgmPU",
    "youtubeId": "oJzpgSFgmPU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1331",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 8 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U8ySubYD1nQ",
    "youtubeId": "U8ySubYD1nQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1332",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 7 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1uambrf1nq8",
    "youtubeId": "1uambrf1nq8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1333",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 6 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AOVMmxw7wd0",
    "youtubeId": "AOVMmxw7wd0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1334",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 5 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tem8LwJUrPY",
    "youtubeId": "tem8LwJUrPY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1335",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 4 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_wJEUPLr54Q",
    "youtubeId": "_wJEUPLr54Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1336",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 3 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cEIRFA6Unnw",
    "youtubeId": "cEIRFA6Unnw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1337",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 2 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gvwWNOOpZDI",
    "youtubeId": "gvwWNOOpZDI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1338",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 54 Ayat 1 Surah Qamar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Ffbiwiq-bY",
    "youtubeId": "_Ffbiwiq-bY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1339",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 62 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uA14BlEw7po",
    "youtubeId": "uA14BlEw7po",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1340",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 61 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nC2GM0JhvXU",
    "youtubeId": "nC2GM0JhvXU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1341",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Conclusion  Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Nc7DpekK80",
    "youtubeId": "0Nc7DpekK80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1342",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 60 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2fF8VcTJcng",
    "youtubeId": "2fF8VcTJcng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1343",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 59 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OHPquG0Wywo",
    "youtubeId": "OHPquG0Wywo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1344",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 58 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jUqtA6G7eQQ",
    "youtubeId": "jUqtA6G7eQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1345",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 57 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0NEtGxkTdG0",
    "youtubeId": "0NEtGxkTdG0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1346",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 56 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JA3HgQYni1o",
    "youtubeId": "JA3HgQYni1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1347",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 55 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L_VVy7U2oEo",
    "youtubeId": "L_VVy7U2oEo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1348",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 54 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K5fwyiz36HA",
    "youtubeId": "K5fwyiz36HA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1349",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 53 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DDTbYWQRCUo",
    "youtubeId": "DDTbYWQRCUo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1350",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 52 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PAzN2R7O0fk",
    "youtubeId": "PAzN2R7O0fk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1351",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 51 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2KU3tcFvyow",
    "youtubeId": "2KU3tcFvyow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1352",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 50 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jgTO56o2OFk",
    "youtubeId": "jgTO56o2OFk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1353",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 49 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SY6Kesqk040",
    "youtubeId": "SY6Kesqk040",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1354",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 48 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pws_Ag425Ik",
    "youtubeId": "pws_Ag425Ik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1355",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 47 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d2mN6rsIzcs",
    "youtubeId": "d2mN6rsIzcs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1356",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 46 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PJT8Ng1cDdc",
    "youtubeId": "PJT8Ng1cDdc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1357",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 45 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qudFr4zYt1s",
    "youtubeId": "qudFr4zYt1s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1358",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 44 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UDyfRrFTHxE",
    "youtubeId": "UDyfRrFTHxE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1359",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 43 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xNbKfodrGiM",
    "youtubeId": "xNbKfodrGiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1360",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 42 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QOK8MIw-E20",
    "youtubeId": "QOK8MIw-E20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1361",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 41 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3yxZ3Ahefkk",
    "youtubeId": "3yxZ3Ahefkk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1362",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 40 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OVCIS4cg-AQ",
    "youtubeId": "OVCIS4cg-AQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1363",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 39 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GwvRJ2njTek",
    "youtubeId": "GwvRJ2njTek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1364",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 38 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3v7zDbPGunM",
    "youtubeId": "3v7zDbPGunM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1365",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 37 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k_JDLoPYi_E",
    "youtubeId": "k_JDLoPYi_E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1366",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 36 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wnNlcbW4I2c",
    "youtubeId": "wnNlcbW4I2c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1367",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 35 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M5MCTwiDjm0",
    "youtubeId": "M5MCTwiDjm0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1368",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 34 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/saydu7BICLY",
    "youtubeId": "saydu7BICLY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1369",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 33 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CBTjC5SzgKU",
    "youtubeId": "CBTjC5SzgKU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1370",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 32 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mVAUivbJjVw",
    "youtubeId": "mVAUivbJjVw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1371",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 31 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0i5tHhypWU0",
    "youtubeId": "0i5tHhypWU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1372",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 30 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m5WQ6OKBk_k",
    "youtubeId": "m5WQ6OKBk_k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1373",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 29 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NfZwZdd86Mc",
    "youtubeId": "NfZwZdd86Mc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1374",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 28 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kKxK_XPOgi0",
    "youtubeId": "kKxK_XPOgi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1375",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 27 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-qwMrdzS4Og",
    "youtubeId": "-qwMrdzS4Og",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1376",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 26 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tHeDWJpuj8w",
    "youtubeId": "tHeDWJpuj8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1377",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 25 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/30GgwQ2JoPI",
    "youtubeId": "30GgwQ2JoPI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1378",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 24 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zlXq4IayAgg",
    "youtubeId": "zlXq4IayAgg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1379",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 23 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/388PlJyHNEU",
    "youtubeId": "388PlJyHNEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1380",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 22 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f8oTbKtaaCM",
    "youtubeId": "f8oTbKtaaCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1381",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 19 -21 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fKLd9jLEqy4",
    "youtubeId": "fKLd9jLEqy4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1382",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 18 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j1cCPI3y1P0",
    "youtubeId": "j1cCPI3y1P0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1383",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 17 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2UZh-TcqbUM",
    "youtubeId": "2UZh-TcqbUM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1384",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 16 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5JdmFiGYHjM",
    "youtubeId": "5JdmFiGYHjM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1385",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 15 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/94nHjPTMbW0",
    "youtubeId": "94nHjPTMbW0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1386",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 14 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G8Wm6AsGXoI",
    "youtubeId": "G8Wm6AsGXoI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1387",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 13 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dv5YX63oVPg",
    "youtubeId": "dv5YX63oVPg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1388",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 12 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f5_Moae7Mh0",
    "youtubeId": "f5_Moae7Mh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1389",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 11 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qnQqH5G48NA",
    "youtubeId": "qnQqH5G48NA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1390",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 10 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mW6v8bvGi1Q",
    "youtubeId": "mW6v8bvGi1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1391",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 9 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PTCnv9LefdE",
    "youtubeId": "PTCnv9LefdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1392",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 8 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z_NzPAz2O_g",
    "youtubeId": "z_NzPAz2O_g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1393",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 7 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uX0pARqhsck",
    "youtubeId": "uX0pARqhsck",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1394",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 6 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tWSBbPPYzLY",
    "youtubeId": "tWSBbPPYzLY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1395",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 5 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dhQlBJhD_P0",
    "youtubeId": "dhQlBJhD_P0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1396",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 4 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pnYzP3oOl0c",
    "youtubeId": "pnYzP3oOl0c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1397",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 3 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pV85Czgy9Gw",
    "youtubeId": "pV85Czgy9Gw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1398",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 2 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EGSy74qTHnk",
    "youtubeId": "EGSy74qTHnk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1399",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 53 Ayat 1 Surah Najm Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gOk2N8lHy5s",
    "youtubeId": "gOk2N8lHy5s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1400",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 49 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TVULuVoEwAU",
    "youtubeId": "TVULuVoEwAU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1401",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 48 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TVBPyBgHleI",
    "youtubeId": "TVBPyBgHleI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1402",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 47 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oIfY_Qutvxg",
    "youtubeId": "oIfY_Qutvxg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1403",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 46 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X0zzzRBNAPg",
    "youtubeId": "X0zzzRBNAPg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1404",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 45 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EjvHAENknc4",
    "youtubeId": "EjvHAENknc4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1405",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 44 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qwPWW_PL4T0",
    "youtubeId": "qwPWW_PL4T0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1406",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 43 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KPaPx2OEr0s",
    "youtubeId": "KPaPx2OEr0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1407",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 42 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B9HWLojo3OU",
    "youtubeId": "B9HWLojo3OU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1408",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 41 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YVCacegcNUw",
    "youtubeId": "YVCacegcNUw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1409",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 40 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/37b9-qFL8hA",
    "youtubeId": "37b9-qFL8hA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1410",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 39 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EE67LTekbVg",
    "youtubeId": "EE67LTekbVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1411",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 38 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fg36VsS9H4g",
    "youtubeId": "fg36VsS9H4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1412",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 37 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/COl69CvzakU",
    "youtubeId": "COl69CvzakU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1413",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 36 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wEGx-4duWos",
    "youtubeId": "wEGx-4duWos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1414",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 35 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FgLuSZTxAQk",
    "youtubeId": "FgLuSZTxAQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1415",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 34 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E8-aaXIRsK0",
    "youtubeId": "E8-aaXIRsK0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1416",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 33 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/swNHUpOiGYk",
    "youtubeId": "swNHUpOiGYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1417",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 32 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VfHn2FHu2HU",
    "youtubeId": "VfHn2FHu2HU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1418",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 31 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FmNOG_a0lxA",
    "youtubeId": "FmNOG_a0lxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1419",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 30 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RtlKtYBoNsk",
    "youtubeId": "RtlKtYBoNsk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1420",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 29 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kjW-rgKeuN8",
    "youtubeId": "kjW-rgKeuN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1421",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 28 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SiWd-ncSI6Y",
    "youtubeId": "SiWd-ncSI6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1422",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 27 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZqISf01duOA",
    "youtubeId": "ZqISf01duOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1423",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 26 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OP8Ip_9tjOI",
    "youtubeId": "OP8Ip_9tjOI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1424",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 25 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wMp7o8os6qM",
    "youtubeId": "wMp7o8os6qM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1425",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 24 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uuGBIOVHgXo",
    "youtubeId": "uuGBIOVHgXo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1426",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 23 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8Kau5SsTXaU",
    "youtubeId": "8Kau5SsTXaU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1427",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 22 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E3EondpU_8c",
    "youtubeId": "E3EondpU_8c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1428",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 21 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aAswhtzqxMk",
    "youtubeId": "aAswhtzqxMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1429",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 20 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8A62xfZngsY",
    "youtubeId": "8A62xfZngsY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1430",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 19 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XUa-owPXkRU",
    "youtubeId": "XUa-owPXkRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1431",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 18 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qfq0pedHt2g",
    "youtubeId": "Qfq0pedHt2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1432",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 17 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0BwzUfJahH4",
    "youtubeId": "0BwzUfJahH4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1433",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 16 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yq3x1-RV5FY",
    "youtubeId": "yq3x1-RV5FY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1434",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 15 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7T4tfz0sF18",
    "youtubeId": "7T4tfz0sF18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1435",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 14 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yDf9BRYy_8E",
    "youtubeId": "yDf9BRYy_8E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1436",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 13 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0tCApfjMIP8",
    "youtubeId": "0tCApfjMIP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1437",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 12 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XeV267kVDCs",
    "youtubeId": "XeV267kVDCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1438",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 11 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O2fMLMqGgx0",
    "youtubeId": "O2fMLMqGgx0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1439",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 10 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wzs-A3DCqcQ",
    "youtubeId": "Wzs-A3DCqcQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1440",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 9 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rdPQh73R90w",
    "youtubeId": "rdPQh73R90w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1441",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 7 & 8 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6b1dLD9oj8I",
    "youtubeId": "6b1dLD9oj8I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1442",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 6 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WiA0Mq1yLp0",
    "youtubeId": "WiA0Mq1yLp0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1443",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 5 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wgnRkvnpgus",
    "youtubeId": "wgnRkvnpgus",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1444",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 4 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-YT2yp-8XGU",
    "youtubeId": "-YT2yp-8XGU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1445",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 3 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lXu_AJ06llU",
    "youtubeId": "lXu_AJ06llU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1446",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 2 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PumPoYlqKjY",
    "youtubeId": "PumPoYlqKjY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1447",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 52 Ayat 1 Surah Tur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J1uDBjzO2Ow",
    "youtubeId": "J1uDBjzO2Ow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1448",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 60 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KwMbMtuCW5A",
    "youtubeId": "KwMbMtuCW5A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1449",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 59 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3gq3BUVs24E",
    "youtubeId": "3gq3BUVs24E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1450",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 58 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ATqxne-eHcg",
    "youtubeId": "ATqxne-eHcg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1451",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 57 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1Lzrumvo8O8",
    "youtubeId": "1Lzrumvo8O8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1452",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 56 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dAh9STZpi0Y",
    "youtubeId": "dAh9STZpi0Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1453",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 55 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PSuU7hUtiXk",
    "youtubeId": "PSuU7hUtiXk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1454",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 54 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GSU12Ey65Uk",
    "youtubeId": "GSU12Ey65Uk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1455",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 53 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oHNtIlh0y6I",
    "youtubeId": "oHNtIlh0y6I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1456",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 52 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zayU4nPc_Rk",
    "youtubeId": "zayU4nPc_Rk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1457",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 51 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xVD5ffjyoBk",
    "youtubeId": "xVD5ffjyoBk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1458",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 50 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-itPMv7fDVk",
    "youtubeId": "-itPMv7fDVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1459",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 49 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kU6v3u-WXvI",
    "youtubeId": "kU6v3u-WXvI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1460",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 48 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OLjJ3D9HR9M",
    "youtubeId": "OLjJ3D9HR9M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1461",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 47 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kFX1h9JIPkw",
    "youtubeId": "kFX1h9JIPkw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1462",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 46 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WlkVcfyO2eo",
    "youtubeId": "WlkVcfyO2eo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1463",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 45 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/762B8tU_XO0",
    "youtubeId": "762B8tU_XO0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1464",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 44 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k1O4pLnSZoo",
    "youtubeId": "k1O4pLnSZoo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1465",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 43 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H9_kSAXtJjA",
    "youtubeId": "H9_kSAXtJjA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1466",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 42 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4vO322UtQ1U",
    "youtubeId": "4vO322UtQ1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1467",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 41 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GvQPJuZ9fpc",
    "youtubeId": "GvQPJuZ9fpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1468",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 40 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AZWUn0IdAYQ",
    "youtubeId": "AZWUn0IdAYQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1469",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 39 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NXVZc-nw__A",
    "youtubeId": "NXVZc-nw__A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1470",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 38 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/peO4W7uBnjM",
    "youtubeId": "peO4W7uBnjM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1471",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 37 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/svI2vo6eGZQ",
    "youtubeId": "svI2vo6eGZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1472",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 35 & 36 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bwB8LMLQf4A",
    "youtubeId": "bwB8LMLQf4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1473",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 34 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PkA85rgmLvk",
    "youtubeId": "PkA85rgmLvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1474",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 32 & 33 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NFYiCPACQJk",
    "youtubeId": "NFYiCPACQJk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1475",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 31 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/848o_fIbQ40",
    "youtubeId": "848o_fIbQ40",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1476",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 30 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T3gO_Pe7UuA",
    "youtubeId": "T3gO_Pe7UuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1477",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 29 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c91zxdxG6dc",
    "youtubeId": "c91zxdxG6dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1478",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 28 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HfXd0cJdW8g",
    "youtubeId": "HfXd0cJdW8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1479",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 27 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2K9b_DInaIM",
    "youtubeId": "2K9b_DInaIM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1480",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 26 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wWS4ZQVqdn0",
    "youtubeId": "wWS4ZQVqdn0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1481",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 25 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gJ9wmdfywik",
    "youtubeId": "gJ9wmdfywik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1482",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 24 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lQ20JPqYwUI",
    "youtubeId": "lQ20JPqYwUI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1483",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 23 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3PyFR_7zgcI",
    "youtubeId": "3PyFR_7zgcI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1484",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 22 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/saep6W1BXxA",
    "youtubeId": "saep6W1BXxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1485",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 21 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5LMm3KP4UYo",
    "youtubeId": "5LMm3KP4UYo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1486",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 20 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-U0B6UV8ndQ",
    "youtubeId": "-U0B6UV8ndQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1487",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 19 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ar4j8xCiGhQ",
    "youtubeId": "Ar4j8xCiGhQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1488",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 18 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Foq8HNwNiwI",
    "youtubeId": "Foq8HNwNiwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1489",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 17 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ANLcXRkUe3E",
    "youtubeId": "ANLcXRkUe3E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1490",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 16 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bdWo3P9d13s",
    "youtubeId": "bdWo3P9d13s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1491",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 15 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wbZZ_zW0kLQ",
    "youtubeId": "wbZZ_zW0kLQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1492",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 14 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U36NRjglFvc",
    "youtubeId": "U36NRjglFvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1493",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 13 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7BFQj4FzVnQ",
    "youtubeId": "7BFQj4FzVnQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1494",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 12 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qt5p-OVCqvk",
    "youtubeId": "qt5p-OVCqvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1495",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 11 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/urFWTooGFok",
    "youtubeId": "urFWTooGFok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1496",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 10 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S5YLOr7pndo",
    "youtubeId": "S5YLOr7pndo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1497",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 9 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PcAeiCDM16Q",
    "youtubeId": "PcAeiCDM16Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1498",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 8 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yc9lV9lCfMA",
    "youtubeId": "Yc9lV9lCfMA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1499",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 7 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7_PQplRGlKQ",
    "youtubeId": "7_PQplRGlKQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1500",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 5 & 6 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Aj5l5DxXYE",
    "youtubeId": "3Aj5l5DxXYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1501",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 4 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0OxiHhyUnS8",
    "youtubeId": "0OxiHhyUnS8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1502",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 3 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GMYeiEvJlWY",
    "youtubeId": "GMYeiEvJlWY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1503",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 51 Ayat 1 & 2 Surah Dhariyat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wImAjAo8SKM",
    "youtubeId": "wImAjAo8SKM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1504",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 45 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d3psU7tiV8A",
    "youtubeId": "d3psU7tiV8A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1505",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 44 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JlbLvsUAIx8",
    "youtubeId": "JlbLvsUAIx8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1506",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 43 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UdpykC9vztY",
    "youtubeId": "UdpykC9vztY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1507",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 42 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LjiNBfhwX5E",
    "youtubeId": "LjiNBfhwX5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1508",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 41 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r_aOchqj3jQ",
    "youtubeId": "r_aOchqj3jQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1509",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 40 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DZejgZMPwGI",
    "youtubeId": "DZejgZMPwGI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1510",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 39 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UzyhvIk2wYI",
    "youtubeId": "UzyhvIk2wYI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1511",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 38 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DM32EKiln7Q",
    "youtubeId": "DM32EKiln7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1512",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 37 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iTyiaPiovOg",
    "youtubeId": "iTyiaPiovOg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1513",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 36 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hF0BrouPSdE",
    "youtubeId": "hF0BrouPSdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1514",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 35 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BpgZW6JwMjs",
    "youtubeId": "BpgZW6JwMjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1515",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 34 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LbHIP4CYdYs",
    "youtubeId": "LbHIP4CYdYs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1516",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 33 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lqlPicLBBRA",
    "youtubeId": "lqlPicLBBRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1517",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 32 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bcV7lXMnwqQ",
    "youtubeId": "bcV7lXMnwqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1518",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 31 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3QnoAaWmaHQ",
    "youtubeId": "3QnoAaWmaHQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1519",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 30 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PGi2H814GDs",
    "youtubeId": "PGi2H814GDs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1520",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 29 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0fw5oQDsrRQ",
    "youtubeId": "0fw5oQDsrRQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1521",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 28 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ocfjjx7eCtE",
    "youtubeId": "Ocfjjx7eCtE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1522",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 27 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3wEp2ZKreQc",
    "youtubeId": "3wEp2ZKreQc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1523",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 26 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DUyzDFALKEk",
    "youtubeId": "DUyzDFALKEk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1524",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 25 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sBXA6g2QIAo",
    "youtubeId": "sBXA6g2QIAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1525",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 24 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tK_KDEcUfWE",
    "youtubeId": "tK_KDEcUfWE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1526",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 23 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ApMlZtwFzgg",
    "youtubeId": "ApMlZtwFzgg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1527",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 22 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bYr4w1qXF00",
    "youtubeId": "bYr4w1qXF00",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1528",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 21 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TcZKoL7OTE0",
    "youtubeId": "TcZKoL7OTE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1529",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 20 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/26Ii4EQgeQM",
    "youtubeId": "26Ii4EQgeQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1530",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 19 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qb7TnQ5s3HY",
    "youtubeId": "qb7TnQ5s3HY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1531",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 18 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kt7X1btS0dE",
    "youtubeId": "kt7X1btS0dE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1532",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 17 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/myQnaEvWFc8",
    "youtubeId": "myQnaEvWFc8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1533",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 16 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cCRt4xmh-vU",
    "youtubeId": "cCRt4xmh-vU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1534",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 15 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KiGEb4THTFE",
    "youtubeId": "KiGEb4THTFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1535",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 12 - 14 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hR1s_Vzu_fY",
    "youtubeId": "hR1s_Vzu_fY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1536",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 11 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iiwh5xEDreE",
    "youtubeId": "iiwh5xEDreE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1537",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 10 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0WFmkUMFtzY",
    "youtubeId": "0WFmkUMFtzY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1538",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 9 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oyrF8pM78R8",
    "youtubeId": "oyrF8pM78R8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1539",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 7 & 8 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lD9iISg5MJY",
    "youtubeId": "lD9iISg5MJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1540",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 6 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FIi241MyUDc",
    "youtubeId": "FIi241MyUDc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1541",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 5 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/me4cijGQQEc",
    "youtubeId": "me4cijGQQEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1542",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 4 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yIaGI06trL0",
    "youtubeId": "yIaGI06trL0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1543",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 3 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QUUtlhrryBk",
    "youtubeId": "QUUtlhrryBk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1544",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 2 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wWeg8LZEeJI",
    "youtubeId": "wWeg8LZEeJI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1545",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 50 Ayat 1 Surah Qaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9ozeqYfTEqk",
    "youtubeId": "9ozeqYfTEqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1546",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 18 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ha0xrWf76K8",
    "youtubeId": "Ha0xrWf76K8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1547",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 17 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d7rAJKSMRpQ",
    "youtubeId": "d7rAJKSMRpQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1548",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 16 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/61vkGVLR2t8",
    "youtubeId": "61vkGVLR2t8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1549",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 15 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bq6NqGwh7aA",
    "youtubeId": "Bq6NqGwh7aA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1550",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 14 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RVhAPNBrcsY",
    "youtubeId": "RVhAPNBrcsY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1551",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 13 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0MQSXr3AQUY",
    "youtubeId": "0MQSXr3AQUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1552",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 12 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B8tjJbVKrHc",
    "youtubeId": "B8tjJbVKrHc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1553",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 11 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tc9s8g6XQKM",
    "youtubeId": "Tc9s8g6XQKM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1554",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 10 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SkmvEsQnTOM",
    "youtubeId": "SkmvEsQnTOM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1555",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 9 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9O9m-Kp7okw",
    "youtubeId": "9O9m-Kp7okw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1556",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 8 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IwcfxczS8PU",
    "youtubeId": "IwcfxczS8PU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1557",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 7 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EWn_5ua-uRs",
    "youtubeId": "EWn_5ua-uRs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1558",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 6 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BSrGCtykOq8",
    "youtubeId": "BSrGCtykOq8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1559",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 5 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EcfHuGEh1SU",
    "youtubeId": "EcfHuGEh1SU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1560",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 4 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_11dm8jXO7k",
    "youtubeId": "_11dm8jXO7k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1561",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 3 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ptbuouh0Ii4",
    "youtubeId": "ptbuouh0Ii4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1562",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 2 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rLIN9p_t9vI",
    "youtubeId": "rLIN9p_t9vI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1563",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 49 Ayat 1 Surah Hujurat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mXx5a1AD9Pg",
    "youtubeId": "mXx5a1AD9Pg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1564",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 29 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oiLrJ7oQQsA",
    "youtubeId": "oiLrJ7oQQsA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1565",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 28 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/il9D0LBIRjI",
    "youtubeId": "il9D0LBIRjI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1566",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 27 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qrdR2zlhodI",
    "youtubeId": "qrdR2zlhodI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1567",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 26 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E9PIm0Y8Bfk",
    "youtubeId": "E9PIm0Y8Bfk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1568",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 25 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KO-3Bkq5Q8M",
    "youtubeId": "KO-3Bkq5Q8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1569",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 24 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1nAn2xtkTzs",
    "youtubeId": "1nAn2xtkTzs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1570",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 23 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N9477cnD_yI",
    "youtubeId": "N9477cnD_yI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1571",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 22 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BBk8S6tcg14",
    "youtubeId": "BBk8S6tcg14",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1572",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 21 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NaTzPmzVwig",
    "youtubeId": "NaTzPmzVwig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1573",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 20 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wiUtFIlyh1I",
    "youtubeId": "wiUtFIlyh1I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1574",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 19 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Udy1yLByONg",
    "youtubeId": "Udy1yLByONg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1575",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 18 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r6GBebNlxHY",
    "youtubeId": "r6GBebNlxHY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1576",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 17 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q_yEUkAX6u8",
    "youtubeId": "q_yEUkAX6u8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1577",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 16 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B9vgjbuMrvc",
    "youtubeId": "B9vgjbuMrvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1578",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 15 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YTppywacyuM",
    "youtubeId": "YTppywacyuM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1579",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 14 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yz6txzOsSUA",
    "youtubeId": "Yz6txzOsSUA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1580",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 13 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4yQV_ogN3Zs",
    "youtubeId": "4yQV_ogN3Zs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1581",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 12 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w1AN219xJdw",
    "youtubeId": "w1AN219xJdw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1582",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 11 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3KYWD65pgQg",
    "youtubeId": "3KYWD65pgQg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1583",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 10 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LGcDe1YG8uE",
    "youtubeId": "LGcDe1YG8uE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1584",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 9 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bHYcfY_tXyc",
    "youtubeId": "bHYcfY_tXyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1585",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 8 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SmwGHovsOf4",
    "youtubeId": "SmwGHovsOf4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1586",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 7 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-n9qBPzLBNg",
    "youtubeId": "-n9qBPzLBNg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1587",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 6 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XZJ4KzGbg-4",
    "youtubeId": "XZJ4KzGbg-4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1588",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 5 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jqEfnYbvH3c",
    "youtubeId": "jqEfnYbvH3c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1589",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 4 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G5BdPm6f32E",
    "youtubeId": "G5BdPm6f32E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1590",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 3 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rzQ2oClItuk",
    "youtubeId": "rzQ2oClItuk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1591",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 2 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0onQKVWiqv0",
    "youtubeId": "0onQKVWiqv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1592",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 48 Ayat 1 Surah Fath Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5K5wlBnJaCk",
    "youtubeId": "5K5wlBnJaCk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1593",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 38 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M2_6CfTK0VY",
    "youtubeId": "M2_6CfTK0VY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1594",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 37 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XgROCWOGmgQ",
    "youtubeId": "XgROCWOGmgQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1595",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 36 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4fYyG9fjw9c",
    "youtubeId": "4fYyG9fjw9c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1596",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 35 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FxLzm2JLYi0",
    "youtubeId": "FxLzm2JLYi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1597",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 34 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-n_3629fTzk",
    "youtubeId": "-n_3629fTzk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1598",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 33 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yVyfVza8j6g",
    "youtubeId": "yVyfVza8j6g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1599",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 32 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9mcfmwM9S6s",
    "youtubeId": "9mcfmwM9S6s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1600",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 31 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IivZKqdxM_c",
    "youtubeId": "IivZKqdxM_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1601",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 30 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2-Z7VEBJaww",
    "youtubeId": "2-Z7VEBJaww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1602",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 29 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X9EhWE3Bd8Q",
    "youtubeId": "X9EhWE3Bd8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1603",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 28 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AKiey1-Ff0s",
    "youtubeId": "AKiey1-Ff0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1604",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 27 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FKxbgf2QG5o",
    "youtubeId": "FKxbgf2QG5o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1605",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 26 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/emAVCP-R9EQ",
    "youtubeId": "emAVCP-R9EQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1606",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 25 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ja-FT9o_7p0",
    "youtubeId": "ja-FT9o_7p0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1607",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 24 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Td5dik3kQJo",
    "youtubeId": "Td5dik3kQJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1608",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 23 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LaLH3Fr5D78",
    "youtubeId": "LaLH3Fr5D78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1609",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 22 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ippdhoupJWM",
    "youtubeId": "ippdhoupJWM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1610",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 21 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eoYKFjvkGCI",
    "youtubeId": "eoYKFjvkGCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1611",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 20 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4Hx6kCskTSo",
    "youtubeId": "4Hx6kCskTSo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1612",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 19 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_GZf25bkvBE",
    "youtubeId": "_GZf25bkvBE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1613",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 18 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fdbFU0KZBLE",
    "youtubeId": "fdbFU0KZBLE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1614",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 17 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B2itejmm8yY",
    "youtubeId": "B2itejmm8yY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1615",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 16 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lk1yQY0ypUY",
    "youtubeId": "lk1yQY0ypUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1616",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 15 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rkCrgjToepg",
    "youtubeId": "rkCrgjToepg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1617",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 14 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AAmXzb-5954",
    "youtubeId": "AAmXzb-5954",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1618",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 13 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zrqOODs6EJc",
    "youtubeId": "zrqOODs6EJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1619",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 12 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ArgRf1Xkas4",
    "youtubeId": "ArgRf1Xkas4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1620",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 11 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eZO59_L8lx0",
    "youtubeId": "eZO59_L8lx0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1621",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 10 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UFsfqI1gJTM",
    "youtubeId": "UFsfqI1gJTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1622",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 9 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ByjrAdgsw_o",
    "youtubeId": "ByjrAdgsw_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1623",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 8 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-nqI_whdmYo",
    "youtubeId": "-nqI_whdmYo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1624",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 7 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1MnPSEtaOTQ",
    "youtubeId": "1MnPSEtaOTQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1625",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 6 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b2Z_yo9xKUA",
    "youtubeId": "b2Z_yo9xKUA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1626",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 5 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n8RjRfJzFo0",
    "youtubeId": "n8RjRfJzFo0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1627",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 4 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bjsrh1gdPaE",
    "youtubeId": "Bjsrh1gdPaE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1628",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 3 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6_VsM321o0w",
    "youtubeId": "6_VsM321o0w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1629",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 2 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/huSAKD5SbtI",
    "youtubeId": "huSAKD5SbtI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1630",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 47 Ayat 1 Surah Muhammed Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pAvVppuVVbA",
    "youtubeId": "pAvVppuVVbA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1631",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 35 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rFVz1PRjlwA",
    "youtubeId": "rFVz1PRjlwA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1632",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 34 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TFpLmnI9ix8",
    "youtubeId": "TFpLmnI9ix8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1633",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 33 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/skeQI8u67LQ",
    "youtubeId": "skeQI8u67LQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1634",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 32 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u2BAotSOLXg",
    "youtubeId": "u2BAotSOLXg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1635",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 31 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MbpC5sQ4eEo",
    "youtubeId": "MbpC5sQ4eEo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1636",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 30 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/25fdQ0aFX3A",
    "youtubeId": "25fdQ0aFX3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1637",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 29 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZNtHv6d__Z8",
    "youtubeId": "ZNtHv6d__Z8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1638",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 28 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NpaKHcE_O64",
    "youtubeId": "NpaKHcE_O64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1639",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 27 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/szbJzG2ol_w",
    "youtubeId": "szbJzG2ol_w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1640",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 26 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wh8HrNOXPDI",
    "youtubeId": "wh8HrNOXPDI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1641",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 25 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/59j82jMZR0Q",
    "youtubeId": "59j82jMZR0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1642",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 24 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LVm1JyHyhBM",
    "youtubeId": "LVm1JyHyhBM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1643",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 23 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MZR497agxdQ",
    "youtubeId": "MZR497agxdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1644",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 22 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qh1WDxCW8Kc",
    "youtubeId": "Qh1WDxCW8Kc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1645",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 21 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZHx3agmTCDA",
    "youtubeId": "ZHx3agmTCDA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1646",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 20 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/851UyVAstkQ",
    "youtubeId": "851UyVAstkQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1647",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 19 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6AwsFb9Ly8I",
    "youtubeId": "6AwsFb9Ly8I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1648",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 18 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h-NLksNNRe4",
    "youtubeId": "h-NLksNNRe4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1649",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 17 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nmXalCaMlME",
    "youtubeId": "nmXalCaMlME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1650",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 16 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ovyUTQz8ph0",
    "youtubeId": "ovyUTQz8ph0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1651",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 15 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-Nn0Km8f3w",
    "youtubeId": "F-Nn0Km8f3w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1652",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 14 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RavuRQxZwho",
    "youtubeId": "RavuRQxZwho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1653",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 13 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lSJEVA_hNBA",
    "youtubeId": "lSJEVA_hNBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1654",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 12 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5AnWuEUaAeQ",
    "youtubeId": "5AnWuEUaAeQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1655",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 11 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/khOF3kJM-E8",
    "youtubeId": "khOF3kJM-E8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1656",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 10 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2wpQ06Q-Ljs",
    "youtubeId": "2wpQ06Q-Ljs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1657",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 9 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sy5weoqFEB8",
    "youtubeId": "Sy5weoqFEB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1658",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 8 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9JzCeIt_A6Q",
    "youtubeId": "9JzCeIt_A6Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1659",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 7 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kHHjmHI2-JE",
    "youtubeId": "kHHjmHI2-JE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1660",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 6 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mg2cM4IdjEE",
    "youtubeId": "Mg2cM4IdjEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1661",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 5 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mrl5Q8c7Rug",
    "youtubeId": "mrl5Q8c7Rug",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1662",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 4 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zI487DzfWn0",
    "youtubeId": "zI487DzfWn0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1663",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 3 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qdpClZEgSkU",
    "youtubeId": "qdpClZEgSkU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1664",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 46 Ayat 1 & 2 Surah Ahqaf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pYiXwbtpC7Q",
    "youtubeId": "pYiXwbtpC7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1665",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 37 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RCm42K5XMe4",
    "youtubeId": "RCm42K5XMe4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1666",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 36 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IAjaUqf4-1w",
    "youtubeId": "IAjaUqf4-1w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1667",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 35 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e2AeVI3-0JM",
    "youtubeId": "e2AeVI3-0JM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1668",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 34 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-ESwrKUI960",
    "youtubeId": "-ESwrKUI960",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1669",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 33 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lND7tljjU_4",
    "youtubeId": "lND7tljjU_4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1670",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 32 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IxEbisqE0B8",
    "youtubeId": "IxEbisqE0B8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1671",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 31 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dQu3Qn7FW_Q",
    "youtubeId": "dQu3Qn7FW_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1672",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 30 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CTcoLaMH-yE",
    "youtubeId": "CTcoLaMH-yE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1673",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 29 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AS6HmWXOepg",
    "youtubeId": "AS6HmWXOepg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1674",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 28 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jx0aWFutWq0",
    "youtubeId": "Jx0aWFutWq0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1675",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 27 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U9eEWUC5S0M",
    "youtubeId": "U9eEWUC5S0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1676",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 26 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eFv9OxHKnr4",
    "youtubeId": "eFv9OxHKnr4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1677",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 25 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oG5LhLs0QY8",
    "youtubeId": "oG5LhLs0QY8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1678",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 24 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fuVVhTAo6Xs",
    "youtubeId": "fuVVhTAo6Xs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1679",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 23 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ro7ooSTIN8M",
    "youtubeId": "ro7ooSTIN8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1680",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 22 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Y-E7cLW0Zc",
    "youtubeId": "9Y-E7cLW0Zc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1681",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 21 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XY09t-5xGdU",
    "youtubeId": "XY09t-5xGdU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1682",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 20 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jl8CM706YEM",
    "youtubeId": "jl8CM706YEM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1683",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 19 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PTdoBtrfe38",
    "youtubeId": "PTdoBtrfe38",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1684",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 18 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZK3vJfiQ2lc",
    "youtubeId": "ZK3vJfiQ2lc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1685",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 17 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oeaNtGEWYIs",
    "youtubeId": "oeaNtGEWYIs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1686",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 16 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9rJXTxK8kXM",
    "youtubeId": "9rJXTxK8kXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1687",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 15 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rwXZ78M1CQU",
    "youtubeId": "rwXZ78M1CQU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1688",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 14 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SRUQ7FLnnU0",
    "youtubeId": "SRUQ7FLnnU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1689",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 13 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QZZCgwvL7n8",
    "youtubeId": "QZZCgwvL7n8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1690",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 12 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ymwCzDyZBaY",
    "youtubeId": "ymwCzDyZBaY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1691",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 11 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gqL3PpSipsI",
    "youtubeId": "gqL3PpSipsI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1692",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 10 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/16wZxCapzzA",
    "youtubeId": "16wZxCapzzA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1693",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 9 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RhVZ4s-Q_r0",
    "youtubeId": "RhVZ4s-Q_r0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1694",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 8 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tl-JfhAcVFs",
    "youtubeId": "Tl-JfhAcVFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1695",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 7 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XYviiqGYs1c",
    "youtubeId": "XYviiqGYs1c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1696",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 6 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dnr7AT45FGk",
    "youtubeId": "Dnr7AT45FGk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1697",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 5 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SA2zsFUoBzU",
    "youtubeId": "SA2zsFUoBzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1698",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 4 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pyw5pWFrAiE",
    "youtubeId": "pyw5pWFrAiE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1699",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 3 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X9BpluQNsFc",
    "youtubeId": "X9BpluQNsFc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1700",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 45 Ayat 1 & 2 Surah Jathiyah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tm1Wn_ZqVFQ",
    "youtubeId": "tm1Wn_ZqVFQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1701",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 59 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jTYi8UPM5Mw",
    "youtubeId": "jTYi8UPM5Mw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1702",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 58 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CWt2mB4Q3EQ",
    "youtubeId": "CWt2mB4Q3EQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1703",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 57 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sWuFSuyL-Ig",
    "youtubeId": "sWuFSuyL-Ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1704",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 56 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xp3SDzMmkXQ",
    "youtubeId": "Xp3SDzMmkXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1705",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 55 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KtiaOpWK4qA",
    "youtubeId": "KtiaOpWK4qA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1706",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 54 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z7cGb4DNdGo",
    "youtubeId": "z7cGb4DNdGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1707",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 53 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Hv7YDLAEVY",
    "youtubeId": "5Hv7YDLAEVY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1708",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 52 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UpA_E3aDIzk",
    "youtubeId": "UpA_E3aDIzk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1709",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 51 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/REUMKGA0U8g",
    "youtubeId": "REUMKGA0U8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1710",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 50 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tkWeYlzZxIY",
    "youtubeId": "tkWeYlzZxIY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1711",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 49 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0nt0r42_GmE",
    "youtubeId": "0nt0r42_GmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1712",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 48 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-HFP46EgUSE",
    "youtubeId": "-HFP46EgUSE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1713",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 47 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g_-fQFqbmMk",
    "youtubeId": "g_-fQFqbmMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1714",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 45 & 46 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eY-hILNis3U",
    "youtubeId": "eY-hILNis3U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1715",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 43 & 44 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zz-Tc0UW_WA",
    "youtubeId": "Zz-Tc0UW_WA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1716",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 42 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z1YmGpuuQ9M",
    "youtubeId": "z1YmGpuuQ9M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1717",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 41 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8YY-jngNyUo",
    "youtubeId": "8YY-jngNyUo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1718",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 40 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HfSF_8iJvV8",
    "youtubeId": "HfSF_8iJvV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1719",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 39 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/owfmMePI8vw",
    "youtubeId": "owfmMePI8vw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1720",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 38 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qMFRLkRvIzs",
    "youtubeId": "qMFRLkRvIzs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1721",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 37 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HiBTL925qn8",
    "youtubeId": "HiBTL925qn8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1722",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 36 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ok9Ua8_yEWA",
    "youtubeId": "Ok9Ua8_yEWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1723",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 34 & 35 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2OFyggDTfp0",
    "youtubeId": "2OFyggDTfp0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1724",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 33 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pqLeJbLU15I",
    "youtubeId": "pqLeJbLU15I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1725",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 32 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MZ22iYhjrqc",
    "youtubeId": "MZ22iYhjrqc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1726",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 31 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wWBJJsZu3IM",
    "youtubeId": "wWBJJsZu3IM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1727",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 30 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rbyIWMutsIE",
    "youtubeId": "rbyIWMutsIE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1728",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 29 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Aq2A9LCQW30",
    "youtubeId": "Aq2A9LCQW30",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1729",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 28 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KbLojcprpmY",
    "youtubeId": "KbLojcprpmY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1730",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 27 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qUXnRRqENhg",
    "youtubeId": "qUXnRRqENhg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1731",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 26 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AASGrGcAD5c",
    "youtubeId": "AASGrGcAD5c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1732",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 25 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/467vHzr3rVc",
    "youtubeId": "467vHzr3rVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1733",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 24 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k2b6YArX3aA",
    "youtubeId": "k2b6YArX3aA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1734",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 23 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qku9g_FYzzw",
    "youtubeId": "Qku9g_FYzzw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1735",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 22 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oVzzZCEOoJ4",
    "youtubeId": "oVzzZCEOoJ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1736",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 21 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R9NQgVKyvEg",
    "youtubeId": "R9NQgVKyvEg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1737",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 20 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_f_Jt1j4nP8",
    "youtubeId": "_f_Jt1j4nP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1738",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 19 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CQggA7qU4FA",
    "youtubeId": "CQggA7qU4FA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1739",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 18 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a3jpjcTb_zw",
    "youtubeId": "a3jpjcTb_zw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1740",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 17 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qEVd0Cb-PEo",
    "youtubeId": "qEVd0Cb-PEo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1741",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 16 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2igGiHiZOYc",
    "youtubeId": "2igGiHiZOYc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1742",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 15 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_v45Oq9W75M",
    "youtubeId": "_v45Oq9W75M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1743",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 14 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pETG8yrpnmE",
    "youtubeId": "pETG8yrpnmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1744",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 13 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FmfF9ZjtNEY",
    "youtubeId": "FmfF9ZjtNEY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1745",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 12 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yGOGC4uoVys",
    "youtubeId": "yGOGC4uoVys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1746",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 11 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q5VehLNies8",
    "youtubeId": "Q5VehLNies8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1747",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 10 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p6gJ0c_C7y8",
    "youtubeId": "p6gJ0c_C7y8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1748",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 9 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n3kFM9YkU0I",
    "youtubeId": "n3kFM9YkU0I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1749",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 8 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/21IA-aMcBF8",
    "youtubeId": "21IA-aMcBF8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1750",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 7 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jjdJ35p2g7Y",
    "youtubeId": "jjdJ35p2g7Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1751",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 6 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dJiqjWtxR7o",
    "youtubeId": "dJiqjWtxR7o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1752",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 5 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/626TomZ_fzg",
    "youtubeId": "626TomZ_fzg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1753",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 4 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BM09xoQP4VA",
    "youtubeId": "BM09xoQP4VA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1754",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 3 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PrdG1sLcAQI",
    "youtubeId": "PrdG1sLcAQI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1755",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 44 Ayat 1 & 2 Surah Dukhan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oCVhDOsanOY",
    "youtubeId": "oCVhDOsanOY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1756",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 89 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OKhiAcF1fDA",
    "youtubeId": "OKhiAcF1fDA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1757",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 88 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jhYKE9IYXYg",
    "youtubeId": "jhYKE9IYXYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1758",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 87 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4rq5qOms0Pk",
    "youtubeId": "4rq5qOms0Pk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1759",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 86 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u6ghoV1EU2g",
    "youtubeId": "u6ghoV1EU2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1760",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 85 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lunLUHHNa2Y",
    "youtubeId": "lunLUHHNa2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1761",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 84 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dzFBK9gzTCM",
    "youtubeId": "dzFBK9gzTCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1762",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 83 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hxInhepuxG8",
    "youtubeId": "hxInhepuxG8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1763",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 82 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i2gE79VX41U",
    "youtubeId": "i2gE79VX41U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1764",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 81 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cBI5mfRVHaQ",
    "youtubeId": "cBI5mfRVHaQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1765",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 80 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-SNRDaCGzdQ",
    "youtubeId": "-SNRDaCGzdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1766",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 79 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8Z-VdmeyFZA",
    "youtubeId": "8Z-VdmeyFZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1767",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 78 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ey0CRvrH2mM",
    "youtubeId": "ey0CRvrH2mM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1768",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 77 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vGbEMNypq9c",
    "youtubeId": "vGbEMNypq9c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1769",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 76 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wtRdeb565p8",
    "youtubeId": "wtRdeb565p8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1770",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 75 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3fLZ_VWKZK0",
    "youtubeId": "3fLZ_VWKZK0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1771",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 74 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/klBjTjRKhyY",
    "youtubeId": "klBjTjRKhyY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1772",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 73 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HbZFBXeGxR4",
    "youtubeId": "HbZFBXeGxR4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1773",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 72 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HifdHw36t8Q",
    "youtubeId": "HifdHw36t8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1774",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 71 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9WkaiUgcMWw",
    "youtubeId": "9WkaiUgcMWw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1775",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 70 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KWH3ECZZcYY",
    "youtubeId": "KWH3ECZZcYY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1776",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 69 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VngIuekSnZU",
    "youtubeId": "VngIuekSnZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1777",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 68 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/amg6LLvDZVQ",
    "youtubeId": "amg6LLvDZVQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1778",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 67 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yVq5Qa16ONo",
    "youtubeId": "yVq5Qa16ONo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1779",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 66 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TvXegAPdoog",
    "youtubeId": "TvXegAPdoog",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1780",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 65 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t_hACSGjOhU",
    "youtubeId": "t_hACSGjOhU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1781",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 64 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p3Ogr4J_u6g",
    "youtubeId": "p3Ogr4J_u6g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1782",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 63 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EJUrOcC_J-k",
    "youtubeId": "EJUrOcC_J-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1783",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 62 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q97pmt2yKwI",
    "youtubeId": "q97pmt2yKwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1784",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 61 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kjXHZYbvM3k",
    "youtubeId": "kjXHZYbvM3k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1785",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 60 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HrLX1EOvyiI",
    "youtubeId": "HrLX1EOvyiI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1786",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 59 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ovAT1Ujx4xU",
    "youtubeId": "ovAT1Ujx4xU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1787",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 58 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ev5TOIC1Nqc",
    "youtubeId": "ev5TOIC1Nqc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1788",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 57 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/slrFcHvGJcU",
    "youtubeId": "slrFcHvGJcU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1789",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 56 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OgFwpqFsv4A",
    "youtubeId": "OgFwpqFsv4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1790",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 55 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fcDLY9LhLvo",
    "youtubeId": "fcDLY9LhLvo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1791",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 54 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-J9L3l4kf7k",
    "youtubeId": "-J9L3l4kf7k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1792",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 53 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sVmdAFxQLfU",
    "youtubeId": "sVmdAFxQLfU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1793",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 52 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2jcz9dgN2I4",
    "youtubeId": "2jcz9dgN2I4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1794",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 51 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vxK7TRYMGao",
    "youtubeId": "vxK7TRYMGao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1795",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 50 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/taoTTJp7e7s",
    "youtubeId": "taoTTJp7e7s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1796",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 49 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uza1V0fATO8",
    "youtubeId": "Uza1V0fATO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1797",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 48 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VWlkq9tOhAM",
    "youtubeId": "VWlkq9tOhAM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1798",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 47 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LC-9Zbytw7c",
    "youtubeId": "LC-9Zbytw7c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1799",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 46 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ejMOPOk13sk",
    "youtubeId": "ejMOPOk13sk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1800",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 45 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SRBq0pZKPjM",
    "youtubeId": "SRBq0pZKPjM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1801",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 44 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wkhmegk4YcE",
    "youtubeId": "wkhmegk4YcE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1802",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 43 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/grGJ17npU3k",
    "youtubeId": "grGJ17npU3k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1803",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 42 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sinyNrWKBAs",
    "youtubeId": "sinyNrWKBAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1804",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 41 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YHNnbXvL4XA",
    "youtubeId": "YHNnbXvL4XA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1805",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 39 & 40 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H0NZrML9szE",
    "youtubeId": "H0NZrML9szE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1806",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 38 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iRe92vNI4OQ",
    "youtubeId": "iRe92vNI4OQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1807",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 37 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HV9_yVf6nU8",
    "youtubeId": "HV9_yVf6nU8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1808",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 36 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bfcQAJABews",
    "youtubeId": "bfcQAJABews",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1809",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 35 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bxP_RhM1lkA",
    "youtubeId": "bxP_RhM1lkA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1810",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 34 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ob5BqMkrO8o",
    "youtubeId": "ob5BqMkrO8o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1811",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 33 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MqtL25GFakM",
    "youtubeId": "MqtL25GFakM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1812",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 32 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i7_CtS6Lz9w",
    "youtubeId": "i7_CtS6Lz9w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1813",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 31 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CEhqDKNt0oY",
    "youtubeId": "CEhqDKNt0oY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1814",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 30 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dk1kCyxQmFo",
    "youtubeId": "Dk1kCyxQmFo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1815",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 29 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RYCBdJYpLts",
    "youtubeId": "RYCBdJYpLts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1816",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 28 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BS2zWHXGyeo",
    "youtubeId": "BS2zWHXGyeo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1817",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 27 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sudm6KmO_3A",
    "youtubeId": "Sudm6KmO_3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1818",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 26 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n6iRjn2vVcY",
    "youtubeId": "n6iRjn2vVcY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1819",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 25 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0VELntKoyKg",
    "youtubeId": "0VELntKoyKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1820",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 24 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KSoC1Egh_bM",
    "youtubeId": "KSoC1Egh_bM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1821",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 23 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gulLoGWV2TY",
    "youtubeId": "gulLoGWV2TY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1822",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 22 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KlQ2zZmDGdQ",
    "youtubeId": "KlQ2zZmDGdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1823",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 21 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eKyaXTQfoGI",
    "youtubeId": "eKyaXTQfoGI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1824",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 20 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/deQnmZtKN5w",
    "youtubeId": "deQnmZtKN5w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1825",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 19 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mlnBFKMYPTw",
    "youtubeId": "mlnBFKMYPTw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1826",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 18 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mfpFlcGRIgs",
    "youtubeId": "mfpFlcGRIgs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1827",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 17 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5eYqTNUGR9g",
    "youtubeId": "5eYqTNUGR9g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1828",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 16 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0EnyqtmCMTg",
    "youtubeId": "0EnyqtmCMTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1829",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 15 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iGp3F8wmSSg",
    "youtubeId": "iGp3F8wmSSg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1830",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 13 & 14 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SCpuuDPVNME",
    "youtubeId": "SCpuuDPVNME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1831",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 12 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/McIConKbzpw",
    "youtubeId": "McIConKbzpw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1832",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 11 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qORuaNTOOvo",
    "youtubeId": "qORuaNTOOvo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1833",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 10 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AaevcsQdwOs",
    "youtubeId": "AaevcsQdwOs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1834",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 9 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gZPUwoch8I0",
    "youtubeId": "gZPUwoch8I0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1835",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 8 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HC68pMbcyGc",
    "youtubeId": "HC68pMbcyGc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1836",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 7 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D97bfrAvraA",
    "youtubeId": "D97bfrAvraA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1837",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 6 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uMByTkhEtTg",
    "youtubeId": "uMByTkhEtTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1838",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 5 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Nf4LdH2IJ4",
    "youtubeId": "7Nf4LdH2IJ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1839",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 4 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d0zyP7kjFRM",
    "youtubeId": "d0zyP7kjFRM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1840",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 3 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1nG86VSDURU",
    "youtubeId": "1nG86VSDURU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1841",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 2 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u_-3rDn1jZA",
    "youtubeId": "u_-3rDn1jZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1842",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 43 Ayat 1 Surah Zukhruf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DDNyBLg0TN8",
    "youtubeId": "DDNyBLg0TN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1843",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 53 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yOFXm3CaLxE",
    "youtubeId": "yOFXm3CaLxE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1844",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 52 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OJaOmX7thKE",
    "youtubeId": "OJaOmX7thKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1845",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 51 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Jx7HdXMOlc",
    "youtubeId": "3Jx7HdXMOlc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1846",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 50 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rgtcAKlpbA8",
    "youtubeId": "rgtcAKlpbA8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1847",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 49 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Id7hSKMfRpo",
    "youtubeId": "Id7hSKMfRpo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1848",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 48 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uWvRguM9agE",
    "youtubeId": "uWvRguM9agE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1849",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 47 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5TxW45ZdGIk",
    "youtubeId": "5TxW45ZdGIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1850",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 46 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hEuC4tcqsOs",
    "youtubeId": "hEuC4tcqsOs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1851",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 45 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/41VtJoRzfF4",
    "youtubeId": "41VtJoRzfF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1852",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 44 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/heMYBdD8xxk",
    "youtubeId": "heMYBdD8xxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1853",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 43 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2_bGtAKuaog",
    "youtubeId": "2_bGtAKuaog",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1854",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 42 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IND8KMHMMzY",
    "youtubeId": "IND8KMHMMzY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1855",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 41 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BaluQftmjlc",
    "youtubeId": "BaluQftmjlc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1856",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 40 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eAqtdNId9P4",
    "youtubeId": "eAqtdNId9P4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1857",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 39 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ya4uaQ16KgU",
    "youtubeId": "ya4uaQ16KgU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1858",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 38 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QzczJ90jNpA",
    "youtubeId": "QzczJ90jNpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1859",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 37 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/99GJceowNjo",
    "youtubeId": "99GJceowNjo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1860",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 36 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lfNfqg509Dw",
    "youtubeId": "lfNfqg509Dw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1861",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 35 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vIvp8tQoUyQ",
    "youtubeId": "vIvp8tQoUyQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1862",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 34 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0LDINgfHgFg",
    "youtubeId": "0LDINgfHgFg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1863",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 33 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MA7c2v0lhB8",
    "youtubeId": "MA7c2v0lhB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1864",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 32 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lZ2C9Y4b3_Y",
    "youtubeId": "lZ2C9Y4b3_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1865",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 31 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X9G-EsYGveo",
    "youtubeId": "X9G-EsYGveo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1866",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 30 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/83FpASy3k9E",
    "youtubeId": "83FpASy3k9E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1867",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 29 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TsQ9Mm5HG0A",
    "youtubeId": "TsQ9Mm5HG0A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1868",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 28 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hOwI1eQilyI",
    "youtubeId": "hOwI1eQilyI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1869",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 27 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hv0ktjsSafw",
    "youtubeId": "hv0ktjsSafw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1870",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 26 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r8E3OtDmbNk",
    "youtubeId": "r8E3OtDmbNk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1871",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 25 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ddAfMk8iZMU",
    "youtubeId": "ddAfMk8iZMU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1872",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 24 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pSBij-qRhD0",
    "youtubeId": "pSBij-qRhD0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1873",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 23 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9p1tNzQ--7s",
    "youtubeId": "9p1tNzQ--7s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1874",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 22 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nkmwxm8P_Oc",
    "youtubeId": "nkmwxm8P_Oc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1875",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 21 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ihiv1RPxifs",
    "youtubeId": "ihiv1RPxifs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1876",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 20 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lm-ANa7bEhk",
    "youtubeId": "lm-ANa7bEhk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1877",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 19 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yZtbjVt5qXA",
    "youtubeId": "yZtbjVt5qXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1878",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 18 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hr3AyyymsTY",
    "youtubeId": "Hr3AyyymsTY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1879",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 17 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N0Oi5I0hd80",
    "youtubeId": "N0Oi5I0hd80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1880",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 16 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jiyjj54dXTY",
    "youtubeId": "jiyjj54dXTY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1881",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 15 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gRWxKC9ZKx4",
    "youtubeId": "gRWxKC9ZKx4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1882",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 14 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/att-beTwat4",
    "youtubeId": "att-beTwat4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1883",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 13 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VYsF7MzOeIw",
    "youtubeId": "VYsF7MzOeIw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1884",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 12 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1bWIzYJ3iMI",
    "youtubeId": "1bWIzYJ3iMI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1885",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 11 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/To5WRDCHzy0",
    "youtubeId": "To5WRDCHzy0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1886",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 10 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CF2bbJqzUAM",
    "youtubeId": "CF2bbJqzUAM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1887",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 9 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cdFw63EaAHo",
    "youtubeId": "cdFw63EaAHo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1888",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 8 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pegC2PJsNrQ",
    "youtubeId": "pegC2PJsNrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1889",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 7 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iteKTYLhJlA",
    "youtubeId": "iteKTYLhJlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1890",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 6 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bGMpRO5d0bo",
    "youtubeId": "bGMpRO5d0bo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1891",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 5 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k78B_cOsyxk",
    "youtubeId": "k78B_cOsyxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1892",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 4 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a858CrtD4GQ",
    "youtubeId": "a858CrtD4GQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1893",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 3 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hzmGt1o2b8Y",
    "youtubeId": "hzmGt1o2b8Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1894",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 42 Ayat 1 & 2 Surah Shura Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PpXjsdNOAmo",
    "youtubeId": "PpXjsdNOAmo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1895",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 54 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xH1B4NSnrBY",
    "youtubeId": "xH1B4NSnrBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1896",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 53 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3fWmybrLYbI",
    "youtubeId": "3fWmybrLYbI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1897",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 52 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Ks8MG6XfRk",
    "youtubeId": "3Ks8MG6XfRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1898",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 51 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L2BwTA-MV_8",
    "youtubeId": "L2BwTA-MV_8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1899",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 50 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Q-NZaulWHQ",
    "youtubeId": "-Q-NZaulWHQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1900",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 49 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0rnugztISBY",
    "youtubeId": "0rnugztISBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1901",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 48 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yJceHG5Wm2s",
    "youtubeId": "yJceHG5Wm2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1902",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 47 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G2cGNK3-RF8",
    "youtubeId": "G2cGNK3-RF8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1903",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 46 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BMtgTFlka9M",
    "youtubeId": "BMtgTFlka9M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1904",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 45 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VbBMigF3YT8",
    "youtubeId": "VbBMigF3YT8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1905",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 44 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-xXenoy3DqA",
    "youtubeId": "-xXenoy3DqA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1906",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 43 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bJkEGPEKvRU",
    "youtubeId": "bJkEGPEKvRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1907",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 42 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ItENSGMpdb4",
    "youtubeId": "ItENSGMpdb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1908",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 41 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tzZ2NaM0Hcg",
    "youtubeId": "tzZ2NaM0Hcg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1909",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 40 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0sTI9LG-NQw",
    "youtubeId": "0sTI9LG-NQw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1910",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 39 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KJeneHISITA",
    "youtubeId": "KJeneHISITA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1911",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 38 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SZgVKgeeDWk",
    "youtubeId": "SZgVKgeeDWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1912",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 37 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fJdLJ-f-wX4",
    "youtubeId": "fJdLJ-f-wX4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1913",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 36 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rlZ6hd3c400",
    "youtubeId": "rlZ6hd3c400",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1914",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 35 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OkzoXbsinm8",
    "youtubeId": "OkzoXbsinm8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1915",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 34 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BHFcaYCUseQ",
    "youtubeId": "BHFcaYCUseQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1916",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 33 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eSaCouVOvOc",
    "youtubeId": "eSaCouVOvOc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1917",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 32 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nzR4hfQyOVE",
    "youtubeId": "nzR4hfQyOVE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1918",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 31 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x_DcfbpX8sQ",
    "youtubeId": "x_DcfbpX8sQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1919",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 30 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YAhTSpq3yvw",
    "youtubeId": "YAhTSpq3yvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1920",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 29 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qd5ZUfPsdCs",
    "youtubeId": "qd5ZUfPsdCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1921",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 28 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oAXgEMMycbc",
    "youtubeId": "oAXgEMMycbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1922",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 27 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D6oQQ8Ohg6Y",
    "youtubeId": "D6oQQ8Ohg6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1923",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 26 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0wHrsmm5MU0",
    "youtubeId": "0wHrsmm5MU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1924",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 25 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A5WickHGVu0",
    "youtubeId": "A5WickHGVu0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1925",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 24 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YaCeQRQyy2k",
    "youtubeId": "YaCeQRQyy2k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1926",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 23 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jHQRxcdjgoc",
    "youtubeId": "jHQRxcdjgoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1927",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 22 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MA1hPf8mQe8",
    "youtubeId": "MA1hPf8mQe8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1928",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 21 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BiQvx7cf1Jg",
    "youtubeId": "BiQvx7cf1Jg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1929",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 20 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tsUMywJcbI8",
    "youtubeId": "tsUMywJcbI8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1930",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 19 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kpeeSlnMy9A",
    "youtubeId": "kpeeSlnMy9A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1931",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 18 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1sqIl01hElA",
    "youtubeId": "1sqIl01hElA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1932",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 17 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gXaUH9jhnEI",
    "youtubeId": "gXaUH9jhnEI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1933",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 16 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0wo9t-GOkGE",
    "youtubeId": "0wo9t-GOkGE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1934",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 15 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O8ZGGSVe8-I",
    "youtubeId": "O8ZGGSVe8-I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1935",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 14 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qel2Rm-UgKo",
    "youtubeId": "qel2Rm-UgKo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1936",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 13 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zj4drxb6U7I",
    "youtubeId": "Zj4drxb6U7I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1937",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 12 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6YAbzgw517M",
    "youtubeId": "6YAbzgw517M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1938",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 11 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ct4-A2yTHlw",
    "youtubeId": "ct4-A2yTHlw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1939",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 10 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sqgw0QGwB0A",
    "youtubeId": "sqgw0QGwB0A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1940",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 9 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jnz9Ez2F8gA",
    "youtubeId": "jnz9Ez2F8gA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1941",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 8 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xYc5hHr_Gys",
    "youtubeId": "xYc5hHr_Gys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1942",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 7 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pDwMGdIfeqQ",
    "youtubeId": "pDwMGdIfeqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1943",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 6 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FL61-YVScv4",
    "youtubeId": "FL61-YVScv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1944",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 5 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W4TNpc32ijg",
    "youtubeId": "W4TNpc32ijg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1945",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 4 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W1uTiRiwgW8",
    "youtubeId": "W1uTiRiwgW8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1946",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 3 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5sk2kwTaN0Q",
    "youtubeId": "5sk2kwTaN0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1947",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 2 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aIT1N752yzU",
    "youtubeId": "aIT1N752yzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1948",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 41 Ayat 1 Surah Fussilat Ha Mim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gZQZftqmxqw",
    "youtubeId": "gZQZftqmxqw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1949",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 85 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/assaWHnMcak",
    "youtubeId": "assaWHnMcak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1950",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 84 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jfet7NdpPZk",
    "youtubeId": "Jfet7NdpPZk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1951",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 83 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gl9wznSFzqk",
    "youtubeId": "Gl9wznSFzqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1952",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 82 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6IF91ZmdX4M",
    "youtubeId": "6IF91ZmdX4M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1953",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 81 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8euIUC39-Is",
    "youtubeId": "8euIUC39-Is",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1954",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 80 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/USRO1fBNqBo",
    "youtubeId": "USRO1fBNqBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1955",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 79 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H1tqDrE9Fo8",
    "youtubeId": "H1tqDrE9Fo8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1956",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 78 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fh6N5ZMTdKs",
    "youtubeId": "fh6N5ZMTdKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1957",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 77 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mliJLEx22SA",
    "youtubeId": "mliJLEx22SA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1958",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 76 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mFydocABUc4",
    "youtubeId": "mFydocABUc4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1959",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 75 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nalZQuTCr6Q",
    "youtubeId": "nalZQuTCr6Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1960",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 74 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5C8YscmE6Zs",
    "youtubeId": "5C8YscmE6Zs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1961",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 73 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EauXIFQQ_X4",
    "youtubeId": "EauXIFQQ_X4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1962",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 72 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wmy5Mi8uVzQ",
    "youtubeId": "Wmy5Mi8uVzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1963",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 71 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tl_zZ5L82NM",
    "youtubeId": "tl_zZ5L82NM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1964",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 70 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K6YBPvaXxdA",
    "youtubeId": "K6YBPvaXxdA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1965",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 69 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9gWG6cj12T8",
    "youtubeId": "9gWG6cj12T8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1966",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 68 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HlbaODuqVPs",
    "youtubeId": "HlbaODuqVPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1967",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 67 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/odnH9hqmMgo",
    "youtubeId": "odnH9hqmMgo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1968",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 66 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Fg0Es1Tjm4",
    "youtubeId": "7Fg0Es1Tjm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1969",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 65 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gWwYfdqC67w",
    "youtubeId": "gWwYfdqC67w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1970",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 64 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4GhLhN7aEJQ",
    "youtubeId": "4GhLhN7aEJQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1971",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 63 Surah Mumin Ghafir Dr Israr Ahmed Urdu 2",
    "type": "video",
    "url": "https://www.youtube.com/embed/HD6yiBuo0b8",
    "youtubeId": "HD6yiBuo0b8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1972",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 62 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WQuezhlp1ZI",
    "youtubeId": "WQuezhlp1ZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1973",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 61 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TeCVrDn_k30",
    "youtubeId": "TeCVrDn_k30",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1974",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 60 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZXIQSwENu3M",
    "youtubeId": "ZXIQSwENu3M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1975",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 59 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VAc7GrOGa64",
    "youtubeId": "VAc7GrOGa64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1976",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 58 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0jLFuOT4fzo",
    "youtubeId": "0jLFuOT4fzo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1977",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 57 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IlAk5CwFloI",
    "youtubeId": "IlAk5CwFloI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1978",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 56 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hodDd-G9vwI",
    "youtubeId": "hodDd-G9vwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1979",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 55 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZpPi5JAETJY",
    "youtubeId": "ZpPi5JAETJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1980",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 54 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HUzp00DzQPc",
    "youtubeId": "HUzp00DzQPc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1981",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 53 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pn4h43ITans",
    "youtubeId": "pn4h43ITans",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1982",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 52 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hw2P7S2ZmUQ",
    "youtubeId": "Hw2P7S2ZmUQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1983",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 51 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uF0rMIDjPzg",
    "youtubeId": "uF0rMIDjPzg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1984",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 50 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/66examZvUdk",
    "youtubeId": "66examZvUdk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1985",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 49 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aFDf7C8lycw",
    "youtubeId": "aFDf7C8lycw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1986",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 48 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vGA07EIz6IA",
    "youtubeId": "vGA07EIz6IA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1987",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 47 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G_WimkAMtpI",
    "youtubeId": "G_WimkAMtpI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1988",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 46 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nKYAUUdyxF0",
    "youtubeId": "nKYAUUdyxF0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1989",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 45 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2TK0RoSkumk",
    "youtubeId": "2TK0RoSkumk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1990",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 44 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G2waSVUGhWU",
    "youtubeId": "G2waSVUGhWU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1991",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 43 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kS4jqhEOfjs",
    "youtubeId": "kS4jqhEOfjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1992",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 42 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1oQHN7gnBs4",
    "youtubeId": "1oQHN7gnBs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1993",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 41 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i-C1Wv-T5-A",
    "youtubeId": "i-C1Wv-T5-A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1994",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 40 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CEqL01BUl9U",
    "youtubeId": "CEqL01BUl9U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1995",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 39 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vybV1PBlKro",
    "youtubeId": "vybV1PBlKro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1996",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 38 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fl1yLMo1UHg",
    "youtubeId": "Fl1yLMo1UHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1997",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 37 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hrcRjZwMJLI",
    "youtubeId": "hrcRjZwMJLI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1998",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 36 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7OQvaudr9FY",
    "youtubeId": "7OQvaudr9FY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-1999",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 35 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UjJ2i7h5KDo",
    "youtubeId": "UjJ2i7h5KDo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2000",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 34 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cS9Od_yRCIA",
    "youtubeId": "cS9Od_yRCIA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2001",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 33 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FggdSrQ7ymA",
    "youtubeId": "FggdSrQ7ymA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2002",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 32 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sCId0nDUTXw",
    "youtubeId": "sCId0nDUTXw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2003",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 31 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HMunAsm3rWI",
    "youtubeId": "HMunAsm3rWI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2004",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 30 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8NvdHy7Prmk",
    "youtubeId": "8NvdHy7Prmk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2005",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 29 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3VCSp4i4NRM",
    "youtubeId": "3VCSp4i4NRM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2006",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 28 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZfhyE62VX5s",
    "youtubeId": "ZfhyE62VX5s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2007",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 27 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aZ5mALEslYg",
    "youtubeId": "aZ5mALEslYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2008",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 26 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YjM1EQdClV8",
    "youtubeId": "YjM1EQdClV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2009",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 25 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6SqCyVDJDWk",
    "youtubeId": "6SqCyVDJDWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2010",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 24 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GP65sYPIQg0",
    "youtubeId": "GP65sYPIQg0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2011",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 23 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BMG4hRECItg",
    "youtubeId": "BMG4hRECItg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2012",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 22 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L6_5gEMHwic",
    "youtubeId": "L6_5gEMHwic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2013",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 21 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_pDg4-TPvDo",
    "youtubeId": "_pDg4-TPvDo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2014",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 20 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dk1L9BVV5Ic",
    "youtubeId": "Dk1L9BVV5Ic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2015",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 19 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yzXJ0mPhu5A",
    "youtubeId": "yzXJ0mPhu5A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2016",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 18 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yiO6eT_XxB8",
    "youtubeId": "yiO6eT_XxB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2017",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 17 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pQHfpSv_800",
    "youtubeId": "pQHfpSv_800",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2018",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 16 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mJCfhnD4bBQ",
    "youtubeId": "mJCfhnD4bBQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2019",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 15 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l2A3dQwOxJ0",
    "youtubeId": "l2A3dQwOxJ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2020",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 14 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yi-Uofq-IDo",
    "youtubeId": "yi-Uofq-IDo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2021",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 13 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JfLujtFjg-E",
    "youtubeId": "JfLujtFjg-E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2022",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 12 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rIkwYCgrSJ8",
    "youtubeId": "rIkwYCgrSJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2023",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 11 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yNjRMkw_tVk",
    "youtubeId": "yNjRMkw_tVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2024",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 10 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DCKUr7xBJ1Y",
    "youtubeId": "DCKUr7xBJ1Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2025",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 9 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JWF89vwGz-M",
    "youtubeId": "JWF89vwGz-M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2026",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 8 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dd4Xt4NoggQ",
    "youtubeId": "dd4Xt4NoggQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2027",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 7 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r8zGQB_g1V0",
    "youtubeId": "r8zGQB_g1V0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2028",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 6 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RkizXvLnCOQ",
    "youtubeId": "RkizXvLnCOQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2029",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 5 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LhRam6X5u0Q",
    "youtubeId": "LhRam6X5u0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2030",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 4 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mjZU8u24ap4",
    "youtubeId": "mjZU8u24ap4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2031",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 3 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B0B4vGr3c_c",
    "youtubeId": "B0B4vGr3c_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2032",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 2 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cEyi5IVQbEY",
    "youtubeId": "cEyi5IVQbEY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2033",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 40 Ayat 1 Surah Mumin Ghafir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qUboR9JRmQY",
    "youtubeId": "qUboR9JRmQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2034",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 75 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OCisTGTK_BQ",
    "youtubeId": "OCisTGTK_BQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2035",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 74 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PLSIQjF2bf0",
    "youtubeId": "PLSIQjF2bf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2036",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 73 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ut_Js8T9oFM",
    "youtubeId": "Ut_Js8T9oFM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2037",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 72 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0DtM9UpKH-w",
    "youtubeId": "0DtM9UpKH-w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2038",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 71 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3QT4BjKsE2s",
    "youtubeId": "3QT4BjKsE2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2039",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 70 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EdYaHkTKwkw",
    "youtubeId": "EdYaHkTKwkw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2040",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 69 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WJWSu8ToQX8",
    "youtubeId": "WJWSu8ToQX8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2041",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 68 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0S3zK3qDK6c",
    "youtubeId": "0S3zK3qDK6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2042",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 67 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/05J0vq54uN8",
    "youtubeId": "05J0vq54uN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2043",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 66 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KGwyi5Y4fds",
    "youtubeId": "KGwyi5Y4fds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2044",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 65 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fNecNqXoAco",
    "youtubeId": "fNecNqXoAco",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2045",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 64 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kRyMxXhY3Y4",
    "youtubeId": "kRyMxXhY3Y4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2046",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 63 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/69XTUlQNTsQ",
    "youtubeId": "69XTUlQNTsQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2047",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 62 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6aIepsIS8eo",
    "youtubeId": "6aIepsIS8eo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2048",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 61 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SGyqMU9o67I",
    "youtubeId": "SGyqMU9o67I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2049",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 60 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ivMm4DKgkg4",
    "youtubeId": "ivMm4DKgkg4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2050",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 59 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qVArwl5_9oQ",
    "youtubeId": "qVArwl5_9oQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2051",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 58 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vg6LAE_ZsuA",
    "youtubeId": "Vg6LAE_ZsuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2052",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 57 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PmjEQmIWN1Q",
    "youtubeId": "PmjEQmIWN1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2053",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 56 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bSrbGhl0u6w",
    "youtubeId": "bSrbGhl0u6w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2054",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 55 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pYTHgtgaDps",
    "youtubeId": "pYTHgtgaDps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2055",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 54 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dUd-QMBTrjw",
    "youtubeId": "dUd-QMBTrjw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2056",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 53 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pEEbl9HhkfQ",
    "youtubeId": "pEEbl9HhkfQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2057",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 52 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-YJuwuarABA",
    "youtubeId": "-YJuwuarABA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2058",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 51 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nTSM4HSKW8g",
    "youtubeId": "nTSM4HSKW8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2059",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 50 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JYsEuYbagcA",
    "youtubeId": "JYsEuYbagcA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2060",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 49 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2a3YNtNJ0eU",
    "youtubeId": "2a3YNtNJ0eU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2061",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 47 & 48 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BEAe9WEJc5g",
    "youtubeId": "BEAe9WEJc5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2062",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 46 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8QJaK5TkcA0",
    "youtubeId": "8QJaK5TkcA0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2063",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 45 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IkhSEglerFQ",
    "youtubeId": "IkhSEglerFQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2064",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 44 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tWQJuLCV5JY",
    "youtubeId": "tWQJuLCV5JY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2065",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 43 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZJHgINk6F18",
    "youtubeId": "ZJHgINk6F18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2066",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 42 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jDpNbjMrE58",
    "youtubeId": "jDpNbjMrE58",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2067",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 41 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RL6sWLPjgQ8",
    "youtubeId": "RL6sWLPjgQ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2068",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 40 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OPLfzP1qgsw",
    "youtubeId": "OPLfzP1qgsw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2069",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 39 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S9N_qrQc09c",
    "youtubeId": "S9N_qrQc09c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2070",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 38 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u3FLtg3Okl4",
    "youtubeId": "u3FLtg3Okl4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2071",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 37 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6wxLdDj2y5U",
    "youtubeId": "6wxLdDj2y5U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2072",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 36 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-ogLN0tRDwQ",
    "youtubeId": "-ogLN0tRDwQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2073",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 35 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rKRexrHe_Ko",
    "youtubeId": "rKRexrHe_Ko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2074",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 34 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kdO5lNJraQg",
    "youtubeId": "kdO5lNJraQg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2075",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 33 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5F-lDLuK8Rw",
    "youtubeId": "5F-lDLuK8Rw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2076",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 32 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U1V_NfJyOwI",
    "youtubeId": "U1V_NfJyOwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2077",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 31 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YkrJjeSBac8",
    "youtubeId": "YkrJjeSBac8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2078",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 30 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/06Zmc1oDICU",
    "youtubeId": "06Zmc1oDICU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2079",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 29 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F9WtmiXnG5M",
    "youtubeId": "F9WtmiXnG5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2080",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 28 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/teEYYc_JmOk",
    "youtubeId": "teEYYc_JmOk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2081",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 27 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L8Fye1XzBek",
    "youtubeId": "L8Fye1XzBek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2082",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 26 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UXL0HWOto2Y",
    "youtubeId": "UXL0HWOto2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2083",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 25 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eCPH2-5DTkE",
    "youtubeId": "eCPH2-5DTkE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2084",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 24 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jugng6LeLjE",
    "youtubeId": "jugng6LeLjE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2085",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 23 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uvkwf3B0BXA",
    "youtubeId": "Uvkwf3B0BXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2086",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 22 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/efMyH6vaRLg",
    "youtubeId": "efMyH6vaRLg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2087",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 21 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2PUtpDXB1zI",
    "youtubeId": "2PUtpDXB1zI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2088",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 20 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-3orLvL-0BE",
    "youtubeId": "-3orLvL-0BE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2089",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 19 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LwfPIRic_ag",
    "youtubeId": "LwfPIRic_ag",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2090",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 18 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VcERCDZmGuo",
    "youtubeId": "VcERCDZmGuo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2091",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 17 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wug7_0oOEtY",
    "youtubeId": "wug7_0oOEtY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2092",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 16 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RkSMinMxDMM",
    "youtubeId": "RkSMinMxDMM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2093",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 15 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eb7_gDTthVw",
    "youtubeId": "eb7_gDTthVw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2094",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 14 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WxpDUeBwwCQ",
    "youtubeId": "WxpDUeBwwCQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2095",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 13 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hCoLRr2EAXo",
    "youtubeId": "hCoLRr2EAXo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2096",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 12 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XwFbbcbzNfQ",
    "youtubeId": "XwFbbcbzNfQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2097",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 11 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/icxzA5q3-jQ",
    "youtubeId": "icxzA5q3-jQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2098",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 10 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/61dE1kwefCc",
    "youtubeId": "61dE1kwefCc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2099",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 9 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BgUpY7K3tw4",
    "youtubeId": "BgUpY7K3tw4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 8 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7uMCJwIT3RY",
    "youtubeId": "7uMCJwIT3RY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 7 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6xpJoDE2tKU",
    "youtubeId": "6xpJoDE2tKU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 6 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EjFZ8K7Cseo",
    "youtubeId": "EjFZ8K7Cseo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 5 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z1V7eFc2ccw",
    "youtubeId": "Z1V7eFc2ccw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 4 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6Ai1Ljux_4g",
    "youtubeId": "6Ai1Ljux_4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 3 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YWZ7WGRib3w",
    "youtubeId": "YWZ7WGRib3w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 2 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H1Z_aoxR9_k",
    "youtubeId": "H1Z_aoxR9_k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 39 Ayat 1 Surah Zumar Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SlI2hDhVinE",
    "youtubeId": "SlI2hDhVinE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 88 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GCrUYkLe3YE",
    "youtubeId": "GCrUYkLe3YE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 87 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZcX3j49fbZg",
    "youtubeId": "ZcX3j49fbZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 86 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rf3Yaw3u5FE",
    "youtubeId": "Rf3Yaw3u5FE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 85 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/leJWaGquYnA",
    "youtubeId": "leJWaGquYnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 84 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/djB3cMLef8g",
    "youtubeId": "djB3cMLef8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 83 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NXEcrJZySgc",
    "youtubeId": "NXEcrJZySgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 82 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KTn8AV0Mwu8",
    "youtubeId": "KTn8AV0Mwu8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 81 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ONxjxtLYTpE",
    "youtubeId": "ONxjxtLYTpE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 80 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LR7AM83j4Q4",
    "youtubeId": "LR7AM83j4Q4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 79 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RrFoRgVvCx0",
    "youtubeId": "RrFoRgVvCx0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 78 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vjEtr4sCcgs",
    "youtubeId": "vjEtr4sCcgs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 77 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QYioQLrhmKY",
    "youtubeId": "QYioQLrhmKY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 76 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-w2AlftBzrw",
    "youtubeId": "-w2AlftBzrw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 75 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xZLOC654WJo",
    "youtubeId": "xZLOC654WJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2122",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 74 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Akz1DgtdEmA",
    "youtubeId": "Akz1DgtdEmA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2123",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 73 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7ivlW7WikK8",
    "youtubeId": "7ivlW7WikK8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2124",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 72 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NmMPIvM3KB8",
    "youtubeId": "NmMPIvM3KB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2125",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 71 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y25lX_r0H-4",
    "youtubeId": "Y25lX_r0H-4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2126",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 70 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dDFgyD2M5ZI",
    "youtubeId": "dDFgyD2M5ZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2127",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 69 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q9AIQGERgTU",
    "youtubeId": "Q9AIQGERgTU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2128",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 68 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fIkVrbU3dv8",
    "youtubeId": "fIkVrbU3dv8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2129",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 67 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nDP6Bw95-Dk",
    "youtubeId": "nDP6Bw95-Dk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2130",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 66 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/baJ2NTBqERg",
    "youtubeId": "baJ2NTBqERg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2131",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 65 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N98d77aewas",
    "youtubeId": "N98d77aewas",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2132",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 64 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/glHOcg_klwg",
    "youtubeId": "glHOcg_klwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2133",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 63 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vOc2fPPRxLk",
    "youtubeId": "vOc2fPPRxLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2134",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 62 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zf28x7Fspkk",
    "youtubeId": "zf28x7Fspkk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2135",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 61 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g9tI_PST9T8",
    "youtubeId": "g9tI_PST9T8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2136",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 60 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D8Gkm-cNX6A",
    "youtubeId": "D8Gkm-cNX6A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2137",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 59 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rl1zc8gaasA",
    "youtubeId": "Rl1zc8gaasA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2138",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 58 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MEVSy29Kxm4",
    "youtubeId": "MEVSy29Kxm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2139",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 57 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Erwuy5xRemQ",
    "youtubeId": "Erwuy5xRemQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2140",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 56 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nmWZyxG0vKI",
    "youtubeId": "nmWZyxG0vKI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2141",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 55 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ED9khrGgDxI",
    "youtubeId": "ED9khrGgDxI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2142",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 54 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ba8K3y_niXw",
    "youtubeId": "Ba8K3y_niXw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2143",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 53 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bh9f3RBYpuU",
    "youtubeId": "Bh9f3RBYpuU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2144",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 52 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lsLAByLtUKE",
    "youtubeId": "lsLAByLtUKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2145",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 51 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rCSKQWfD368",
    "youtubeId": "rCSKQWfD368",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2146",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 50 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uIp6JCNSr8M",
    "youtubeId": "uIp6JCNSr8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2147",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 49 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ij8yNYEXjV0",
    "youtubeId": "ij8yNYEXjV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2148",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 48 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EMKk824wcUQ",
    "youtubeId": "EMKk824wcUQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2149",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 47 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HJHvGJhKWCI",
    "youtubeId": "HJHvGJhKWCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2150",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 46 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4PObhUNB40w",
    "youtubeId": "4PObhUNB40w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2151",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 45 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/77IIjHstfBA",
    "youtubeId": "77IIjHstfBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2152",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 44 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TCZi-gozdgM",
    "youtubeId": "TCZi-gozdgM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2153",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 43 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lDWmXrM0gus",
    "youtubeId": "lDWmXrM0gus",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2154",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 42 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UM6qjZMEABo",
    "youtubeId": "UM6qjZMEABo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2155",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 41 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-NM9JL4nQQg",
    "youtubeId": "-NM9JL4nQQg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2156",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 40 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uN6qtpt6CwM",
    "youtubeId": "uN6qtpt6CwM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2157",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 39 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hgtkdWp02jY",
    "youtubeId": "hgtkdWp02jY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2158",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 38 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WdlE4JHDouM",
    "youtubeId": "WdlE4JHDouM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2159",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 37 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qSG6isUODKU",
    "youtubeId": "qSG6isUODKU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2160",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 36 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e14u9VWoGp0",
    "youtubeId": "e14u9VWoGp0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2161",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 35 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jCs7HVvnmRg",
    "youtubeId": "jCs7HVvnmRg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2162",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 34 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T5S7eiHG3cI",
    "youtubeId": "T5S7eiHG3cI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2163",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 33 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vKbQ5rFsCpk",
    "youtubeId": "vKbQ5rFsCpk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2164",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 32 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CIPIsgpKYMc",
    "youtubeId": "CIPIsgpKYMc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2165",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 31 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JQlQczOt0Jw",
    "youtubeId": "JQlQczOt0Jw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2166",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 30 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r7qN4WAUnkM",
    "youtubeId": "r7qN4WAUnkM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2167",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 29 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eGOP0iXjXBg",
    "youtubeId": "eGOP0iXjXBg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2168",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 28 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lo27FvpAQeI",
    "youtubeId": "Lo27FvpAQeI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2169",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 27 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bGfQKIklqx0",
    "youtubeId": "bGfQKIklqx0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2170",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 26 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JE7gQRHXvB0",
    "youtubeId": "JE7gQRHXvB0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2171",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 25 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wvabHWGHNvc",
    "youtubeId": "wvabHWGHNvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2172",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 24 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hkLx0ykGY1E",
    "youtubeId": "hkLx0ykGY1E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2173",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 23 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J8jo5gQ4Un0",
    "youtubeId": "J8jo5gQ4Un0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2174",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 22 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iORVX4FHFB8",
    "youtubeId": "iORVX4FHFB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2175",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 21 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nv13Q3x0fu4",
    "youtubeId": "Nv13Q3x0fu4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2176",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 20 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fsBEVvFwwSg",
    "youtubeId": "fsBEVvFwwSg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2177",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 19 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iLeMMn7FpWc",
    "youtubeId": "iLeMMn7FpWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2178",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 18 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UfpBST7RlRk",
    "youtubeId": "UfpBST7RlRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2179",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 17 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cxMKiTQqhWU",
    "youtubeId": "cxMKiTQqhWU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2180",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 16 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iq1DQvGweEc",
    "youtubeId": "iq1DQvGweEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2181",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 15 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y0IevHKNT1s",
    "youtubeId": "y0IevHKNT1s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2182",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 14 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mEGvB0cjLAQ",
    "youtubeId": "mEGvB0cjLAQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2183",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 13 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ygl2bXEe1vg",
    "youtubeId": "ygl2bXEe1vg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2184",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 12 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cla-ytXn83k",
    "youtubeId": "Cla-ytXn83k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2185",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 11 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aHZ4ywcKc3Y",
    "youtubeId": "aHZ4ywcKc3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2186",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 10 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ORQmSJgXqes",
    "youtubeId": "ORQmSJgXqes",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2187",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 9 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/15-ef6GN-mo",
    "youtubeId": "15-ef6GN-mo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2188",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 8 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jx_0cn18FHI",
    "youtubeId": "Jx_0cn18FHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2189",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 7 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/feewWm0-iNU",
    "youtubeId": "feewWm0-iNU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2190",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 6 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0N78wsdWam8",
    "youtubeId": "0N78wsdWam8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2191",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 5 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6YgqQaDaRWs",
    "youtubeId": "6YgqQaDaRWs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2192",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 4 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aLVf8T5Uaz8",
    "youtubeId": "aLVf8T5Uaz8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2193",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 3 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hn9ymyiOkzU",
    "youtubeId": "Hn9ymyiOkzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2194",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 2 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SsA8_a7Zw4c",
    "youtubeId": "SsA8_a7Zw4c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2195",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 38 Ayat 1 Surah Sad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dHbnsm1WQqk",
    "youtubeId": "dHbnsm1WQqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2196",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 182 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3KKjXkd8OCc",
    "youtubeId": "3KKjXkd8OCc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2197",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 181 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AWWkxbMc1l4",
    "youtubeId": "AWWkxbMc1l4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2198",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 180 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vr3ogBqgKt0",
    "youtubeId": "Vr3ogBqgKt0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2199",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 178 & 179 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d-5Orru-t1o",
    "youtubeId": "d-5Orru-t1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2200",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 177 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XnC2jvGTxwE",
    "youtubeId": "XnC2jvGTxwE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2201",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 176 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gn60PYtWaEg",
    "youtubeId": "Gn60PYtWaEg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2202",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 175 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-9x2ih-XwMk",
    "youtubeId": "-9x2ih-XwMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2203",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 174 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3rvFaNfuoPg",
    "youtubeId": "3rvFaNfuoPg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2204",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 173 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/89NBLIYXiys",
    "youtubeId": "89NBLIYXiys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2205",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 172 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wdrwvO_nxG8",
    "youtubeId": "wdrwvO_nxG8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2206",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 171 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5vz7Lo5dV4M",
    "youtubeId": "5vz7Lo5dV4M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2207",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 170 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oLkrQJAFltc",
    "youtubeId": "oLkrQJAFltc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2208",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 167 -  169 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ehJuEbeiIHo",
    "youtubeId": "ehJuEbeiIHo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2209",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 166 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mgjXJU5p_tM",
    "youtubeId": "mgjXJU5p_tM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2210",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 165 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K4fA253Yeyk",
    "youtubeId": "K4fA253Yeyk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2211",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 164 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PHkZ0HVZ1ds",
    "youtubeId": "PHkZ0HVZ1ds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2212",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 161 - 163 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bp7-PoYz9gM",
    "youtubeId": "bp7-PoYz9gM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2213",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 160 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jO44iQ8jao0",
    "youtubeId": "jO44iQ8jao0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2214",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 159 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/43rY7JiQkf0",
    "youtubeId": "43rY7JiQkf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2215",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 158 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LKShsiiSneA",
    "youtubeId": "LKShsiiSneA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2216",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 157 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y0Tmv_cAK2s",
    "youtubeId": "y0Tmv_cAK2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2217",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 156 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6loXiI0EguQ",
    "youtubeId": "6loXiI0EguQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2218",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 155 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f6igzbpxfSg",
    "youtubeId": "f6igzbpxfSg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2219",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 154 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wDEme3-buQM",
    "youtubeId": "wDEme3-buQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2220",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 153 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TnBWZW3QRJk",
    "youtubeId": "TnBWZW3QRJk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2221",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 151 & 152 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FBnpaSYAVd8",
    "youtubeId": "FBnpaSYAVd8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2222",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 150 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6whmwDGtx6Q",
    "youtubeId": "6whmwDGtx6Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2223",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 149 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3tDrgH21rZo",
    "youtubeId": "3tDrgH21rZo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2224",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 148 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-bHH00kbJzU",
    "youtubeId": "-bHH00kbJzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2225",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 147 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hAvLZfC6O7I",
    "youtubeId": "hAvLZfC6O7I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2226",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 146 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GHfN3YqLMYg",
    "youtubeId": "GHfN3YqLMYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2227",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 145 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o7EdoRJ2QrI",
    "youtubeId": "o7EdoRJ2QrI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2228",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 144 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JNFFqvupQ14",
    "youtubeId": "JNFFqvupQ14",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2229",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 143 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NXwoZMzR-Qg",
    "youtubeId": "NXwoZMzR-Qg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2230",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 142 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4Dgp4g8gs9c",
    "youtubeId": "4Dgp4g8gs9c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2231",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 141 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7MkkesF5dLk",
    "youtubeId": "7MkkesF5dLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2232",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 139 & 140 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PJC19G14Qpc",
    "youtubeId": "PJC19G14Qpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2233",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 137 & 138 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r8M_CaqWIRA",
    "youtubeId": "r8M_CaqWIRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2234",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 136 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7RoftEg98jE",
    "youtubeId": "7RoftEg98jE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2235",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 135 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hd_YLoEZ5wQ",
    "youtubeId": "hd_YLoEZ5wQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2236",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 134 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uIzL65mj6Hs",
    "youtubeId": "uIzL65mj6Hs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2237",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 133 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/57Hly0XUz_U",
    "youtubeId": "57Hly0XUz_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2238",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 130  - 132 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fxt1tGG578c",
    "youtubeId": "Fxt1tGG578c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2239",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 129 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lPmdzX68JLo",
    "youtubeId": "lPmdzX68JLo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2240",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 128 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OK8sElXEDMU",
    "youtubeId": "OK8sElXEDMU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2241",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 127 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c58aDujEJuo",
    "youtubeId": "c58aDujEJuo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2242",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 126 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8z0OVZzisPQ",
    "youtubeId": "8z0OVZzisPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2243",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 125 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XMDB2bw39v0",
    "youtubeId": "XMDB2bw39v0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2244",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 124 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hEDDvQeH4A8",
    "youtubeId": "hEDDvQeH4A8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2245",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 123 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z1jKKzRjlfQ",
    "youtubeId": "z1jKKzRjlfQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2246",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 121 & 122 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3le3VZbqVMo",
    "youtubeId": "3le3VZbqVMo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2247",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 120 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E77x1oxIgNk",
    "youtubeId": "E77x1oxIgNk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2248",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 119 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/30w1u_Y3_NU",
    "youtubeId": "30w1u_Y3_NU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2249",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 118 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R9RAYLc9xLg",
    "youtubeId": "R9RAYLc9xLg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2250",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 117 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NyizLhrxW4o",
    "youtubeId": "NyizLhrxW4o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2251",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 116 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xsvcwkKe6UI",
    "youtubeId": "xsvcwkKe6UI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2252",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 115 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5JLMWzP79Ps",
    "youtubeId": "5JLMWzP79Ps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2253",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 114 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qnTmKD9CpXQ",
    "youtubeId": "qnTmKD9CpXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2254",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 113 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/in4oxNQT7zg",
    "youtubeId": "in4oxNQT7zg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2255",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 112 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XKYU2qJRQQE",
    "youtubeId": "XKYU2qJRQQE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2256",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 111 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O0TxBFz-FFQ",
    "youtubeId": "O0TxBFz-FFQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2257",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 110 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/26AW_p0cZio",
    "youtubeId": "26AW_p0cZio",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2258",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 109 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zcmOp_vXu94",
    "youtubeId": "zcmOp_vXu94",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2259",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 108 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x9ZPXRGXJJQ",
    "youtubeId": "x9ZPXRGXJJQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2260",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 107 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e75nV3pyPRk",
    "youtubeId": "e75nV3pyPRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2261",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 106 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ghC6Fg_fw_o",
    "youtubeId": "ghC6Fg_fw_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2262",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 105 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KQ07OSFIFAQ",
    "youtubeId": "KQ07OSFIFAQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2263",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 104 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bmP1EIueF6o",
    "youtubeId": "bmP1EIueF6o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2264",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 103 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HAAAKeMW4Ec",
    "youtubeId": "HAAAKeMW4Ec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2265",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 102 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BPih78_c-U8",
    "youtubeId": "BPih78_c-U8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2266",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 101 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QDKmssPgVoA",
    "youtubeId": "QDKmssPgVoA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2267",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 100 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5EOA_Cf4_DI",
    "youtubeId": "5EOA_Cf4_DI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2268",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 99 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nDYK9Ah1GJs",
    "youtubeId": "nDYK9Ah1GJs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2269",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 98 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iYeNO5MNiJA",
    "youtubeId": "iYeNO5MNiJA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2270",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 97 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-mWlu83iXzI",
    "youtubeId": "-mWlu83iXzI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2271",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 96 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TABKBC1kE7w",
    "youtubeId": "TABKBC1kE7w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2272",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 95 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4YF1FgSxzos",
    "youtubeId": "4YF1FgSxzos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2273",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 94 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KcT0kuJi_jY",
    "youtubeId": "KcT0kuJi_jY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2274",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 93 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1LssbDJYPcg",
    "youtubeId": "1LssbDJYPcg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2275",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 92 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UOrpQVAoX08",
    "youtubeId": "UOrpQVAoX08",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2276",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 91 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ofmk9sNmiH4",
    "youtubeId": "Ofmk9sNmiH4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2277",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 90 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/06f6QbOkZXE",
    "youtubeId": "06f6QbOkZXE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2278",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 89 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5D3Mr9w-BKg",
    "youtubeId": "5D3Mr9w-BKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2279",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 88 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XQOeEAmfazQ",
    "youtubeId": "XQOeEAmfazQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2280",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 87 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ilGMlxnk7o0",
    "youtubeId": "ilGMlxnk7o0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2281",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 86 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rWcYSqfKe7c",
    "youtubeId": "rWcYSqfKe7c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2282",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 85 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bsPdcrp1Fvc",
    "youtubeId": "bsPdcrp1Fvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2283",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 84 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b_0ZsvC10-w",
    "youtubeId": "b_0ZsvC10-w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2284",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 83 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-_NpzI5nsEQ",
    "youtubeId": "-_NpzI5nsEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2285",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 82 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NdWX7ecOImY",
    "youtubeId": "NdWX7ecOImY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2286",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 81 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r9_i_ctUTMY",
    "youtubeId": "r9_i_ctUTMY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2287",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 80 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FcoVb3nTtyE",
    "youtubeId": "FcoVb3nTtyE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2288",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 79 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j-LJrccpcSk",
    "youtubeId": "j-LJrccpcSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2289",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 77 & 78 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KYyMsm32Zio",
    "youtubeId": "KYyMsm32Zio",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2290",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 76 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LDI9zrOhG0U",
    "youtubeId": "LDI9zrOhG0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2291",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 75 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WAqiWf0CMqQ",
    "youtubeId": "WAqiWf0CMqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2292",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 74 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kf6eJDAyBdk",
    "youtubeId": "kf6eJDAyBdk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2293",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 73 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KgL5aqUD02Y",
    "youtubeId": "KgL5aqUD02Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2294",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 72 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h5nvH4JZcTI",
    "youtubeId": "h5nvH4JZcTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2295",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 71 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NIcx1HO41kA",
    "youtubeId": "NIcx1HO41kA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2296",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 70 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1puh1iHfpvY",
    "youtubeId": "1puh1iHfpvY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2297",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 69 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NRLdrEtZxlM",
    "youtubeId": "NRLdrEtZxlM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2298",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 68 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xb2C4AStD3w",
    "youtubeId": "xb2C4AStD3w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2299",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 67 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WzWpjZXrTNs",
    "youtubeId": "WzWpjZXrTNs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2300",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 66 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6P4qO3z9yrY",
    "youtubeId": "6P4qO3z9yrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2301",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 65 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/crriRGX0ORU",
    "youtubeId": "crriRGX0ORU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2302",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 64 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IH20rgN1kY4",
    "youtubeId": "IH20rgN1kY4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2303",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 63 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zsQrHao0zk4",
    "youtubeId": "zsQrHao0zk4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2304",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 62 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q9aXrQ-GO1k",
    "youtubeId": "q9aXrQ-GO1k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2305",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 61 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hRs0WbdlxIg",
    "youtubeId": "hRs0WbdlxIg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2306",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 60 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XEKYoCwxIAc",
    "youtubeId": "XEKYoCwxIAc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2307",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 59 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h-r89xv2w7s",
    "youtubeId": "h-r89xv2w7s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2308",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 58 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DDLinP396pY",
    "youtubeId": "DDLinP396pY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2309",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 57 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mhoWngR2Fm4",
    "youtubeId": "mhoWngR2Fm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2310",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 56 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n5xsxBBRROg",
    "youtubeId": "n5xsxBBRROg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2311",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 55 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uhjJfLxWezk",
    "youtubeId": "uhjJfLxWezk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2312",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 54 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aCZHT6pgE5s",
    "youtubeId": "aCZHT6pgE5s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2313",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 53 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tqONYmUwhn0",
    "youtubeId": "tqONYmUwhn0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2314",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 52 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lwGNhnPWKlM",
    "youtubeId": "lwGNhnPWKlM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2315",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 51 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eAaedF4ctzo",
    "youtubeId": "eAaedF4ctzo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2316",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 50 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gmM2I-zr1dc",
    "youtubeId": "gmM2I-zr1dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2317",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 49 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ICO8Bs4Aq8Q",
    "youtubeId": "ICO8Bs4Aq8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2318",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 48 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jhexeTNBrv8",
    "youtubeId": "jhexeTNBrv8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2319",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 47 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cqo4qJP4PVk",
    "youtubeId": "cqo4qJP4PVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2320",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 46 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MA20GsJRAOY",
    "youtubeId": "MA20GsJRAOY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2321",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 45 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9OkbWjhwqts",
    "youtubeId": "9OkbWjhwqts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2322",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 44 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BZasDh7YUwk",
    "youtubeId": "BZasDh7YUwk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2323",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 43 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UuROffskLLc",
    "youtubeId": "UuROffskLLc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2324",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 42 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pho8C4vsooo",
    "youtubeId": "pho8C4vsooo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2325",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 41 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/19hXuULGxkY",
    "youtubeId": "19hXuULGxkY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2326",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 40 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1qhcJBgjd2o",
    "youtubeId": "1qhcJBgjd2o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2327",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 39 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LUXJeuOlSus",
    "youtubeId": "LUXJeuOlSus",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2328",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 38 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F4xkSqBcgSM",
    "youtubeId": "F4xkSqBcgSM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2329",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 37 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cHyQKiiQZQg",
    "youtubeId": "cHyQKiiQZQg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2330",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 36 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rimvmutL_5Q",
    "youtubeId": "rimvmutL_5Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2331",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 35 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-wX04qNi8Ek",
    "youtubeId": "-wX04qNi8Ek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2332",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 34 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EUE0VljnjCc",
    "youtubeId": "EUE0VljnjCc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2333",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 33 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O6rlN4xIO8g",
    "youtubeId": "O6rlN4xIO8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2334",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 32 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rsuDNl5bh84",
    "youtubeId": "rsuDNl5bh84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2335",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 31 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gcn1P057lgI",
    "youtubeId": "Gcn1P057lgI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2336",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 30 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mxjymd6Eszo",
    "youtubeId": "mxjymd6Eszo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2337",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 29 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q4HYtB4bXA4",
    "youtubeId": "Q4HYtB4bXA4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2338",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 28 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sOre3YuAEZ4",
    "youtubeId": "sOre3YuAEZ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2339",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 27 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9ZzX4PeQqW8",
    "youtubeId": "9ZzX4PeQqW8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2340",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 26 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lyCqEJrwqhA",
    "youtubeId": "lyCqEJrwqhA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2341",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 25 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wof7QD6ZkUI",
    "youtubeId": "wof7QD6ZkUI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2342",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 24 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nl5LRmr65qo",
    "youtubeId": "Nl5LRmr65qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2343",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 23 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_1dTeybOVLs",
    "youtubeId": "_1dTeybOVLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2344",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 22 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-QHumOZgbTk",
    "youtubeId": "-QHumOZgbTk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2345",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 21 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GOIJT-gpULs",
    "youtubeId": "GOIJT-gpULs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2346",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 20 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XY875StSsTk",
    "youtubeId": "XY875StSsTk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2347",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 19 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FFmAJxEpC0w",
    "youtubeId": "FFmAJxEpC0w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2348",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 18 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMLl0X4n_3E",
    "youtubeId": "cMLl0X4n_3E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2349",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 17 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fzCBFCSqh04",
    "youtubeId": "fzCBFCSqh04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2350",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 16 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mlapoJM-OFw",
    "youtubeId": "mlapoJM-OFw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2351",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 15 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bVvMIM2Ju_g",
    "youtubeId": "bVvMIM2Ju_g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2352",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 14 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wK4HIQTSv_o",
    "youtubeId": "wK4HIQTSv_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2353",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 13 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Rz5bARWFRQ",
    "youtubeId": "-Rz5bARWFRQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2354",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 12 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/exU9kdfkApQ",
    "youtubeId": "exU9kdfkApQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2355",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 11 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6bjkKc1DDNc",
    "youtubeId": "6bjkKc1DDNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2356",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 10 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U3abTdHya0Q",
    "youtubeId": "U3abTdHya0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2357",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 9 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Orz1qLnZ-NM",
    "youtubeId": "Orz1qLnZ-NM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2358",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 8 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9VYtLr2G9LY",
    "youtubeId": "9VYtLr2G9LY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2359",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 7 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KKhdaEknyiU",
    "youtubeId": "KKhdaEknyiU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2360",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 6 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OvYC4lVJdXE",
    "youtubeId": "OvYC4lVJdXE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2361",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 5 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2DrFx8EL8QE",
    "youtubeId": "2DrFx8EL8QE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2362",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 4 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AxT_-o9WgY4",
    "youtubeId": "AxT_-o9WgY4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2363",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 3 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OdQk3sK_FJc",
    "youtubeId": "OdQk3sK_FJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2364",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 2 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m9FskM9ZvGY",
    "youtubeId": "m9FskM9ZvGY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2365",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 37 Ayat 1 Surah Saffat Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RlQxnh6TWqA",
    "youtubeId": "RlQxnh6TWqA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2366",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 83 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B4bAUD5frLU",
    "youtubeId": "B4bAUD5frLU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2367",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 82 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QoQOftyCKqw",
    "youtubeId": "QoQOftyCKqw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2368",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 81 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i73PwOP4HLk",
    "youtubeId": "i73PwOP4HLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2369",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 80 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lizDczIxI9w",
    "youtubeId": "lizDczIxI9w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2370",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 79 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5QpyDj12Zu0",
    "youtubeId": "5QpyDj12Zu0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2371",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 78 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0S5ABOafheE",
    "youtubeId": "0S5ABOafheE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2372",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 77 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NLuyp0NZmSo",
    "youtubeId": "NLuyp0NZmSo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2373",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 76 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xzy6g78FQYk",
    "youtubeId": "Xzy6g78FQYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2374",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 75 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t--rrDngBko",
    "youtubeId": "t--rrDngBko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2375",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 74 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M7Mu5MxKnqI",
    "youtubeId": "M7Mu5MxKnqI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2376",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 73 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nkTKmkblo08",
    "youtubeId": "nkTKmkblo08",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2377",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 72 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GiATiS-Yi78",
    "youtubeId": "GiATiS-Yi78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2378",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 71 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nCwzFQ_jiqE",
    "youtubeId": "nCwzFQ_jiqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2379",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 70 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OgaSzjHfR5c",
    "youtubeId": "OgaSzjHfR5c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2380",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 69 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6oMAhW2xx7Y",
    "youtubeId": "6oMAhW2xx7Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2381",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 68 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kdJ9wBjET1Q",
    "youtubeId": "kdJ9wBjET1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2382",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 67 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gUcMjiK-Zog",
    "youtubeId": "gUcMjiK-Zog",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2383",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 66 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wQqzseQHWFg",
    "youtubeId": "wQqzseQHWFg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2384",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 65 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zG8zoOAqXJg",
    "youtubeId": "zG8zoOAqXJg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2385",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 64 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8PO14q0x3Hc",
    "youtubeId": "8PO14q0x3Hc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2386",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 63 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fA44UU7CeTI",
    "youtubeId": "fA44UU7CeTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2387",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 62 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m8ex7A2nVh4",
    "youtubeId": "m8ex7A2nVh4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2388",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 61 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5zGg1njKbyI",
    "youtubeId": "5zGg1njKbyI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2389",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 60 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fhHLBPbkZIk",
    "youtubeId": "fhHLBPbkZIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2390",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 59 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/57__5NOvCpU",
    "youtubeId": "57__5NOvCpU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2391",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 58 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v0OuV9ROHEE",
    "youtubeId": "v0OuV9ROHEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2392",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 57 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nF-JzWVccBA",
    "youtubeId": "nF-JzWVccBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2393",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 56 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PGwGrlfgQHU",
    "youtubeId": "PGwGrlfgQHU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2394",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 55 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zt3mmRi1AAs",
    "youtubeId": "zt3mmRi1AAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2395",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 54 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T2WQQQyvnTg",
    "youtubeId": "T2WQQQyvnTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2396",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 53 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/isDi7sjzano",
    "youtubeId": "isDi7sjzano",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2397",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 52 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GDXI3eQEVEU",
    "youtubeId": "GDXI3eQEVEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2398",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 51 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tqJHj25VxAA",
    "youtubeId": "tqJHj25VxAA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2399",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 50 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ej3mDxjh_6Y",
    "youtubeId": "ej3mDxjh_6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2400",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 49 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qdJxf8xJpyI",
    "youtubeId": "qdJxf8xJpyI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2401",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 48 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hdG1huA8TjA",
    "youtubeId": "hdG1huA8TjA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2402",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 47 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bwxBsJRYo6U",
    "youtubeId": "bwxBsJRYo6U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2403",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 46 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mow4e4ik6n4",
    "youtubeId": "mow4e4ik6n4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2404",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 45 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xi3EpQRlvpc",
    "youtubeId": "xi3EpQRlvpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2405",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 44 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a1RIIHa0-vM",
    "youtubeId": "a1RIIHa0-vM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2406",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 43 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gKvYwBm4s5M",
    "youtubeId": "gKvYwBm4s5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2407",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 42 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qxggghrI6fU",
    "youtubeId": "qxggghrI6fU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2408",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 41 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RvQfOgbXyGo",
    "youtubeId": "RvQfOgbXyGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2409",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 40 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qpsPL2-lVYk",
    "youtubeId": "qpsPL2-lVYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2410",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 39 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9ZgVVq30VvU",
    "youtubeId": "9ZgVVq30VvU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2411",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 38 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e09RI6A3a1o",
    "youtubeId": "e09RI6A3a1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2412",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 37 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l0UUERduQ_E",
    "youtubeId": "l0UUERduQ_E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2413",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 36 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YrGKC-S5CQw",
    "youtubeId": "YrGKC-S5CQw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2414",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 35 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7g3saeONlDk",
    "youtubeId": "7g3saeONlDk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2415",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 34 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dsdVFc-gODQ",
    "youtubeId": "dsdVFc-gODQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2416",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 33 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JzlI8LfdBFg",
    "youtubeId": "JzlI8LfdBFg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2417",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 32 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZV94cfWLcyQ",
    "youtubeId": "ZV94cfWLcyQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2418",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 31 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ex1YDLU7feM",
    "youtubeId": "Ex1YDLU7feM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2419",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 30 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pHALAhVuD_U",
    "youtubeId": "pHALAhVuD_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2420",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 28 & 29 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ugr8iplILIw",
    "youtubeId": "Ugr8iplILIw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2421",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 26 & 27 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tVHK4za2R8s",
    "youtubeId": "tVHK4za2R8s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2422",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 25 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2ttWiq3p7mU",
    "youtubeId": "2ttWiq3p7mU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2423",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 24 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qrx-pUNGSTw",
    "youtubeId": "qrx-pUNGSTw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2424",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 23 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hvNogsdNDEE",
    "youtubeId": "hvNogsdNDEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2425",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 22 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yD6JLajfO9Q",
    "youtubeId": "yD6JLajfO9Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2426",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 21 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IymaDlRVa54",
    "youtubeId": "IymaDlRVa54",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2427",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 20 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/opGolhtpE_s",
    "youtubeId": "opGolhtpE_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2428",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 19 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ShoK5oStX5U",
    "youtubeId": "ShoK5oStX5U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2429",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 18 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7jg1u4t9IPo",
    "youtubeId": "7jg1u4t9IPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2430",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 17 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gRYQLTJ90nk",
    "youtubeId": "gRYQLTJ90nk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2431",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 16 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GY-szCJFbMU",
    "youtubeId": "GY-szCJFbMU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2432",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 15 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QXncVfmuuD0",
    "youtubeId": "QXncVfmuuD0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2433",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 14 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BupGKvOhfMs",
    "youtubeId": "BupGKvOhfMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2434",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 13 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tR_YYb2y2Qg",
    "youtubeId": "tR_YYb2y2Qg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2435",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 12 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Ap6X4lMb9M",
    "youtubeId": "0Ap6X4lMb9M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2436",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 11 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X7-gUIUC52s",
    "youtubeId": "X7-gUIUC52s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2437",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 10 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5OqRXObgh4M",
    "youtubeId": "5OqRXObgh4M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2438",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 9 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UcIo0LXg17Q",
    "youtubeId": "UcIo0LXg17Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2439",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 8 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SjvAfNaHmYQ",
    "youtubeId": "SjvAfNaHmYQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2440",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 7 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lYA6T7t3uI8",
    "youtubeId": "lYA6T7t3uI8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2441",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 6 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b6GlHWPzur0",
    "youtubeId": "b6GlHWPzur0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2442",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 5 Surah Ya Sin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bJxtMiPG1b4",
    "youtubeId": "bJxtMiPG1b4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2443",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 4 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/75hPDBN46jk",
    "youtubeId": "75hPDBN46jk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2444",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 3 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4G2lzsgwSHk",
    "youtubeId": "4G2lzsgwSHk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2445",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 2 Surah YaSin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/logIqOnST0M",
    "youtubeId": "logIqOnST0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2446",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 36 Ayat 1 Surah Yasin Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LFYNhi7iBWc",
    "youtubeId": "LFYNhi7iBWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2447",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 45 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_7x8zCTVtww",
    "youtubeId": "_7x8zCTVtww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2448",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 44 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cxsBS6zJ5JM",
    "youtubeId": "cxsBS6zJ5JM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2449",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 43 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GCluwRzcgBI",
    "youtubeId": "GCluwRzcgBI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2450",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 42 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KlVJKYvXXGo",
    "youtubeId": "KlVJKYvXXGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2451",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 41 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bjws5uIhqHI",
    "youtubeId": "bjws5uIhqHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2452",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 40 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NQlG0889nlY",
    "youtubeId": "NQlG0889nlY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2453",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 39 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pxJxk9OTuSk",
    "youtubeId": "pxJxk9OTuSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2454",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 38 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lay-nG2NtwM",
    "youtubeId": "lay-nG2NtwM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2455",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 37 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kh8q1m25alw",
    "youtubeId": "kh8q1m25alw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2456",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 36 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fo4JFFFtXvY",
    "youtubeId": "Fo4JFFFtXvY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2457",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 35 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eycujTuwLXM",
    "youtubeId": "eycujTuwLXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2458",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 34 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TFPuRPK-pNw",
    "youtubeId": "TFPuRPK-pNw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2459",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 33 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/63r2VXvST6U",
    "youtubeId": "63r2VXvST6U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2460",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 32 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EiDjeaGYKJw",
    "youtubeId": "EiDjeaGYKJw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2461",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 31 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4YEfmJavdaI",
    "youtubeId": "4YEfmJavdaI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2462",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 30 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RbO-J06IV_U",
    "youtubeId": "RbO-J06IV_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2463",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 29 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M27eC6Otp3I",
    "youtubeId": "M27eC6Otp3I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2464",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 28 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sfj_A0RKV74",
    "youtubeId": "Sfj_A0RKV74",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2465",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 27 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eq39Oi78810",
    "youtubeId": "eq39Oi78810",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2466",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 26 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qWhdKZghDi8",
    "youtubeId": "qWhdKZghDi8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2467",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 25 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mgAzyHaiakE",
    "youtubeId": "mgAzyHaiakE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2468",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 24 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kNJr6o182zY",
    "youtubeId": "kNJr6o182zY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2469",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 23 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XAbWm4pY9ro",
    "youtubeId": "XAbWm4pY9ro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2470",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 22 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S_9BC-cUuns",
    "youtubeId": "S_9BC-cUuns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2471",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 21 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0AJEWxfXkg0",
    "youtubeId": "0AJEWxfXkg0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2472",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 20 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aD5a8M1PpWw",
    "youtubeId": "aD5a8M1PpWw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2473",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 19 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Jc3uAX8aeQ",
    "youtubeId": "_Jc3uAX8aeQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2474",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 18 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qy_StNyFCo4",
    "youtubeId": "qy_StNyFCo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2475",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 17 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RMVIqAwGRnA",
    "youtubeId": "RMVIqAwGRnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2476",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 16 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cN2FD_HlPXI",
    "youtubeId": "cN2FD_HlPXI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2477",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 15 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gw_noHN9Xyc",
    "youtubeId": "Gw_noHN9Xyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2478",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 14 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QAKoA5iJZHI",
    "youtubeId": "QAKoA5iJZHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2479",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 13 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/md_OwO3zhCE",
    "youtubeId": "md_OwO3zhCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2480",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 12 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L7ppzRJDcrc",
    "youtubeId": "L7ppzRJDcrc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2481",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 11 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mMniYNvgi9k",
    "youtubeId": "mMniYNvgi9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2482",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 10 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VnY0yQ1usL0",
    "youtubeId": "VnY0yQ1usL0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2483",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 9 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YIGr4X6QhXk",
    "youtubeId": "YIGr4X6QhXk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2484",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 8 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_7dph18dL4E",
    "youtubeId": "_7dph18dL4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2485",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 7 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CvjJXQJ_9Uw",
    "youtubeId": "CvjJXQJ_9Uw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2486",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 6 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CSZ4lP10c5U",
    "youtubeId": "CSZ4lP10c5U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2487",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 5 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2VicGxYJOA4",
    "youtubeId": "2VicGxYJOA4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2488",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 4 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YZV3OlaFwtk",
    "youtubeId": "YZV3OlaFwtk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2489",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 3 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mZ3N8Kpopkw",
    "youtubeId": "mZ3N8Kpopkw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2490",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 2 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lr5OT7iPeVM",
    "youtubeId": "lr5OT7iPeVM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2491",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 35 Ayat 1 Surah Fatir Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GUHckrN_5QA",
    "youtubeId": "GUHckrN_5QA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2492",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 54 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jH9JYKDGUrs",
    "youtubeId": "jH9JYKDGUrs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2493",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 53 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6_PV7kplAbc",
    "youtubeId": "6_PV7kplAbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2494",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 52 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NphgF13iBwA",
    "youtubeId": "NphgF13iBwA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2495",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 51 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SZR_t_0CvTU",
    "youtubeId": "SZR_t_0CvTU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2496",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 50 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BEPWNGfA0g0",
    "youtubeId": "BEPWNGfA0g0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2497",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 49 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EcOI9JG9xdo",
    "youtubeId": "EcOI9JG9xdo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2498",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 48 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rabyL192VEQ",
    "youtubeId": "rabyL192VEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2499",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 47 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BLqonWOOUpE",
    "youtubeId": "BLqonWOOUpE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2500",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 46 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VoosDqVFWmk",
    "youtubeId": "VoosDqVFWmk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2501",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 45 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7oTEmFhj6pc",
    "youtubeId": "7oTEmFhj6pc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2502",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 44 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2jJ2KkKbOlk",
    "youtubeId": "2jJ2KkKbOlk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2503",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 43 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c19BQ_2LYqE",
    "youtubeId": "c19BQ_2LYqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2504",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 42 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3eRtCRNCQjs",
    "youtubeId": "3eRtCRNCQjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2505",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 41 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KskiMzBdDwk",
    "youtubeId": "KskiMzBdDwk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2506",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 40 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KytUKBqBxVs",
    "youtubeId": "KytUKBqBxVs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2507",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 39 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gDJyXPoU2jA",
    "youtubeId": "gDJyXPoU2jA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2508",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 38 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zd8J3ZI_TsY",
    "youtubeId": "zd8J3ZI_TsY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2509",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 37 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EdXOyCwlvM8",
    "youtubeId": "EdXOyCwlvM8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2510",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 36 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j1BP0p2hsks",
    "youtubeId": "j1BP0p2hsks",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2511",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 35 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bHx1kYwmZgQ",
    "youtubeId": "bHx1kYwmZgQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2512",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 34 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1QRCR6hR1xE",
    "youtubeId": "1QRCR6hR1xE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2513",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 33 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aAlZDz16h6E",
    "youtubeId": "aAlZDz16h6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2514",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 32 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yfRa-RPCFFA",
    "youtubeId": "yfRa-RPCFFA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2515",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 31 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fx_Q6sT1wes",
    "youtubeId": "Fx_Q6sT1wes",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2516",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 30 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bUCxK6mKyLQ",
    "youtubeId": "bUCxK6mKyLQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2517",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 29 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aH-xm1HFiQs",
    "youtubeId": "aH-xm1HFiQs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2518",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 28 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oFDQnnabF0E",
    "youtubeId": "oFDQnnabF0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2519",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 27 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jmD1CrR9XoA",
    "youtubeId": "jmD1CrR9XoA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2520",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 26 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uJ5_Xq7yJnA",
    "youtubeId": "uJ5_Xq7yJnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2521",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 25 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XiNH6RRICS0",
    "youtubeId": "XiNH6RRICS0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2522",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 24 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/txgX9c7ECaE",
    "youtubeId": "txgX9c7ECaE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2523",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 23 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i3eomykSsj0",
    "youtubeId": "i3eomykSsj0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2524",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 22 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AQBUgWDzYUA",
    "youtubeId": "AQBUgWDzYUA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2525",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 21 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QafW_IFXEjg",
    "youtubeId": "QafW_IFXEjg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2526",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 20 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gwrix-GeemU",
    "youtubeId": "Gwrix-GeemU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2527",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 19 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bxy4A1mxNqo",
    "youtubeId": "Bxy4A1mxNqo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2528",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 18 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ddYW-h8U4jM",
    "youtubeId": "ddYW-h8U4jM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2529",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 17 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/caQCiRYYjA8",
    "youtubeId": "caQCiRYYjA8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2530",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 16 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9wqQYcOJ9Ig",
    "youtubeId": "9wqQYcOJ9Ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2531",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 15 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uIzveAVnCO8",
    "youtubeId": "uIzveAVnCO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2532",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 14 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MQ2NjtUrZqw",
    "youtubeId": "MQ2NjtUrZqw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2533",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 13 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GWMyH4GdNJg",
    "youtubeId": "GWMyH4GdNJg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2534",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 12 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X2RTeibY63g",
    "youtubeId": "X2RTeibY63g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2535",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 11 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hK8r_Q5Z8go",
    "youtubeId": "hK8r_Q5Z8go",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2536",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 10 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rdAXuyB6mj8",
    "youtubeId": "rdAXuyB6mj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2537",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 9 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BkNDyl5jY4c",
    "youtubeId": "BkNDyl5jY4c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2538",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 8 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u82tUh1N4g8",
    "youtubeId": "u82tUh1N4g8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2539",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 7 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EnWO0jThhzQ",
    "youtubeId": "EnWO0jThhzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2540",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 6 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_rGFdwyOsuA",
    "youtubeId": "_rGFdwyOsuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2541",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 5 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F_yroMvA2vg",
    "youtubeId": "F_yroMvA2vg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2542",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 4 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/if3hGfbH-6I",
    "youtubeId": "if3hGfbH-6I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2543",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 3 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RNq9c6ne5H4",
    "youtubeId": "RNq9c6ne5H4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2544",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 2 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i6_d2w0CNiI",
    "youtubeId": "i6_d2w0CNiI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2545",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 34 Ayat 1 Surah Saba Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-0J0FhyH9jE",
    "youtubeId": "-0J0FhyH9jE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2546",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 73 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jl3dY3KHDc4",
    "youtubeId": "jl3dY3KHDc4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2547",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 72 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1Agr6A0H4u0",
    "youtubeId": "1Agr6A0H4u0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2548",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 71 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iHXya6JwDR4",
    "youtubeId": "iHXya6JwDR4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2549",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 70 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AzLXzwJGIdk",
    "youtubeId": "AzLXzwJGIdk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2550",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 69 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WwvUA0auPfw",
    "youtubeId": "WwvUA0auPfw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2551",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 68 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1UHUT1u4KCc",
    "youtubeId": "1UHUT1u4KCc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2552",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 67 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1G5sy0KesEQ",
    "youtubeId": "1G5sy0KesEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2553",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 66 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/64sHZa6hef8",
    "youtubeId": "64sHZa6hef8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2554",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 65 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VBgB_r9kNFE",
    "youtubeId": "VBgB_r9kNFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2555",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 64 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ud7UygqoB1c",
    "youtubeId": "Ud7UygqoB1c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2556",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 63 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/We-TikFtqJo",
    "youtubeId": "We-TikFtqJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2557",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 62 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4988goyCuKE",
    "youtubeId": "4988goyCuKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2558",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 61 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fQbk1keJyQE",
    "youtubeId": "fQbk1keJyQE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2559",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 59 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P0TW90RZDtY",
    "youtubeId": "P0TW90RZDtY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2560",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 60 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QSbEHFVWqzQ",
    "youtubeId": "QSbEHFVWqzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2561",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 58 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cheAxYPDHtA",
    "youtubeId": "cheAxYPDHtA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2562",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 57 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LUE7ij4WPAA",
    "youtubeId": "LUE7ij4WPAA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2563",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 56 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9-hIrBzlAj4",
    "youtubeId": "9-hIrBzlAj4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2564",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 55 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5MnE3tO6T9Y",
    "youtubeId": "5MnE3tO6T9Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2565",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 54 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s99m-gnp_hc",
    "youtubeId": "s99m-gnp_hc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2566",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 53 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UMTGSYiPBt0",
    "youtubeId": "UMTGSYiPBt0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2567",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 52 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/che3f7_LaIo",
    "youtubeId": "che3f7_LaIo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2568",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 51 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f34g7qmUrnw",
    "youtubeId": "f34g7qmUrnw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2569",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 50 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ulo6hGJgu8U",
    "youtubeId": "ulo6hGJgu8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2570",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 49 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PojDN5tgsZo",
    "youtubeId": "PojDN5tgsZo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2571",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 48 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kvBRchkkOus",
    "youtubeId": "kvBRchkkOus",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2572",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 47 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AMWMfRx7gRY",
    "youtubeId": "AMWMfRx7gRY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2573",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 45 & 46 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/saR-XeQbKl8",
    "youtubeId": "saR-XeQbKl8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2574",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 44 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uVbWOfSnHfY",
    "youtubeId": "uVbWOfSnHfY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2575",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 43 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UHWlCltRcm0",
    "youtubeId": "UHWlCltRcm0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2576",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 42 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NKxsfo2Epms",
    "youtubeId": "NKxsfo2Epms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2577",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 41 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ojToXs41h60",
    "youtubeId": "ojToXs41h60",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2578",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 40 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kEh6Q3v4T_s",
    "youtubeId": "kEh6Q3v4T_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2579",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 39 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xvfUqfCabvc",
    "youtubeId": "xvfUqfCabvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2580",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 38 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tdja3KsbZE8",
    "youtubeId": "Tdja3KsbZE8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2581",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 37 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iaNXIOEHpwo",
    "youtubeId": "iaNXIOEHpwo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2582",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 36 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q055uYEz5hM",
    "youtubeId": "q055uYEz5hM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2583",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 35 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ddiBUDRXlwc",
    "youtubeId": "ddiBUDRXlwc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2584",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 34 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bhjWOeAoArw",
    "youtubeId": "bhjWOeAoArw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2585",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 33 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i4zAroFfvy4",
    "youtubeId": "i4zAroFfvy4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2586",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 32 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rdm37-oUklY",
    "youtubeId": "rdm37-oUklY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2587",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 31 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2ZgOjUjoiWc",
    "youtubeId": "2ZgOjUjoiWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2588",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 30 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Geujv7X8iUU",
    "youtubeId": "Geujv7X8iUU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2589",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 29 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZLcvn34XgRc",
    "youtubeId": "ZLcvn34XgRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2590",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 28 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KnewkpdSmgs",
    "youtubeId": "KnewkpdSmgs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2591",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 27 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QPr_kJJXIKc",
    "youtubeId": "QPr_kJJXIKc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2592",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 26 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1fTajRj9hEc",
    "youtubeId": "1fTajRj9hEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2593",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 25 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WQ9PvYbbM5E",
    "youtubeId": "WQ9PvYbbM5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2594",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 24 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WKlngs3jzLE",
    "youtubeId": "WKlngs3jzLE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2595",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 23 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gcxUzGR3AqY",
    "youtubeId": "gcxUzGR3AqY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2596",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 22 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2Q2bIYBn1D4",
    "youtubeId": "2Q2bIYBn1D4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2597",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 21 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hgDY05QvGds",
    "youtubeId": "hgDY05QvGds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2598",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 20 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ziQ6RqXziho",
    "youtubeId": "ziQ6RqXziho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2599",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 19 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m5t5QBllWiM",
    "youtubeId": "m5t5QBllWiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2600",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 18 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s2Yl3w22lLg",
    "youtubeId": "s2Yl3w22lLg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2601",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 17 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MD9iBPW9gA4",
    "youtubeId": "MD9iBPW9gA4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2602",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 16 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/szYjewcHET8",
    "youtubeId": "szYjewcHET8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2603",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 15 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dNry1gccKpc",
    "youtubeId": "dNry1gccKpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2604",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 14 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uf--INz2vAI",
    "youtubeId": "Uf--INz2vAI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2605",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 13 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kjIMu67VQpo",
    "youtubeId": "kjIMu67VQpo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2606",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 12 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KvryQYtb__I",
    "youtubeId": "KvryQYtb__I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2607",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 11 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vUyCMgplp-M",
    "youtubeId": "vUyCMgplp-M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2608",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 10 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QmkuY5kLReM",
    "youtubeId": "QmkuY5kLReM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2609",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 9 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bq-cpw2ZIsM",
    "youtubeId": "Bq-cpw2ZIsM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2610",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 8 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qRCkBQI-ULk",
    "youtubeId": "qRCkBQI-ULk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2611",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 7 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JCkd9ZxiNw0",
    "youtubeId": "JCkd9ZxiNw0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2612",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 6 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LZf5-VqSTMg",
    "youtubeId": "LZf5-VqSTMg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2613",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 5 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x8d72VqRFbo",
    "youtubeId": "x8d72VqRFbo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2614",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 4 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dgx8vpG5eE0",
    "youtubeId": "dgx8vpG5eE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2615",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 3 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a3EESUFSfW4",
    "youtubeId": "a3EESUFSfW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2616",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 2 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JyLJJrfBTvs",
    "youtubeId": "JyLJJrfBTvs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2617",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 33 Ayat 1 Surah Ahzab Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ea61pnx4tJ8",
    "youtubeId": "ea61pnx4tJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2618",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 30 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wf4jDr6MeJI",
    "youtubeId": "Wf4jDr6MeJI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2619",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 29 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/90kNg0Iu5Tk",
    "youtubeId": "90kNg0Iu5Tk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2620",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 28 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nA6zXN4EfCU",
    "youtubeId": "nA6zXN4EfCU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2621",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 27 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1rhnopjxisg",
    "youtubeId": "1rhnopjxisg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2622",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 26 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aM_tjy1ynbc",
    "youtubeId": "aM_tjy1ynbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2623",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 25 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oQkJe2MwEQk",
    "youtubeId": "oQkJe2MwEQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2624",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 24 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8UsvL9xwAGA",
    "youtubeId": "8UsvL9xwAGA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2625",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 23 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zLzxkDXXIYU",
    "youtubeId": "zLzxkDXXIYU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2626",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 22 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q3zGXDib9D0",
    "youtubeId": "q3zGXDib9D0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2627",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 21 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PJpps9Wpq3U",
    "youtubeId": "PJpps9Wpq3U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2628",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 20 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H1FmDvOWMyc",
    "youtubeId": "H1FmDvOWMyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2629",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 19 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qt9pvgopmPQ",
    "youtubeId": "Qt9pvgopmPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2630",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 18 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s1znPJ8xBNU",
    "youtubeId": "s1znPJ8xBNU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2631",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 17 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kzp-IA7Luhg",
    "youtubeId": "Kzp-IA7Luhg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2632",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 16 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7PnP2CjGbQY",
    "youtubeId": "7PnP2CjGbQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2633",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 14 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fa1VqjRP8_o",
    "youtubeId": "Fa1VqjRP8_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2634",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 15 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zP8NyGVjaWs",
    "youtubeId": "zP8NyGVjaWs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2635",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 13 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yLRsbpaduTo",
    "youtubeId": "yLRsbpaduTo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2636",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 12 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CW17JU2D4HU",
    "youtubeId": "CW17JU2D4HU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2637",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 11 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cf3uxAH4gYw",
    "youtubeId": "cf3uxAH4gYw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2638",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 10 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gOawXY338l0",
    "youtubeId": "gOawXY338l0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2639",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 9 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C5cr1Eo-ixs",
    "youtubeId": "C5cr1Eo-ixs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2640",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 8 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/972cx07apjE",
    "youtubeId": "972cx07apjE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2641",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 7 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y41RAZV2eM8",
    "youtubeId": "y41RAZV2eM8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2642",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 6 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tFfmnY4tdtI",
    "youtubeId": "tFfmnY4tdtI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2643",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 5 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vuSKVK0kAFs",
    "youtubeId": "vuSKVK0kAFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2644",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 4 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E7jy0_NqvzI",
    "youtubeId": "E7jy0_NqvzI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2645",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 3 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OqwXrFhLxg4",
    "youtubeId": "OqwXrFhLxg4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2646",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 32 Ayat 2 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q_Mm-CHLMc8",
    "youtubeId": "q_Mm-CHLMc8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2647",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction and Ayat 1 Surah Sajdah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/up8fbZxJIXY",
    "youtubeId": "up8fbZxJIXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2648",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 34 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/geAMb7YUD3s",
    "youtubeId": "geAMb7YUD3s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2649",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 33 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FCEQlwXmXQk",
    "youtubeId": "FCEQlwXmXQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2650",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 32 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i17UhR4SM0w",
    "youtubeId": "i17UhR4SM0w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2651",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 31 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dJGp0f8gXbY",
    "youtubeId": "dJGp0f8gXbY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2652",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 30 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wdYgoiq8FOA",
    "youtubeId": "wdYgoiq8FOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2653",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 29 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MJgXmbP7pKE",
    "youtubeId": "MJgXmbP7pKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2654",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 28 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/klCXhq3t6Vs",
    "youtubeId": "klCXhq3t6Vs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2655",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 27 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oTV4yuNKqh8",
    "youtubeId": "oTV4yuNKqh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2656",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 26 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zIisdk_aiLU",
    "youtubeId": "zIisdk_aiLU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2657",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 25 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TiCGVdEB5Hw",
    "youtubeId": "TiCGVdEB5Hw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2658",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 24 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/443Hbl18xrQ",
    "youtubeId": "443Hbl18xrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2659",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 23 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W1px_IeVBpQ",
    "youtubeId": "W1px_IeVBpQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2660",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 22 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0ba0m9CFCTM",
    "youtubeId": "0ba0m9CFCTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2661",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 21 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MYwE0jmvx1I",
    "youtubeId": "MYwE0jmvx1I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2662",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 20 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8IsxnmnlDXc",
    "youtubeId": "8IsxnmnlDXc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2663",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 19 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6RLvX2zYwlk",
    "youtubeId": "6RLvX2zYwlk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2664",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 18 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oE3fLgXlTWA",
    "youtubeId": "oE3fLgXlTWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2665",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 17 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TJ27M9TZAkE",
    "youtubeId": "TJ27M9TZAkE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2666",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 16 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/29yPOlIgYY4",
    "youtubeId": "29yPOlIgYY4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2667",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 15 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iKb4_6bjLDs",
    "youtubeId": "iKb4_6bjLDs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2668",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 14 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XWQDzmq-UyM",
    "youtubeId": "XWQDzmq-UyM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2669",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 13 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zka-3b0exic",
    "youtubeId": "zka-3b0exic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2670",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 12 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UdUH9zt4ndA",
    "youtubeId": "UdUH9zt4ndA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2671",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 11 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u7WYm4QXBpQ",
    "youtubeId": "u7WYm4QXBpQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2672",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 10 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/95oEuVcUFkw",
    "youtubeId": "95oEuVcUFkw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2673",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 9 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l0wZj9uaxac",
    "youtubeId": "l0wZj9uaxac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2674",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 8 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A0sIQ34YOLw",
    "youtubeId": "A0sIQ34YOLw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2675",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 7 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a-G2uVyeGpY",
    "youtubeId": "a-G2uVyeGpY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2676",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 6 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wI-Z7H-mESk",
    "youtubeId": "wI-Z7H-mESk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2677",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 5 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k1mtYF4o2Ro",
    "youtubeId": "k1mtYF4o2Ro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2678",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 4 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k9n368wK6KQ",
    "youtubeId": "k9n368wK6KQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2679",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 3 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JiENAGwAMVg",
    "youtubeId": "JiENAGwAMVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2680",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 2 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8SSYoY0nBnc",
    "youtubeId": "8SSYoY0nBnc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2681",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 31 Ayat 1 Surah Luqman Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P0_ydiOGT4w",
    "youtubeId": "P0_ydiOGT4w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2682",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 60 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AOoL8BekpXM",
    "youtubeId": "AOoL8BekpXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2683",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 59 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xizfj49wQgU",
    "youtubeId": "Xizfj49wQgU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2684",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 58 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1VHFcW3dGbM",
    "youtubeId": "1VHFcW3dGbM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2685",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 57 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U4KBPeWtmrQ",
    "youtubeId": "U4KBPeWtmrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2686",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 56 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cb_hssXFY-k",
    "youtubeId": "Cb_hssXFY-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2687",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 55 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NWZj3KJTHNI",
    "youtubeId": "NWZj3KJTHNI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2688",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 54 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mRX2t90cimA",
    "youtubeId": "mRX2t90cimA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2689",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 53 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-W9XAtf3DAw",
    "youtubeId": "-W9XAtf3DAw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2690",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 52 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V34S4P24xb0",
    "youtubeId": "V34S4P24xb0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2691",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 51 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XZw7Y5AlPek",
    "youtubeId": "XZw7Y5AlPek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2692",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 50 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lfcTdLtStWg",
    "youtubeId": "lfcTdLtStWg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2693",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 49 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wxUlpsYcnoc",
    "youtubeId": "wxUlpsYcnoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2694",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 48 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0JNzS2bDVyk",
    "youtubeId": "0JNzS2bDVyk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2695",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 47 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/87PBjnOpjcI",
    "youtubeId": "87PBjnOpjcI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2696",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 46 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L7JBOiPrLD0",
    "youtubeId": "L7JBOiPrLD0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2697",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 45 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FPQpxavlrio",
    "youtubeId": "FPQpxavlrio",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2698",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 44 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p_FVPG4hWao",
    "youtubeId": "p_FVPG4hWao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2699",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 42 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G0VxWLJpWDA",
    "youtubeId": "G0VxWLJpWDA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2700",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 43 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4wrDah9X4eI",
    "youtubeId": "4wrDah9X4eI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2701",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 41 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9j-hhf2m-ek",
    "youtubeId": "9j-hhf2m-ek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2702",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 40 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L3Xpj_fXc04",
    "youtubeId": "L3Xpj_fXc04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2703",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 39 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vcIf7FbCiMA",
    "youtubeId": "vcIf7FbCiMA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2704",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 38 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pmyoOh-7W0U",
    "youtubeId": "pmyoOh-7W0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2705",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 37 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qVVpu6c5CN4",
    "youtubeId": "qVVpu6c5CN4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2706",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 36 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AWEdXbA5gN4",
    "youtubeId": "AWEdXbA5gN4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2707",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 35 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DeE_Rl4V-T4",
    "youtubeId": "DeE_Rl4V-T4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2708",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 34 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qhu3W1MiTVs",
    "youtubeId": "Qhu3W1MiTVs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2709",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 33 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aCBECiXucoI",
    "youtubeId": "aCBECiXucoI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2710",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 32 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mYR2MOGk4Ew",
    "youtubeId": "mYR2MOGk4Ew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2711",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 31 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZWp8g8ifv_Q",
    "youtubeId": "ZWp8g8ifv_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2712",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 30 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Pe0yDRvR8KQ",
    "youtubeId": "Pe0yDRvR8KQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2713",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 29 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KfBvxs5aKec",
    "youtubeId": "KfBvxs5aKec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2714",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 28 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8NTkPSoPlw0",
    "youtubeId": "8NTkPSoPlw0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2715",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 27 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wcIwNYxjoqw",
    "youtubeId": "wcIwNYxjoqw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2716",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 26 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OTdtZFyRowA",
    "youtubeId": "OTdtZFyRowA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2717",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 25 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WIrUpA0Yqd8",
    "youtubeId": "WIrUpA0Yqd8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2718",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 24 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RPQBLjJllxA",
    "youtubeId": "RPQBLjJllxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2719",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 23 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k2YuPiVr5Oc",
    "youtubeId": "k2YuPiVr5Oc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2720",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 22 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ou61zeVhq0s",
    "youtubeId": "ou61zeVhq0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2721",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 21 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kvHq8AUzD18",
    "youtubeId": "kvHq8AUzD18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2722",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 20 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sNRoOkhcBpU",
    "youtubeId": "sNRoOkhcBpU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2723",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 19 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ez2QPmyHAKE",
    "youtubeId": "Ez2QPmyHAKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2724",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 18 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hp9uPpOBfz4",
    "youtubeId": "Hp9uPpOBfz4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2725",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 17 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/50yZZSrDIng",
    "youtubeId": "50yZZSrDIng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2726",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 16 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IDDC0ySDBqc",
    "youtubeId": "IDDC0ySDBqc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2727",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 15 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LrZ_uyVose8",
    "youtubeId": "LrZ_uyVose8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2728",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 14 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7I6QMTex-Fs",
    "youtubeId": "7I6QMTex-Fs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2729",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 13 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-6U7sQNt_h4",
    "youtubeId": "-6U7sQNt_h4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2730",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 12 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pPioMMbK0Hc",
    "youtubeId": "pPioMMbK0Hc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2731",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 11 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c5b-5UNl-JY",
    "youtubeId": "c5b-5UNl-JY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2732",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 10 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_DW5KGAGbZU",
    "youtubeId": "_DW5KGAGbZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2733",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 9 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ap7BD7qVFdk",
    "youtubeId": "ap7BD7qVFdk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2734",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 8 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X2KYnQdWuCE",
    "youtubeId": "X2KYnQdWuCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2735",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 7 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VlsHNh2B5ME",
    "youtubeId": "VlsHNh2B5ME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2736",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 6 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z75pzrvOds4",
    "youtubeId": "Z75pzrvOds4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2737",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 5 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_VDY29H_118",
    "youtubeId": "_VDY29H_118",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2738",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 4 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ey-8O6BW7B0",
    "youtubeId": "Ey-8O6BW7B0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2739",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 3 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ig8ZZM0Idbg",
    "youtubeId": "Ig8ZZM0Idbg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2740",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 30 Ayat 2 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BX91839EKd4",
    "youtubeId": "BX91839EKd4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2741",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction and Ayat 1 Surah Rum Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gf1Bpb-ALyo",
    "youtubeId": "Gf1Bpb-ALyo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2742",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 69 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lYK-KYVeEBQ",
    "youtubeId": "lYK-KYVeEBQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2743",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 68 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1-xOgS1yfJc",
    "youtubeId": "1-xOgS1yfJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2744",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 67 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xd23X3GxtXI",
    "youtubeId": "xd23X3GxtXI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2745",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 66 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FmFqy0gK4os",
    "youtubeId": "FmFqy0gK4os",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2746",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 65 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mTko7MbIrBo",
    "youtubeId": "mTko7MbIrBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2747",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 64 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S7Dsq1rxmGA",
    "youtubeId": "S7Dsq1rxmGA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2748",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 63 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b8QF0N3z7HA",
    "youtubeId": "b8QF0N3z7HA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2749",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 62 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mYYEUqGi7dc",
    "youtubeId": "mYYEUqGi7dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2750",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 61 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/riijB5wuqNs",
    "youtubeId": "riijB5wuqNs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2751",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 60 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JvSCA0NAVQ8",
    "youtubeId": "JvSCA0NAVQ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2752",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 59 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fQlWPORvVdQ",
    "youtubeId": "fQlWPORvVdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2753",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 58 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qa4zYy_qcnk",
    "youtubeId": "qa4zYy_qcnk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2754",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 57 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AUuSk_7giwE",
    "youtubeId": "AUuSk_7giwE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2755",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 56 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/84qELRjylKc",
    "youtubeId": "84qELRjylKc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2756",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 55 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SqWxhXdZCRo",
    "youtubeId": "SqWxhXdZCRo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2757",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 54 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_uarTbkYGTk",
    "youtubeId": "_uarTbkYGTk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2758",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 53 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wiyIOIHE7Cg",
    "youtubeId": "wiyIOIHE7Cg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2759",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 52 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MfL8HMukiCI",
    "youtubeId": "MfL8HMukiCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2760",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 51 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NOtsKJCVp6Y",
    "youtubeId": "NOtsKJCVp6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2761",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 50 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3vMb1XuS2-0",
    "youtubeId": "3vMb1XuS2-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2762",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 49 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/opM5qCU65PY",
    "youtubeId": "opM5qCU65PY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2763",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 48 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RV4jSRh8NsE",
    "youtubeId": "RV4jSRh8NsE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2764",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 47 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mJ5YHNP46d8",
    "youtubeId": "mJ5YHNP46d8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2765",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 46 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V3mh15POhgU",
    "youtubeId": "V3mh15POhgU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2766",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 45 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0pyb99-51jQ",
    "youtubeId": "0pyb99-51jQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2767",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 44 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gTa2w2ty7_o",
    "youtubeId": "gTa2w2ty7_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2768",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 43 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xJN3QM0_59E",
    "youtubeId": "xJN3QM0_59E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2769",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 42 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qc0aTxZiVMs",
    "youtubeId": "Qc0aTxZiVMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2770",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 41 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BP_TYuGxs3Y",
    "youtubeId": "BP_TYuGxs3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2771",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 40 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Ppc4qAY5xM",
    "youtubeId": "9Ppc4qAY5xM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2772",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 39 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wWwaM1jaWak",
    "youtubeId": "wWwaM1jaWak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2773",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 38 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IDhpDkQnNdE",
    "youtubeId": "IDhpDkQnNdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2774",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 37 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qJlj1mJuJn0",
    "youtubeId": "qJlj1mJuJn0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2775",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 36 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JSa3FPE8XXM",
    "youtubeId": "JSa3FPE8XXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2776",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 35 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-8yuEpX9GX4",
    "youtubeId": "-8yuEpX9GX4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2777",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 34 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LcTkjAxKLI0",
    "youtubeId": "LcTkjAxKLI0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2778",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 33 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4YoU9sG6j1E",
    "youtubeId": "4YoU9sG6j1E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2779",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 32 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wya2kbNZ4uM",
    "youtubeId": "wya2kbNZ4uM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2780",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 31 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NoyU3fs5-ps",
    "youtubeId": "NoyU3fs5-ps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2781",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 30 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BELfUy4VbJU",
    "youtubeId": "BELfUy4VbJU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2782",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 29 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hYH_ukMF0yg",
    "youtubeId": "hYH_ukMF0yg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2783",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 28 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a7FggIA0E5M",
    "youtubeId": "a7FggIA0E5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2784",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 27 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GtloiH0Y3-Q",
    "youtubeId": "GtloiH0Y3-Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2785",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 26 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sQjPgwEKAHM",
    "youtubeId": "sQjPgwEKAHM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2786",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 25 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f80kXdczOm4",
    "youtubeId": "f80kXdczOm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2787",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 24 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B05Q-HaKEv0",
    "youtubeId": "B05Q-HaKEv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2788",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 23 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AtR4FL9sepM",
    "youtubeId": "AtR4FL9sepM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2789",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 22 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pjxEP7w2mxA",
    "youtubeId": "pjxEP7w2mxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2790",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 21 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6ImlVAzt4y4",
    "youtubeId": "6ImlVAzt4y4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2791",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 20 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WNtILkj8YoE",
    "youtubeId": "WNtILkj8YoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2792",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 19 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RiNsADnFb3A",
    "youtubeId": "RiNsADnFb3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2793",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 18 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NHjlKqaHqME",
    "youtubeId": "NHjlKqaHqME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2794",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 17 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FEOXRyl1vFw",
    "youtubeId": "FEOXRyl1vFw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2795",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 16 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eZbCSkwudzs",
    "youtubeId": "eZbCSkwudzs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2796",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 15 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lMwAW9oUQDs",
    "youtubeId": "lMwAW9oUQDs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2797",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 14 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xTvXgY56LMo",
    "youtubeId": "xTvXgY56LMo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2798",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 13 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wg95cuf27GU",
    "youtubeId": "Wg95cuf27GU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2799",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 12 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G2GTYyNrI5M",
    "youtubeId": "G2GTYyNrI5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2800",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 11 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JCfoZCF51sc",
    "youtubeId": "JCfoZCF51sc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2801",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 10 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nEMwGQK_aMM",
    "youtubeId": "nEMwGQK_aMM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2802",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 9 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8eY4oRvF8o4",
    "youtubeId": "8eY4oRvF8o4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2803",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 8 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gj6hNNQqfkA",
    "youtubeId": "gj6hNNQqfkA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2804",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 7 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u16BTiFr0nY",
    "youtubeId": "u16BTiFr0nY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2805",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 6 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yi1ljO6fKvg",
    "youtubeId": "yi1ljO6fKvg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2806",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 5 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZOMfoyGgksc",
    "youtubeId": "ZOMfoyGgksc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2807",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 4 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8T8nnGuSdWM",
    "youtubeId": "8T8nnGuSdWM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2808",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 3 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ADLODREgm-4",
    "youtubeId": "ADLODREgm-4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2809",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 2 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m9zDn8Ci9XQ",
    "youtubeId": "m9zDn8Ci9XQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2810",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 29 Ayat 1 Surah Ankabut Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/akVS_F0HK4A",
    "youtubeId": "akVS_F0HK4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2811",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 88 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ch5MKbJulIE",
    "youtubeId": "ch5MKbJulIE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2812",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 87 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZHb5dZAs9JQ",
    "youtubeId": "ZHb5dZAs9JQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2813",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 86 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k4JspaxMffY",
    "youtubeId": "k4JspaxMffY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2814",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 85 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qNPoybe9-Ak",
    "youtubeId": "qNPoybe9-Ak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2815",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 84 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z7sOI4MxI7A",
    "youtubeId": "z7sOI4MxI7A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2816",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 83 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Dc8VlxXfrU",
    "youtubeId": "-Dc8VlxXfrU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2817",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 82 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zZefQpAEaCs",
    "youtubeId": "zZefQpAEaCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2818",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 81 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/knHAS6s3opI",
    "youtubeId": "knHAS6s3opI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2819",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 80 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DDEun5zX600",
    "youtubeId": "DDEun5zX600",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2820",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 79 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1Tb74KdoOf0",
    "youtubeId": "1Tb74KdoOf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2821",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 78 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h3-UMsUz25k",
    "youtubeId": "h3-UMsUz25k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2822",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 77 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L-aWck_ft-U",
    "youtubeId": "L-aWck_ft-U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2823",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 76 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VyF1UobFkcE",
    "youtubeId": "VyF1UobFkcE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2824",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 75 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wktHuIqkOqE",
    "youtubeId": "wktHuIqkOqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2825",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 74 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7x5PIS6BJ5s",
    "youtubeId": "7x5PIS6BJ5s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2826",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 73 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yMjO9-18ZOk",
    "youtubeId": "yMjO9-18ZOk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2827",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 72 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zFe7pTZt7KQ",
    "youtubeId": "zFe7pTZt7KQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2828",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 71 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LS2xx6scSLk",
    "youtubeId": "LS2xx6scSLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2829",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 70 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wybVpWK8PCE",
    "youtubeId": "wybVpWK8PCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2830",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 69 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SGz0clyb5dY",
    "youtubeId": "SGz0clyb5dY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2831",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 68 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wqbE5wnF3D4",
    "youtubeId": "wqbE5wnF3D4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2832",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 67 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NGLsFJgaxl4",
    "youtubeId": "NGLsFJgaxl4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2833",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 66 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kBWRJCBHgts",
    "youtubeId": "kBWRJCBHgts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2834",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 65 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NzrYZ6kuiO4",
    "youtubeId": "NzrYZ6kuiO4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2835",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 64 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vghB7OedY0s",
    "youtubeId": "vghB7OedY0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2836",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 63 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/My4iNEiEt2k",
    "youtubeId": "My4iNEiEt2k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2837",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 62 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LwxwQB8LWQs",
    "youtubeId": "LwxwQB8LWQs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2838",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 61 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zvsphyLK34k",
    "youtubeId": "zvsphyLK34k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2839",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 60 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/njgV_BHGcz0",
    "youtubeId": "njgV_BHGcz0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2840",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 59 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BYYTALOuh8g",
    "youtubeId": "BYYTALOuh8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2841",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 58 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5acXrfBIA_I",
    "youtubeId": "5acXrfBIA_I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2842",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 57 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-NhHBg3NH_Q",
    "youtubeId": "-NhHBg3NH_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2843",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 56 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ujM27MN3cw8",
    "youtubeId": "ujM27MN3cw8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2844",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 55 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3hWL1SWjjNA",
    "youtubeId": "3hWL1SWjjNA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2845",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 54 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V0CPU6qUf3U",
    "youtubeId": "V0CPU6qUf3U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2846",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 53 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tIMSN0vvHFY",
    "youtubeId": "tIMSN0vvHFY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2847",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 52 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bKlbP-71Kv4",
    "youtubeId": "bKlbP-71Kv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2848",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 51 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zTs-0GwusGk",
    "youtubeId": "zTs-0GwusGk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2849",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 50 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IjZlrDQxmZA",
    "youtubeId": "IjZlrDQxmZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2850",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 49 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4qwDO7wYZUQ",
    "youtubeId": "4qwDO7wYZUQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2851",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 48 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-iRcsUCa4lY",
    "youtubeId": "-iRcsUCa4lY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2852",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 47 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uFt8z3tzaJI",
    "youtubeId": "uFt8z3tzaJI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2853",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 46 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iojCPT7psaw",
    "youtubeId": "iojCPT7psaw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2854",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 45 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KWhYF4rtkG8",
    "youtubeId": "KWhYF4rtkG8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2855",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 44 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PadCWGuIsj0",
    "youtubeId": "PadCWGuIsj0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2856",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 43 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5I7BMPa_3cM",
    "youtubeId": "5I7BMPa_3cM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2857",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 42 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sSYtFG2aQMw",
    "youtubeId": "sSYtFG2aQMw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2858",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 41 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h4U2JTscq3Y",
    "youtubeId": "h4U2JTscq3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2859",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 40 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S-KV6bpwVrE",
    "youtubeId": "S-KV6bpwVrE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2860",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 39 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iw-IAESbazk",
    "youtubeId": "iw-IAESbazk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2861",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 38 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HR3ornhXXP8",
    "youtubeId": "HR3ornhXXP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2862",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 37 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LsugC3RSVhw",
    "youtubeId": "LsugC3RSVhw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2863",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 36 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mYFGn28MqTQ",
    "youtubeId": "mYFGn28MqTQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2864",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 35 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EkWPVaFMD0Q",
    "youtubeId": "EkWPVaFMD0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2865",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 34 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PmN6SJsBwm8",
    "youtubeId": "PmN6SJsBwm8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2866",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 33 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rRETAwAWnRw",
    "youtubeId": "rRETAwAWnRw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2867",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 32 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DJY6F1RT3Og",
    "youtubeId": "DJY6F1RT3Og",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2868",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 31 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jQAMehLrIsI",
    "youtubeId": "jQAMehLrIsI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2869",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 30 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/skQMDfSRyOA",
    "youtubeId": "skQMDfSRyOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2870",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 29 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1wvomkpVJpg",
    "youtubeId": "1wvomkpVJpg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2871",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 28 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1NGKVhaSAWY",
    "youtubeId": "1NGKVhaSAWY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2872",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 27 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HrG0HWbh10U",
    "youtubeId": "HrG0HWbh10U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2873",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 26 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VqEw_f0KvQQ",
    "youtubeId": "VqEw_f0KvQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2874",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 25 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tNjnvIXo3NU",
    "youtubeId": "tNjnvIXo3NU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2875",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 24 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1fPG1dk0EAw",
    "youtubeId": "1fPG1dk0EAw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2876",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 23 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/npXXUyESRuI",
    "youtubeId": "npXXUyESRuI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2877",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 22 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fk0Mg3rwmCo",
    "youtubeId": "Fk0Mg3rwmCo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2878",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 21 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tWZfEITXAEY",
    "youtubeId": "tWZfEITXAEY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2879",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 20 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ow_74i_EpQw",
    "youtubeId": "ow_74i_EpQw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2880",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 19 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5WI3GyaAJyU",
    "youtubeId": "5WI3GyaAJyU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2881",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 18 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4kPVyVz9yNI",
    "youtubeId": "4kPVyVz9yNI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2882",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 17 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LMyMKfAkRBo",
    "youtubeId": "LMyMKfAkRBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2883",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 16 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4BwG0yZ-czE",
    "youtubeId": "4BwG0yZ-czE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2884",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 15 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JUNp89vCMQM",
    "youtubeId": "JUNp89vCMQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2885",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 14 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NeomuuFV8JA",
    "youtubeId": "NeomuuFV8JA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2886",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 13 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S6Nq6N8TUNo",
    "youtubeId": "S6Nq6N8TUNo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2887",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 12 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KIICr_tFc8Q",
    "youtubeId": "KIICr_tFc8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2888",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 11 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GlDbVp_08IE",
    "youtubeId": "GlDbVp_08IE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2889",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 10 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gNtL-OtIbT0",
    "youtubeId": "gNtL-OtIbT0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2890",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 9 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TFCEaq450hs",
    "youtubeId": "TFCEaq450hs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2891",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 8 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N9e43gT0_yw",
    "youtubeId": "N9e43gT0_yw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2892",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 7 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YJpnHJSeXRU",
    "youtubeId": "YJpnHJSeXRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2893",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 6 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XWtDngMP0tA",
    "youtubeId": "XWtDngMP0tA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2894",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 5 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RqMBKxRRAVQ",
    "youtubeId": "RqMBKxRRAVQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2895",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 4 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jwQtAo3bL-M",
    "youtubeId": "jwQtAo3bL-M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2896",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 3 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J4CW7IZHpHY",
    "youtubeId": "J4CW7IZHpHY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2897",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 2 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L2vbXLHCYg8",
    "youtubeId": "L2vbXLHCYg8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2898",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 28 Ayat 1 Surah Qasas Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/028Si1A7KdY",
    "youtubeId": "028Si1A7KdY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2899",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 93 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wx6tBB0hzRA",
    "youtubeId": "wx6tBB0hzRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2900",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 92 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KOIzpwG9kfY",
    "youtubeId": "KOIzpwG9kfY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2901",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 91 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_U4YxOhJ5wc",
    "youtubeId": "_U4YxOhJ5wc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2902",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 90 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B7aOp0rkMsI",
    "youtubeId": "B7aOp0rkMsI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2903",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 89 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2da_rVixVKc",
    "youtubeId": "2da_rVixVKc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2904",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 88 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m4lFoaLJqvA",
    "youtubeId": "m4lFoaLJqvA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2905",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 87 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LEzqWim-Sps",
    "youtubeId": "LEzqWim-Sps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2906",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 86 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0gLADQoDytg",
    "youtubeId": "0gLADQoDytg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2907",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 85 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mnIwso1e938",
    "youtubeId": "mnIwso1e938",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2908",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 84 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VrGdtbGtDIk",
    "youtubeId": "VrGdtbGtDIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2909",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 83 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vBT3smeInpY",
    "youtubeId": "vBT3smeInpY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2910",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 82 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4xmkXq8HyCw",
    "youtubeId": "4xmkXq8HyCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2911",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 81 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/99XH2ARQyzQ",
    "youtubeId": "99XH2ARQyzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2912",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 80 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hS_LzbImgko",
    "youtubeId": "hS_LzbImgko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2913",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 79 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZcMcl5_98JQ",
    "youtubeId": "ZcMcl5_98JQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2914",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 78 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WZPzddXKQME",
    "youtubeId": "WZPzddXKQME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2915",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 77 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nudrDgW8Y9o",
    "youtubeId": "nudrDgW8Y9o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2916",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 76 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0E7y8TVbsgQ",
    "youtubeId": "0E7y8TVbsgQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2917",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 75 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9YHTUnKfRPs",
    "youtubeId": "9YHTUnKfRPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2918",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 74 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rufzqAETfjk",
    "youtubeId": "rufzqAETfjk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2919",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 73 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EZTmyhaJUoI",
    "youtubeId": "EZTmyhaJUoI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2920",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 72 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IXa9DwryUJA",
    "youtubeId": "IXa9DwryUJA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2921",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 71 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/__wMj3zRicE",
    "youtubeId": "__wMj3zRicE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2922",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 70 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WRA6VnsQ7HQ",
    "youtubeId": "WRA6VnsQ7HQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2923",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 69 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EHgi1CKWBsA",
    "youtubeId": "EHgi1CKWBsA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2924",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 68 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/goqfsd1k6e8",
    "youtubeId": "goqfsd1k6e8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2925",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 67 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pyAEfd-N97Y",
    "youtubeId": "pyAEfd-N97Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2926",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 66 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RhuHIMmzff8",
    "youtubeId": "RhuHIMmzff8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2927",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 65 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jFmPv7ay9hM",
    "youtubeId": "jFmPv7ay9hM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2928",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 64 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O5iLSOUHZEw",
    "youtubeId": "O5iLSOUHZEw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2929",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 63 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WT1nhaixVi0",
    "youtubeId": "WT1nhaixVi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2930",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 62 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dUyE0TJZP3Y",
    "youtubeId": "dUyE0TJZP3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2931",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 61 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/357TalKNVMI",
    "youtubeId": "357TalKNVMI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2932",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 60 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wCdtH_0fdIw",
    "youtubeId": "wCdtH_0fdIw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2933",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 59 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z_gTiOUUfr8",
    "youtubeId": "Z_gTiOUUfr8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2934",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 58 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zkAKhHz17CA",
    "youtubeId": "zkAKhHz17CA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2935",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 57 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g05LERvA6F4",
    "youtubeId": "g05LERvA6F4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2936",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 56 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gwNaMFFJbUI",
    "youtubeId": "gwNaMFFJbUI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2937",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 55 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CIy0sQVzlAE",
    "youtubeId": "CIy0sQVzlAE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2938",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 54 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ardU4141zWM",
    "youtubeId": "ardU4141zWM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2939",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 53 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z1jnZZAWaRQ",
    "youtubeId": "z1jnZZAWaRQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2940",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 52 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wcQJCpVbHAs",
    "youtubeId": "wcQJCpVbHAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2941",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 51 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5DhO3ytdxF4",
    "youtubeId": "5DhO3ytdxF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2942",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 50 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GzYJAu1kF2Y",
    "youtubeId": "GzYJAu1kF2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2943",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 49 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_tvchGwhLbE",
    "youtubeId": "_tvchGwhLbE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2944",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 48 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dZFy3lbSUAw",
    "youtubeId": "dZFy3lbSUAw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2945",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 47 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OGBZktuG1yw",
    "youtubeId": "OGBZktuG1yw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2946",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 46 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sHZNMj5RetM",
    "youtubeId": "sHZNMj5RetM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2947",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 45 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/trtm0WVlF8U",
    "youtubeId": "trtm0WVlF8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2948",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 44 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AV2KPHL8cO8",
    "youtubeId": "AV2KPHL8cO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2949",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 43 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Z1fOnZS9LI",
    "youtubeId": "7Z1fOnZS9LI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2950",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 42 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6f05sA8mhjk",
    "youtubeId": "6f05sA8mhjk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2951",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 41 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sMMXpi8boRg",
    "youtubeId": "sMMXpi8boRg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2952",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 40 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6PvBfsPeQyM",
    "youtubeId": "6PvBfsPeQyM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2953",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 39 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o9UjU39Bvis",
    "youtubeId": "o9UjU39Bvis",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2954",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 38 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uS01Zcllzjk",
    "youtubeId": "uS01Zcllzjk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2955",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 37 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/idX1LQhVB-Y",
    "youtubeId": "idX1LQhVB-Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2956",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 36 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pY93XyuOdKU",
    "youtubeId": "pY93XyuOdKU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2957",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 35 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uzJEBlRwBFY",
    "youtubeId": "uzJEBlRwBFY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2958",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 34 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/96KJL5ZgAZI",
    "youtubeId": "96KJL5ZgAZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2959",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 33 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XUb_m6-pu7s",
    "youtubeId": "XUb_m6-pu7s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2960",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 32 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-gTLr78Irfw",
    "youtubeId": "-gTLr78Irfw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2961",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 31 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/90TDyAaJPnA",
    "youtubeId": "90TDyAaJPnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2962",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 30 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wqKqX20msYg",
    "youtubeId": "wqKqX20msYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2963",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 29 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1ZARYrGvOM0",
    "youtubeId": "1ZARYrGvOM0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2964",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 28 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/srzVWXfywyY",
    "youtubeId": "srzVWXfywyY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2965",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 27 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nDs9RXgdFFE",
    "youtubeId": "nDs9RXgdFFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2966",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 26 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A-NCu-fDiJQ",
    "youtubeId": "A-NCu-fDiJQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2967",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 25 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZHKxK0HsPRc",
    "youtubeId": "ZHKxK0HsPRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2968",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 24 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o38ToI2Y8OI",
    "youtubeId": "o38ToI2Y8OI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2969",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 23 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ob6-VO5wztM",
    "youtubeId": "ob6-VO5wztM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2970",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 22 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vgpcOX97w4A",
    "youtubeId": "vgpcOX97w4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2971",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 21 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ttl3c-1JVs4",
    "youtubeId": "ttl3c-1JVs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2972",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 20 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4pMbWdC5cbU",
    "youtubeId": "4pMbWdC5cbU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2973",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 19 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RudKakdSao8",
    "youtubeId": "RudKakdSao8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2974",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 18 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1jJZ86F7L-8",
    "youtubeId": "1jJZ86F7L-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2975",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 17 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6omXm7D8wHs",
    "youtubeId": "6omXm7D8wHs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2976",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 16 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PawdumUpR8s",
    "youtubeId": "PawdumUpR8s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2977",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 15 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LAfcn2NSeP4",
    "youtubeId": "LAfcn2NSeP4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2978",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 14 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BOgcR3-58Fs",
    "youtubeId": "BOgcR3-58Fs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2979",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 13 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P4tNtRADr-M",
    "youtubeId": "P4tNtRADr-M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2980",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 12 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pyjfBMnrsE0",
    "youtubeId": "pyjfBMnrsE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2981",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 11 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eJzGrA9SRzU",
    "youtubeId": "eJzGrA9SRzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2982",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 10 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UKLVxovf_t8",
    "youtubeId": "UKLVxovf_t8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2983",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 9 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QqIfYkcQkC4",
    "youtubeId": "QqIfYkcQkC4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2984",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 8 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qm7W-Wg8JCo",
    "youtubeId": "Qm7W-Wg8JCo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2985",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 7 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Bq77WOZzXY",
    "youtubeId": "-Bq77WOZzXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2986",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 6 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1Dhaa9NquTs",
    "youtubeId": "1Dhaa9NquTs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2987",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 5 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u9p56GGqanA",
    "youtubeId": "u9p56GGqanA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2988",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 4 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IJbFu9VsuTg",
    "youtubeId": "IJbFu9VsuTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2989",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 3 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dC7UkbBi_rE",
    "youtubeId": "dC7UkbBi_rE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2990",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 2 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EfSZrNXMYL0",
    "youtubeId": "EfSZrNXMYL0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2991",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 27 Ayat 1 Surah Naml Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SkLmADtDx-4",
    "youtubeId": "SkLmADtDx-4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2992",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 227 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q8TJIH1pKSc",
    "youtubeId": "q8TJIH1pKSc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2993",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 226 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pXgSr7OMqps",
    "youtubeId": "pXgSr7OMqps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2994",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 225 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0GaYsbLZR6M",
    "youtubeId": "0GaYsbLZR6M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2995",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 224 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c_7sqzSj3lk",
    "youtubeId": "c_7sqzSj3lk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2996",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 223 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CAXXbzhFTI8",
    "youtubeId": "CAXXbzhFTI8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2997",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 222 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mPGtEw9T6Q8",
    "youtubeId": "mPGtEw9T6Q8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2998",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 221 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pSpsXLwzqOU",
    "youtubeId": "pSpsXLwzqOU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-2999",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 220 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2ftvWCBToSk",
    "youtubeId": "2ftvWCBToSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3000",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 219 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sNw-HxZXpdg",
    "youtubeId": "sNw-HxZXpdg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3001",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 218 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KLHFkq3czcA",
    "youtubeId": "KLHFkq3czcA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3002",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 217 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WBZBuB7YJ7E",
    "youtubeId": "WBZBuB7YJ7E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3003",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 216 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G7K_DHo3wFI",
    "youtubeId": "G7K_DHo3wFI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3004",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 215 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bbJMmXd6okQ",
    "youtubeId": "bbJMmXd6okQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3005",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 214 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BG2iOPCBTH4",
    "youtubeId": "BG2iOPCBTH4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3006",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 213 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d0oJDkFKmCU",
    "youtubeId": "d0oJDkFKmCU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3007",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 212 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LI337ljzZv0",
    "youtubeId": "LI337ljzZv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3008",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 211 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AEjBH1B8cKs",
    "youtubeId": "AEjBH1B8cKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3009",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 210 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MMTXvCNaGls",
    "youtubeId": "MMTXvCNaGls",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3010",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 209 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gMSJmPUebZg",
    "youtubeId": "gMSJmPUebZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3011",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 208 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5MbcmlVVKPU",
    "youtubeId": "5MbcmlVVKPU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3012",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 207 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m_qib9fg6Xo",
    "youtubeId": "m_qib9fg6Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3013",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 206 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gioq7K5at5g",
    "youtubeId": "gioq7K5at5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3014",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 205 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hUjAgZdlpPw",
    "youtubeId": "hUjAgZdlpPw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3015",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 204 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VfsRZlDqE6w",
    "youtubeId": "VfsRZlDqE6w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3016",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 203 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IJIQ5tIorLs",
    "youtubeId": "IJIQ5tIorLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3017",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 202 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lRVPTSqknq0",
    "youtubeId": "lRVPTSqknq0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3018",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 201 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C2bvcPyIhLs",
    "youtubeId": "C2bvcPyIhLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3019",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 200 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZCzz9VDiaiM",
    "youtubeId": "ZCzz9VDiaiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3020",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 199 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/suwXFgwZ1As",
    "youtubeId": "suwXFgwZ1As",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3021",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 198 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_fYHETU8_VE",
    "youtubeId": "_fYHETU8_VE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3022",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 197 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OJDW8FiPgwI",
    "youtubeId": "OJDW8FiPgwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3023",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 196 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tui4RvUYgrE",
    "youtubeId": "Tui4RvUYgrE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3024",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 195 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nOLkrpV4_Xo",
    "youtubeId": "nOLkrpV4_Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3025",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 194 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fe34dusxocs",
    "youtubeId": "fe34dusxocs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3026",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 193 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7d6sbkhr2KA",
    "youtubeId": "7d6sbkhr2KA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3027",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 192 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y7hmxx31s4o",
    "youtubeId": "y7hmxx31s4o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3028",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 190 -191 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T8ZGOAMnRcs",
    "youtubeId": "T8ZGOAMnRcs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3029",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 188 -189 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gnuXwZqe1NY",
    "youtubeId": "gnuXwZqe1NY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3030",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 187 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_cIyTRaA3V0",
    "youtubeId": "_cIyTRaA3V0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3031",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 186 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XW7ge0yrqR8",
    "youtubeId": "XW7ge0yrqR8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3032",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 185 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SDmbd_m3Fd4",
    "youtubeId": "SDmbd_m3Fd4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3033",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 184 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pAcRXMN_nf0",
    "youtubeId": "pAcRXMN_nf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3034",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 183 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8LU9Rir06Ro",
    "youtubeId": "8LU9Rir06Ro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3035",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 177 -182 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GX7XP5mOTNA",
    "youtubeId": "GX7XP5mOTNA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3036",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 176 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t0CeoDQR3_A",
    "youtubeId": "t0CeoDQR3_A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3037",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 174 - 175 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2I-DE4PxFXM",
    "youtubeId": "2I-DE4PxFXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3038",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 173 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hQQWgLG6LdE",
    "youtubeId": "hQQWgLG6LdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3039",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 172 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QQcc6lL-0Gs",
    "youtubeId": "QQcc6lL-0Gs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3040",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 171 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dsyI9uvK3SM",
    "youtubeId": "dsyI9uvK3SM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3041",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 170 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/su-8BvkqUKs",
    "youtubeId": "su-8BvkqUKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3042",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 169 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QSQNCJNgK4I",
    "youtubeId": "QSQNCJNgK4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3043",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 168 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V1vyknSRYE4",
    "youtubeId": "V1vyknSRYE4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3044",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 167 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X6czHaZct-w",
    "youtubeId": "X6czHaZct-w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3045",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 166 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nSwTckpeesk",
    "youtubeId": "nSwTckpeesk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3046",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 160 -165 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kc4Al7mUAFM",
    "youtubeId": "kc4Al7mUAFM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3047",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 158 -159 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MAd5v-oh7x4",
    "youtubeId": "MAd5v-oh7x4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3048",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 157 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wghayOr6jH8",
    "youtubeId": "wghayOr6jH8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3049",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 156 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fg83qgDD4IA",
    "youtubeId": "fg83qgDD4IA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3050",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 155 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eLjqsYvMKZw",
    "youtubeId": "eLjqsYvMKZw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3051",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 154 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_YqH51E-Nv4",
    "youtubeId": "_YqH51E-Nv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3052",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 153 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lqd5wDHFZZs",
    "youtubeId": "lqd5wDHFZZs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3053",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 152 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fp5rKPbUCmk",
    "youtubeId": "Fp5rKPbUCmk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3054",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 151 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A2hu3zngXbc",
    "youtubeId": "A2hu3zngXbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3055",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 141 -150 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k7FSabbuTqo",
    "youtubeId": "k7FSabbuTqo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3056",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 137 140 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b4V7EjSWeKY",
    "youtubeId": "b4V7EjSWeKY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3057",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 134 -136 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NmriZ5hu3CY",
    "youtubeId": "NmriZ5hu3CY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3058",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 133 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gxNVLFYIn9I",
    "youtubeId": "gxNVLFYIn9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3059",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 132 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mp2GKQTzLvA",
    "youtubeId": "Mp2GKQTzLvA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3060",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 131 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m9EfqYwTyMs",
    "youtubeId": "m9EfqYwTyMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3061",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 130 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GE6HyW-x6TE",
    "youtubeId": "GE6HyW-x6TE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3062",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 129 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5_SSNPJizUM",
    "youtubeId": "5_SSNPJizUM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3063",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 127 -128 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XuRVtIzc_Y4",
    "youtubeId": "XuRVtIzc_Y4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3064",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 123 - 126 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AzhxQjO-Rbg",
    "youtubeId": "AzhxQjO-Rbg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3065",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 122 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wjrsl0-xS9E",
    "youtubeId": "wjrsl0-xS9E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3066",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 121 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-TeBAMOGV1A",
    "youtubeId": "-TeBAMOGV1A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3067",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 120 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sGPb-2Ygakg",
    "youtubeId": "sGPb-2Ygakg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3068",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 119 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8TxMgKb9xVg",
    "youtubeId": "8TxMgKb9xVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3069",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 118 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vcnvUh4NT4g",
    "youtubeId": "vcnvUh4NT4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3070",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 117 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fVSx7N8akFk",
    "youtubeId": "fVSx7N8akFk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3071",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 116 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vw58QPFeZro",
    "youtubeId": "vw58QPFeZro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3072",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 115 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bsinb_lyl5M",
    "youtubeId": "bsinb_lyl5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3073",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 114 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pbNFO4UjtrQ",
    "youtubeId": "pbNFO4UjtrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3074",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 113 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HpWrW9APpr8",
    "youtubeId": "HpWrW9APpr8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3075",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 112 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mvkLAcDd8Z4",
    "youtubeId": "mvkLAcDd8Z4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3076",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 111 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T595UhrKXIk",
    "youtubeId": "T595UhrKXIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3077",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 110 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V7zESH7aJNQ",
    "youtubeId": "V7zESH7aJNQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3078",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 109 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qd1arW2vvyQ",
    "youtubeId": "qd1arW2vvyQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3079",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 108 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IH3sEiOfW50",
    "youtubeId": "IH3sEiOfW50",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3080",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 107 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wsiOD_A0BjE",
    "youtubeId": "wsiOD_A0BjE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3081",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 106 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O3FETxn3cXQ",
    "youtubeId": "O3FETxn3cXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3082",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 105 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vp7Fj85gm-I",
    "youtubeId": "vp7Fj85gm-I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3083",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 104 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rLRDCHAMvos",
    "youtubeId": "rLRDCHAMvos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3084",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 103 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rHQcN9PlVeU",
    "youtubeId": "rHQcN9PlVeU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3085",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 102 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4qMWuDxgo9I",
    "youtubeId": "4qMWuDxgo9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3086",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 101 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XaJePjWkFHE",
    "youtubeId": "XaJePjWkFHE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3087",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 100 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HtSveEVoFM8",
    "youtubeId": "HtSveEVoFM8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3088",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 99 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uJFU-2kq1N4",
    "youtubeId": "uJFU-2kq1N4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3089",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 98 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xS8OAzsEI3I",
    "youtubeId": "xS8OAzsEI3I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3090",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 97 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NjTW_RX4aro",
    "youtubeId": "NjTW_RX4aro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3091",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 96 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k6y6JhHwWrY",
    "youtubeId": "k6y6JhHwWrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3092",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 95 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/18WXi0PjQ2k",
    "youtubeId": "18WXi0PjQ2k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3093",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 94 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y0OX_D48KSM",
    "youtubeId": "Y0OX_D48KSM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3094",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 93 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HEjsf_F2vBc",
    "youtubeId": "HEjsf_F2vBc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3095",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 92 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XL9eNgxqcVs",
    "youtubeId": "XL9eNgxqcVs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3096",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 91 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/phgMpCIMsaU",
    "youtubeId": "phgMpCIMsaU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3097",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 90 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pmObUNyosd4",
    "youtubeId": "pmObUNyosd4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3098",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 89 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nI6gqZiBHzU",
    "youtubeId": "nI6gqZiBHzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3099",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 88 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WEGC2S2g3kE",
    "youtubeId": "WEGC2S2g3kE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 87 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j5O2FnnPoYk",
    "youtubeId": "j5O2FnnPoYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 86 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vptiJWu90vo",
    "youtubeId": "vptiJWu90vo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 85 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Unsvm3GgwiA",
    "youtubeId": "Unsvm3GgwiA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 84 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eIlkhJir82U",
    "youtubeId": "eIlkhJir82U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 83 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gQwwnI_L4Nk",
    "youtubeId": "gQwwnI_L4Nk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 82 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qNfR3G_LfCI",
    "youtubeId": "qNfR3G_LfCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 81 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TDU6Sx9Q9mw",
    "youtubeId": "TDU6Sx9Q9mw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 80 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7xrM_4CvDjk",
    "youtubeId": "7xrM_4CvDjk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 79 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wgJ_pvxDRX8",
    "youtubeId": "wgJ_pvxDRX8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 78 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3n3Tnwh13go",
    "youtubeId": "3n3Tnwh13go",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 77 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7EhzP02lzSQ",
    "youtubeId": "7EhzP02lzSQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 76 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0r2tNwTtQns",
    "youtubeId": "0r2tNwTtQns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 75 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qhmZcwozHNc",
    "youtubeId": "qhmZcwozHNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 74 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BrrCsW9OAMQ",
    "youtubeId": "BrrCsW9OAMQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 73 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CiTJLunXbKA",
    "youtubeId": "CiTJLunXbKA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 72 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/58JyuYXdHGk",
    "youtubeId": "58JyuYXdHGk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 71 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cD24pU4jB3A",
    "youtubeId": "cD24pU4jB3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 70 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q-LiIjUzdeI",
    "youtubeId": "Q-LiIjUzdeI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 69 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZGk87PtzbQE",
    "youtubeId": "ZGk87PtzbQE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 68 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RtGrNgnV17c",
    "youtubeId": "RtGrNgnV17c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 67 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AtuVdJiwPgU",
    "youtubeId": "AtuVdJiwPgU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 66 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TyqNNxp_ySk",
    "youtubeId": "TyqNNxp_ySk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3122",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 65 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WhBcJ9A6ycc",
    "youtubeId": "WhBcJ9A6ycc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3123",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 64 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/izZ6-ifYUDs",
    "youtubeId": "izZ6-ifYUDs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3124",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 63 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EWYVu0fwzdg",
    "youtubeId": "EWYVu0fwzdg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3125",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 62 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X3LBR4NXI9g",
    "youtubeId": "X3LBR4NXI9g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3126",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 61 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x4hFQMpEJtA",
    "youtubeId": "x4hFQMpEJtA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3127",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 60 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w515yEgZMKw",
    "youtubeId": "w515yEgZMKw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3128",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 59 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8bWfRVdnyrA",
    "youtubeId": "8bWfRVdnyrA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3129",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 58 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/28isQqMoi7Q",
    "youtubeId": "28isQqMoi7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3130",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 57 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SYMtn1rN9W8",
    "youtubeId": "SYMtn1rN9W8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3131",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 56 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5FKRqzZ7uBI",
    "youtubeId": "5FKRqzZ7uBI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3132",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 55 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KqSSh956xx4",
    "youtubeId": "KqSSh956xx4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3133",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 54 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6YFpaeEWK08",
    "youtubeId": "6YFpaeEWK08",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3134",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 53 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N59V5U8hQpA",
    "youtubeId": "N59V5U8hQpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3135",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 52 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RthVdaimNsg",
    "youtubeId": "RthVdaimNsg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3136",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 51 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HUhf7VmY4uY",
    "youtubeId": "HUhf7VmY4uY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3137",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 50 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ee54VuuxXDY",
    "youtubeId": "ee54VuuxXDY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3138",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 49 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SNn3vAAhCzE",
    "youtubeId": "SNn3vAAhCzE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3139",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 48 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ikITotjpkT4",
    "youtubeId": "ikITotjpkT4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3140",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 47 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tgDzidr1xrY",
    "youtubeId": "tgDzidr1xrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3141",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 46 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/01LmTRwaC68",
    "youtubeId": "01LmTRwaC68",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3142",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 45 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kuakfzTc6KY",
    "youtubeId": "kuakfzTc6KY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3143",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 44 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9k_1JlSsSvk",
    "youtubeId": "9k_1JlSsSvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3144",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 43 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OYXTJ5OUJyU",
    "youtubeId": "OYXTJ5OUJyU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3145",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 42 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LsePbFWxS4w",
    "youtubeId": "LsePbFWxS4w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3146",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 41 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4GAiUHKyvE4",
    "youtubeId": "4GAiUHKyvE4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3147",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 40 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hmp41zISICM",
    "youtubeId": "hmp41zISICM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3148",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 39 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kqTLLoXipQY",
    "youtubeId": "kqTLLoXipQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3149",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 38 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1extV7vhxik",
    "youtubeId": "1extV7vhxik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3150",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 37 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZBvQfn2mlRo",
    "youtubeId": "ZBvQfn2mlRo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3151",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 36 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ggmihazktao",
    "youtubeId": "ggmihazktao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3152",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 35 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wsNWNVS11-g",
    "youtubeId": "wsNWNVS11-g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3153",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 34 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b547CkTtYd0",
    "youtubeId": "b547CkTtYd0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3154",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 33 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7G_y_ufG3gQ",
    "youtubeId": "7G_y_ufG3gQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3155",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 32 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cwFYG4Y3DSs",
    "youtubeId": "cwFYG4Y3DSs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3156",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 31 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eJrJewrH6l8",
    "youtubeId": "eJrJewrH6l8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3157",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 30 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vIjqC0LY1HQ",
    "youtubeId": "vIjqC0LY1HQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3158",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 29 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N8WHVUbjVp8",
    "youtubeId": "N8WHVUbjVp8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3159",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 28 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_123j1gYkAU",
    "youtubeId": "_123j1gYkAU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3160",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 27 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bd5ziTW64bc",
    "youtubeId": "bd5ziTW64bc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3161",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 26 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9voSsCWx14M",
    "youtubeId": "9voSsCWx14M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3162",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 25 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-_swqy9E7ac",
    "youtubeId": "-_swqy9E7ac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3163",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 24 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9aauad4Oe-o",
    "youtubeId": "9aauad4Oe-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3164",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 23 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aBlnLP7UkJw",
    "youtubeId": "aBlnLP7UkJw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3165",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 22 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YmssGoPQ__U",
    "youtubeId": "YmssGoPQ__U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3166",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 21 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/73kA-Prv3oU",
    "youtubeId": "73kA-Prv3oU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3167",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 20 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ukk5IozIF20",
    "youtubeId": "Ukk5IozIF20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3168",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 19 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B1zpltuH7Eg",
    "youtubeId": "B1zpltuH7Eg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3169",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 18 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p80ZeMFi6a8",
    "youtubeId": "p80ZeMFi6a8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3170",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 17 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BCLV6SNv0nw",
    "youtubeId": "BCLV6SNv0nw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3171",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 16 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mzUGBB6pTis",
    "youtubeId": "mzUGBB6pTis",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3172",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 15 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GmEnVJHU9MM",
    "youtubeId": "GmEnVJHU9MM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3173",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 14 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wzme2cXmTe4",
    "youtubeId": "Wzme2cXmTe4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3174",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 13 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0tC-86zXyeU",
    "youtubeId": "0tC-86zXyeU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3175",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 12 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ECtwWpCqRNQ",
    "youtubeId": "ECtwWpCqRNQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3176",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 11 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MBTal3m94i0",
    "youtubeId": "MBTal3m94i0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3177",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 10 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jlon-jkuftk",
    "youtubeId": "Jlon-jkuftk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3178",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 9 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v1nUYCqAFyU",
    "youtubeId": "v1nUYCqAFyU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3179",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 8 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7UySSgnachc",
    "youtubeId": "7UySSgnachc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3180",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 7 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EJxVQaIntgY",
    "youtubeId": "EJxVQaIntgY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3181",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 6 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QLvLuPIXR8I",
    "youtubeId": "QLvLuPIXR8I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3182",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 5 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Onh9qTHgAfA",
    "youtubeId": "Onh9qTHgAfA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3183",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 4 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gohhV_3ramw",
    "youtubeId": "gohhV_3ramw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3184",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 3 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wp2h21qpjyI",
    "youtubeId": "Wp2h21qpjyI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3185",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 2 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UGsLSZvGwyA",
    "youtubeId": "UGsLSZvGwyA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3186",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 26 Ayat 1 Surah Shuara Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BBrP8I_VYog",
    "youtubeId": "BBrP8I_VYog",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3187",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 77 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KTffxbHiauM",
    "youtubeId": "KTffxbHiauM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3188",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 76 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OI8DBhv6oMk",
    "youtubeId": "OI8DBhv6oMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3189",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 75 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oJt-O1LL4l8",
    "youtubeId": "oJt-O1LL4l8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3190",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 74 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lBvb_TXte3s",
    "youtubeId": "lBvb_TXte3s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3191",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 73 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eH5z7Cm6UPQ",
    "youtubeId": "eH5z7Cm6UPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3192",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 72 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/snV5yCguna4",
    "youtubeId": "snV5yCguna4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3193",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 71 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FjW8Hy6Qew0",
    "youtubeId": "FjW8Hy6Qew0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3194",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 70 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kFNWscWceQc",
    "youtubeId": "kFNWscWceQc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3195",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 69 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CzoTq81p1a8",
    "youtubeId": "CzoTq81p1a8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3196",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 68 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pynpzXl3ZjQ",
    "youtubeId": "pynpzXl3ZjQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3197",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 67 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yB2EHmUwE-o",
    "youtubeId": "yB2EHmUwE-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3198",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 66 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9L-9uj7rwzw",
    "youtubeId": "9L-9uj7rwzw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3199",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 65 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OeL--9adFy0",
    "youtubeId": "OeL--9adFy0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3200",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 64 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VyTdTWSbf7Y",
    "youtubeId": "VyTdTWSbf7Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3201",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 63 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X4Qktk6_dxg",
    "youtubeId": "X4Qktk6_dxg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3202",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 62 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iDNPM3hV7BI",
    "youtubeId": "iDNPM3hV7BI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3203",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 61 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yNSeT6AWgvw",
    "youtubeId": "yNSeT6AWgvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3204",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 60 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h4kUHQW3pVo",
    "youtubeId": "h4kUHQW3pVo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3205",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 59 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hU3_1dzr4PM",
    "youtubeId": "hU3_1dzr4PM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3206",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 58 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5OJzPbFqJ_4",
    "youtubeId": "5OJzPbFqJ_4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3207",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 57 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pOKkWVfCLus",
    "youtubeId": "pOKkWVfCLus",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3208",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 56 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4-90bm5nQ7M",
    "youtubeId": "4-90bm5nQ7M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3209",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 55 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o9V2jHFJZi4",
    "youtubeId": "o9V2jHFJZi4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3210",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 54 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vQLWB6m5F3I",
    "youtubeId": "vQLWB6m5F3I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3211",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 53 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sTCCeAKVdxk",
    "youtubeId": "sTCCeAKVdxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3212",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 52 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6zxRaV0H6tU",
    "youtubeId": "6zxRaV0H6tU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3213",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 51 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wUUmw4xHXiM",
    "youtubeId": "wUUmw4xHXiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3214",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 50 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7vJaGEhQX7E",
    "youtubeId": "7vJaGEhQX7E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3215",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 49 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gEEOnuW6Vdg",
    "youtubeId": "gEEOnuW6Vdg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3216",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 48 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aLt1vBe0oho",
    "youtubeId": "aLt1vBe0oho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3217",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 47 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qU3oMuJt3L4",
    "youtubeId": "qU3oMuJt3L4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3218",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 46 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BGxdG_b5jgA",
    "youtubeId": "BGxdG_b5jgA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3219",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 45 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hR1FUVK4nHw",
    "youtubeId": "hR1FUVK4nHw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3220",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 44 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i1zXB9rNW4Q",
    "youtubeId": "i1zXB9rNW4Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3221",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 43 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5xh6ADUxsZA",
    "youtubeId": "5xh6ADUxsZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3222",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 42 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dznul1jyO6k",
    "youtubeId": "dznul1jyO6k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3223",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 41 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TMwhUFJOmmU",
    "youtubeId": "TMwhUFJOmmU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3224",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 40 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/onGAxkTMvao",
    "youtubeId": "onGAxkTMvao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3225",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 39 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G-lmAZs57s8",
    "youtubeId": "G-lmAZs57s8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3226",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 38 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vFXiBc2gy_Y",
    "youtubeId": "vFXiBc2gy_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3227",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 37 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GWhxioLVmJo",
    "youtubeId": "GWhxioLVmJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3228",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 36 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SgmAWOFE0wk",
    "youtubeId": "SgmAWOFE0wk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3229",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 35 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uL1-trQPLuI",
    "youtubeId": "uL1-trQPLuI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3230",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 34 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bph95uMKKrw",
    "youtubeId": "Bph95uMKKrw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3231",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 33 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZzCTfHghX-E",
    "youtubeId": "ZzCTfHghX-E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3232",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 32 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fY4DfPYbc70",
    "youtubeId": "fY4DfPYbc70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3233",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 31 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KD5HWL2hQW8",
    "youtubeId": "KD5HWL2hQW8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3234",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 30 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BoPPHYdodH0",
    "youtubeId": "BoPPHYdodH0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3235",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 29 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UaEifJETmVg",
    "youtubeId": "UaEifJETmVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3236",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 28 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PQdbyDVwzUs",
    "youtubeId": "PQdbyDVwzUs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3237",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 27 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dEpWrDkadAE",
    "youtubeId": "dEpWrDkadAE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3238",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 26 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1kCeP14q2Bw",
    "youtubeId": "1kCeP14q2Bw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3239",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 25 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yj9fMzwYnkQ",
    "youtubeId": "yj9fMzwYnkQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3240",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 24 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_4UtyFSlrU4",
    "youtubeId": "_4UtyFSlrU4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3241",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 23 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W9aMp0Znpn4",
    "youtubeId": "W9aMp0Znpn4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3242",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 22 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0kEWDzsk-9Q",
    "youtubeId": "0kEWDzsk-9Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3243",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 21 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wcCwXkxyjwU",
    "youtubeId": "wcCwXkxyjwU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3244",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 20 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/97yqTPe3JK4",
    "youtubeId": "97yqTPe3JK4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3245",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 19 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WkiUHS5nd08",
    "youtubeId": "WkiUHS5nd08",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3246",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 18 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q-__srI5WDo",
    "youtubeId": "q-__srI5WDo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3247",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 17 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bs00EvZiTV0",
    "youtubeId": "bs00EvZiTV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3248",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 16 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UeoftQssNaA",
    "youtubeId": "UeoftQssNaA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3249",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 15 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vHTy-Nygf_I",
    "youtubeId": "vHTy-Nygf_I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3250",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 14 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kj6hw2BqX0E",
    "youtubeId": "Kj6hw2BqX0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3251",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 13 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y_6_hHw8n-0",
    "youtubeId": "Y_6_hHw8n-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3252",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 12 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sPgv7OEAD-0",
    "youtubeId": "sPgv7OEAD-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3253",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 11 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8b_K6YRt6t4",
    "youtubeId": "8b_K6YRt6t4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3254",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 10 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MSjb8MwzCh0",
    "youtubeId": "MSjb8MwzCh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3255",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 9 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QlXkAhqPKQo",
    "youtubeId": "QlXkAhqPKQo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3256",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 8 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rv43oaqsLTM",
    "youtubeId": "rv43oaqsLTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3257",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 7 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lCKNl1qHCC8",
    "youtubeId": "lCKNl1qHCC8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3258",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 6 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aYYHqnwqR3Y",
    "youtubeId": "aYYHqnwqR3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3259",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 5 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RQGGAz7Vb9w",
    "youtubeId": "RQGGAz7Vb9w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3260",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 4 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ch9_4-l60WM",
    "youtubeId": "Ch9_4-l60WM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3261",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 3 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2frP_H8FWiU",
    "youtubeId": "2frP_H8FWiU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3262",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 2 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dxN0j3fY4dg",
    "youtubeId": "dxN0j3fY4dg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3263",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 25 Ayat 1 Surah Furqan Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FEh6Oh-Jm2Y",
    "youtubeId": "FEh6Oh-Jm2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3264",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 64 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vIBxX4YdoHU",
    "youtubeId": "vIBxX4YdoHU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3265",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 63 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0nWfaGlZgUk",
    "youtubeId": "0nWfaGlZgUk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3266",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 62 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yIBFw3j30Qo",
    "youtubeId": "yIBFw3j30Qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3267",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 61 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jK3T96pPvbM",
    "youtubeId": "jK3T96pPvbM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3268",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 60 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fg_n7kXqG6U",
    "youtubeId": "fg_n7kXqG6U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3269",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 59 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FjR1BLOlvIE",
    "youtubeId": "FjR1BLOlvIE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3270",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 58 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/En4STVf0E0E",
    "youtubeId": "En4STVf0E0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3271",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 57 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bIvs1uEbbNA",
    "youtubeId": "bIvs1uEbbNA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3272",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 56 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ww6kKMZCARs",
    "youtubeId": "Ww6kKMZCARs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3273",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 55 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MBAEv9jNut8",
    "youtubeId": "MBAEv9jNut8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3274",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 54 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5yvXO4CoP3A",
    "youtubeId": "5yvXO4CoP3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3275",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 53 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-TABZ7J5_Po",
    "youtubeId": "-TABZ7J5_Po",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3276",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 52 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DahtP-ROQ2s",
    "youtubeId": "DahtP-ROQ2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3277",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 51 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qz9DSzP6F84",
    "youtubeId": "Qz9DSzP6F84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3278",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 50 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Z46fKT6J3A",
    "youtubeId": "-Z46fKT6J3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3279",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 49 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dMArYH_yZSk",
    "youtubeId": "dMArYH_yZSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3280",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 48 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G8Z7JUcvp4I",
    "youtubeId": "G8Z7JUcvp4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3281",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 47 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0830E8Db2Lc",
    "youtubeId": "0830E8Db2Lc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3282",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 46 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sajowHpCFyE",
    "youtubeId": "sajowHpCFyE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3283",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 45 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EhWIM-jWbCU",
    "youtubeId": "EhWIM-jWbCU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3284",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 44 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KKJoErGu_-o",
    "youtubeId": "KKJoErGu_-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3285",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 43 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZI-y8iMvE-8",
    "youtubeId": "ZI-y8iMvE-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3286",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 42 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lnk1pbpSwv0",
    "youtubeId": "Lnk1pbpSwv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3287",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 41 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sgL1ql_JMpA",
    "youtubeId": "sgL1ql_JMpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3288",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 40 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Z3CA6k2BqA",
    "youtubeId": "3Z3CA6k2BqA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3289",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 39 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6EQqADe_5GM",
    "youtubeId": "6EQqADe_5GM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3290",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 38 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0DRfml8B2wY",
    "youtubeId": "0DRfml8B2wY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3291",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 37 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/phTIx8_5Hdw",
    "youtubeId": "phTIx8_5Hdw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3292",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 36 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WAbjgf9sFns",
    "youtubeId": "WAbjgf9sFns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3293",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 35 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ar2qQaoKKKo",
    "youtubeId": "ar2qQaoKKKo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3294",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 34 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wd_K4araafk",
    "youtubeId": "Wd_K4araafk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3295",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 33 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e-HcI1ioO8Y",
    "youtubeId": "e-HcI1ioO8Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3296",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 32 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NovQSu4Ye-0",
    "youtubeId": "NovQSu4Ye-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3297",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 31 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xUb9uLJZlMA",
    "youtubeId": "xUb9uLJZlMA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3298",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 30 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/REJilNZyueo",
    "youtubeId": "REJilNZyueo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3299",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 29 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-dEFJbwjYvw",
    "youtubeId": "-dEFJbwjYvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3300",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 28 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a2YykUg0RIU",
    "youtubeId": "a2YykUg0RIU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3301",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 27 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZV5xOACDDro",
    "youtubeId": "ZV5xOACDDro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3302",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 26 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XBN36c3T-no",
    "youtubeId": "XBN36c3T-no",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3303",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 25 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_a2hVMufomM",
    "youtubeId": "_a2hVMufomM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3304",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 24 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5779P4SivuM",
    "youtubeId": "5779P4SivuM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3305",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 23 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KJgivN9OID0",
    "youtubeId": "KJgivN9OID0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3306",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 22 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K0D7XDwH4PQ",
    "youtubeId": "K0D7XDwH4PQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3307",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 21 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NrYSTgYjy2U",
    "youtubeId": "NrYSTgYjy2U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3308",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 20 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b_Xr4psbsCI",
    "youtubeId": "b_Xr4psbsCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3309",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 19 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N5nJezxAJgY",
    "youtubeId": "N5nJezxAJgY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3310",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 18 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DeUFvWeBddk",
    "youtubeId": "DeUFvWeBddk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3311",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 17 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cXPCJoG5JoM",
    "youtubeId": "cXPCJoG5JoM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3312",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 16 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rLtUa7zSdkg",
    "youtubeId": "rLtUa7zSdkg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3313",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 15 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/10aMFj6HWW0",
    "youtubeId": "10aMFj6HWW0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3314",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 14 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yhkJGO_t--o",
    "youtubeId": "yhkJGO_t--o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3315",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 13 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DuRzNHTbl1Y",
    "youtubeId": "DuRzNHTbl1Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3316",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 12 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-HEgb_jSmww",
    "youtubeId": "-HEgb_jSmww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3317",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 11 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X-yzdEYaw18",
    "youtubeId": "X-yzdEYaw18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3318",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 10 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j41WpJVsolw",
    "youtubeId": "j41WpJVsolw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3319",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 9 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nrXfPOwKyf8",
    "youtubeId": "nrXfPOwKyf8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3320",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 8 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RsUT-zjxhNw",
    "youtubeId": "RsUT-zjxhNw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3321",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 7 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0cYEFHo8aeo",
    "youtubeId": "0cYEFHo8aeo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3322",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 6 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BPMaSudU4YY",
    "youtubeId": "BPMaSudU4YY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3323",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 5 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KZ23bRQhCb8",
    "youtubeId": "KZ23bRQhCb8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3324",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 4 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eFxyONVsgzE",
    "youtubeId": "eFxyONVsgzE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3325",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 3 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RG6fe6Xj2mI",
    "youtubeId": "RG6fe6Xj2mI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3326",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 2 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/37swkynaVHI",
    "youtubeId": "37swkynaVHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3327",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 24 Ayat 1 Surah Nur Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0ffpLZ8Xp6E",
    "youtubeId": "0ffpLZ8Xp6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3328",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 118 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z_uLeSPyWok",
    "youtubeId": "z_uLeSPyWok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3329",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 117 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JWLlIIwnujg",
    "youtubeId": "JWLlIIwnujg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3330",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 116 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2oO2Ygbts9U",
    "youtubeId": "2oO2Ygbts9U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3331",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 115 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T4i2La26xlY",
    "youtubeId": "T4i2La26xlY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3332",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 114 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EqkeVg1k5DY",
    "youtubeId": "EqkeVg1k5DY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3333",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 113 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jEDGYXm-1-A",
    "youtubeId": "jEDGYXm-1-A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3334",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 112 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PvP0sqshVQs",
    "youtubeId": "PvP0sqshVQs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3335",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 111 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/25CUJno9BMw",
    "youtubeId": "25CUJno9BMw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3336",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 110 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EDQqP7LaUUY",
    "youtubeId": "EDQqP7LaUUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3337",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 109 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W6QxjsDNFwU",
    "youtubeId": "W6QxjsDNFwU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3338",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 108 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1xQPg5MNwgY",
    "youtubeId": "1xQPg5MNwgY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3339",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 107 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bFGZgp9LCyE",
    "youtubeId": "bFGZgp9LCyE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3340",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 106 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sVzrWNpQKh0",
    "youtubeId": "sVzrWNpQKh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3341",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 105 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CP0JaYftqU4",
    "youtubeId": "CP0JaYftqU4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3342",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 104 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jzC6pondMHE",
    "youtubeId": "jzC6pondMHE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3343",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 103 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NEzJ1WW4vZg",
    "youtubeId": "NEzJ1WW4vZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3344",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 102 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oJ6XCbYKpo8",
    "youtubeId": "oJ6XCbYKpo8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3345",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 101 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6MCiPwzp5hs",
    "youtubeId": "6MCiPwzp5hs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3346",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 100 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QSs9lXWWkNo",
    "youtubeId": "QSs9lXWWkNo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3347",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 99 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2j-QBjJMmaU",
    "youtubeId": "2j-QBjJMmaU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3348",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 98 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rpGf_pUV_lU",
    "youtubeId": "rpGf_pUV_lU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3349",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 97 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Wp9yKwbgVE",
    "youtubeId": "9Wp9yKwbgVE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3350",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 96 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/whLuM5hMj7I",
    "youtubeId": "whLuM5hMj7I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3351",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 95 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dCUCHownSts",
    "youtubeId": "dCUCHownSts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3352",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 94 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/byiagOy9enE",
    "youtubeId": "byiagOy9enE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3353",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 93 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-6eNAF0WBDY",
    "youtubeId": "-6eNAF0WBDY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3354",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 92 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w6uFWp4cpss",
    "youtubeId": "w6uFWp4cpss",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3355",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 91 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z5fm8RROonQ",
    "youtubeId": "z5fm8RROonQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3356",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 90 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tBwPM11wCYg",
    "youtubeId": "tBwPM11wCYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3357",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 89 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rg3g3htul1o",
    "youtubeId": "Rg3g3htul1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3358",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 88 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k6EzmZZbdPs",
    "youtubeId": "k6EzmZZbdPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3359",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 87 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6lsGfOMMBow",
    "youtubeId": "6lsGfOMMBow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3360",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 86 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0t-AmlHs7Mk",
    "youtubeId": "0t-AmlHs7Mk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3361",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 85 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VnqlncgNDvw",
    "youtubeId": "VnqlncgNDvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3362",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 84 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MaSSmkZDDAM",
    "youtubeId": "MaSSmkZDDAM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3363",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 83 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hcFyGPjm55M",
    "youtubeId": "hcFyGPjm55M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3364",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 82 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4quG-nlISYA",
    "youtubeId": "4quG-nlISYA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3365",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 81 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/02_-FHFk9dc",
    "youtubeId": "02_-FHFk9dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3366",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 80 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-rqOQxoQxh8",
    "youtubeId": "-rqOQxoQxh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3367",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 79 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ffQj3f4R21w",
    "youtubeId": "ffQj3f4R21w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3368",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 78 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hJM5aK_mc4Y",
    "youtubeId": "hJM5aK_mc4Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3369",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 77 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e9Fr9vbD8Ck",
    "youtubeId": "e9Fr9vbD8Ck",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3370",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 76 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KtX9Q9sJxm4",
    "youtubeId": "KtX9Q9sJxm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3371",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 75 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WrXJ-ICWy8c",
    "youtubeId": "WrXJ-ICWy8c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3372",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 74 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fnX13g8UJvI",
    "youtubeId": "fnX13g8UJvI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3373",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 73 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Luinn1usof8",
    "youtubeId": "Luinn1usof8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3374",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 72 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0GBVgxaK0gc",
    "youtubeId": "0GBVgxaK0gc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3375",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 71 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dOQDmxR_Pjw",
    "youtubeId": "dOQDmxR_Pjw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3376",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 70 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Pxya3L9J5-A",
    "youtubeId": "Pxya3L9J5-A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3377",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 69 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3KEuwioseS8",
    "youtubeId": "3KEuwioseS8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3378",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 68 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NqydFi1JRDY",
    "youtubeId": "NqydFi1JRDY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3379",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 67 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-sh0GbKIiIk",
    "youtubeId": "-sh0GbKIiIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3380",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 66 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sBntDz7yHdo",
    "youtubeId": "sBntDz7yHdo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3381",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 65 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ozh1Ntj72dY",
    "youtubeId": "ozh1Ntj72dY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3382",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 64 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ee2WFGJdYLA",
    "youtubeId": "ee2WFGJdYLA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3383",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 63 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BiDZxMSeqfA",
    "youtubeId": "BiDZxMSeqfA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3384",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 62 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fG9aQCMiGd0",
    "youtubeId": "fG9aQCMiGd0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3385",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 61 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9vYvGHEqONU",
    "youtubeId": "9vYvGHEqONU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3386",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 60 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n7QXntCPOeg",
    "youtubeId": "n7QXntCPOeg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3387",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 59 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/btAchv4Q5iE",
    "youtubeId": "btAchv4Q5iE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3388",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 58 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1KiKZc0_Kck",
    "youtubeId": "1KiKZc0_Kck",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3389",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 57 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/40M1v5HybPo",
    "youtubeId": "40M1v5HybPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3390",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 56 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SugHEzBm1ec",
    "youtubeId": "SugHEzBm1ec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3391",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 55 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-gNyrPhSoSQ",
    "youtubeId": "-gNyrPhSoSQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3392",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 54 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hgs4n-Q9PRA",
    "youtubeId": "Hgs4n-Q9PRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3393",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 53 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KPt2yOmr2hA",
    "youtubeId": "KPt2yOmr2hA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3394",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 52 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cDL0Mlb_45U",
    "youtubeId": "cDL0Mlb_45U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3395",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 51 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XuxFyBQfAio",
    "youtubeId": "XuxFyBQfAio",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3396",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 50 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kGGgeS4_GYs",
    "youtubeId": "kGGgeS4_GYs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3397",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 49 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bt9zovHXDR4",
    "youtubeId": "Bt9zovHXDR4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3398",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 48 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UKlrRAUN6fg",
    "youtubeId": "UKlrRAUN6fg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3399",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 47 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_eTmgVcoP4Q",
    "youtubeId": "_eTmgVcoP4Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3400",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 46 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hio7LIXV3OA",
    "youtubeId": "Hio7LIXV3OA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3401",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 45 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5-NpNCeh-2E",
    "youtubeId": "5-NpNCeh-2E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3402",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 44 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ecMH1zuFQZQ",
    "youtubeId": "ecMH1zuFQZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3403",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 43 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ya_OsaBsVcg",
    "youtubeId": "ya_OsaBsVcg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3404",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 42 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jLIbRWc15UI",
    "youtubeId": "jLIbRWc15UI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3405",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 41 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LpxlQcwd0LQ",
    "youtubeId": "LpxlQcwd0LQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3406",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 40 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/01RLDtdwnyo",
    "youtubeId": "01RLDtdwnyo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3407",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 39 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N7zRNLji7aY",
    "youtubeId": "N7zRNLji7aY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3408",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 38 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bb0tj5lW-Rk",
    "youtubeId": "bb0tj5lW-Rk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3409",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 37 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SYG37-IeLJc",
    "youtubeId": "SYG37-IeLJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3410",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 36 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xwsFSP4hdg4",
    "youtubeId": "xwsFSP4hdg4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3411",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 35 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ah45h0DcjKk",
    "youtubeId": "ah45h0DcjKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3412",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 34 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xzsl0gf1Qzw",
    "youtubeId": "Xzsl0gf1Qzw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3413",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 33 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EUZavcvQmSk",
    "youtubeId": "EUZavcvQmSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3414",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 32 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OurY9mNYUrw",
    "youtubeId": "OurY9mNYUrw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3415",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 31 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xZlrj0CgLeM",
    "youtubeId": "xZlrj0CgLeM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3416",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 30 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0mczPwyFxYE",
    "youtubeId": "0mczPwyFxYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3417",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 29 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5KOAT3QqY3w",
    "youtubeId": "5KOAT3QqY3w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3418",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 28 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P2ULdvygsEc",
    "youtubeId": "P2ULdvygsEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3419",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 27 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ziGnrRZpGF8",
    "youtubeId": "ziGnrRZpGF8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3420",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 26 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5doY4P8-ltg",
    "youtubeId": "5doY4P8-ltg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3421",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 25 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kc-6vasUzuA",
    "youtubeId": "Kc-6vasUzuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3422",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 24 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_IGv4ci2KJ8",
    "youtubeId": "_IGv4ci2KJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3423",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 23 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wXAkpjTgfrM",
    "youtubeId": "wXAkpjTgfrM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3424",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 22 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Urcn7np3ooU",
    "youtubeId": "Urcn7np3ooU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3425",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 21 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QheOKfiljPE",
    "youtubeId": "QheOKfiljPE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3426",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 20 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/luMIdnaf1A4",
    "youtubeId": "luMIdnaf1A4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3427",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 19 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T6mraxE7O5w",
    "youtubeId": "T6mraxE7O5w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3428",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 18 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9PvC8nuyd-o",
    "youtubeId": "9PvC8nuyd-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3429",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 17 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gUy0BPIkbAU",
    "youtubeId": "gUy0BPIkbAU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3430",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 16 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dL9gZMB9fqo",
    "youtubeId": "dL9gZMB9fqo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3431",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 15 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pEcyY88IGa8",
    "youtubeId": "pEcyY88IGa8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3432",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 14 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K9rX9h-p9QA",
    "youtubeId": "K9rX9h-p9QA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3433",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 13 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Tp6QslJPu0",
    "youtubeId": "7Tp6QslJPu0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3434",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 12 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nla9g8ctxhI",
    "youtubeId": "Nla9g8ctxhI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3435",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 11 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IO6gGwkfizw",
    "youtubeId": "IO6gGwkfizw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3436",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 10 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7uvm0KmH35c",
    "youtubeId": "7uvm0KmH35c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3437",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 9 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zvICGresLZM",
    "youtubeId": "zvICGresLZM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3438",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 8 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DzuBSJ9lPqE",
    "youtubeId": "DzuBSJ9lPqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3439",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 7 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZjXoPDb3Jbw",
    "youtubeId": "ZjXoPDb3Jbw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3440",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 6 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ulru04uKdVg",
    "youtubeId": "Ulru04uKdVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3441",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 5 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E6d5fFgh_LU",
    "youtubeId": "E6d5fFgh_LU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3442",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 4 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e-7dnzNiyNE",
    "youtubeId": "e-7dnzNiyNE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3443",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 3 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/btXAXjYqEpc",
    "youtubeId": "btXAXjYqEpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3444",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 2 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kKQKnmsLSmQ",
    "youtubeId": "kKQKnmsLSmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3445",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 23 Ayat 1 Surah Muminun Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0xujMB4uioY",
    "youtubeId": "0xujMB4uioY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3446",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 78 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M9pWRhaqLes",
    "youtubeId": "M9pWRhaqLes",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3447",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 77 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xxjtvx9Hs4Q",
    "youtubeId": "xxjtvx9Hs4Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3448",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 76 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMgnvY9eL84",
    "youtubeId": "cMgnvY9eL84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3449",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 75 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MG4UHlXrX24",
    "youtubeId": "MG4UHlXrX24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3450",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 74 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/un_iUL75eDE",
    "youtubeId": "un_iUL75eDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3451",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 73 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sSuaO-21LEA",
    "youtubeId": "sSuaO-21LEA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3452",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 72 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jf9j0RTJ6is",
    "youtubeId": "jf9j0RTJ6is",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3453",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 71 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qyrg5sUvtgQ",
    "youtubeId": "Qyrg5sUvtgQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3454",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 70 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SitW9GhC5mc",
    "youtubeId": "SitW9GhC5mc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3455",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 69 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1OQyy9yu_o8",
    "youtubeId": "1OQyy9yu_o8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3456",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 68 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dMnnakpYM0I",
    "youtubeId": "dMnnakpYM0I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3457",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 67 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z2VUUZ66P-s",
    "youtubeId": "Z2VUUZ66P-s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3458",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 66 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4NkvFhJL4fA",
    "youtubeId": "4NkvFhJL4fA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3459",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 65 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ftJ6J5LFb3Q",
    "youtubeId": "ftJ6J5LFb3Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3460",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 64 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k13IXuC_8Rk",
    "youtubeId": "k13IXuC_8Rk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3461",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 63 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SxHTevuHgFE",
    "youtubeId": "SxHTevuHgFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3462",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 62 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VTDOpN2YVRE",
    "youtubeId": "VTDOpN2YVRE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3463",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 61 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cRvHzLIvBhs",
    "youtubeId": "cRvHzLIvBhs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3464",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 60 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BW3PeW5nc04",
    "youtubeId": "BW3PeW5nc04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3465",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 59 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E_Tk-UrNxh8",
    "youtubeId": "E_Tk-UrNxh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3466",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 58 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4OBIwxFhU80",
    "youtubeId": "4OBIwxFhU80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3467",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 57 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hKCkLliqzeU",
    "youtubeId": "hKCkLliqzeU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3468",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 56 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MUXQRf3KRl8",
    "youtubeId": "MUXQRf3KRl8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3469",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 55 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-vp8LMOzhIo",
    "youtubeId": "-vp8LMOzhIo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3470",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 54 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bd8tUUW0EGk",
    "youtubeId": "bd8tUUW0EGk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3471",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 53 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hj_VLpa8BTU",
    "youtubeId": "hj_VLpa8BTU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3472",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 52 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ibB6RvJqD0o",
    "youtubeId": "ibB6RvJqD0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3473",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 51 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vFgOkcsr9Ws",
    "youtubeId": "vFgOkcsr9Ws",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3474",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 50 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qfhBw0mgORg",
    "youtubeId": "qfhBw0mgORg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3475",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 49 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IdavWnVP_vw",
    "youtubeId": "IdavWnVP_vw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3476",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 48 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cxjx_czSJAs",
    "youtubeId": "cxjx_czSJAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3477",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 47 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/47WEHBakmHQ",
    "youtubeId": "47WEHBakmHQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3478",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 46 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DV0vcwdE78c",
    "youtubeId": "DV0vcwdE78c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3479",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 45 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Clc3z6lnO34",
    "youtubeId": "Clc3z6lnO34",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3480",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 44 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qSbBk42KJ_A",
    "youtubeId": "qSbBk42KJ_A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3481",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 43 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pRevvqV3BNY",
    "youtubeId": "pRevvqV3BNY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3482",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 42 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8mhuiFg7g3A",
    "youtubeId": "8mhuiFg7g3A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3483",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 41 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iXiFx2ZETv8",
    "youtubeId": "iXiFx2ZETv8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3484",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 40 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ksYwjjA6V9I",
    "youtubeId": "ksYwjjA6V9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3485",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 39 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y8bmUtYKV7U",
    "youtubeId": "Y8bmUtYKV7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3486",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 38 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y8doYSCplnI",
    "youtubeId": "y8doYSCplnI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3487",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 37 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jCj94EuHyRk",
    "youtubeId": "jCj94EuHyRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3488",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 36 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-_20M42n9nA",
    "youtubeId": "-_20M42n9nA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3489",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 35 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CusVtX83dPA",
    "youtubeId": "CusVtX83dPA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3490",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 34 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UkFK75zM09w",
    "youtubeId": "UkFK75zM09w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3491",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 33 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ozpNkb0-XUw",
    "youtubeId": "ozpNkb0-XUw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3492",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 32 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0fTpgjabRpw",
    "youtubeId": "0fTpgjabRpw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3493",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 31 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vqTSYr9D0Vo",
    "youtubeId": "vqTSYr9D0Vo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3494",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 30 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5OZ7WzQLTKQ",
    "youtubeId": "5OZ7WzQLTKQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3495",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 29 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fkXSvNIj6Gk",
    "youtubeId": "fkXSvNIj6Gk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3496",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 28 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oKJyn89AyEY",
    "youtubeId": "oKJyn89AyEY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3497",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 27 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mQlIJm-_6NM",
    "youtubeId": "mQlIJm-_6NM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3498",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 26 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pNsuewWx40c",
    "youtubeId": "pNsuewWx40c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3499",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 25 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6a_w2tbykSI",
    "youtubeId": "6a_w2tbykSI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3500",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 24 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w3fwdpbW-Kc",
    "youtubeId": "w3fwdpbW-Kc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3501",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 23 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E7d4B19yK4g",
    "youtubeId": "E7d4B19yK4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3502",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 22 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2FQaKJixF5Y",
    "youtubeId": "2FQaKJixF5Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3503",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 21 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YsYbReBu86k",
    "youtubeId": "YsYbReBu86k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3504",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 20 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QBEPMaZitGY",
    "youtubeId": "QBEPMaZitGY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3505",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 19 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1gsG52kOPq0",
    "youtubeId": "1gsG52kOPq0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3506",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 18 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YZc1BobHNQ4",
    "youtubeId": "YZc1BobHNQ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3507",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 17 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_cDZ1-_WBE8",
    "youtubeId": "_cDZ1-_WBE8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3508",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 16 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OpdmjtC2kZE",
    "youtubeId": "OpdmjtC2kZE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3509",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 15 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SVRgOIa2u4w",
    "youtubeId": "SVRgOIa2u4w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3510",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 14 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cqQCFZvEb4g",
    "youtubeId": "cqQCFZvEb4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3511",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 13 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bfYAOuuLxTg",
    "youtubeId": "bfYAOuuLxTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3512",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 12 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t966DH_ShQ8",
    "youtubeId": "t966DH_ShQ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3513",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 11 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QKMQxa688Ig",
    "youtubeId": "QKMQxa688Ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3514",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 10 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OgI6YNAJivU",
    "youtubeId": "OgI6YNAJivU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3515",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 9 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J4xxJSolRB8",
    "youtubeId": "J4xxJSolRB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3516",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 8 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EuIbUB_ujws",
    "youtubeId": "EuIbUB_ujws",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3517",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 7 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IthCBoOhEQM",
    "youtubeId": "IthCBoOhEQM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3518",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 6 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DIaLo8G49-0",
    "youtubeId": "DIaLo8G49-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3519",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 5 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JlcKa6o-nwY",
    "youtubeId": "JlcKa6o-nwY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3520",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 4 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o7Wpzdoz1m0",
    "youtubeId": "o7Wpzdoz1m0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3521",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 3 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZsCTNfvUCpo",
    "youtubeId": "ZsCTNfvUCpo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3522",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 2 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5QUfi401XVk",
    "youtubeId": "5QUfi401XVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3523",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 22 Ayat 1 Surah Hajj Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G6vgYB-kkxk",
    "youtubeId": "G6vgYB-kkxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3524",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 112 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PlAz4sSlzn0",
    "youtubeId": "PlAz4sSlzn0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3525",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 111 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KQB-NffjwJY",
    "youtubeId": "KQB-NffjwJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3526",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 110 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GJP70sPeWnw",
    "youtubeId": "GJP70sPeWnw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3527",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 109 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aIPkLFI2QB8",
    "youtubeId": "aIPkLFI2QB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3528",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 108 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SNq5VUIYJEE",
    "youtubeId": "SNq5VUIYJEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3529",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 107 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0HvkEAYEgBA",
    "youtubeId": "0HvkEAYEgBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3530",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 106 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/36Sl9S0i1LM",
    "youtubeId": "36Sl9S0i1LM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3531",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 105 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZKkaoOss2zE",
    "youtubeId": "ZKkaoOss2zE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3532",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 104 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A8t2ZMNHqcU",
    "youtubeId": "A8t2ZMNHqcU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3533",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 103 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P4HgeI7jSU0",
    "youtubeId": "P4HgeI7jSU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3534",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 102 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eSzviZ9rC1U",
    "youtubeId": "eSzviZ9rC1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3535",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 101 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fh6t8iW3Vu4",
    "youtubeId": "fh6t8iW3Vu4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3536",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 100 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NzA6TEgOjjU",
    "youtubeId": "NzA6TEgOjjU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3537",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 99 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GVoqPAqgx3k",
    "youtubeId": "GVoqPAqgx3k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3538",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 98 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qfHgoETav24",
    "youtubeId": "qfHgoETav24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3539",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 97 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ORRVY0Zxne4",
    "youtubeId": "ORRVY0Zxne4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3540",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 96 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9abq5vzAN_I",
    "youtubeId": "9abq5vzAN_I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3541",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 95 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6RrSt43-rYM",
    "youtubeId": "6RrSt43-rYM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3542",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 94 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8BZaQR23eZ0",
    "youtubeId": "8BZaQR23eZ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3543",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 93 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DU6LngDRB6c",
    "youtubeId": "DU6LngDRB6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3544",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 92 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8_3n5-3MUac",
    "youtubeId": "8_3n5-3MUac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3545",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 91 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m9g3zEUOIhg",
    "youtubeId": "m9g3zEUOIhg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3546",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 90 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0ytM6FVh8jY",
    "youtubeId": "0ytM6FVh8jY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3547",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 89 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-ySl6Ad0CdE",
    "youtubeId": "-ySl6Ad0CdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3548",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 88 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e8iL45n1GeA",
    "youtubeId": "e8iL45n1GeA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3549",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 87 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HMJm3XtLNZI",
    "youtubeId": "HMJm3XtLNZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3550",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 86 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CkU2Kv7okCM",
    "youtubeId": "CkU2Kv7okCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3551",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 85 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eDqy1sAiyOY",
    "youtubeId": "eDqy1sAiyOY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3552",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 84 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3fawAjXT8PA",
    "youtubeId": "3fawAjXT8PA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3553",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 83 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zp8qRoVfcd4",
    "youtubeId": "Zp8qRoVfcd4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3554",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 82 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ht_ejCt4e8c",
    "youtubeId": "Ht_ejCt4e8c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3555",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 81 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/miu-B5csK_A",
    "youtubeId": "miu-B5csK_A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3556",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 80 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OFSvVkYXQLk",
    "youtubeId": "OFSvVkYXQLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3557",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 79 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R7hHbjZuobA",
    "youtubeId": "R7hHbjZuobA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3558",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 78 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6pbXsCxpOC4",
    "youtubeId": "6pbXsCxpOC4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3559",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 77 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mK-CXavnAs4",
    "youtubeId": "mK-CXavnAs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3560",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 76 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PFoAyP6AgmM",
    "youtubeId": "PFoAyP6AgmM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3561",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 75 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Pg9ABCShWPo",
    "youtubeId": "Pg9ABCShWPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3562",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 74 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/--_3Dvvm1wg",
    "youtubeId": "--_3Dvvm1wg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3563",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 73 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tCrGd1CN2KE",
    "youtubeId": "tCrGd1CN2KE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3564",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 72 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZzxMIqXR-Bg",
    "youtubeId": "ZzxMIqXR-Bg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3565",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 71 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uWgVmlhtVv4",
    "youtubeId": "uWgVmlhtVv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3566",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 70 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F0ErT3LEWK8",
    "youtubeId": "F0ErT3LEWK8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3567",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 69 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/woyXlXX5f0o",
    "youtubeId": "woyXlXX5f0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3568",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 68 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BpbI3qXT4ms",
    "youtubeId": "BpbI3qXT4ms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3569",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 67 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9rE4rnPCqvU",
    "youtubeId": "9rE4rnPCqvU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3570",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 66 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lwa7X9fnHyw",
    "youtubeId": "Lwa7X9fnHyw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3571",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 65 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tnGDyJb-4nA",
    "youtubeId": "tnGDyJb-4nA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3572",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 64 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J5_qOo9j9qA",
    "youtubeId": "J5_qOo9j9qA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3573",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 63 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BJYvNAPjX28",
    "youtubeId": "BJYvNAPjX28",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3574",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 62 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aumtPSFwpGA",
    "youtubeId": "aumtPSFwpGA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3575",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 61 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FHbnP02cGno",
    "youtubeId": "FHbnP02cGno",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3576",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 60 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sz2ijm9JNxk",
    "youtubeId": "sz2ijm9JNxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3577",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 59 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pC20tZhmD7w",
    "youtubeId": "pC20tZhmD7w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3578",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 58 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V-vhHP5FjLM",
    "youtubeId": "V-vhHP5FjLM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3579",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 57 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S8gMQSoO9h0",
    "youtubeId": "S8gMQSoO9h0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3580",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 56 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fnZAl6XlKlg",
    "youtubeId": "fnZAl6XlKlg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3581",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 55 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FjIPK8_QdbA",
    "youtubeId": "FjIPK8_QdbA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3582",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 54 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gjgN52QuZ1U",
    "youtubeId": "gjgN52QuZ1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3583",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 53 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BTlM5B-x-eE",
    "youtubeId": "BTlM5B-x-eE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3584",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 52 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pd1VIFq3WaQ",
    "youtubeId": "pd1VIFq3WaQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3585",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 51 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nX1jxe0iCk4",
    "youtubeId": "nX1jxe0iCk4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3586",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 50 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wJdNR0CXxRc",
    "youtubeId": "wJdNR0CXxRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3587",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 49 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HJmQJrG7tSc",
    "youtubeId": "HJmQJrG7tSc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3588",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 48 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z6FvCV087Ys",
    "youtubeId": "Z6FvCV087Ys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3589",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 47 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tYqPD1YCfcE",
    "youtubeId": "tYqPD1YCfcE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3590",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 46 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xMab-460iS0",
    "youtubeId": "xMab-460iS0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3591",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 45 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G8koUbFC9oA",
    "youtubeId": "G8koUbFC9oA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3592",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 44 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RPOUWqFNmb4",
    "youtubeId": "RPOUWqFNmb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3593",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 43 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pklgIjNrtbY",
    "youtubeId": "pklgIjNrtbY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3594",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 42 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e-Z4IsoFiB4",
    "youtubeId": "e-Z4IsoFiB4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3595",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 41 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fvaSFtrYqX4",
    "youtubeId": "fvaSFtrYqX4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3596",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 40 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dhlmg25NNgE",
    "youtubeId": "dhlmg25NNgE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3597",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 39 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bmfGRwSFgak",
    "youtubeId": "bmfGRwSFgak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3598",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 38 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bdq_4ttZkdg",
    "youtubeId": "bdq_4ttZkdg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3599",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 37 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nctYDoc3FGE",
    "youtubeId": "nctYDoc3FGE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3600",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 36 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0X_RN5pEc2g",
    "youtubeId": "0X_RN5pEc2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3601",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 35 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FZZPDHp4BrQ",
    "youtubeId": "FZZPDHp4BrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3602",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 34 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MtHRB0nRVYQ",
    "youtubeId": "MtHRB0nRVYQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3603",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 33 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zfId11taotI",
    "youtubeId": "zfId11taotI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3604",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 32 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pB-6oYI8T7Y",
    "youtubeId": "pB-6oYI8T7Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3605",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 31 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GZ5JJbO0jrs",
    "youtubeId": "GZ5JJbO0jrs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3606",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 30 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NPXkFghz4_I",
    "youtubeId": "NPXkFghz4_I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3607",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 29 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q8WDVrv9zg0",
    "youtubeId": "q8WDVrv9zg0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3608",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 28 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bc0UiyVgsYo",
    "youtubeId": "Bc0UiyVgsYo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3609",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 27 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vyiuQykdwZU",
    "youtubeId": "vyiuQykdwZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3610",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 26 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z12Rt-kEgVM",
    "youtubeId": "Z12Rt-kEgVM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3611",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 25 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lNgCDogu32M",
    "youtubeId": "lNgCDogu32M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3612",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 24 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SRV64SjdC3w",
    "youtubeId": "SRV64SjdC3w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3613",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 23 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YZw2R7ZFBoI",
    "youtubeId": "YZw2R7ZFBoI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3614",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 22 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EcFjU9YqeGY",
    "youtubeId": "EcFjU9YqeGY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3615",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 21 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LTcI8Vsv2M8",
    "youtubeId": "LTcI8Vsv2M8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3616",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 20 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/veWDrf3lAR0",
    "youtubeId": "veWDrf3lAR0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3617",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 19 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pWhcqmnET38",
    "youtubeId": "pWhcqmnET38",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3618",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 18 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q6Ci1KiTAXs",
    "youtubeId": "q6Ci1KiTAXs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3619",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 17 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cULM6q1DkBI",
    "youtubeId": "cULM6q1DkBI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3620",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 16 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TEhPzfsu-oc",
    "youtubeId": "TEhPzfsu-oc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3621",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 15 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cu4TRCbqkEk",
    "youtubeId": "cu4TRCbqkEk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3622",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 14 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WgZIB7KaF5k",
    "youtubeId": "WgZIB7KaF5k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3623",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 13 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F54valSOcCI",
    "youtubeId": "F54valSOcCI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3624",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 12 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lggtEgo-Mjw",
    "youtubeId": "lggtEgo-Mjw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3625",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 11 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YhKNR1QgIJA",
    "youtubeId": "YhKNR1QgIJA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3626",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 10 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HSja5xg7iQQ",
    "youtubeId": "HSja5xg7iQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3627",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 9 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IRdvMZx6BIs",
    "youtubeId": "IRdvMZx6BIs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3628",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 8 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1J3e50B9vzU",
    "youtubeId": "1J3e50B9vzU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3629",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 7 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GAzJstTgKlo",
    "youtubeId": "GAzJstTgKlo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3630",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 6 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CupM_I09OYE",
    "youtubeId": "CupM_I09OYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3631",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 5 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/54I83VTX0ts",
    "youtubeId": "54I83VTX0ts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3632",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 4 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Osp7DwkH8k",
    "youtubeId": "_Osp7DwkH8k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3633",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 3 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ngcltm0md6M",
    "youtubeId": "Ngcltm0md6M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3634",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 1 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1xbZIgFD9vU",
    "youtubeId": "1xbZIgFD9vU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3635",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 21 Ayat 2 Surah Anbiya Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dCXd9jdHSJY",
    "youtubeId": "dCXd9jdHSJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3636",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 135 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H1eS776UQ4w",
    "youtubeId": "H1eS776UQ4w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3637",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 134 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MDq9a8CnLEU",
    "youtubeId": "MDq9a8CnLEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3638",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 133 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nbMTjQK1JPY",
    "youtubeId": "nbMTjQK1JPY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3639",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 132 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cisf99NB4VQ",
    "youtubeId": "cisf99NB4VQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3640",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 131 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2gxhckE5lig",
    "youtubeId": "2gxhckE5lig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3641",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 130 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PVJ408psUC0",
    "youtubeId": "PVJ408psUC0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3642",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 129 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-vv9i5VHKs",
    "youtubeId": "F-vv9i5VHKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3643",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 128 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E2sJWuvPebY",
    "youtubeId": "E2sJWuvPebY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3644",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 127 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fXoPoUWZBK4",
    "youtubeId": "fXoPoUWZBK4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3645",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 126 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/se8yWIuodk8",
    "youtubeId": "se8yWIuodk8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3646",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 125 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lXMmFkBy-kc",
    "youtubeId": "lXMmFkBy-kc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3647",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 124 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dgji1ZAn9PM",
    "youtubeId": "dgji1ZAn9PM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3648",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 123 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eLk-9efZOJw",
    "youtubeId": "eLk-9efZOJw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3649",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 122 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rn_vZ4muZK4",
    "youtubeId": "rn_vZ4muZK4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3650",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 121 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/anJ7ms-tVEY",
    "youtubeId": "anJ7ms-tVEY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3651",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 120 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nAl_WQys5es",
    "youtubeId": "nAl_WQys5es",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3652",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 119 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nfzSE6LZSTA",
    "youtubeId": "nfzSE6LZSTA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3653",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 118 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/stNdafR_shM",
    "youtubeId": "stNdafR_shM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3654",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 117 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q5pUg8Ods7g",
    "youtubeId": "Q5pUg8Ods7g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3655",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 116 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vGfknEbzzZ4",
    "youtubeId": "vGfknEbzzZ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3656",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 115 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eP-eLVhN7lk",
    "youtubeId": "eP-eLVhN7lk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3657",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 114 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iPMyJGTfrBM",
    "youtubeId": "iPMyJGTfrBM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3658",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 113 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9T8L69T8xKQ",
    "youtubeId": "9T8L69T8xKQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3659",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 112 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2R90DEAgpgI",
    "youtubeId": "2R90DEAgpgI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3660",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 111 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I2PzqsFYVyk",
    "youtubeId": "I2PzqsFYVyk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3661",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 110 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4TsiS0VjAas",
    "youtubeId": "4TsiS0VjAas",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3662",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 109 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rc3ibc0a-SU",
    "youtubeId": "Rc3ibc0a-SU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3663",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 108 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vJcSTei4VU0",
    "youtubeId": "vJcSTei4VU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3664",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 107 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7pxnuaIA-OI",
    "youtubeId": "7pxnuaIA-OI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3665",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 106 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GDRRDZ646EA",
    "youtubeId": "GDRRDZ646EA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3666",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 105 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4pT9VooZ67k",
    "youtubeId": "4pT9VooZ67k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3667",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 104 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JD8nn4rGw4o",
    "youtubeId": "JD8nn4rGw4o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3668",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 103 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-3ZacIjv6jQ",
    "youtubeId": "-3ZacIjv6jQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3669",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 102 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xtCtMSyrSI0",
    "youtubeId": "xtCtMSyrSI0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3670",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 101 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IMILexqek0Q",
    "youtubeId": "IMILexqek0Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3671",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 100 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VhX266oDpfM",
    "youtubeId": "VhX266oDpfM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3672",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 99 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-7Nn3pwVuQU",
    "youtubeId": "-7Nn3pwVuQU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3673",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 98 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2cmrKzXm6-0",
    "youtubeId": "2cmrKzXm6-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3674",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 97 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZvCBQR6i6iY",
    "youtubeId": "ZvCBQR6i6iY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3675",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 96 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nk1LIpwIWRw",
    "youtubeId": "Nk1LIpwIWRw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3676",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 95 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ivnmPEvrN-c",
    "youtubeId": "ivnmPEvrN-c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3677",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 94 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hIopghm5cbk",
    "youtubeId": "hIopghm5cbk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3678",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 93 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lScU6Ta9kfc",
    "youtubeId": "lScU6Ta9kfc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3679",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 92 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qy4MRXsBfcE",
    "youtubeId": "qy4MRXsBfcE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3680",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 91 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gcApnGmvB50",
    "youtubeId": "gcApnGmvB50",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3681",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 90 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eOqJiPG5qhM",
    "youtubeId": "eOqJiPG5qhM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3682",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 89 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I7CeGGG39ng",
    "youtubeId": "I7CeGGG39ng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3683",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 88 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SDnlbQLGfZ0",
    "youtubeId": "SDnlbQLGfZ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3684",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 87 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G7-h3s98OJg",
    "youtubeId": "G7-h3s98OJg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3685",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 86 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iXouRHtpa58",
    "youtubeId": "iXouRHtpa58",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3686",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 85 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1EAtgD1MK2A",
    "youtubeId": "1EAtgD1MK2A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3687",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 84 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oTHr8Z5LKqU",
    "youtubeId": "oTHr8Z5LKqU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3688",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 83 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AvNps8RYC0M",
    "youtubeId": "AvNps8RYC0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3689",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 82 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x4znLlpsDb8",
    "youtubeId": "x4znLlpsDb8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3690",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 81 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g0z7pNYRMDo",
    "youtubeId": "g0z7pNYRMDo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3691",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 80 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NNv4rLcL6a0",
    "youtubeId": "NNv4rLcL6a0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3692",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 79 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k13VY4u4-GM",
    "youtubeId": "k13VY4u4-GM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3693",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 78 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hjI2UdNln_c",
    "youtubeId": "hjI2UdNln_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3694",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 77 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w3jifWPXgrg",
    "youtubeId": "w3jifWPXgrg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3695",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 76 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s6tglqmxtQk",
    "youtubeId": "s6tglqmxtQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3696",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 75 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h9FgHAcA1Ns",
    "youtubeId": "h9FgHAcA1Ns",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3697",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 74 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5hT3wZYf-FA",
    "youtubeId": "5hT3wZYf-FA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3698",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 73 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TQWzmkhFPk0",
    "youtubeId": "TQWzmkhFPk0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3699",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 72 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SW_198ON13o",
    "youtubeId": "SW_198ON13o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3700",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 71 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JsBUEgxRAGU",
    "youtubeId": "JsBUEgxRAGU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3701",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 70 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/quoXB7KaepM",
    "youtubeId": "quoXB7KaepM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3702",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 69 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6wVcKS-CbRQ",
    "youtubeId": "6wVcKS-CbRQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3703",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 68 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X6k1z5hie4g",
    "youtubeId": "X6k1z5hie4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3704",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 67 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4ifFKHAjMZg",
    "youtubeId": "4ifFKHAjMZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3705",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 66 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7mD-KZV8Y1Y",
    "youtubeId": "7mD-KZV8Y1Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3706",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 65 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/om7nppii4pY",
    "youtubeId": "om7nppii4pY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3707",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 64 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y34egNcnctU",
    "youtubeId": "y34egNcnctU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3708",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 63 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZxObcJBVW3g",
    "youtubeId": "ZxObcJBVW3g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3709",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 62 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tsz3dLUsztM",
    "youtubeId": "tsz3dLUsztM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3710",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 61 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TGg9jjtfMQo",
    "youtubeId": "TGg9jjtfMQo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3711",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 60 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fNSHutwNuoY",
    "youtubeId": "fNSHutwNuoY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3712",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 59 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wR0Pjb8nbgg",
    "youtubeId": "wR0Pjb8nbgg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3713",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 58 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R9Z78-rVK7E",
    "youtubeId": "R9Z78-rVK7E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3714",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 57 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j2hUBCjhgXQ",
    "youtubeId": "j2hUBCjhgXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3715",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 56 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8qhWWl-UbRc",
    "youtubeId": "8qhWWl-UbRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3716",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 55 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RfbRpFAlMv0",
    "youtubeId": "RfbRpFAlMv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3717",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 54 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3yBU_WXLL14",
    "youtubeId": "3yBU_WXLL14",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3718",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 53 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6SrU4l5hCwQ",
    "youtubeId": "6SrU4l5hCwQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3719",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 52 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I4-e_Bu25_Q",
    "youtubeId": "I4-e_Bu25_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3720",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 51 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9MPjX6ld-cg",
    "youtubeId": "9MPjX6ld-cg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3721",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 50 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZwlqnJIwW_c",
    "youtubeId": "ZwlqnJIwW_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3722",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 49 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ubQZ1C6RUSo",
    "youtubeId": "ubQZ1C6RUSo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3723",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 48 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fFezu7q3waM",
    "youtubeId": "fFezu7q3waM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3724",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 47 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OjlkB4LdHTw",
    "youtubeId": "OjlkB4LdHTw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3725",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 46 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lkPuQuR1zkY",
    "youtubeId": "lkPuQuR1zkY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3726",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 45 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0BDB5KTOgAk",
    "youtubeId": "0BDB5KTOgAk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3727",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 44 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rDqNsBjZLqY",
    "youtubeId": "rDqNsBjZLqY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3728",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 43 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A9j79p2-mbM",
    "youtubeId": "A9j79p2-mbM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3729",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 42 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BIqjqBkMrU8",
    "youtubeId": "BIqjqBkMrU8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3730",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 41 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8cZAjOHzEHo",
    "youtubeId": "8cZAjOHzEHo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3731",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 40 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FcJVukDqwsk",
    "youtubeId": "FcJVukDqwsk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3732",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 39 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/edhaVuEjthk",
    "youtubeId": "edhaVuEjthk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3733",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 38 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-PtnuSMI9Fo",
    "youtubeId": "-PtnuSMI9Fo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3734",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 37 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Qc4E84VWGI",
    "youtubeId": "9Qc4E84VWGI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3735",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 36 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ghQGNO3G1Ho",
    "youtubeId": "ghQGNO3G1Ho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3736",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 35 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LbC4xg465Kk",
    "youtubeId": "LbC4xg465Kk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3737",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 34 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ndTiOZekCBw",
    "youtubeId": "ndTiOZekCBw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3738",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 33 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PncU6UswcKE",
    "youtubeId": "PncU6UswcKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3739",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 32 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fOW6KMR_3Gg",
    "youtubeId": "fOW6KMR_3Gg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3740",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 31 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tllV9d2ttEQ",
    "youtubeId": "tllV9d2ttEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3741",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 30 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mOAK78uMazc",
    "youtubeId": "mOAK78uMazc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3742",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 29 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m6avxKz8ffI",
    "youtubeId": "m6avxKz8ffI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3743",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 28 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m3jHLETLeBY",
    "youtubeId": "m3jHLETLeBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3744",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 27 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ffayy7SJUnY",
    "youtubeId": "ffayy7SJUnY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3745",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 26 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sjl8NIvV_ME",
    "youtubeId": "sjl8NIvV_ME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3746",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 25 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZxPDUHLmGr8",
    "youtubeId": "ZxPDUHLmGr8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3747",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 24 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8z53LVPuvkk",
    "youtubeId": "8z53LVPuvkk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3748",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 23 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9H9hvaF6Ie4",
    "youtubeId": "9H9hvaF6Ie4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3749",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 22 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TiEwkw3SLDc",
    "youtubeId": "TiEwkw3SLDc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3750",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 21 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eNcNshEwE5g",
    "youtubeId": "eNcNshEwE5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3751",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 20 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qPHiPv1jRzA",
    "youtubeId": "qPHiPv1jRzA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3752",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 19 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JR7qS_fZm2A",
    "youtubeId": "JR7qS_fZm2A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3753",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 18 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xwRQRECAJwI",
    "youtubeId": "xwRQRECAJwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3754",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 17 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mQmhhzIoN8M",
    "youtubeId": "mQmhhzIoN8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3755",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 16 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hOJGC7-2XUo",
    "youtubeId": "hOJGC7-2XUo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3756",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 15 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8cVkbW3xqpA",
    "youtubeId": "8cVkbW3xqpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3757",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 14 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q1HF-bk0jX4",
    "youtubeId": "q1HF-bk0jX4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3758",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 13 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NUk53u95-lA",
    "youtubeId": "NUk53u95-lA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3759",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 12 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/81kyNCnu_AM",
    "youtubeId": "81kyNCnu_AM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3760",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 11 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/509nPrqDJWw",
    "youtubeId": "509nPrqDJWw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3761",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 10 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/scHK-_JaIoA",
    "youtubeId": "scHK-_JaIoA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3762",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 9 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YYJODoUkE-c",
    "youtubeId": "YYJODoUkE-c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3763",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 8 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tDDKw-omJGA",
    "youtubeId": "tDDKw-omJGA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3764",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 7 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X2vHlFoG2vg",
    "youtubeId": "X2vHlFoG2vg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3765",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 6 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UNxzc_WkYm4",
    "youtubeId": "UNxzc_WkYm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3766",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 5 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PL5ivWH8baU",
    "youtubeId": "PL5ivWH8baU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3767",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 4 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3hbJhsxcRn4",
    "youtubeId": "3hbJhsxcRn4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3768",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 3 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cj90vtB9cGw",
    "youtubeId": "Cj90vtB9cGw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3769",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 2 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/px5qZf7DodY",
    "youtubeId": "px5qZf7DodY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3770",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 20 Ayat 1 Surah TaHa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RvGy1NtQ_6c",
    "youtubeId": "RvGy1NtQ_6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3771",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 98 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KoMBc7LxLcI",
    "youtubeId": "KoMBc7LxLcI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3772",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 97 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TvV5QTlkcgk",
    "youtubeId": "TvV5QTlkcgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3773",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 96 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/973FuPO7Uh0",
    "youtubeId": "973FuPO7Uh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3774",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 95 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r4Lk86nyOHI",
    "youtubeId": "r4Lk86nyOHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3775",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 94 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OclCtca3jyA",
    "youtubeId": "OclCtca3jyA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3776",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 93 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/snAJyiWdQIQ",
    "youtubeId": "snAJyiWdQIQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3777",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 92 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LfiVhOYa5fw",
    "youtubeId": "LfiVhOYa5fw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3778",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 91 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aGCKsa9p3Nc",
    "youtubeId": "aGCKsa9p3Nc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3779",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 90 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q8kWBElZzic",
    "youtubeId": "Q8kWBElZzic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3780",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 89 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xY2oAggiYTc",
    "youtubeId": "xY2oAggiYTc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3781",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 88 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WMiZsxpGGNc",
    "youtubeId": "WMiZsxpGGNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3782",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 87 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sg1CoCb8dgk",
    "youtubeId": "sg1CoCb8dgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3783",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 86 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z1fdFStyq90",
    "youtubeId": "z1fdFStyq90",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3784",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 85 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q6OrL5dtfbc",
    "youtubeId": "Q6OrL5dtfbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3785",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 84 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M3LjkmieA78",
    "youtubeId": "M3LjkmieA78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3786",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 83 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YEI9hq9p4FQ",
    "youtubeId": "YEI9hq9p4FQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3787",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 82 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m2w2VyoHJ2U",
    "youtubeId": "m2w2VyoHJ2U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3788",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 81 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/21-psVaXK_A",
    "youtubeId": "21-psVaXK_A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3789",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 80 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vmil8liwthI",
    "youtubeId": "Vmil8liwthI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3790",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 79 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rI998QZTNfg",
    "youtubeId": "rI998QZTNfg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3791",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 78 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zh1xn4NXy74",
    "youtubeId": "zh1xn4NXy74",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3792",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 77 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QVa85bCjNFA",
    "youtubeId": "QVa85bCjNFA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3793",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 76 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vwex0Hop6Dw",
    "youtubeId": "Vwex0Hop6Dw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3794",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 75 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ifBPIdv6q_0",
    "youtubeId": "ifBPIdv6q_0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3795",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 74 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MoOaKBAOQnQ",
    "youtubeId": "MoOaKBAOQnQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3796",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 73 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MehwHoBAGXM",
    "youtubeId": "MehwHoBAGXM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3797",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 72 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dru2jtaJveU",
    "youtubeId": "dru2jtaJveU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3798",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 71 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W-s_MOTg_hM",
    "youtubeId": "W-s_MOTg_hM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3799",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 70 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b7gS-Wr4ycg",
    "youtubeId": "b7gS-Wr4ycg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3800",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 69 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sOV5v00uQ1o",
    "youtubeId": "sOV5v00uQ1o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3801",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 68 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sEBHBB9GTh4",
    "youtubeId": "sEBHBB9GTh4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3802",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 67 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NoN1uCW5kwM",
    "youtubeId": "NoN1uCW5kwM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3803",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 66 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wsH2Xde6T6c",
    "youtubeId": "wsH2Xde6T6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3804",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 65 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pFYQ7gND0GM",
    "youtubeId": "pFYQ7gND0GM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3805",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 64 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rzMfNuEp-TI",
    "youtubeId": "rzMfNuEp-TI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3806",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 63 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hveUGNqK8uE",
    "youtubeId": "hveUGNqK8uE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3807",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 62 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TQkd_qnrovo",
    "youtubeId": "TQkd_qnrovo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3808",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 61 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SWMtQYZS23E",
    "youtubeId": "SWMtQYZS23E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3809",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 60 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ehLBqnlpyek",
    "youtubeId": "ehLBqnlpyek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3810",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 59 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Usr2vZkixdQ",
    "youtubeId": "Usr2vZkixdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3811",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 58 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xp1-a5_HQFI",
    "youtubeId": "xp1-a5_HQFI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3812",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 57 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H8xmgTTI_ng",
    "youtubeId": "H8xmgTTI_ng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3813",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 56 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AGyXGEK5TFY",
    "youtubeId": "AGyXGEK5TFY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3814",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 55 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HrdYOmAfk7w",
    "youtubeId": "HrdYOmAfk7w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3815",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 54 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T4IP-k6Y6O8",
    "youtubeId": "T4IP-k6Y6O8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3816",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 53 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SdaA9QaWyG4",
    "youtubeId": "SdaA9QaWyG4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3817",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 52 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1MvreprPxjw",
    "youtubeId": "1MvreprPxjw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3818",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 51 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EHAg1ZuIQek",
    "youtubeId": "EHAg1ZuIQek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3819",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 50 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3S2PDGC-8GA",
    "youtubeId": "3S2PDGC-8GA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3820",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 49 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LZz_605WCnI",
    "youtubeId": "LZz_605WCnI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3821",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 48 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zlMcDrY9XTM",
    "youtubeId": "zlMcDrY9XTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3822",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 47 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lqt9Br19iUg",
    "youtubeId": "Lqt9Br19iUg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3823",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 46 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BXUWdZKTYXA",
    "youtubeId": "BXUWdZKTYXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3824",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 45 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FyxfQlTtKxw",
    "youtubeId": "FyxfQlTtKxw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3825",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 44 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wi6JSNBP9vo",
    "youtubeId": "Wi6JSNBP9vo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3826",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 43 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hu6XRHhIAYY",
    "youtubeId": "Hu6XRHhIAYY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3827",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 42 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9fmQZuLrdsc",
    "youtubeId": "9fmQZuLrdsc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3828",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 41 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aQ_sNy16KP8",
    "youtubeId": "aQ_sNy16KP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3829",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 40 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fsloBuEtJec",
    "youtubeId": "fsloBuEtJec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3830",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 39 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S1RM6I3T_8A",
    "youtubeId": "S1RM6I3T_8A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3831",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 37 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zuSNP68Wdsg",
    "youtubeId": "zuSNP68Wdsg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3832",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 38 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BrG3fq8p3tI",
    "youtubeId": "BrG3fq8p3tI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3833",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 36 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iUA7C2BVTL4",
    "youtubeId": "iUA7C2BVTL4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3834",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 35 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9a8K1JiZHrQ",
    "youtubeId": "9a8K1JiZHrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3835",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 34 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z0CpUg_dv4Q",
    "youtubeId": "z0CpUg_dv4Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3836",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 33 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rea7aKObA5g",
    "youtubeId": "rea7aKObA5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3837",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 32 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tor2lYTgHqE",
    "youtubeId": "tor2lYTgHqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3838",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 31 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wi5X4jL5JWI",
    "youtubeId": "Wi5X4jL5JWI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3839",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 30 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b2jTW5rEBNA",
    "youtubeId": "b2jTW5rEBNA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3840",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 29 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d8Wj6B2XJqQ",
    "youtubeId": "d8Wj6B2XJqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3841",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 28 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lqsi374Q2L0",
    "youtubeId": "Lqsi374Q2L0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3842",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 27 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6RSj6oR-C8Q",
    "youtubeId": "6RSj6oR-C8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3843",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 26 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rnrRFLXZMgE",
    "youtubeId": "rnrRFLXZMgE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3844",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 25 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mypOjice8NU",
    "youtubeId": "mypOjice8NU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3845",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 24 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BwHfh8wIe-Q",
    "youtubeId": "BwHfh8wIe-Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3846",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 23 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6nm8_KClUko",
    "youtubeId": "6nm8_KClUko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3847",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 22 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sMheAiH283Q",
    "youtubeId": "sMheAiH283Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3848",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 21 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a_v-jClWGFM",
    "youtubeId": "a_v-jClWGFM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3849",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 20 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/buVnthFQCAY",
    "youtubeId": "buVnthFQCAY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3850",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 19 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/04fbQAFpsE0",
    "youtubeId": "04fbQAFpsE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3851",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 18 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rWjbGr_6ipw",
    "youtubeId": "rWjbGr_6ipw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3852",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 17 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FC3J5iBGC6Y",
    "youtubeId": "FC3J5iBGC6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3853",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 16 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d_80MojVUTA",
    "youtubeId": "d_80MojVUTA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3854",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 15 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z_gDuLgCNBI",
    "youtubeId": "z_gDuLgCNBI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3855",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 14 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oJDJ4e_ZIGE",
    "youtubeId": "oJDJ4e_ZIGE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3856",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 13 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nkrfvqEL94k",
    "youtubeId": "nkrfvqEL94k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3857",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 12 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S-ky5AXkOf0",
    "youtubeId": "S-ky5AXkOf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3858",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 11 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r0Q_SSYzkjM",
    "youtubeId": "r0Q_SSYzkjM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3859",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 10 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SHUBJVGrkTE",
    "youtubeId": "SHUBJVGrkTE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3860",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 9 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/htj2IK52i9E",
    "youtubeId": "htj2IK52i9E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3861",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 8 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SBiF1y6a3XU",
    "youtubeId": "SBiF1y6a3XU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3862",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 7 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JbO_6JyoHGs",
    "youtubeId": "JbO_6JyoHGs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3863",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 6 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6eaOz92yMQY",
    "youtubeId": "6eaOz92yMQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3864",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 5 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ampe784iiN8",
    "youtubeId": "ampe784iiN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3865",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 4 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ElIrtG49ghQ",
    "youtubeId": "ElIrtG49ghQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3866",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 3 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4_sBcrPbZoY",
    "youtubeId": "4_sBcrPbZoY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3867",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 19 Ayat 1 & 2 Surah Maryam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CLzS00C3JhY",
    "youtubeId": "CLzS00C3JhY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3868",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 110 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P1gKhb1CwFs",
    "youtubeId": "P1gKhb1CwFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3869",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 109 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WQ9IxZLl0UA",
    "youtubeId": "WQ9IxZLl0UA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3870",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 108 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jKHoLnbkEY0",
    "youtubeId": "jKHoLnbkEY0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3871",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 107 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3HADpHMd5lU",
    "youtubeId": "3HADpHMd5lU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3872",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 106 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5fcKoW31tpQ",
    "youtubeId": "5fcKoW31tpQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3873",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 105 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rJUCpP7FD9Y",
    "youtubeId": "rJUCpP7FD9Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3874",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 104 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3tWSbrFmYUU",
    "youtubeId": "3tWSbrFmYUU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3875",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 103 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8s2HN35XvB8",
    "youtubeId": "8s2HN35XvB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3876",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 102 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KS5si_xdVa4",
    "youtubeId": "KS5si_xdVa4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3877",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 101 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NPRZenMRC5Y",
    "youtubeId": "NPRZenMRC5Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3878",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 100 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1BXvrfx0Z84",
    "youtubeId": "1BXvrfx0Z84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3879",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 99 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P_kcPqV5Lwg",
    "youtubeId": "P_kcPqV5Lwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3880",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 98 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T9nxQ-0QVcQ",
    "youtubeId": "T9nxQ-0QVcQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3881",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 97 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g9rTUJMmsV0",
    "youtubeId": "g9rTUJMmsV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3882",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 96 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xzqV01heo64",
    "youtubeId": "xzqV01heo64",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3883",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 95 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gz5rApV2_pY",
    "youtubeId": "gz5rApV2_pY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3884",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 94 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2ARLL9cqccM",
    "youtubeId": "2ARLL9cqccM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3885",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 93 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_hf07gM_28w",
    "youtubeId": "_hf07gM_28w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3886",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 92 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1s2wBNnHBoc",
    "youtubeId": "1s2wBNnHBoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3887",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 91 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kd0OxuSv8LA",
    "youtubeId": "Kd0OxuSv8LA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3888",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 90 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uh7epXpLjK8",
    "youtubeId": "Uh7epXpLjK8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3889",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 89 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a166w9v9sJ4",
    "youtubeId": "a166w9v9sJ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3890",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 88 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pXcBL4RKrn0",
    "youtubeId": "pXcBL4RKrn0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3891",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 87 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dObN1lVFlJA",
    "youtubeId": "dObN1lVFlJA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3892",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 86 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UD9iCmJDqvA",
    "youtubeId": "UD9iCmJDqvA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3893",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 85 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8XuSll0s8T0",
    "youtubeId": "8XuSll0s8T0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3894",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 84 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MMbI7Q_EX8U",
    "youtubeId": "MMbI7Q_EX8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3895",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 83 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/525ZFufQz84",
    "youtubeId": "525ZFufQz84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3896",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 82 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JIqkfH0qRo4",
    "youtubeId": "JIqkfH0qRo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3897",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 81 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KI_GIx0qeBo",
    "youtubeId": "KI_GIx0qeBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3898",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 80 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WPrFUtEIeIA",
    "youtubeId": "WPrFUtEIeIA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3899",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 79 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Oo0erU31xFc",
    "youtubeId": "Oo0erU31xFc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3900",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 78 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P2N_cunX42M",
    "youtubeId": "P2N_cunX42M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3901",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 77 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PxY2oy9LQgs",
    "youtubeId": "PxY2oy9LQgs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3902",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 76 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NSrBLgJt3GM",
    "youtubeId": "NSrBLgJt3GM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3903",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 75 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JcirMOWSg-8",
    "youtubeId": "JcirMOWSg-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3904",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 74 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ctwduZijmtE",
    "youtubeId": "ctwduZijmtE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3905",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 73 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Blkxl-cEVEs",
    "youtubeId": "Blkxl-cEVEs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3906",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 72 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BToyUjQu04Y",
    "youtubeId": "BToyUjQu04Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3907",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 71 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kiKFaB5IqVA",
    "youtubeId": "kiKFaB5IqVA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3908",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 70 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FSMztCYLICs",
    "youtubeId": "FSMztCYLICs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3909",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 69 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-qumGZYvytM",
    "youtubeId": "-qumGZYvytM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3910",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 68 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_wgWvy9dKVY",
    "youtubeId": "_wgWvy9dKVY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3911",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 67 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HBgwvL3LNhE",
    "youtubeId": "HBgwvL3LNhE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3912",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 66 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4kPu7CEC4WU",
    "youtubeId": "4kPu7CEC4WU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3913",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 65 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dXR7WBA4s-M",
    "youtubeId": "dXR7WBA4s-M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3914",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 64 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XKDgt8S8d2E",
    "youtubeId": "XKDgt8S8d2E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3915",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 63 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DWSHqhwj1zg",
    "youtubeId": "DWSHqhwj1zg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3916",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 62 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zgfPk3kVO_s",
    "youtubeId": "zgfPk3kVO_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3917",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 61 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KjzULsbYesM",
    "youtubeId": "KjzULsbYesM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3918",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 60 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dURpJg8e78Y",
    "youtubeId": "dURpJg8e78Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3919",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 59 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SxlXr9ZK_Zo",
    "youtubeId": "SxlXr9ZK_Zo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3920",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 58 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2riGSVYpxpA",
    "youtubeId": "2riGSVYpxpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3921",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 57 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gv0xjdgYO2o",
    "youtubeId": "Gv0xjdgYO2o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3922",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 56 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IsDhR8meMug",
    "youtubeId": "IsDhR8meMug",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3923",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 55 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2K1WjjptzKI",
    "youtubeId": "2K1WjjptzKI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3924",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 54 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Y998_5rOfk",
    "youtubeId": "7Y998_5rOfk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3925",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 53 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NJaE_x_RezA",
    "youtubeId": "NJaE_x_RezA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3926",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 52 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w5hXfUgpL8w",
    "youtubeId": "w5hXfUgpL8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3927",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 51 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QWO59XV7Dg0",
    "youtubeId": "QWO59XV7Dg0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3928",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 50  Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jnIe2GbwXvM",
    "youtubeId": "jnIe2GbwXvM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3929",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 49 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ca6qTapz0ZE",
    "youtubeId": "Ca6qTapz0ZE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3930",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 48 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kb5mt5TlVqc",
    "youtubeId": "kb5mt5TlVqc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3931",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 47 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QYLTwL6VhUs",
    "youtubeId": "QYLTwL6VhUs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3932",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 46 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N4W4REK9e-o",
    "youtubeId": "N4W4REK9e-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3933",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 45 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kq59-Vd8LQ8",
    "youtubeId": "Kq59-Vd8LQ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3934",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 44 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8ITnidzpPTA",
    "youtubeId": "8ITnidzpPTA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3935",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 43 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/30D2uAxYWiM",
    "youtubeId": "30D2uAxYWiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3936",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 42 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NgGKnUUn47s",
    "youtubeId": "NgGKnUUn47s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3937",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 41 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WleBvE4ubrU",
    "youtubeId": "WleBvE4ubrU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3938",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 40 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NJMKVqGISF4",
    "youtubeId": "NJMKVqGISF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3939",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 39 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YziCThIFn1M",
    "youtubeId": "YziCThIFn1M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3940",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 38 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sNBZvJIbUZc",
    "youtubeId": "sNBZvJIbUZc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3941",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 37 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LzrrjkfSAeY",
    "youtubeId": "LzrrjkfSAeY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3942",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 35 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v2sgCN6w0tE",
    "youtubeId": "v2sgCN6w0tE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3943",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 33 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7E7hDk4toFk",
    "youtubeId": "7E7hDk4toFk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3944",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 36 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ok_BB83_jAg",
    "youtubeId": "Ok_BB83_jAg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3945",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 34 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MFIdZ9y51vg",
    "youtubeId": "MFIdZ9y51vg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3946",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 32 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rp9Gw8TzeIk",
    "youtubeId": "Rp9Gw8TzeIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3947",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 31 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f73xTBP3Nio",
    "youtubeId": "f73xTBP3Nio",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3948",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 30 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ewGO86DfRdw",
    "youtubeId": "ewGO86DfRdw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3949",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 29 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8uV3utkJ6sc",
    "youtubeId": "8uV3utkJ6sc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3950",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 28 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qx6EYlYC_Qo",
    "youtubeId": "Qx6EYlYC_Qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3951",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 27 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bBAWZSODw_c",
    "youtubeId": "bBAWZSODw_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3952",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 26 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QXm_k8M6AC8",
    "youtubeId": "QXm_k8M6AC8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3953",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 25 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xAWnz0MH5nU",
    "youtubeId": "xAWnz0MH5nU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3954",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 24 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5PVXUgg4EeI",
    "youtubeId": "5PVXUgg4EeI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3955",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 23 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k92PPVlEfa4",
    "youtubeId": "k92PPVlEfa4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3956",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 22 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZvPGVKyzRAM",
    "youtubeId": "ZvPGVKyzRAM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3957",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 21 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yax54VvcNEo",
    "youtubeId": "yax54VvcNEo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3958",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 20 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nPtaFNjHMf4",
    "youtubeId": "nPtaFNjHMf4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3959",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 19 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K8b7aMADCME",
    "youtubeId": "K8b7aMADCME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3960",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 18 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yRTL0TaCrrY",
    "youtubeId": "yRTL0TaCrrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3961",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 17 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xFY3Y7UvYLc",
    "youtubeId": "xFY3Y7UvYLc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3962",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 16 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VKhojffPBoE",
    "youtubeId": "VKhojffPBoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3963",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 15 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GOCrLbYkbMk",
    "youtubeId": "GOCrLbYkbMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3964",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 14 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eYuwmV8-gSo",
    "youtubeId": "eYuwmV8-gSo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3965",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 13 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8wlZbz_eLC0",
    "youtubeId": "8wlZbz_eLC0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3966",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 12 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UHaB9Qir3YE",
    "youtubeId": "UHaB9Qir3YE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3967",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 11 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pg0woaalcQI",
    "youtubeId": "pg0woaalcQI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3968",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 10 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x1OKM0xynoc",
    "youtubeId": "x1OKM0xynoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3969",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 9 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZV9JKhgDMy8",
    "youtubeId": "ZV9JKhgDMy8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3970",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 8 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q4Y9i4-elTw",
    "youtubeId": "Q4Y9i4-elTw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3971",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 7 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c59QGCUdBzc",
    "youtubeId": "c59QGCUdBzc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3972",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 6 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MX56Lwg5_i8",
    "youtubeId": "MX56Lwg5_i8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3973",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 5 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RJgQ9yFm_4I",
    "youtubeId": "RJgQ9yFm_4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3974",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 4 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jGr3dHo_dLY",
    "youtubeId": "jGr3dHo_dLY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3975",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 3 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/scq1zJCA9dY",
    "youtubeId": "scq1zJCA9dY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3976",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 2 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pEBaxz_2r20",
    "youtubeId": "pEBaxz_2r20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3977",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 18 Ayat 1 Surah Kahf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1H0dhPv2G4U",
    "youtubeId": "1H0dhPv2G4U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3978",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 111 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/QjRDQR3lPzM",
    "youtubeId": "QjRDQR3lPzM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3979",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 110 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/oDZ26tsZMnk",
    "youtubeId": "oDZ26tsZMnk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3980",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 109 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/-cNfwlC-FSU",
    "youtubeId": "-cNfwlC-FSU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3981",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 108 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/-20qya2OYUM",
    "youtubeId": "-20qya2OYUM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3982",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 107 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vj4bmk0hHgo",
    "youtubeId": "Vj4bmk0hHgo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3983",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 106 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/m4DdTMwAtaw",
    "youtubeId": "m4DdTMwAtaw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3984",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 105 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/o7NvZxbcN6E",
    "youtubeId": "o7NvZxbcN6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3985",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 104 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/dQOikxC-020",
    "youtubeId": "dQOikxC-020",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3986",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 103 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/wduYK8X_sHg",
    "youtubeId": "wduYK8X_sHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3987",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 102 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/fTFymWxQpAY",
    "youtubeId": "fTFymWxQpAY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3988",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 101 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y-PRm8CxSHk",
    "youtubeId": "Y-PRm8CxSHk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3989",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 100 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/IsNfh2TdkRE",
    "youtubeId": "IsNfh2TdkRE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3990",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 99 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/UraHMH5zU0Y",
    "youtubeId": "UraHMH5zU0Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3991",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 98 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/CjQUg5rUdTI",
    "youtubeId": "CjQUg5rUdTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3992",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 97 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/qFbVRmKG1bk",
    "youtubeId": "qFbVRmKG1bk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3993",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 96 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/0EEtVZFgt6A",
    "youtubeId": "0EEtVZFgt6A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3994",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 95 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hyix9K1iZF4",
    "youtubeId": "Hyix9K1iZF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3995",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 94 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/1xOZMsX5t0M",
    "youtubeId": "1xOZMsX5t0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3996",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 93 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/VR-yNUYZO-s",
    "youtubeId": "VR-yNUYZO-s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3997",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 92 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/eDFhKhDa_gI",
    "youtubeId": "eDFhKhDa_gI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3998",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 91 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/R2mogvfq-Xo",
    "youtubeId": "R2mogvfq-Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-3999",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 90 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/KUfWML-kFOA",
    "youtubeId": "KUfWML-kFOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4000",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 89 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/kS38sb5lgNc",
    "youtubeId": "kS38sb5lgNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4001",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 88 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/00Np-SZHy1U",
    "youtubeId": "00Np-SZHy1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4002",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 87 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/x3MRwXXxBPQ",
    "youtubeId": "x3MRwXXxBPQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4003",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 86 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/srMLth_v-Do",
    "youtubeId": "srMLth_v-Do",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4004",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 85 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/cErkqEgf9wI",
    "youtubeId": "cErkqEgf9wI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4005",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 84 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/YyJOPNU1jY0",
    "youtubeId": "YyJOPNU1jY0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4006",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 83 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/2VL4VEYgUGQ",
    "youtubeId": "2VL4VEYgUGQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4007",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 82 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/YnOWWA6PWgU",
    "youtubeId": "YnOWWA6PWgU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4008",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 81 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/SdDe11MDRrY",
    "youtubeId": "SdDe11MDRrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4009",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 80 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/ARhDBXsdQBo",
    "youtubeId": "ARhDBXsdQBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4010",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 79 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/nvxJ0xuMG8Q",
    "youtubeId": "nvxJ0xuMG8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4011",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 78 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/bmnQqXV0iao",
    "youtubeId": "bmnQqXV0iao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4012",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 77 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/RZlfwrZuVVI",
    "youtubeId": "RZlfwrZuVVI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4013",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 76 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/O1-CAqlPuk8",
    "youtubeId": "O1-CAqlPuk8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4014",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 75 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/F4A6jbGl49Q",
    "youtubeId": "F4A6jbGl49Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4015",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 74 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/G9YLgfBIJ2s",
    "youtubeId": "G9YLgfBIJ2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4016",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 73 Surah Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/iAT3QecqUk4",
    "youtubeId": "iAT3QecqUk4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4017",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 72 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/alLj8yP6nvY",
    "youtubeId": "alLj8yP6nvY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4018",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 71 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/ccSHiht018o",
    "youtubeId": "ccSHiht018o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4019",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 70 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/jU77bJYlcps",
    "youtubeId": "jU77bJYlcps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4020",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 69 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/iSyKAJaY7gs",
    "youtubeId": "iSyKAJaY7gs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4021",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 68 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/45AmQOAVBv0",
    "youtubeId": "45AmQOAVBv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4022",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 67 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/dAOi73lutZE",
    "youtubeId": "dAOi73lutZE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4023",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 66 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/plwqZyY3HjY",
    "youtubeId": "plwqZyY3HjY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4024",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 65 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/w50f2EKAMHg",
    "youtubeId": "w50f2EKAMHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4025",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 64 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZXTXiSzQsTo",
    "youtubeId": "ZXTXiSzQsTo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4026",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 63 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/aT0MTRvdENY",
    "youtubeId": "aT0MTRvdENY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4027",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 62 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/z2BBLWjIR74",
    "youtubeId": "z2BBLWjIR74",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4028",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 61 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/ruX9hVrP0ao",
    "youtubeId": "ruX9hVrP0ao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4029",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 60 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/6CXzxuJonEs",
    "youtubeId": "6CXzxuJonEs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4030",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 59 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/CVhM_t7H5lw",
    "youtubeId": "CVhM_t7H5lw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4031",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 58 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/3pl6eh9DVOg",
    "youtubeId": "3pl6eh9DVOg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4032",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 57 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/U_636ljnzOA",
    "youtubeId": "U_636ljnzOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4033",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 56 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/HQ_bFZjhQfs",
    "youtubeId": "HQ_bFZjhQfs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4034",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 55 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/vKNWWYwkImk",
    "youtubeId": "vKNWWYwkImk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4035",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 54 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/4BRsZxIjJrc",
    "youtubeId": "4BRsZxIjJrc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4036",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 53 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/wRk4Lp0f4u0",
    "youtubeId": "wRk4Lp0f4u0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4037",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 52 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/szSzfgL_YkI",
    "youtubeId": "szSzfgL_YkI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4038",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 51 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Sj38nyjeKg",
    "youtubeId": "7Sj38nyjeKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4039",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 50 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/mPiv4kCPWBY",
    "youtubeId": "mPiv4kCPWBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4040",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 49 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/xSTriujGisk",
    "youtubeId": "xSTriujGisk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4041",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 48 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/O5BTRzYsXlU",
    "youtubeId": "O5BTRzYsXlU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4042",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 47 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/n_X_8i7WQi4",
    "youtubeId": "n_X_8i7WQi4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4043",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 46 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/ShYOHp4YvF0",
    "youtubeId": "ShYOHp4YvF0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4044",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 45 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/8jBER3Iy4Qg",
    "youtubeId": "8jBER3Iy4Qg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4045",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 44 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/mFNV5eFaOJY",
    "youtubeId": "mFNV5eFaOJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4046",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 43 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/w3kf3J7gzPw",
    "youtubeId": "w3kf3J7gzPw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4047",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 42 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/P3qva2Tu2IY",
    "youtubeId": "P3qva2Tu2IY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4048",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 41 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/eRe8le77hyg",
    "youtubeId": "eRe8le77hyg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4049",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 40 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/8RrHehv2DaE",
    "youtubeId": "8RrHehv2DaE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4050",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 39 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/MzZFjDS1-Fk",
    "youtubeId": "MzZFjDS1-Fk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4051",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 38 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/1wvA-Cdxp80",
    "youtubeId": "1wvA-Cdxp80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4052",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 37 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/BsiThgirjZg",
    "youtubeId": "BsiThgirjZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4053",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 36 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/IpE9MtF_5JQ",
    "youtubeId": "IpE9MtF_5JQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4054",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 35 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/lepScc8AZQA",
    "youtubeId": "lepScc8AZQA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4055",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 34 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yn6MTpzAGLs",
    "youtubeId": "Yn6MTpzAGLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4056",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 33 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/CXD-NmhCEqg",
    "youtubeId": "CXD-NmhCEqg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4057",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 32 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/JR49U8TJ-uI",
    "youtubeId": "JR49U8TJ-uI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4058",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 31 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/abgyrW8o-lU",
    "youtubeId": "abgyrW8o-lU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4059",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 30 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/aFQVuwe7u5U",
    "youtubeId": "aFQVuwe7u5U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4060",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 29 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y-qzE2oJbps",
    "youtubeId": "Y-qzE2oJbps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4061",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 28 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/RlBMmtca5mg",
    "youtubeId": "RlBMmtca5mg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4062",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 27 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/6Cxo3l__mrw",
    "youtubeId": "6Cxo3l__mrw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4063",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 26 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/wasmPG9fNuA",
    "youtubeId": "wasmPG9fNuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4064",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 25 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/WTc2E3TqU1w",
    "youtubeId": "WTc2E3TqU1w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4065",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 24 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/opV_Ltr9-JU",
    "youtubeId": "opV_Ltr9-JU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4066",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 23 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/1rYPfUmhym8",
    "youtubeId": "1rYPfUmhym8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4067",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 22 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/uVtbRrTH3GQ",
    "youtubeId": "uVtbRrTH3GQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4068",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 21 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/pRO9WXtdfTI",
    "youtubeId": "pRO9WXtdfTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4069",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 20 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/XICRGIYzQ3I",
    "youtubeId": "XICRGIYzQ3I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4070",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 19 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/cwN6VnS9yEM",
    "youtubeId": "cwN6VnS9yEM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4071",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 18 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/LNdu7cZsVjs",
    "youtubeId": "LNdu7cZsVjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4072",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 17 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/RHaEiWNwA50",
    "youtubeId": "RHaEiWNwA50",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4073",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 16 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/ksoeMsFRt4A",
    "youtubeId": "ksoeMsFRt4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4074",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 15 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/eBhTIP9Qios",
    "youtubeId": "eBhTIP9Qios",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4075",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 14 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/W_vqmNMqqow",
    "youtubeId": "W_vqmNMqqow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4076",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 13 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/RlacpoAt6zw",
    "youtubeId": "RlacpoAt6zw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4077",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 12 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/aYgelQUdzuE",
    "youtubeId": "aYgelQUdzuE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4078",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 11 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/U7h1AmLU0ro",
    "youtubeId": "U7h1AmLU0ro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4079",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 10 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMg-TcTryrM",
    "youtubeId": "cMg-TcTryrM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4080",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 9 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q9_916e8PYc",
    "youtubeId": "Q9_916e8PYc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4081",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 8 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/G2HfYIbuqI8",
    "youtubeId": "G2HfYIbuqI8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4082",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 7 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mhj3c76llyw",
    "youtubeId": "Mhj3c76llyw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4083",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 6 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/NxAwRENCQ1A",
    "youtubeId": "NxAwRENCQ1A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4084",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 5 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/lIoFfX8cuj8",
    "youtubeId": "lIoFfX8cuj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4085",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 4 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Gfsm9RXHoE",
    "youtubeId": "0Gfsm9RXHoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4086",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 3 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/gMFAPRuLI_U",
    "youtubeId": "gMFAPRuLI_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4087",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 2 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/wySaJC2gUR0",
    "youtubeId": "wySaJC2gUR0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4088",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 17 Ayat 1 Surah Bani Israel Dr Israr Ahmed URDU",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ss8PRsQvlN4",
    "youtubeId": "Ss8PRsQvlN4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4089",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 128 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-LsE8cvTIA",
    "youtubeId": "F-LsE8cvTIA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4090",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 127 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D5WmTXuoGbc",
    "youtubeId": "D5WmTXuoGbc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4091",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 126 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9fBTlcsm5T4",
    "youtubeId": "9fBTlcsm5T4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4092",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 125 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hDg5plHtcTw",
    "youtubeId": "hDg5plHtcTw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4093",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 124 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dfLHc_olyCw",
    "youtubeId": "dfLHc_olyCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4094",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 123 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xhgtYVQHAY0",
    "youtubeId": "xhgtYVQHAY0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4095",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 122 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K1xrf2n_EeQ",
    "youtubeId": "K1xrf2n_EeQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4096",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 121 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lsVIsmvDeE0",
    "youtubeId": "lsVIsmvDeE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4097",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 120 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QIr11I2G7Uw",
    "youtubeId": "QIr11I2G7Uw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4098",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 119 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cvdjV9vxk6U",
    "youtubeId": "cvdjV9vxk6U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4099",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 118 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s1kv6j22x6I",
    "youtubeId": "s1kv6j22x6I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 117 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7aCJnaSsFU0",
    "youtubeId": "7aCJnaSsFU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 116 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YBLDo5f1xzc",
    "youtubeId": "YBLDo5f1xzc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 115 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/idpWd93RyG4",
    "youtubeId": "idpWd93RyG4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 114 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P3txFbYYXSY",
    "youtubeId": "P3txFbYYXSY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 113 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4atSOfYaa3U",
    "youtubeId": "4atSOfYaa3U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 112 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a3J2-L6Q65A",
    "youtubeId": "a3J2-L6Q65A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 111 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CpP9754WZKk",
    "youtubeId": "CpP9754WZKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 110 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JF9ulelv13k",
    "youtubeId": "JF9ulelv13k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 109 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IvCG95lqiSI",
    "youtubeId": "IvCG95lqiSI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 108 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qXMLKOzicts",
    "youtubeId": "qXMLKOzicts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 107 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FGUvonCgOuw",
    "youtubeId": "FGUvonCgOuw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 106 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2AVMBVUpe2Y",
    "youtubeId": "2AVMBVUpe2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 105 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TufA-J-HXHM",
    "youtubeId": "TufA-J-HXHM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 104 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Et9QHHdvsZo",
    "youtubeId": "Et9QHHdvsZo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 103 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eKsIzAYhJ8U",
    "youtubeId": "eKsIzAYhJ8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 102 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vzUDzXpGRV8",
    "youtubeId": "vzUDzXpGRV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 101 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vp7H3duMFrA",
    "youtubeId": "vp7H3duMFrA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 100 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2gWcSTgeuEk",
    "youtubeId": "2gWcSTgeuEk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 99 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KanTL9SN_hE",
    "youtubeId": "KanTL9SN_hE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 98 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bu_HHX1iCuM",
    "youtubeId": "Bu_HHX1iCuM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 97 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y26tNvotYj4",
    "youtubeId": "y26tNvotYj4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 96 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NBS_3rhjNqA",
    "youtubeId": "NBS_3rhjNqA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4122",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 95 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/12yPDv97HLQ",
    "youtubeId": "12yPDv97HLQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4123",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 94 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nw4a5hafxtY",
    "youtubeId": "nw4a5hafxtY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4124",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 93 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jnA6IDD9GMs",
    "youtubeId": "jnA6IDD9GMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4125",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 92 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/58fHDrWUINc",
    "youtubeId": "58fHDrWUINc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4126",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 91 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2NGgSjxEwNY",
    "youtubeId": "2NGgSjxEwNY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4127",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 90 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fn5QDmVkLyc",
    "youtubeId": "fn5QDmVkLyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4128",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 89 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ux-MmhY64hI",
    "youtubeId": "ux-MmhY64hI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4129",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 88 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xdu9m-3mp00",
    "youtubeId": "Xdu9m-3mp00",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4130",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 87 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OW-Y2cyUo9k",
    "youtubeId": "OW-Y2cyUo9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4131",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 86 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9CkZ1KwWHE0",
    "youtubeId": "9CkZ1KwWHE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4132",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 85 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GbVx0Tf65dU",
    "youtubeId": "GbVx0Tf65dU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4133",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 84 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_PC0lL5pOxA",
    "youtubeId": "_PC0lL5pOxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4134",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 83 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i_Rq7lLT6t0",
    "youtubeId": "i_Rq7lLT6t0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4135",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 82 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RCfIUO35Oyc",
    "youtubeId": "RCfIUO35Oyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4136",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 81 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HZgrF0hf9pU",
    "youtubeId": "HZgrF0hf9pU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4137",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 80 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eH7OH3IG_-g",
    "youtubeId": "eH7OH3IG_-g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4138",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 79 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9rDRL89mCwM",
    "youtubeId": "9rDRL89mCwM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4139",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 78 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/znkxqiVT3js",
    "youtubeId": "znkxqiVT3js",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4140",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 77 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e_q5T_1QnRE",
    "youtubeId": "e_q5T_1QnRE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4141",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 76 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iRVaEpqFv60",
    "youtubeId": "iRVaEpqFv60",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4142",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 75 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KuL4lPc6akk",
    "youtubeId": "KuL4lPc6akk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4143",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 74 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/chVn7xGG33A",
    "youtubeId": "chVn7xGG33A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4144",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 73 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mo8aPPUIr6s",
    "youtubeId": "mo8aPPUIr6s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4145",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 72 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gFalRop6Msk",
    "youtubeId": "gFalRop6Msk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4146",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 71 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dtK0UteQSD8",
    "youtubeId": "dtK0UteQSD8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4147",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 70 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/toj6VI7rFUw",
    "youtubeId": "toj6VI7rFUw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4148",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 69 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D4JZR2Y81OQ",
    "youtubeId": "D4JZR2Y81OQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4149",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 68 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qhrbvar7ZDU",
    "youtubeId": "Qhrbvar7ZDU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4150",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 67 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RwZFpupDGxg",
    "youtubeId": "RwZFpupDGxg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4151",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 66 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5hhAfV5ygb4",
    "youtubeId": "5hhAfV5ygb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4152",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 65 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gXqKp8J8InM",
    "youtubeId": "gXqKp8J8InM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4153",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 64 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pGAbpzjcXQY",
    "youtubeId": "pGAbpzjcXQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4154",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 63 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9oYHSQrkiCo",
    "youtubeId": "9oYHSQrkiCo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4155",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 62 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DvUrHZgsHR4",
    "youtubeId": "DvUrHZgsHR4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4156",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 61 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yXB5-4Rc4ok",
    "youtubeId": "yXB5-4Rc4ok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4157",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 60 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hF3B1g6rPDE",
    "youtubeId": "hF3B1g6rPDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4158",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 59 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zaQTuTDCDtg",
    "youtubeId": "zaQTuTDCDtg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4159",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 58 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GI5z4sN2Om4",
    "youtubeId": "GI5z4sN2Om4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4160",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 57 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UrIoUJHtbic",
    "youtubeId": "UrIoUJHtbic",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4161",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 56 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JpMlDLwzYRc",
    "youtubeId": "JpMlDLwzYRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4162",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 55 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B-54hZYCYZA",
    "youtubeId": "B-54hZYCYZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4163",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 54 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_OECJIfVWO8",
    "youtubeId": "_OECJIfVWO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4164",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 53 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0ziUU9xeq_s",
    "youtubeId": "0ziUU9xeq_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4165",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 52 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V9ctjALlSnE",
    "youtubeId": "V9ctjALlSnE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4166",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 51 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qGdTeN0lIF4",
    "youtubeId": "qGdTeN0lIF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4167",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 50 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wzqs3lXqzqM",
    "youtubeId": "wzqs3lXqzqM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4168",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 49 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zdgjCVo0e1Q",
    "youtubeId": "zdgjCVo0e1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4169",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 48 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mYTKVrYWaZw",
    "youtubeId": "mYTKVrYWaZw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4170",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 47 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4cYzXdqXfhY",
    "youtubeId": "4cYzXdqXfhY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4171",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 46 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8pdGqINNx9o",
    "youtubeId": "8pdGqINNx9o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4172",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 45 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RNlLP3PdCv4",
    "youtubeId": "RNlLP3PdCv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4173",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 44 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BqeecEjg8mY",
    "youtubeId": "BqeecEjg8mY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4174",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 43 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HxvhxjkU6aQ",
    "youtubeId": "HxvhxjkU6aQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4175",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 42 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1DB5cOTGQLs",
    "youtubeId": "1DB5cOTGQLs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4176",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 41 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tj49KeoUKAA",
    "youtubeId": "tj49KeoUKAA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4177",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 40 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MH9N8xQ0qL8",
    "youtubeId": "MH9N8xQ0qL8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4178",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 39 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Qh20U-J1T4",
    "youtubeId": "0Qh20U-J1T4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4179",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 38 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/llWpbUtaP9I",
    "youtubeId": "llWpbUtaP9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4180",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 37 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K7eQWlG8jVg",
    "youtubeId": "K7eQWlG8jVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4181",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 36 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/__AfxUsDghg",
    "youtubeId": "__AfxUsDghg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4182",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 35 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/At_aXr59A78",
    "youtubeId": "At_aXr59A78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4183",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 34 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wIWMErJivcM",
    "youtubeId": "wIWMErJivcM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4184",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 33 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fw8TJeI5N2Y",
    "youtubeId": "fw8TJeI5N2Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4185",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 32 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vUFVd4d6zhU",
    "youtubeId": "vUFVd4d6zhU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4186",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 31 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bcH4AbyD71M",
    "youtubeId": "bcH4AbyD71M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4187",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 30 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Coh8XVI2vTM",
    "youtubeId": "Coh8XVI2vTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4188",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 29 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dhh_cJUXmRE",
    "youtubeId": "Dhh_cJUXmRE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4189",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 28 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-_rVJiIdb0I",
    "youtubeId": "-_rVJiIdb0I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4190",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 27 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MeRiMidBrBo",
    "youtubeId": "MeRiMidBrBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4191",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 26 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UnrJA7jk5YA",
    "youtubeId": "UnrJA7jk5YA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4192",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 25 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WW5NiZqcj7c",
    "youtubeId": "WW5NiZqcj7c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4193",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 24 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EenlWFLv_vw",
    "youtubeId": "EenlWFLv_vw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4194",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 23 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UCG38EC9MJs",
    "youtubeId": "UCG38EC9MJs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4195",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 22 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GlXeUCKGqVs",
    "youtubeId": "GlXeUCKGqVs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4196",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 21 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YSrHLf06Am4",
    "youtubeId": "YSrHLf06Am4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4197",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 20 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kEOBmSsYrqs",
    "youtubeId": "kEOBmSsYrqs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4198",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 19 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xN-lNTj1laU",
    "youtubeId": "xN-lNTj1laU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4199",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 18 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/taxFycMqqlM",
    "youtubeId": "taxFycMqqlM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4200",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 17 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ixhrH6ViFWo",
    "youtubeId": "ixhrH6ViFWo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4201",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 16 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DsWbCYu83cc",
    "youtubeId": "DsWbCYu83cc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4202",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 15 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZFWqjeqIiR8",
    "youtubeId": "ZFWqjeqIiR8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4203",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 14 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BNEWCoHNeao",
    "youtubeId": "BNEWCoHNeao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4204",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 13 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r7B8u6UT1Mw",
    "youtubeId": "r7B8u6UT1Mw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4205",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 12 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GvDix_Sr5TQ",
    "youtubeId": "GvDix_Sr5TQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4206",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 11 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zIaOcXvuDF0",
    "youtubeId": "zIaOcXvuDF0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4207",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 10 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KdHljRayAyc",
    "youtubeId": "KdHljRayAyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4208",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 9 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3LvwvAp2GEE",
    "youtubeId": "3LvwvAp2GEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4209",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 8 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ilHW9YYKPE0",
    "youtubeId": "ilHW9YYKPE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4210",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 7 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/04VliYj83WA",
    "youtubeId": "04VliYj83WA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4211",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 6 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v5zlsnefqpo",
    "youtubeId": "v5zlsnefqpo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4212",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 5 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y-w2v6yoicM",
    "youtubeId": "Y-w2v6yoicM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4213",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 4 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RBKY0XpcjoE",
    "youtubeId": "RBKY0XpcjoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4214",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 3 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F7ttX3OqieU",
    "youtubeId": "F7ttX3OqieU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4215",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 2 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GGMYKWR_1EA",
    "youtubeId": "GGMYKWR_1EA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4216",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 16 Ayat 1 Surah Nahl Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9MC2QM5x_es",
    "youtubeId": "9MC2QM5x_es",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4217",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 99 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zGHBzo4GSuc",
    "youtubeId": "zGHBzo4GSuc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4218",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 98 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nZ62_MgFyQc",
    "youtubeId": "nZ62_MgFyQc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4219",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 97 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_f_CUjB3USU",
    "youtubeId": "_f_CUjB3USU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4220",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 96 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LHz0gEtxSec",
    "youtubeId": "LHz0gEtxSec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4221",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 95 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b1AVQrUIPi0",
    "youtubeId": "b1AVQrUIPi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4222",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 94 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z95D9vqWNKk",
    "youtubeId": "Z95D9vqWNKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4223",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 93 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MEzSRrYzK98",
    "youtubeId": "MEzSRrYzK98",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4224",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 92 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cjIcHiTfRPs",
    "youtubeId": "cjIcHiTfRPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4225",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 91 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cWXNurCyCmE",
    "youtubeId": "cWXNurCyCmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4226",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 90 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PcwrSCYSWF4",
    "youtubeId": "PcwrSCYSWF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4227",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 89 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_y5uPlvnu7U",
    "youtubeId": "_y5uPlvnu7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4228",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 88 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zYNFEOecYqE",
    "youtubeId": "zYNFEOecYqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4229",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 87 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/stM1cnxhEcc",
    "youtubeId": "stM1cnxhEcc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4230",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 86 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cOY2SviH0yk",
    "youtubeId": "cOY2SviH0yk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4231",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 85 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QmtvqSwjiuQ",
    "youtubeId": "QmtvqSwjiuQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4232",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 84 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u0ryM01CsN0",
    "youtubeId": "u0ryM01CsN0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4233",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 83 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8JSBC74Z0cA",
    "youtubeId": "8JSBC74Z0cA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4234",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 82 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nDno3M-diiM",
    "youtubeId": "nDno3M-diiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4235",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 81 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r864dkdvnhI",
    "youtubeId": "r864dkdvnhI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4236",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 80 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VNk-I5z3kGg",
    "youtubeId": "VNk-I5z3kGg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4237",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 79 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1riha2wWia4",
    "youtubeId": "1riha2wWia4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4238",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 78 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/18AeCo2Is9k",
    "youtubeId": "18AeCo2Is9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4239",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 77 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hj0Kh-P2JBc",
    "youtubeId": "Hj0Kh-P2JBc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4240",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 76 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OMHc72bZlJg",
    "youtubeId": "OMHc72bZlJg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4241",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 75 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U56ahoR3hgI",
    "youtubeId": "U56ahoR3hgI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4242",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 74 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4BByx7YZEMw",
    "youtubeId": "4BByx7YZEMw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4243",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 73 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ql1W2sgOcUE",
    "youtubeId": "ql1W2sgOcUE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4244",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 73 Surah Hijr Dr Israr Ahmed Urdu 2",
    "type": "video",
    "url": "https://www.youtube.com/embed/EXMAFFDqxQs",
    "youtubeId": "EXMAFFDqxQs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4245",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 71 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dFRfY_1E7GA",
    "youtubeId": "dFRfY_1E7GA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4246",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 70 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sL9TIuTk8u4",
    "youtubeId": "sL9TIuTk8u4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4247",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 69 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1hVGtT2PDsQ",
    "youtubeId": "1hVGtT2PDsQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4248",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 68 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D3mwVi9Py18",
    "youtubeId": "D3mwVi9Py18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4249",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 67 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nA78OrH8vlA",
    "youtubeId": "nA78OrH8vlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4250",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 66 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ti69V5hKStY",
    "youtubeId": "Ti69V5hKStY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4251",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 65 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-R_0GOh0zoM",
    "youtubeId": "-R_0GOh0zoM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4252",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 64 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eitySWeegYU",
    "youtubeId": "eitySWeegYU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4253",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 63 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D8NSeYCAvKk",
    "youtubeId": "D8NSeYCAvKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4254",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 62 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kepCFX6dMFo",
    "youtubeId": "kepCFX6dMFo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4255",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 61 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wg-p2alG_wA",
    "youtubeId": "wg-p2alG_wA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4256",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 60 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eKiXkgPNWHg",
    "youtubeId": "eKiXkgPNWHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4257",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 59 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UB4QBAB05eU",
    "youtubeId": "UB4QBAB05eU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4258",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 58 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KGREuslFpsc",
    "youtubeId": "KGREuslFpsc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4259",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 57 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L2MLLqTQPsU",
    "youtubeId": "L2MLLqTQPsU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4260",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 56 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MXC1v9IrPxU",
    "youtubeId": "MXC1v9IrPxU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4261",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 55 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gFlNMwrR2sc",
    "youtubeId": "gFlNMwrR2sc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4262",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 54 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rzKdzJNwmno",
    "youtubeId": "rzKdzJNwmno",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4263",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 53 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IsJ0aPttDL8",
    "youtubeId": "IsJ0aPttDL8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4264",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 52 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9xaM5JnV6l8",
    "youtubeId": "9xaM5JnV6l8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4265",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 51 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8BKTgErJm88",
    "youtubeId": "8BKTgErJm88",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4266",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 50 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IXUGOE-M4Iw",
    "youtubeId": "IXUGOE-M4Iw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4267",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 49 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F7hwwMU94EQ",
    "youtubeId": "F7hwwMU94EQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4268",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 48 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZFy6VapLuU0",
    "youtubeId": "ZFy6VapLuU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4269",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 47 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KV-aIqs-3Hk",
    "youtubeId": "KV-aIqs-3Hk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4270",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 46 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JHlADz45mrc",
    "youtubeId": "JHlADz45mrc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4271",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 45 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-n5cCf5PJoM",
    "youtubeId": "-n5cCf5PJoM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4272",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 44 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JoCZaa79mcM",
    "youtubeId": "JoCZaa79mcM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4273",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 43 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nyYyJOH-7TM",
    "youtubeId": "nyYyJOH-7TM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4274",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 42 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cJSrDV2dSho",
    "youtubeId": "cJSrDV2dSho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4275",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 41 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AjYFeLtFcrM",
    "youtubeId": "AjYFeLtFcrM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4276",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 40 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N55PxcTCnD4",
    "youtubeId": "N55PxcTCnD4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4277",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 39 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OlA1sHNgLmQ",
    "youtubeId": "OlA1sHNgLmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4278",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 38 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/77XD485fn-o",
    "youtubeId": "77XD485fn-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4279",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 37 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SfbC7RpoWbQ",
    "youtubeId": "SfbC7RpoWbQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4280",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 36 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wf7RZhX0cCA",
    "youtubeId": "wf7RZhX0cCA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4281",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 35 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mihH0Zpca4w",
    "youtubeId": "mihH0Zpca4w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4282",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 34 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_qi1dY9fe1s",
    "youtubeId": "_qi1dY9fe1s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4283",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 33 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-i-FzadkQ0",
    "youtubeId": "F-i-FzadkQ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4284",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 32 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B4-9nMUSHk0",
    "youtubeId": "B4-9nMUSHk0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4285",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 31 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f8jZYJoEsLk",
    "youtubeId": "f8jZYJoEsLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4286",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 30 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-q3IrFWzaL8",
    "youtubeId": "-q3IrFWzaL8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4287",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 29 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p8AoqKhAXnA",
    "youtubeId": "p8AoqKhAXnA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4288",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 28 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4LAkN66sISk",
    "youtubeId": "4LAkN66sISk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4289",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 27 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lWYCn3lJUNw",
    "youtubeId": "lWYCn3lJUNw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4290",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 26 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jSR3ZvAc9bs",
    "youtubeId": "jSR3ZvAc9bs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4291",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 25 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cSqd3UGD0Ko",
    "youtubeId": "cSqd3UGD0Ko",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4292",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 24 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3EWwi28jQGo",
    "youtubeId": "3EWwi28jQGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4293",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 23 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3lQTT8k9Zvw",
    "youtubeId": "3lQTT8k9Zvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4294",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 22 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PrBaRMyvklY",
    "youtubeId": "PrBaRMyvklY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4295",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 21 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KhMHeXObSfk",
    "youtubeId": "KhMHeXObSfk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4296",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 20 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JiDWMpbOPw4",
    "youtubeId": "JiDWMpbOPw4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4297",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 19 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EmxGR4YLkYI",
    "youtubeId": "EmxGR4YLkYI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4298",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 18 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FtIfYuqLC0U",
    "youtubeId": "FtIfYuqLC0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4299",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 17 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oNdmX2s_Atk",
    "youtubeId": "oNdmX2s_Atk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4300",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 16 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3J35eHRx_DI",
    "youtubeId": "3J35eHRx_DI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4301",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 15 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t4kM7NGtIo4",
    "youtubeId": "t4kM7NGtIo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4302",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 14 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z-4fj2dl69A",
    "youtubeId": "Z-4fj2dl69A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4303",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 13 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wk_FX8skOlw",
    "youtubeId": "wk_FX8skOlw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4304",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 12 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BkBoDV44EgM",
    "youtubeId": "BkBoDV44EgM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4305",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 11 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hPmVe0sabjs",
    "youtubeId": "hPmVe0sabjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4306",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 10 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gXd7Rx25R38",
    "youtubeId": "gXd7Rx25R38",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4307",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 9 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mGO2ybNiKm8",
    "youtubeId": "mGO2ybNiKm8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4308",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 8 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aCBhQ4RvW7o",
    "youtubeId": "aCBhQ4RvW7o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4309",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 7 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4BBf6sI5pps",
    "youtubeId": "4BBf6sI5pps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4310",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 6 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q67IdNtPADQ",
    "youtubeId": "Q67IdNtPADQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4311",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 5 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1HR-iofMzvg",
    "youtubeId": "1HR-iofMzvg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4312",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 4 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hqQ10v1JvRk",
    "youtubeId": "hqQ10v1JvRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4313",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 3 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/caueZO0ImrQ",
    "youtubeId": "caueZO0ImrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4314",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 2 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MjH0g4y2Rnw",
    "youtubeId": "MjH0g4y2Rnw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4315",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 15 Ayat 1 Surah Hijr Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Joa3lr7pTg",
    "youtubeId": "5Joa3lr7pTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4316",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 52 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1VLzLIbsMmk",
    "youtubeId": "1VLzLIbsMmk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4317",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 51 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BpkD27mRAuc",
    "youtubeId": "BpkD27mRAuc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4318",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 50 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QBdTTqNjbf0",
    "youtubeId": "QBdTTqNjbf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4319",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 49 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XQXqDGJnAYg",
    "youtubeId": "XQXqDGJnAYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4320",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 48 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aFuM-d_zYNE",
    "youtubeId": "aFuM-d_zYNE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4321",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 47 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gSpOqS2NqOw",
    "youtubeId": "gSpOqS2NqOw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4322",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 46 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F1IuXo-u07Y",
    "youtubeId": "F1IuXo-u07Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4323",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 45 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/avcKp9Y8DIs",
    "youtubeId": "avcKp9Y8DIs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4324",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 44 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/En_MUthvawY",
    "youtubeId": "En_MUthvawY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4325",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 43 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TislhieTu0k",
    "youtubeId": "TislhieTu0k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4326",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 42 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LV6LvmKNWpA",
    "youtubeId": "LV6LvmKNWpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4327",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 41 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WhJU2bo9TrQ",
    "youtubeId": "WhJU2bo9TrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4328",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 40 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tncK2_bOXmQ",
    "youtubeId": "tncK2_bOXmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4329",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 39 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/418iOqDZVy4",
    "youtubeId": "418iOqDZVy4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4330",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 38 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m1MR51vDsOI",
    "youtubeId": "m1MR51vDsOI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4331",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 37 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AUNHSt6Xalc",
    "youtubeId": "AUNHSt6Xalc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4332",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 36 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DfL2gyTpRbw",
    "youtubeId": "DfL2gyTpRbw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4333",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 35 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rZDHrFC3vpM",
    "youtubeId": "rZDHrFC3vpM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4334",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 34 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rIqn-zuHzgc",
    "youtubeId": "rIqn-zuHzgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4335",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 33 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Rphh-xmtkiU",
    "youtubeId": "Rphh-xmtkiU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4336",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 32 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-WQsUkMJR_Q",
    "youtubeId": "-WQsUkMJR_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4337",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 31 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Go1hIHXzpxQ",
    "youtubeId": "Go1hIHXzpxQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4338",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 30 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_fd6rmFEjfg",
    "youtubeId": "_fd6rmFEjfg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4339",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 29 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qgXLNA1jEuQ",
    "youtubeId": "qgXLNA1jEuQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4340",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 28 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/efr1d_FzMFE",
    "youtubeId": "efr1d_FzMFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4341",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 27 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O6mzYa_E060",
    "youtubeId": "O6mzYa_E060",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4342",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 26 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OjMozFkoJ2c",
    "youtubeId": "OjMozFkoJ2c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4343",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 25 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/B_EhnfKDZDM",
    "youtubeId": "B_EhnfKDZDM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4344",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 24 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7KBloMIa9kM",
    "youtubeId": "7KBloMIa9kM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4345",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 23 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/91dPztuFjJ0",
    "youtubeId": "91dPztuFjJ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4346",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 22 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OvPNGQy7B3I",
    "youtubeId": "OvPNGQy7B3I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4347",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 21 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tzj_3FuwuIw",
    "youtubeId": "tzj_3FuwuIw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4348",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 20 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_KZ4YDLvK8Q",
    "youtubeId": "_KZ4YDLvK8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4349",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 19 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/081LmQW0Xak",
    "youtubeId": "081LmQW0Xak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4350",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 18 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RD7mt03_ehE",
    "youtubeId": "RD7mt03_ehE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4351",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 17 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DeNLFIPSzRw",
    "youtubeId": "DeNLFIPSzRw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4352",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 16 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AgCAJeV5gDE",
    "youtubeId": "AgCAJeV5gDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4353",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 15 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qhz-CzQv_ss",
    "youtubeId": "qhz-CzQv_ss",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4354",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 14 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P05NLZWsPs4",
    "youtubeId": "P05NLZWsPs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4355",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 13 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vrajm_dBiSM",
    "youtubeId": "vrajm_dBiSM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4356",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 12 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G0ckZAmeOAw",
    "youtubeId": "G0ckZAmeOAw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4357",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 11 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fneznw7Ccps",
    "youtubeId": "fneznw7Ccps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4358",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 10 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dLC8Ek_4AZU",
    "youtubeId": "dLC8Ek_4AZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4359",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 9 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/skjGmpd7XoE",
    "youtubeId": "skjGmpd7XoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4360",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 7 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lbQs0pAOCuQ",
    "youtubeId": "lbQs0pAOCuQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4361",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 8 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zkzQiGKMMZE",
    "youtubeId": "zkzQiGKMMZE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4362",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 7 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iSJCpurAKoQ",
    "youtubeId": "iSJCpurAKoQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4363",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 6 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qdK4GEtGdIE",
    "youtubeId": "qdK4GEtGdIE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4364",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 5 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8Av__b3LRo0",
    "youtubeId": "8Av__b3LRo0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4365",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 4 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0sMz2J85-GU",
    "youtubeId": "0sMz2J85-GU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4366",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 3 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cCLS1-uDQPs",
    "youtubeId": "cCLS1-uDQPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4367",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 2 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mTVNesFg4uI",
    "youtubeId": "mTVNesFg4uI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4368",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 14 Ayat 1 Surah Ibrahim Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-UTHOuAapOo",
    "youtubeId": "-UTHOuAapOo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4369",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 43 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C2bpVeSWNkU",
    "youtubeId": "C2bpVeSWNkU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4370",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 42 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q4YEZtV-HVo",
    "youtubeId": "Q4YEZtV-HVo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4371",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 41 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t88T8erXje8",
    "youtubeId": "t88T8erXje8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4372",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 40 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E6OI0II5B3Y",
    "youtubeId": "E6OI0II5B3Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4373",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 39 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ADVPfbt3bWk",
    "youtubeId": "ADVPfbt3bWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4374",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 38 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OawEsbOhjYE",
    "youtubeId": "OawEsbOhjYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4375",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 37 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GK9WgeUVGpA",
    "youtubeId": "GK9WgeUVGpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4376",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 36 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RTaNPAfYGR0",
    "youtubeId": "RTaNPAfYGR0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4377",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 35 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VBtrI-RSg30",
    "youtubeId": "VBtrI-RSg30",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4378",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 34 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NpEmxALQ50A",
    "youtubeId": "NpEmxALQ50A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4379",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 33 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UZLl_Bf1dyY",
    "youtubeId": "UZLl_Bf1dyY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4380",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 32 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/il7gjnmVExk",
    "youtubeId": "il7gjnmVExk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4381",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 31 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DTDGRYPGKgc",
    "youtubeId": "DTDGRYPGKgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4382",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 30 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cg2F7qi6doo",
    "youtubeId": "cg2F7qi6doo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4383",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 29 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3HWMvuynrcY",
    "youtubeId": "3HWMvuynrcY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4384",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 28 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gexJ2oAcUDs",
    "youtubeId": "gexJ2oAcUDs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4385",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 27 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/97YjunISs7A",
    "youtubeId": "97YjunISs7A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4386",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 26 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1-fMwSw6c0c",
    "youtubeId": "1-fMwSw6c0c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4387",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 25 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q5LcU2tBaes",
    "youtubeId": "q5LcU2tBaes",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4388",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 24 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yvuqOtIn850",
    "youtubeId": "yvuqOtIn850",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4389",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 23 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xwNg0FT6T0U",
    "youtubeId": "xwNg0FT6T0U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4390",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 22 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2YPIsWuIy4Y",
    "youtubeId": "2YPIsWuIy4Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4391",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 21 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A9wJC27V_1k",
    "youtubeId": "A9wJC27V_1k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4392",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 20 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N3tCVgDspZU",
    "youtubeId": "N3tCVgDspZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4393",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 19 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L4rj9RF2w-k",
    "youtubeId": "L4rj9RF2w-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4394",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 18 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MZeW7yc6-vU",
    "youtubeId": "MZeW7yc6-vU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4395",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 17 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iWJIfSHuEMs",
    "youtubeId": "iWJIfSHuEMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4396",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 16 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7sqF3YjiG5U",
    "youtubeId": "7sqF3YjiG5U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4397",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 15 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KpjYLtj061g",
    "youtubeId": "KpjYLtj061g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4398",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 14 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H1gtoMKM3ls",
    "youtubeId": "H1gtoMKM3ls",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4399",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 13 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TtJeVmVc9Pc",
    "youtubeId": "TtJeVmVc9Pc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4400",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 12 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HTxm97IN-gI",
    "youtubeId": "HTxm97IN-gI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4401",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 11 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JQx4stWpFKY",
    "youtubeId": "JQx4stWpFKY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4402",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 10 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qbxGu-BdkoI",
    "youtubeId": "qbxGu-BdkoI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4403",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 9 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jUlZ8Lr9lfc",
    "youtubeId": "jUlZ8Lr9lfc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4404",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 8 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hUxr_LlzXx8",
    "youtubeId": "hUxr_LlzXx8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4405",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 7 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9qZeukMAXGM",
    "youtubeId": "9qZeukMAXGM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4406",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 6 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EJtOWZVHEUk",
    "youtubeId": "EJtOWZVHEUk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4407",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 5 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4jp0i6dMFvw",
    "youtubeId": "4jp0i6dMFvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4408",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 4 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uICBwoRzsso",
    "youtubeId": "uICBwoRzsso",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4409",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 3 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/leq_Oc4xqGI",
    "youtubeId": "leq_Oc4xqGI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4410",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 2 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uuwmzd1Stv4",
    "youtubeId": "uuwmzd1Stv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4411",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 13 Ayat 1 Surah Rad Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xXS8X1xyrRc",
    "youtubeId": "xXS8X1xyrRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4412",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 111 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sZK-GyIdqCY",
    "youtubeId": "sZK-GyIdqCY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4413",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 110 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BgFiEXGDYWc",
    "youtubeId": "BgFiEXGDYWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4414",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 109 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iVRVOtZVaDk",
    "youtubeId": "iVRVOtZVaDk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4415",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 108 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7UBgUcm8mTM",
    "youtubeId": "7UBgUcm8mTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4416",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 107 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EpUn85XJ1Sc",
    "youtubeId": "EpUn85XJ1Sc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4417",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 106 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z016wLz137Y",
    "youtubeId": "Z016wLz137Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4418",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 105 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o3cKSYVfg4U",
    "youtubeId": "o3cKSYVfg4U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4419",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 104 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jBpZfF1YhGc",
    "youtubeId": "jBpZfF1YhGc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4420",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 103 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b-uHDYUH3Xo",
    "youtubeId": "b-uHDYUH3Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4421",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 102 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SiZ9M5H9uVM",
    "youtubeId": "SiZ9M5H9uVM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4422",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 101 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/megkuj28EiI",
    "youtubeId": "megkuj28EiI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4423",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 100 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g5oKifXCshw",
    "youtubeId": "g5oKifXCshw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4424",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 99 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Yv9ytYHg54",
    "youtubeId": "0Yv9ytYHg54",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4425",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 98 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LAyJvTQ2nKc",
    "youtubeId": "LAyJvTQ2nKc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4426",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 97 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E8q3EH0YKGs",
    "youtubeId": "E8q3EH0YKGs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4427",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 96 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R6S05_h3BII",
    "youtubeId": "R6S05_h3BII",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4428",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 95 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KBWYwSSSSJI",
    "youtubeId": "KBWYwSSSSJI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4429",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 94 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q-udPyw7axY",
    "youtubeId": "q-udPyw7axY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4430",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 93 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RbcDfggqEts",
    "youtubeId": "RbcDfggqEts",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4431",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 92 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0TrGfjibu2E",
    "youtubeId": "0TrGfjibu2E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4432",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 91 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e6hEJ4kcvjc",
    "youtubeId": "e6hEJ4kcvjc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4433",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 90 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vAEgAPiejQ4",
    "youtubeId": "vAEgAPiejQ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4434",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 89 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hYuTUMJ5kjY",
    "youtubeId": "hYuTUMJ5kjY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4435",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 88 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E2KaJiqo4L8",
    "youtubeId": "E2KaJiqo4L8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4436",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 87 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CN-9xwXq1WM",
    "youtubeId": "CN-9xwXq1WM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4437",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 86 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i9HTwVU2Z_0",
    "youtubeId": "i9HTwVU2Z_0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4438",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 85 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6s_dvUs9t68",
    "youtubeId": "6s_dvUs9t68",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4439",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 84 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0WU0oIjVOv8",
    "youtubeId": "0WU0oIjVOv8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4440",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 83 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zgs7x9moScc",
    "youtubeId": "zgs7x9moScc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4441",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 82 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ubQu0FbyWLw",
    "youtubeId": "ubQu0FbyWLw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4442",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 81 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xfhidAHgKCU",
    "youtubeId": "xfhidAHgKCU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4443",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 80 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2YWrww2bcNc",
    "youtubeId": "2YWrww2bcNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4444",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 79 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iDti4Hh8yHM",
    "youtubeId": "iDti4Hh8yHM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4445",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 78 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TA7UWbf_U6o",
    "youtubeId": "TA7UWbf_U6o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4446",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 77 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QDdOn9gQPxI",
    "youtubeId": "QDdOn9gQPxI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4447",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 76 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dg-BoLD9Ezk",
    "youtubeId": "dg-BoLD9Ezk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4448",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 75 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/On4YIl_Wyhc",
    "youtubeId": "On4YIl_Wyhc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4449",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 74 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UA7Gi3euQXY",
    "youtubeId": "UA7Gi3euQXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4450",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 73 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-kAn22hmGyc",
    "youtubeId": "-kAn22hmGyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4451",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 72 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6_M4wwBP9kk",
    "youtubeId": "6_M4wwBP9kk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4452",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 71 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h_1UzgIlTy8",
    "youtubeId": "h_1UzgIlTy8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4453",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 70 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X2VxsSpdi8E",
    "youtubeId": "X2VxsSpdi8E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4454",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 69 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dcQZ0fPKhsI",
    "youtubeId": "dcQZ0fPKhsI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4455",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 68 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/55czJzudXGo",
    "youtubeId": "55czJzudXGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4456",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 67 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AqSkPBgc66w",
    "youtubeId": "AqSkPBgc66w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4457",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 66 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u-EIAqaJf1Q",
    "youtubeId": "u-EIAqaJf1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4458",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 65 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DLTZy7yqpso",
    "youtubeId": "DLTZy7yqpso",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4459",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 64 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CiqtnD70xWg",
    "youtubeId": "CiqtnD70xWg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4460",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 63 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QT35Jz5Jtcs",
    "youtubeId": "QT35Jz5Jtcs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4461",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 62 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eeo90a_WvMY",
    "youtubeId": "eeo90a_WvMY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4462",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 61 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SAVF9-JJ9Jg",
    "youtubeId": "SAVF9-JJ9Jg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4463",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 60 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UoQ30Rmql0k",
    "youtubeId": "UoQ30Rmql0k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4464",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 59 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uoM3mOgFiCw",
    "youtubeId": "uoM3mOgFiCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4465",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 58 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1e6OynM10NA",
    "youtubeId": "1e6OynM10NA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4466",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 57 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BjTHALPIvE0",
    "youtubeId": "BjTHALPIvE0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4467",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 56 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Sg9kMbplXA",
    "youtubeId": "0Sg9kMbplXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4468",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 55 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YpGTq1bFOFU",
    "youtubeId": "YpGTq1bFOFU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4469",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 54 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9iIxs4mqv00",
    "youtubeId": "9iIxs4mqv00",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4470",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 53 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZvbA5Ey2HPo",
    "youtubeId": "ZvbA5Ey2HPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4471",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 52 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aBEnRpQfZR0",
    "youtubeId": "aBEnRpQfZR0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4472",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 51 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/876TdCtfkP8",
    "youtubeId": "876TdCtfkP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4473",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 50 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lwyHlaWRMRU",
    "youtubeId": "lwyHlaWRMRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4474",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 49 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-I_Xi67BlxQ",
    "youtubeId": "-I_Xi67BlxQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4475",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 48 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9PFDI_Xjjv4",
    "youtubeId": "9PFDI_Xjjv4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4476",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 47 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LBJJliYrZzo",
    "youtubeId": "LBJJliYrZzo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4477",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 46 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pg2AtnI3W9k",
    "youtubeId": "pg2AtnI3W9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4478",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 45 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FEJLx9td1oo",
    "youtubeId": "FEJLx9td1oo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4479",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 44 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LhTYLHKn2Qo",
    "youtubeId": "LhTYLHKn2Qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4480",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 43 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/guPHc8AqCHI",
    "youtubeId": "guPHc8AqCHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4481",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 42 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l-RIIC_sGdM",
    "youtubeId": "l-RIIC_sGdM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4482",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 41 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jqUzrbftUEE",
    "youtubeId": "jqUzrbftUEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4483",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 40 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ErEwwtqd07o",
    "youtubeId": "ErEwwtqd07o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4484",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 39 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TRI8IeggUdE",
    "youtubeId": "TRI8IeggUdE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4485",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 38 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fARMgwsx2LI",
    "youtubeId": "fARMgwsx2LI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4486",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 37 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qg9Uyf-0JEM",
    "youtubeId": "Qg9Uyf-0JEM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4487",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 36 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gtvleDaO6Gc",
    "youtubeId": "gtvleDaO6Gc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4488",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 35 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z41hKTlOwUI",
    "youtubeId": "Z41hKTlOwUI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4489",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 34 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7UV68jY00s0",
    "youtubeId": "7UV68jY00s0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4490",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 33 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HvEvDc4_-xA",
    "youtubeId": "HvEvDc4_-xA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4491",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 32 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xZVlsHBjEOs",
    "youtubeId": "xZVlsHBjEOs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4492",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 31 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bx7AG32w49s",
    "youtubeId": "bx7AG32w49s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4493",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 30 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cdWNJlTfQxw",
    "youtubeId": "cdWNJlTfQxw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4494",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 29 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oNm1WBVz8M8",
    "youtubeId": "oNm1WBVz8M8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4495",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 28 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T-DGwfdA9qA",
    "youtubeId": "T-DGwfdA9qA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4496",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 27 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2mUiPwNxquk",
    "youtubeId": "2mUiPwNxquk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4497",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 26 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yNVFXXRSHzg",
    "youtubeId": "yNVFXXRSHzg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4498",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 25 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bF-voGCXf_Y",
    "youtubeId": "bF-voGCXf_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4499",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 24 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tXUEklkAESQ",
    "youtubeId": "tXUEklkAESQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4500",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 23 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LVVYhJ5CsRs",
    "youtubeId": "LVVYhJ5CsRs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4501",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 22 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yrdyb92iMgI",
    "youtubeId": "Yrdyb92iMgI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4502",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 21 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JllfvIYNrXs",
    "youtubeId": "JllfvIYNrXs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4503",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 20 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dwije2vcw80",
    "youtubeId": "dwije2vcw80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4504",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 19 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7ZwObDGmZaQ",
    "youtubeId": "7ZwObDGmZaQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4505",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 18 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3d_IzMMWQdg",
    "youtubeId": "3d_IzMMWQdg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4506",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 17 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f2uLV91cyoA",
    "youtubeId": "f2uLV91cyoA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4507",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 16 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Chpeh-mM4dA",
    "youtubeId": "Chpeh-mM4dA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4508",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 15 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rq8O84Gps-Y",
    "youtubeId": "rq8O84Gps-Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4509",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 14 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AXgQXalC61U",
    "youtubeId": "AXgQXalC61U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4510",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 13 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0gtW9TbTrHw",
    "youtubeId": "0gtW9TbTrHw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4511",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 12 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0KzOc-bMC78",
    "youtubeId": "0KzOc-bMC78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4512",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 11 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XC65VGt1Hx8",
    "youtubeId": "XC65VGt1Hx8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4513",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 10 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ikv5GTxdpao",
    "youtubeId": "ikv5GTxdpao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4514",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 9 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6yiCIKdP588",
    "youtubeId": "6yiCIKdP588",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4515",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 8 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8_0EjfYycEE",
    "youtubeId": "8_0EjfYycEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4516",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 7 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lu68xLQu2to",
    "youtubeId": "Lu68xLQu2to",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4517",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 6 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SIH5oXHUL5k",
    "youtubeId": "SIH5oXHUL5k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4518",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 5 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rBEbPo_I61o",
    "youtubeId": "rBEbPo_I61o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4519",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 4 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gkWKwpdPANI",
    "youtubeId": "gkWKwpdPANI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4520",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 3 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sR3GKni0znc",
    "youtubeId": "sR3GKni0znc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4521",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 2 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zqcmR56ZSXE",
    "youtubeId": "zqcmR56ZSXE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4522",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 12 Ayat 1 Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ztUnyhM4SFs",
    "youtubeId": "ztUnyhM4SFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4523",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction Surah Yusuf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XsiJx5dx18A",
    "youtubeId": "XsiJx5dx18A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4524",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 123 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VqT0ONId6cU",
    "youtubeId": "VqT0ONId6cU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4525",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 122 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6HirHq0e1ms",
    "youtubeId": "6HirHq0e1ms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4526",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 121 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uFuoOy93lxo",
    "youtubeId": "uFuoOy93lxo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4527",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 120 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/URYiiYe4xdY",
    "youtubeId": "URYiiYe4xdY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4528",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 119 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V6VonhCZ3rs",
    "youtubeId": "V6VonhCZ3rs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4529",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 118 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m9kZlFPcirA",
    "youtubeId": "m9kZlFPcirA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4530",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 117 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vI1EIt2hFfs",
    "youtubeId": "vI1EIt2hFfs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4531",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 116 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WG4A-AM_RLI",
    "youtubeId": "WG4A-AM_RLI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4532",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 115 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bJncsG1tmZ8",
    "youtubeId": "bJncsG1tmZ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4533",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 114 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eJpnBynwuEE",
    "youtubeId": "eJpnBynwuEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4534",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 113 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j8ELytZ0DTM",
    "youtubeId": "j8ELytZ0DTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4535",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 112 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zXrwaQp67hc",
    "youtubeId": "zXrwaQp67hc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4536",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 111 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ufrGFyA9ou4",
    "youtubeId": "ufrGFyA9ou4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4537",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 110 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dQByZxawREE",
    "youtubeId": "dQByZxawREE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4538",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 109 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YockMrIhxa4",
    "youtubeId": "YockMrIhxa4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4539",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 108 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WFEk7TNLJ4Q",
    "youtubeId": "WFEk7TNLJ4Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4540",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 107 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GIPdsFpR_FA",
    "youtubeId": "GIPdsFpR_FA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4541",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 106 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ss4Pb1dyLRQ",
    "youtubeId": "ss4Pb1dyLRQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4542",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 105 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i0-PIBt3eV0",
    "youtubeId": "i0-PIBt3eV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4543",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 104 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Hlatk7SEYg",
    "youtubeId": "9Hlatk7SEYg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4544",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 103 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iwvxpDgCKaI",
    "youtubeId": "iwvxpDgCKaI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4545",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 102 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xtey_YyH6MA",
    "youtubeId": "xtey_YyH6MA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4546",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 101 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_uWDFHiyygQ",
    "youtubeId": "_uWDFHiyygQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4547",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 100 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sf7QhoUxyQk",
    "youtubeId": "Sf7QhoUxyQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4548",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 99 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZYd93UYPTx4",
    "youtubeId": "ZYd93UYPTx4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4549",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 98 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wcOlfqqOWX8",
    "youtubeId": "wcOlfqqOWX8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4550",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 97 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gePVFo9IgZs",
    "youtubeId": "gePVFo9IgZs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4551",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 96 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aDHFGC1lDcw",
    "youtubeId": "aDHFGC1lDcw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4552",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 95 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jyZLMxaTSS8",
    "youtubeId": "jyZLMxaTSS8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4553",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 94 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gjwoZ-nD0Lk",
    "youtubeId": "gjwoZ-nD0Lk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4554",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 93 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UOioRsUWU_w",
    "youtubeId": "UOioRsUWU_w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4555",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 92 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9pWvGqOWKWc",
    "youtubeId": "9pWvGqOWKWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4556",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 91 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aMrmWGXpcKA",
    "youtubeId": "aMrmWGXpcKA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4557",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 90 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rMOOqKHU1nE",
    "youtubeId": "rMOOqKHU1nE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4558",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 89 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Xl_9UpAgwQ",
    "youtubeId": "-Xl_9UpAgwQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4559",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 88 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M0this38Oh8",
    "youtubeId": "M0this38Oh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4560",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 87 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JtA1y7jKKdQ",
    "youtubeId": "JtA1y7jKKdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4561",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 86 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NRdqoZ4YSlc",
    "youtubeId": "NRdqoZ4YSlc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4562",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 85 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MxQCr8-6Ing",
    "youtubeId": "MxQCr8-6Ing",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4563",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 84 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LkI8UyUA-tg",
    "youtubeId": "LkI8UyUA-tg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4564",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 84 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/97m5XL693e8",
    "youtubeId": "97m5XL693e8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4565",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 83 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3HKH4LHXS-s",
    "youtubeId": "3HKH4LHXS-s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4566",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 82 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K0QRo2U-Jqo",
    "youtubeId": "K0QRo2U-Jqo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4567",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 81 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZbfdpQSnNJo",
    "youtubeId": "ZbfdpQSnNJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4568",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 80 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p9gClxlxhvk",
    "youtubeId": "p9gClxlxhvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4569",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 79 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E4D-iWCVfIM",
    "youtubeId": "E4D-iWCVfIM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4570",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 78 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ukQ7DY_DRTk",
    "youtubeId": "ukQ7DY_DRTk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4571",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 77 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rNHAqMRgpCE",
    "youtubeId": "rNHAqMRgpCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4572",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 76 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cIAxEOZ9Q4o",
    "youtubeId": "cIAxEOZ9Q4o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4573",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 75 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XJo0TpEqNWY",
    "youtubeId": "XJo0TpEqNWY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4574",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 74 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TP3xchP6VTc",
    "youtubeId": "TP3xchP6VTc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4575",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 73 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4f4V1LN7fb4",
    "youtubeId": "4f4V1LN7fb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4576",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 72 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-lNDqU6t4_I",
    "youtubeId": "-lNDqU6t4_I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4577",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 71 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oi75YFXJdck",
    "youtubeId": "oi75YFXJdck",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4578",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 70 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iAYcK8-iAY8",
    "youtubeId": "iAYcK8-iAY8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4579",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 69 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-wH25nhH1g",
    "youtubeId": "F-wH25nhH1g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4580",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 68 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JmhR73QpQ8g",
    "youtubeId": "JmhR73QpQ8g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4581",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 67 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DxdAOwKUGw8",
    "youtubeId": "DxdAOwKUGw8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4582",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 66 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C42Xg3lhSbY",
    "youtubeId": "C42Xg3lhSbY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4583",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 65 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xi3e0beoIQk",
    "youtubeId": "xi3e0beoIQk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4584",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 64 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/66lwQhYejg0",
    "youtubeId": "66lwQhYejg0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4585",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 63 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ph8QK-20cQQ",
    "youtubeId": "ph8QK-20cQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4586",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 62 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iN9SnkBhLiQ",
    "youtubeId": "iN9SnkBhLiQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4587",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 61 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AtuTGqEbe2s",
    "youtubeId": "AtuTGqEbe2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4588",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 60 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c72_fgD_hf0",
    "youtubeId": "c72_fgD_hf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4589",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 59 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HsZL1atre8M",
    "youtubeId": "HsZL1atre8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4590",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 58 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2AzUABE0kXc",
    "youtubeId": "2AzUABE0kXc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4591",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 57 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KaYBg6FGRVk",
    "youtubeId": "KaYBg6FGRVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4592",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 56 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nC50vtRkcWI",
    "youtubeId": "nC50vtRkcWI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4593",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 55 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-lquN6kKat0",
    "youtubeId": "-lquN6kKat0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4594",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 54 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rR3954B9Jqg",
    "youtubeId": "rR3954B9Jqg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4595",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 53 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VTQd9_EUNRc",
    "youtubeId": "VTQd9_EUNRc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4596",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 52 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_8FJETmCTo4",
    "youtubeId": "_8FJETmCTo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4597",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 51 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NuDut-lb_JM",
    "youtubeId": "NuDut-lb_JM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4598",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 50 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vttyWU6ECH8",
    "youtubeId": "vttyWU6ECH8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4599",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 49 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cXIphjsn8PE",
    "youtubeId": "cXIphjsn8PE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4600",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 48 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J9TG_bovN0E",
    "youtubeId": "J9TG_bovN0E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4601",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 47 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oZmMPW1uJgA",
    "youtubeId": "oZmMPW1uJgA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4602",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 46 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ECxyitkjDBM",
    "youtubeId": "ECxyitkjDBM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4603",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 45 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/85crTWUNY-A",
    "youtubeId": "85crTWUNY-A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4604",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 44 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kIyuphiPUkE",
    "youtubeId": "kIyuphiPUkE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4605",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 43 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QS2SKRGUaLU",
    "youtubeId": "QS2SKRGUaLU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4606",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 42 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iK6YBDaPmVc",
    "youtubeId": "iK6YBDaPmVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4607",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 41 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RUke-2dw6hk",
    "youtubeId": "RUke-2dw6hk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4608",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 40 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mY77NsZInyI",
    "youtubeId": "mY77NsZInyI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4609",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 39 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uo65qKorIJY",
    "youtubeId": "Uo65qKorIJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4610",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 38 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LF3oY4s4MYM",
    "youtubeId": "LF3oY4s4MYM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4611",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 37 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2PXcbkefnQc",
    "youtubeId": "2PXcbkefnQc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4612",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 36 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qpX5wmw9Vc4",
    "youtubeId": "qpX5wmw9Vc4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4613",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 35 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZOcqvPtTTCk",
    "youtubeId": "ZOcqvPtTTCk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4614",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 34 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aiNF8Bd-ROA",
    "youtubeId": "aiNF8Bd-ROA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4615",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 33 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cYbJqXYm6cs",
    "youtubeId": "cYbJqXYm6cs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4616",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 32 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1LndivS1scY",
    "youtubeId": "1LndivS1scY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4617",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 31 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u2wEUhASG68",
    "youtubeId": "u2wEUhASG68",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4618",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 30 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W7hZQwojgdQ",
    "youtubeId": "W7hZQwojgdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4619",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 29 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YMJ1pNqqK2Q",
    "youtubeId": "YMJ1pNqqK2Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4620",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 28 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NqEQy6_ML70",
    "youtubeId": "NqEQy6_ML70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4621",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 27 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EZvXd3qAa8E",
    "youtubeId": "EZvXd3qAa8E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4622",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 26 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SWLQJdWD1g4",
    "youtubeId": "SWLQJdWD1g4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4623",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 25 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HSEm3QB_zCw",
    "youtubeId": "HSEm3QB_zCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4624",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 24 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HbgfThSaxfQ",
    "youtubeId": "HbgfThSaxfQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4625",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 23 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/smmwVZ6mlIk",
    "youtubeId": "smmwVZ6mlIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4626",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 22 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tPgXiGcccSE",
    "youtubeId": "tPgXiGcccSE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4627",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 21 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/25xpOrZVcgc",
    "youtubeId": "25xpOrZVcgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4628",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 20 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/97uDvPM7Nms",
    "youtubeId": "97uDvPM7Nms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4629",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 19 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iUBZuHoDIZA",
    "youtubeId": "iUBZuHoDIZA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4630",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 18 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YUKhyRdpfDo",
    "youtubeId": "YUKhyRdpfDo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4631",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 17 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/He3Zg_C1qpc",
    "youtubeId": "He3Zg_C1qpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4632",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 16 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wMyeYgzbX10",
    "youtubeId": "wMyeYgzbX10",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4633",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 15 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Xq_1io_RQv8",
    "youtubeId": "Xq_1io_RQv8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4634",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 14 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A7uyNbtgy6w",
    "youtubeId": "A7uyNbtgy6w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4635",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 13 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UjcZB1aAvFg",
    "youtubeId": "UjcZB1aAvFg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4636",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 12 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ljh3i1UwLCE",
    "youtubeId": "Ljh3i1UwLCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4637",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 11 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ImwdQS5TQPU",
    "youtubeId": "ImwdQS5TQPU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4638",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 10 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o0BYJO4PK9g",
    "youtubeId": "o0BYJO4PK9g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4639",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 9 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JWe_WQQzeh8",
    "youtubeId": "JWe_WQQzeh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4640",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 8 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4E-uXY80XTI",
    "youtubeId": "4E-uXY80XTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4641",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 7 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EESFdGBE0VQ",
    "youtubeId": "EESFdGBE0VQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4642",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 6 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jFqpFDZyi5M",
    "youtubeId": "jFqpFDZyi5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4643",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 5 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vBQZVrgM3ss",
    "youtubeId": "vBQZVrgM3ss",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4644",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 4 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mFZEBWG3_9o",
    "youtubeId": "mFZEBWG3_9o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4645",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 3 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HKWgY8UGgMk",
    "youtubeId": "HKWgY8UGgMk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4646",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 2 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gfhOrf86gPM",
    "youtubeId": "gfhOrf86gPM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4647",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 11 Ayat 1 Surah Hud Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6qohBsahBaA",
    "youtubeId": "6qohBsahBaA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4648",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 109 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RUAtFhJX5hs",
    "youtubeId": "RUAtFhJX5hs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4649",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 108 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1CTOPysiKF4",
    "youtubeId": "1CTOPysiKF4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4650",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 107 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i8RZgZdh1i4",
    "youtubeId": "i8RZgZdh1i4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4651",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 106 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S-gZXooFE6k",
    "youtubeId": "S-gZXooFE6k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4652",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 105 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3tGt2pW2RXY",
    "youtubeId": "3tGt2pW2RXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4653",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 104 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OmofTWF3Kuc",
    "youtubeId": "OmofTWF3Kuc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4654",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 103 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G7pDeCRH3BQ",
    "youtubeId": "G7pDeCRH3BQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4655",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 102 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xdGXBVJyhBo",
    "youtubeId": "xdGXBVJyhBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4656",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 101 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YXoi7FggIDE",
    "youtubeId": "YXoi7FggIDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4657",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 100 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C0-5-oLP9TA",
    "youtubeId": "C0-5-oLP9TA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4658",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 99 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sv92I2U2P-A",
    "youtubeId": "Sv92I2U2P-A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4659",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 98 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yiMbnOV9nTo",
    "youtubeId": "yiMbnOV9nTo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4660",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 97 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/85ojri3TgJ8",
    "youtubeId": "85ojri3TgJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4661",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 96 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yRLWYXNratQ",
    "youtubeId": "yRLWYXNratQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4662",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 95 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sl7uBW6nEnk",
    "youtubeId": "sl7uBW6nEnk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4663",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 94 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w8Y42Tl90oM",
    "youtubeId": "w8Y42Tl90oM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4664",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 93 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9ndjjMPXwQw",
    "youtubeId": "9ndjjMPXwQw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4665",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 92 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iZCRPUd-3mM",
    "youtubeId": "iZCRPUd-3mM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4666",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 91 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2t4HThNqs9A",
    "youtubeId": "2t4HThNqs9A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4667",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 90 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tLExozj7uz8",
    "youtubeId": "tLExozj7uz8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4668",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 89 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8p1-fk7if20",
    "youtubeId": "8p1-fk7if20",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4669",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 88 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ka0d4Vrkwds",
    "youtubeId": "Ka0d4Vrkwds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4670",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 87 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LvgmPe8XVRU",
    "youtubeId": "LvgmPe8XVRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4671",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 86 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ST8L0BQWsJM",
    "youtubeId": "ST8L0BQWsJM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4672",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 85 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9f8421eBWrI",
    "youtubeId": "9f8421eBWrI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4673",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 84 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6LWidDsmwpc",
    "youtubeId": "6LWidDsmwpc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4674",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 83 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ga0dV_7jSSw",
    "youtubeId": "Ga0dV_7jSSw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4675",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 82 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RYnwK054i88",
    "youtubeId": "RYnwK054i88",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4676",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 81 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gth1qVB3FBA",
    "youtubeId": "Gth1qVB3FBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4677",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 80 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FieGrgfSv9k",
    "youtubeId": "FieGrgfSv9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4678",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 79 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X_aaH4dPu9U",
    "youtubeId": "X_aaH4dPu9U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4679",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 78 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T_FMDzpRhwg",
    "youtubeId": "T_FMDzpRhwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4680",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 77 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u-txv1b4d1w",
    "youtubeId": "u-txv1b4d1w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4681",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 76 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ze4wo8RQePQ",
    "youtubeId": "ze4wo8RQePQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4682",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 75 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZD0u1Ko08ro",
    "youtubeId": "ZD0u1Ko08ro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4683",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 74 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/85z2On3EonQ",
    "youtubeId": "85z2On3EonQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4684",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 73 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e9i6wVhtftc",
    "youtubeId": "e9i6wVhtftc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4685",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 72 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6DA705hdLxk",
    "youtubeId": "6DA705hdLxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4686",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 71 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dTXC5qGdjEA",
    "youtubeId": "dTXC5qGdjEA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4687",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 70 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/inlnmAOnAPc",
    "youtubeId": "inlnmAOnAPc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4688",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 69 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3wGVu1BfPyM",
    "youtubeId": "3wGVu1BfPyM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4689",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 68 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wPMUmOs8Lrw",
    "youtubeId": "wPMUmOs8Lrw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4690",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 67 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9tLvtF49iiM",
    "youtubeId": "9tLvtF49iiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4691",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 66 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G5Yz7QUUMT0",
    "youtubeId": "G5Yz7QUUMT0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4692",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 65 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m9Ok3QGHUhg",
    "youtubeId": "m9Ok3QGHUhg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4693",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 64 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T1658kxfHmw",
    "youtubeId": "T1658kxfHmw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4694",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 63 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kKu2gCgkij0",
    "youtubeId": "kKu2gCgkij0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4695",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 62 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e2FZObz69a8",
    "youtubeId": "e2FZObz69a8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4696",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 61 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lSE2xjqAbCM",
    "youtubeId": "lSE2xjqAbCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4697",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 60 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PKFmjAP66hU",
    "youtubeId": "PKFmjAP66hU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4698",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 59 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WrpXDy5HoBo",
    "youtubeId": "WrpXDy5HoBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4699",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 58 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s3G8pYR1rwY",
    "youtubeId": "s3G8pYR1rwY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4700",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 57 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Z2abDrSOak",
    "youtubeId": "_Z2abDrSOak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4701",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 56 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BV2NGxlkjoc",
    "youtubeId": "BV2NGxlkjoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4702",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 55 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N9omuWVGMxI",
    "youtubeId": "N9omuWVGMxI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4703",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 54 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZuxWPmFjC_I",
    "youtubeId": "ZuxWPmFjC_I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4704",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 53 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yJDm1Igqxx4",
    "youtubeId": "yJDm1Igqxx4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4705",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 52 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oyVxqwIao60",
    "youtubeId": "oyVxqwIao60",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4706",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 51 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WhGq6Mijuos",
    "youtubeId": "WhGq6Mijuos",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4707",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 50 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/krTIftXPMw0",
    "youtubeId": "krTIftXPMw0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4708",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 49 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N_y_4shXBfY",
    "youtubeId": "N_y_4shXBfY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4709",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 48 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6ziYtDo406w",
    "youtubeId": "6ziYtDo406w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4710",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 47 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kLCiQYjrBm8",
    "youtubeId": "kLCiQYjrBm8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4711",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 46 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U4oyaKqnzyg",
    "youtubeId": "U4oyaKqnzyg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4712",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 45 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DXgdTptuQB4",
    "youtubeId": "DXgdTptuQB4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4713",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 44 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z2zlyrrW9l0",
    "youtubeId": "Z2zlyrrW9l0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4714",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 43 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TOeab6iu5cI",
    "youtubeId": "TOeab6iu5cI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4715",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 42 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AjqEa8Iwk34",
    "youtubeId": "AjqEa8Iwk34",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4716",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 41 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2HTbJM2J8kI",
    "youtubeId": "2HTbJM2J8kI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4717",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 40 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zFcc0QbH2uQ",
    "youtubeId": "zFcc0QbH2uQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4718",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 39 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jCENMUn5_u4",
    "youtubeId": "jCENMUn5_u4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4719",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 38 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2aavi6h6yMI",
    "youtubeId": "2aavi6h6yMI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4720",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 37 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zOdqdzu4yQQ",
    "youtubeId": "zOdqdzu4yQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4721",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 36 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gwkt30gLAEU",
    "youtubeId": "Gwkt30gLAEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4722",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 35 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l-xmHEwa0JA",
    "youtubeId": "l-xmHEwa0JA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4723",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 34 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bXpylJ25MeI",
    "youtubeId": "bXpylJ25MeI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4724",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 33 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NSd-jyYnE9k",
    "youtubeId": "NSd-jyYnE9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4725",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 32 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NrQVA7yvH54",
    "youtubeId": "NrQVA7yvH54",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4726",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 31 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JpUkE51tH6c",
    "youtubeId": "JpUkE51tH6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4727",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 30 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WDVkHKHkzwE",
    "youtubeId": "WDVkHKHkzwE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4728",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 29 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QMim5uLyIPo",
    "youtubeId": "QMim5uLyIPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4729",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 28 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FIPdVi3oc3Q",
    "youtubeId": "FIPdVi3oc3Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4730",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 27 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oWIetXh_ytE",
    "youtubeId": "oWIetXh_ytE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4731",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 26 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yfoWJ-SsHy0",
    "youtubeId": "yfoWJ-SsHy0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4732",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 25 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gh2G_z8EpXQ",
    "youtubeId": "gh2G_z8EpXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4733",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 24 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_mmf7W53sHM",
    "youtubeId": "_mmf7W53sHM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4734",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 23 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/klA6GHmTKO0",
    "youtubeId": "klA6GHmTKO0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4735",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 22 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nHxYAcwXm34",
    "youtubeId": "nHxYAcwXm34",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4736",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 21 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HSSyKyz1fFw",
    "youtubeId": "HSSyKyz1fFw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4737",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 20 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mWCcPWFoepE",
    "youtubeId": "mWCcPWFoepE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4738",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 19 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GgFF2oSX7V8",
    "youtubeId": "GgFF2oSX7V8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4739",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 17 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1ORWhqr5IXo",
    "youtubeId": "1ORWhqr5IXo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4740",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 18 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HoFmwU1XyPs",
    "youtubeId": "HoFmwU1XyPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4741",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 16 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uv-wwHU-hTg",
    "youtubeId": "uv-wwHU-hTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4742",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 15 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zxzGzi6OzvI",
    "youtubeId": "zxzGzi6OzvI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4743",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 14 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/flTzMQRLjIU",
    "youtubeId": "flTzMQRLjIU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4744",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 13 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D0foaLd5t8o",
    "youtubeId": "D0foaLd5t8o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4745",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 12 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_9ga0pMp4_k",
    "youtubeId": "_9ga0pMp4_k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4746",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 11 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jud56dfjZKA",
    "youtubeId": "jud56dfjZKA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4747",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 10 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-dpV9NmwER4",
    "youtubeId": "-dpV9NmwER4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4748",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 9 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e4LdVISBzJ4",
    "youtubeId": "e4LdVISBzJ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4749",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 8 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c8h8qifq5D8",
    "youtubeId": "c8h8qifq5D8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4750",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 7 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cq7jtxdyzy8",
    "youtubeId": "cq7jtxdyzy8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4751",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 6 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sJ6Z5-uly5w",
    "youtubeId": "sJ6Z5-uly5w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4752",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 5 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/53Rjov2ngqk",
    "youtubeId": "53Rjov2ngqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4753",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 4 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C8oFhA_HnHA",
    "youtubeId": "C8oFhA_HnHA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4754",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 3 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZhwZurDkGVc",
    "youtubeId": "ZhwZurDkGVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4755",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 2 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8ja_qUXCW6s",
    "youtubeId": "8ja_qUXCW6s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4756",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 10 Ayat 1 Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q5vn_ZnRFjM",
    "youtubeId": "q5vn_ZnRFjM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4757",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction Surah Yunus Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zy-8pP2EMzk",
    "youtubeId": "Zy-8pP2EMzk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4758",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 129 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ACQEu9Q8OO8",
    "youtubeId": "ACQEu9Q8OO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4759",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 128 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T7rkPxpkCpA",
    "youtubeId": "T7rkPxpkCpA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4760",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 127 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WBUFFbMo_fQ",
    "youtubeId": "WBUFFbMo_fQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4761",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 126 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lODjWCMEndk",
    "youtubeId": "lODjWCMEndk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4762",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 125 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3WH0_H21Kr0",
    "youtubeId": "3WH0_H21Kr0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4763",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 124 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zXSTwkpLmb4",
    "youtubeId": "zXSTwkpLmb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4764",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 123 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qlz25w8Sf90",
    "youtubeId": "Qlz25w8Sf90",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4765",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 122 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jIQIqUgZWLw",
    "youtubeId": "jIQIqUgZWLw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4766",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 121 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/huAOEJVLp5E",
    "youtubeId": "huAOEJVLp5E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4767",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 120 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SGep-_eElzQ",
    "youtubeId": "SGep-_eElzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4768",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 119 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QV-GSv_de1U",
    "youtubeId": "QV-GSv_de1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4769",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 118 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hh0HHXRYoy0",
    "youtubeId": "Hh0HHXRYoy0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4770",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 117 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-vrV3HG6NpE",
    "youtubeId": "-vrV3HG6NpE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4771",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 116 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F73AUrx66UA",
    "youtubeId": "F73AUrx66UA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4772",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 115 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_ACrJYvEcIk",
    "youtubeId": "_ACrJYvEcIk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4773",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 114 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P-U1Em5NDSs",
    "youtubeId": "P-U1Em5NDSs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4774",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 113 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YPoyZJ7WA6w",
    "youtubeId": "YPoyZJ7WA6w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4775",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 112 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/34GPETaR6xM",
    "youtubeId": "34GPETaR6xM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4776",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 111 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H_8jy-QK0nc",
    "youtubeId": "H_8jy-QK0nc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4777",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 110 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vxNNoOXN0JA",
    "youtubeId": "vxNNoOXN0JA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4778",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 109 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0ZJDGzw2KTs",
    "youtubeId": "0ZJDGzw2KTs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4779",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 108 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M69W62zE5RQ",
    "youtubeId": "M69W62zE5RQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4780",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 107 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/altz9HuEtdo",
    "youtubeId": "altz9HuEtdo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4781",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 106 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uiUh6XjPVj8",
    "youtubeId": "uiUh6XjPVj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4782",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 105 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6UwcvaYtmtE",
    "youtubeId": "6UwcvaYtmtE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4783",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 104 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ePmfah3hAVw",
    "youtubeId": "ePmfah3hAVw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4784",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 103 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HWWEhAs3Hbk",
    "youtubeId": "HWWEhAs3Hbk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4785",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 102 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nXV_bHIAMbA",
    "youtubeId": "nXV_bHIAMbA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4786",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 101 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gnzJ9nGb5LE",
    "youtubeId": "gnzJ9nGb5LE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4787",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 100 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/izgxUkt6Kbg",
    "youtubeId": "izgxUkt6Kbg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4788",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 99 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gNMytGy-UzE",
    "youtubeId": "gNMytGy-UzE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4789",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 98 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DwA__fVjfdw",
    "youtubeId": "DwA__fVjfdw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4790",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 97 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VeGMtz0wYoM",
    "youtubeId": "VeGMtz0wYoM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4791",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 96 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GPBb7zer-9A",
    "youtubeId": "GPBb7zer-9A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4792",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 95 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lkzVxIkjKM0",
    "youtubeId": "lkzVxIkjKM0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4793",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 94 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qhDCsJ4jGgA",
    "youtubeId": "qhDCsJ4jGgA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4794",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 93 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7SRmZhxP1JM",
    "youtubeId": "7SRmZhxP1JM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4795",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 92 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mfv1k0lYL08",
    "youtubeId": "Mfv1k0lYL08",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4796",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 91 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oQQ0BmjMfX0",
    "youtubeId": "oQQ0BmjMfX0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4797",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 90 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7K2K9tMsMiI",
    "youtubeId": "7K2K9tMsMiI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4798",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 89 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xXi05jDYh10",
    "youtubeId": "xXi05jDYh10",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4799",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 88 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_j0kkADZvuM",
    "youtubeId": "_j0kkADZvuM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4800",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 87 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4-e663pRh9I",
    "youtubeId": "4-e663pRh9I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4801",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 86 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tgY1L_DWj_0",
    "youtubeId": "tgY1L_DWj_0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4802",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 85 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aOuyKUb1DRk",
    "youtubeId": "aOuyKUb1DRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4803",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 84 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_1fMKA62_O0",
    "youtubeId": "_1fMKA62_O0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4804",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 83 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n4KMzFNh5o0",
    "youtubeId": "n4KMzFNh5o0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4805",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 82 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FcNx6X_KH_8",
    "youtubeId": "FcNx6X_KH_8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4806",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 81 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n6hNOBDTa2A",
    "youtubeId": "n6hNOBDTa2A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4807",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 80 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2tVwyGTCLWk",
    "youtubeId": "2tVwyGTCLWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4808",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 79 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CdFyiSrZcqg",
    "youtubeId": "CdFyiSrZcqg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4809",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 78 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4wEpV-iByHI",
    "youtubeId": "4wEpV-iByHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4810",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 77 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6mrpqELdgwg",
    "youtubeId": "6mrpqELdgwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4811",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 76 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FdMs6KTzsy8",
    "youtubeId": "FdMs6KTzsy8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4812",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 75 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Le8gVVnxUOs",
    "youtubeId": "Le8gVVnxUOs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4813",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 74 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Je_gEM8I8Y",
    "youtubeId": "7Je_gEM8I8Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4814",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 73 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7fsEGAsyJOw",
    "youtubeId": "7fsEGAsyJOw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4815",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 72 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tv-2w8jWirs",
    "youtubeId": "Tv-2w8jWirs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4816",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 71 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fdc636L16Pc",
    "youtubeId": "Fdc636L16Pc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4817",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 70 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FBftzrxyC4g",
    "youtubeId": "FBftzrxyC4g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4818",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 69 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aIIDqPqRyOE",
    "youtubeId": "aIIDqPqRyOE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4819",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 68 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QX_NgenR3-k",
    "youtubeId": "QX_NgenR3-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4820",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 67 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q73wbpBP3nA",
    "youtubeId": "q73wbpBP3nA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4821",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 66 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XhiI2D93dzo",
    "youtubeId": "XhiI2D93dzo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4822",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 65 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/idGCo94bBHQ",
    "youtubeId": "idGCo94bBHQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4823",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 64 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z03t2PQD7jA",
    "youtubeId": "z03t2PQD7jA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4824",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 63 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uRs5dZEXKo0",
    "youtubeId": "uRs5dZEXKo0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4825",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 62 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/43vqBdEDax8",
    "youtubeId": "43vqBdEDax8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4826",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 61 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-y5fdoDo3Dg",
    "youtubeId": "-y5fdoDo3Dg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4827",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 60 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7byvx9WeSUY",
    "youtubeId": "7byvx9WeSUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4828",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 59 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jkFko4cgEN8",
    "youtubeId": "jkFko4cgEN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4829",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 58 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5NLEma2r5Vg",
    "youtubeId": "5NLEma2r5Vg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4830",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 57 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fZO8irasX0g",
    "youtubeId": "fZO8irasX0g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4831",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 56 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8J51hPFUlSE",
    "youtubeId": "8J51hPFUlSE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4832",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 55 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IsgzUMQWEgA",
    "youtubeId": "IsgzUMQWEgA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4833",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 54 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J_UKzVQUIys",
    "youtubeId": "J_UKzVQUIys",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4834",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 53 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-cX69mwaSXs",
    "youtubeId": "-cX69mwaSXs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4835",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 52 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GQBEs1RmF_8",
    "youtubeId": "GQBEs1RmF_8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4836",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 51 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M31hZNTad-A",
    "youtubeId": "M31hZNTad-A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4837",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 50 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KI2r6Doddr8",
    "youtubeId": "KI2r6Doddr8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4838",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 49 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vV7WAsK8OAI",
    "youtubeId": "vV7WAsK8OAI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4839",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 48 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V15sMQRBgdk",
    "youtubeId": "V15sMQRBgdk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4840",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 47 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N5e3RIdCjRU",
    "youtubeId": "N5e3RIdCjRU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4841",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 46 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W2HKO-V07BM",
    "youtubeId": "W2HKO-V07BM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4842",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 45 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dpgMcojoqo4",
    "youtubeId": "dpgMcojoqo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4843",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 44 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/084qcH-UjO0",
    "youtubeId": "084qcH-UjO0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4844",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 43 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ytq-qPHx8A4",
    "youtubeId": "Ytq-qPHx8A4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4845",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 42 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CG3rZDJsEB4",
    "youtubeId": "CG3rZDJsEB4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4846",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 41 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cb86tSQCMwA",
    "youtubeId": "Cb86tSQCMwA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4847",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 40 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8QR2jMGahDg",
    "youtubeId": "8QR2jMGahDg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4848",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 39 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KoV1atdxDl0",
    "youtubeId": "KoV1atdxDl0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4849",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 38 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eqIX4wGDMvI",
    "youtubeId": "eqIX4wGDMvI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4850",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 37 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4BP4nTBhV0Y",
    "youtubeId": "4BP4nTBhV0Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4851",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 34 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DZT9kQ9aRr8",
    "youtubeId": "DZT9kQ9aRr8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4852",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 36 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dAVEJETwqWs",
    "youtubeId": "dAVEJETwqWs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4853",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 35 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WUSL1tdO4E0",
    "youtubeId": "WUSL1tdO4E0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4854",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 33 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6-MTxwyacRk",
    "youtubeId": "6-MTxwyacRk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4855",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 32 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gvUJqK2Wv9c",
    "youtubeId": "gvUJqK2Wv9c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4856",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 31 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NX26mMXPSpQ",
    "youtubeId": "NX26mMXPSpQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4857",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 30 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DJDZY1a1gtg",
    "youtubeId": "DJDZY1a1gtg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4858",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 29 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rUNjIV_VGL0",
    "youtubeId": "rUNjIV_VGL0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4859",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 28 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LaSNUC-jQjg",
    "youtubeId": "LaSNUC-jQjg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4860",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 27 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x7o_ZWE5AO8",
    "youtubeId": "x7o_ZWE5AO8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4861",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 26 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N9kTEYLgaJA",
    "youtubeId": "N9kTEYLgaJA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4862",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 25 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0VFDQ0qXaLc",
    "youtubeId": "0VFDQ0qXaLc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4863",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 24 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PTC92igz60o",
    "youtubeId": "PTC92igz60o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4864",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 23 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AZk6eoQPQfs",
    "youtubeId": "AZk6eoQPQfs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4865",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 22 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t4sNUscIVsk",
    "youtubeId": "t4sNUscIVsk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4866",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 21 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ipl4MJfksDE",
    "youtubeId": "Ipl4MJfksDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4867",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 20 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mFL3j8IvIJM",
    "youtubeId": "mFL3j8IvIJM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4868",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 19 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CvNUPVn2t6A",
    "youtubeId": "CvNUPVn2t6A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4869",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 18 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/92O3shlXxi8",
    "youtubeId": "92O3shlXxi8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4870",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 17 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nO-bHcI5FXE",
    "youtubeId": "nO-bHcI5FXE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4871",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 16 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iiNNktq3HQY",
    "youtubeId": "iiNNktq3HQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4872",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 15 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tdcJDF1jthA",
    "youtubeId": "tdcJDF1jthA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4873",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 14 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LW0HU1Pl0Ok",
    "youtubeId": "LW0HU1Pl0Ok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4874",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 13 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7QftTaArPNE",
    "youtubeId": "7QftTaArPNE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4875",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 12 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0L38SyN2buU",
    "youtubeId": "0L38SyN2buU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4876",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 11 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-iGxgt7F43U",
    "youtubeId": "-iGxgt7F43U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4877",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 10 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fs6eaDE47jE",
    "youtubeId": "Fs6eaDE47jE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4878",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 9 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_thhv5qJQ2g",
    "youtubeId": "_thhv5qJQ2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4879",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 8 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qddDHfCqqNg",
    "youtubeId": "qddDHfCqqNg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4880",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 7 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fbfQN4_GXUY",
    "youtubeId": "fbfQN4_GXUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4881",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 6 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b9srZudI8jE",
    "youtubeId": "b9srZudI8jE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4882",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 5 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jf7cRZgfcp4",
    "youtubeId": "jf7cRZgfcp4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4883",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 4 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3JnmhFLKd7c",
    "youtubeId": "3JnmhFLKd7c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4884",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 3 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S20Lv6_MZ7s",
    "youtubeId": "S20Lv6_MZ7s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4885",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 2 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8ZuDAD5M1rA",
    "youtubeId": "8ZuDAD5M1rA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4886",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 9 Ayat 1 Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HpSKXRaztuo",
    "youtubeId": "HpSKXRaztuo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4887",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction Surah Taubah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LoWqxw1DUKY",
    "youtubeId": "LoWqxw1DUKY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4888",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 75 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jMruBpTJm48",
    "youtubeId": "jMruBpTJm48",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4889",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 74 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AWNQNyJKUtA",
    "youtubeId": "AWNQNyJKUtA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4890",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 73 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mMc_GyukUgs",
    "youtubeId": "mMc_GyukUgs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4891",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 72 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PburFyTB0cU",
    "youtubeId": "PburFyTB0cU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4892",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 71 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nlCjHyATfHI",
    "youtubeId": "nlCjHyATfHI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4893",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 70 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cNbUv5c9T7c",
    "youtubeId": "cNbUv5c9T7c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4894",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 69 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xLxkbQNB2yg",
    "youtubeId": "xLxkbQNB2yg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4895",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 68 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j4eHtvXbHWk",
    "youtubeId": "j4eHtvXbHWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4896",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 67 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9PEAbJeDeRA",
    "youtubeId": "9PEAbJeDeRA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4897",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 66 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yR6eZVWOb9o",
    "youtubeId": "yR6eZVWOb9o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4898",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 65 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ctviEmmyDXQ",
    "youtubeId": "ctviEmmyDXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4899",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 64 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2SEvE9938k4",
    "youtubeId": "2SEvE9938k4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4900",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 63 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G2dnmssKqeE",
    "youtubeId": "G2dnmssKqeE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4901",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 62 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yS1r7vy-xW0",
    "youtubeId": "yS1r7vy-xW0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4902",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 61 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TICi_YUziDU",
    "youtubeId": "TICi_YUziDU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4903",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 60 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JuUolNBywRs",
    "youtubeId": "JuUolNBywRs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4904",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 59 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b6s4SGc0zoc",
    "youtubeId": "b6s4SGc0zoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4905",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 58 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b8t_YnVMg8U",
    "youtubeId": "b8t_YnVMg8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4906",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 57 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GakJy-CtsU8",
    "youtubeId": "GakJy-CtsU8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4907",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 56 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PgCktNqaKGM",
    "youtubeId": "PgCktNqaKGM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4908",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 55 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SW-dRC9_sFg",
    "youtubeId": "SW-dRC9_sFg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4909",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 54 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lx-602cJ85Y",
    "youtubeId": "Lx-602cJ85Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4910",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 53 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1SMGeRhImI4",
    "youtubeId": "1SMGeRhImI4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4911",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 52 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2m1Ao2zg7_4",
    "youtubeId": "2m1Ao2zg7_4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4912",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 51 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZCHSin5EJuw",
    "youtubeId": "ZCHSin5EJuw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4913",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 50 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7Gnxvlbq958",
    "youtubeId": "7Gnxvlbq958",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4914",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 49 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SEJ-q-pdK7E",
    "youtubeId": "SEJ-q-pdK7E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4915",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 48 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/elDKM57R7Zc",
    "youtubeId": "elDKM57R7Zc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4916",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 47 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lyATmxZH88g",
    "youtubeId": "lyATmxZH88g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4917",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 46 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9cMPcUwqAQY",
    "youtubeId": "9cMPcUwqAQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4918",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 45 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ruQ6zzRgacI",
    "youtubeId": "ruQ6zzRgacI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4919",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 44 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Jy0TNgE92I",
    "youtubeId": "3Jy0TNgE92I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4920",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 43 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KOiTOKToSWc",
    "youtubeId": "KOiTOKToSWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4921",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 42 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ufhMOjsOrME",
    "youtubeId": "ufhMOjsOrME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4922",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 41 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cQuZC8EuQUs",
    "youtubeId": "cQuZC8EuQUs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4923",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 40 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mzPlezgrIRI",
    "youtubeId": "mzPlezgrIRI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4924",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 39 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/129DJycM--Q",
    "youtubeId": "129DJycM--Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4925",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 38 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CQMEt7TlqPw",
    "youtubeId": "CQMEt7TlqPw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4926",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 37 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jxxoMoDMaKg",
    "youtubeId": "jxxoMoDMaKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4927",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 36 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RHQqMAlbWDk",
    "youtubeId": "RHQqMAlbWDk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4928",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 35 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gdxv2CgCsTk",
    "youtubeId": "Gdxv2CgCsTk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4929",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 34 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UvgSSrY_kjs",
    "youtubeId": "UvgSSrY_kjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4930",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 33 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8klhnlryjCs",
    "youtubeId": "8klhnlryjCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4931",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 32 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GLXli2rdP3M",
    "youtubeId": "GLXli2rdP3M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4932",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 31 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q0uzd_EPDOY",
    "youtubeId": "q0uzd_EPDOY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4933",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 30 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i7ZAfATqcmQ",
    "youtubeId": "i7ZAfATqcmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4934",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 29 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/30INuTxMC4M",
    "youtubeId": "30INuTxMC4M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4935",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 28 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hpd8k6MRDks",
    "youtubeId": "hpd8k6MRDks",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4936",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 27 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yZa-TTuTSe8",
    "youtubeId": "yZa-TTuTSe8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4937",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 26 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AB5Eu1G6T3s",
    "youtubeId": "AB5Eu1G6T3s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4938",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 25 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7nOzNQJbt7U",
    "youtubeId": "7nOzNQJbt7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4939",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 24 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fOnrQkLnwCU",
    "youtubeId": "fOnrQkLnwCU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4940",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 23 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mUnxawCFL30",
    "youtubeId": "mUnxawCFL30",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4941",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 22 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8dxmMbFR5P0",
    "youtubeId": "8dxmMbFR5P0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4942",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 21 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uyMU4vJqUMs",
    "youtubeId": "uyMU4vJqUMs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4943",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 20 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kIKLdRUxhw4",
    "youtubeId": "kIKLdRUxhw4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4944",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 19 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Dy9wOHpYlQ",
    "youtubeId": "3Dy9wOHpYlQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4945",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 18 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fo1VSZ6Kwcs",
    "youtubeId": "fo1VSZ6Kwcs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4946",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 17 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sbSrx59dqAE",
    "youtubeId": "sbSrx59dqAE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4947",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 16 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Hp6EHrZ1y_s",
    "youtubeId": "Hp6EHrZ1y_s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4948",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 15 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/v5DsL2GNsJ8",
    "youtubeId": "v5DsL2GNsJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4949",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 14 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L11zbdDZJcw",
    "youtubeId": "L11zbdDZJcw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4950",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 13 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4LFc9por-Uw",
    "youtubeId": "4LFc9por-Uw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4951",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 12 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7zNWE0iKfTI",
    "youtubeId": "7zNWE0iKfTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4952",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 11 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VhEopJ7ctGA",
    "youtubeId": "VhEopJ7ctGA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4953",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 10 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kUENqt7VtIE",
    "youtubeId": "kUENqt7VtIE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4954",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 9 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8EqIT5CsS7s",
    "youtubeId": "8EqIT5CsS7s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4955",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 8 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XY8P-lS3j2g",
    "youtubeId": "XY8P-lS3j2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4956",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 7 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_BigPZkZK0I",
    "youtubeId": "_BigPZkZK0I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4957",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 6 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pQcz0qDHyzk",
    "youtubeId": "pQcz0qDHyzk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4958",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 5 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NQemNSS_QvA",
    "youtubeId": "NQemNSS_QvA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4959",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 4 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gtrm1gDhjFM",
    "youtubeId": "gtrm1gDhjFM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4960",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 3 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GRUQKP8B98I",
    "youtubeId": "GRUQKP8B98I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4961",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 2 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/z6mywqnyFI0",
    "youtubeId": "z6mywqnyFI0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4962",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 8 Ayat 1 Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xKx1wqxCyYw",
    "youtubeId": "xKx1wqxCyYw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4963",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction Surah Anfaal Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fsZcLKBUxqg",
    "youtubeId": "fsZcLKBUxqg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4964",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 206 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JKGXKFGntDI",
    "youtubeId": "JKGXKFGntDI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4965",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 205 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QrpKhi3GzgU",
    "youtubeId": "QrpKhi3GzgU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4966",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 204 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GJUheDecOVQ",
    "youtubeId": "GJUheDecOVQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4967",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 203 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C8jym996xqQ",
    "youtubeId": "C8jym996xqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4968",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 202 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BT_PCM9vsxM",
    "youtubeId": "BT_PCM9vsxM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4969",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 201 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nUacGDegDLQ",
    "youtubeId": "nUacGDegDLQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4970",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 200 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/svxT6tok_x0",
    "youtubeId": "svxT6tok_x0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4971",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 199 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/viAxOGia7Io",
    "youtubeId": "viAxOGia7Io",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4972",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 198 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LBweYS6xTII",
    "youtubeId": "LBweYS6xTII",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4973",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 197 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pICj-nOxp5w",
    "youtubeId": "pICj-nOxp5w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4974",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 196 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AvghdFqP81w",
    "youtubeId": "AvghdFqP81w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4975",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 195 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xHLHjxEhO9k",
    "youtubeId": "xHLHjxEhO9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4976",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 194 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HPijDLcfx7I",
    "youtubeId": "HPijDLcfx7I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4977",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 193 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SK5TIcbz-os",
    "youtubeId": "SK5TIcbz-os",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4978",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 192 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kIfbmxMusSw",
    "youtubeId": "kIfbmxMusSw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4979",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 191 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N5RlWyKD6IA",
    "youtubeId": "N5RlWyKD6IA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4980",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 190 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/57NQpZPu23Y",
    "youtubeId": "57NQpZPu23Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4981",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 189 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g2xtCM46eLM",
    "youtubeId": "g2xtCM46eLM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4982",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 188 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E4e2PBxOET0",
    "youtubeId": "E4e2PBxOET0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4983",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 187 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ss_Mx83yeQg",
    "youtubeId": "ss_Mx83yeQg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4984",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 186 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/up5-NF2jSdY",
    "youtubeId": "up5-NF2jSdY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4985",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 185 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5qTV55xgDFw",
    "youtubeId": "5qTV55xgDFw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4986",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 184 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SUG6LyZZF_Q",
    "youtubeId": "SUG6LyZZF_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4987",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 183 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HEhDIB-UXW4",
    "youtubeId": "HEhDIB-UXW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4988",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 182 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5zuxoGdnJs0",
    "youtubeId": "5zuxoGdnJs0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4989",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 181 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jTTmQHO4V8Q",
    "youtubeId": "jTTmQHO4V8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4990",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 180 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R5pu9INtVpk",
    "youtubeId": "R5pu9INtVpk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4991",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 179 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zb5TUQghjvY",
    "youtubeId": "Zb5TUQghjvY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4992",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 178 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NnzE_wXopL4",
    "youtubeId": "NnzE_wXopL4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4993",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 177 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Cv9XmMw6ZOA",
    "youtubeId": "Cv9XmMw6ZOA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4994",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 176 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QaeIc1VAQ0o",
    "youtubeId": "QaeIc1VAQ0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4995",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 175 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nvT7_gWUv9s",
    "youtubeId": "nvT7_gWUv9s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4996",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 174 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8jmetiTCA24",
    "youtubeId": "8jmetiTCA24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4997",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 173 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/72IBisW-C6Q",
    "youtubeId": "72IBisW-C6Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4998",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 172 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2lCqNSI1Gjg",
    "youtubeId": "2lCqNSI1Gjg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-4999",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 171 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vbGpFSdI4xQ",
    "youtubeId": "vbGpFSdI4xQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5000",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 170 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JkDw3SVsCV8",
    "youtubeId": "JkDw3SVsCV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5001",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 169 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EgZAzooboxk",
    "youtubeId": "EgZAzooboxk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5002",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 168 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/addQWf6gK4I",
    "youtubeId": "addQWf6gK4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5003",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 167 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8ZjNS2Dr_QQ",
    "youtubeId": "8ZjNS2Dr_QQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5004",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 166 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u0FRBY4GhMo",
    "youtubeId": "u0FRBY4GhMo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5005",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 165 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ErUWS31dxW0",
    "youtubeId": "ErUWS31dxW0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5006",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 164 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lK_75SuGduk",
    "youtubeId": "lK_75SuGduk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5007",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 163 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j5xU83T1dKg",
    "youtubeId": "j5xU83T1dKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5008",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 162 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XzlDutCSvZk",
    "youtubeId": "XzlDutCSvZk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5009",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 161 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r0mbbLXZK0Y",
    "youtubeId": "r0mbbLXZK0Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5010",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 160 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UgPFHwYmrHA",
    "youtubeId": "UgPFHwYmrHA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5011",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 159 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9HTE3V9j754",
    "youtubeId": "9HTE3V9j754",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5012",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 158 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K0jyAOIvzYE",
    "youtubeId": "K0jyAOIvzYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5013",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 157 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k0OloIOuRPo",
    "youtubeId": "k0OloIOuRPo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5014",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 156 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ydn9ssLCkVk",
    "youtubeId": "ydn9ssLCkVk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5015",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 155 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ed5DZRyfmkU",
    "youtubeId": "ed5DZRyfmkU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5016",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 154 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jh0_Q7YoDvw",
    "youtubeId": "Jh0_Q7YoDvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5017",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 153 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E4ubByyu-Qs",
    "youtubeId": "E4ubByyu-Qs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5018",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 152 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/roNWwfldFWA",
    "youtubeId": "roNWwfldFWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5019",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 151 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3-ZXw5djAoQ",
    "youtubeId": "3-ZXw5djAoQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5020",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 150 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nn_2zJy9J-0",
    "youtubeId": "nn_2zJy9J-0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5021",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 149 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UM8AtxXt3T0",
    "youtubeId": "UM8AtxXt3T0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5022",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 148 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DL3e5sX6wM4",
    "youtubeId": "DL3e5sX6wM4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5023",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 147 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cWnUuC27AIc",
    "youtubeId": "cWnUuC27AIc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5024",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 146 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9fOEmSzYnoo",
    "youtubeId": "9fOEmSzYnoo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5025",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 145 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FIS-qJ6GG_c",
    "youtubeId": "FIS-qJ6GG_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5026",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 144 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MwdoxuSSUu8",
    "youtubeId": "MwdoxuSSUu8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5027",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 143 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l9hhutBN1H4",
    "youtubeId": "l9hhutBN1H4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5028",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 142 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e7rVx5mI9bw",
    "youtubeId": "e7rVx5mI9bw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5029",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 141 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uUZaDmuaTXE",
    "youtubeId": "uUZaDmuaTXE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5030",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 140 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kENCLHo0xxQ",
    "youtubeId": "kENCLHo0xxQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5031",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 139 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oEpAnNonxrQ",
    "youtubeId": "oEpAnNonxrQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5032",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 138 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PQ159Mp02n0",
    "youtubeId": "PQ159Mp02n0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5033",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 137 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DNIm2NcbBSA",
    "youtubeId": "DNIm2NcbBSA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5034",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 136 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kP9OqV6XYCA",
    "youtubeId": "kP9OqV6XYCA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5035",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 135 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/06QFn4K48pw",
    "youtubeId": "06QFn4K48pw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5036",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 134 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kCdsj5ACF80",
    "youtubeId": "kCdsj5ACF80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5037",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 133 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a8kCFE9NfXk",
    "youtubeId": "a8kCFE9NfXk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5038",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 132 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/892ENNeEsU8",
    "youtubeId": "892ENNeEsU8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5039",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 131 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tjRXaLXEtLI",
    "youtubeId": "tjRXaLXEtLI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5040",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 130 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vfCK24iUN0s",
    "youtubeId": "vfCK24iUN0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5041",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 129 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-amqTW2UHuA",
    "youtubeId": "-amqTW2UHuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5042",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 128 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BWufSHq5XGs",
    "youtubeId": "BWufSHq5XGs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5043",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 127 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/siKpdejXyPc",
    "youtubeId": "siKpdejXyPc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5044",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 126 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oGC9povNVgc",
    "youtubeId": "oGC9povNVgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5045",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 125 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M1tA6XHuvmY",
    "youtubeId": "M1tA6XHuvmY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5046",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 124 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H85FO_byw7U",
    "youtubeId": "H85FO_byw7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5047",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 123 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/57QxHQwjIBU",
    "youtubeId": "57QxHQwjIBU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5048",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 122 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DmObmDdsndU",
    "youtubeId": "DmObmDdsndU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5049",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 121 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8rFSSlCwJM8",
    "youtubeId": "8rFSSlCwJM8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5050",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 120 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zoG8gAtHvM0",
    "youtubeId": "zoG8gAtHvM0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5051",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 119 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w5WDy8dwNXw",
    "youtubeId": "w5WDy8dwNXw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5052",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 118 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N41bAVyKxoU",
    "youtubeId": "N41bAVyKxoU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5053",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 117 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t5KEoic14Ag",
    "youtubeId": "t5KEoic14Ag",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5054",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 116 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RCdZQKhQPZg",
    "youtubeId": "RCdZQKhQPZg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5055",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 115 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T75yTFNPH18",
    "youtubeId": "T75yTFNPH18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5056",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 114 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tvdtkg7OQtY",
    "youtubeId": "Tvdtkg7OQtY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5057",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 113 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eysws1zJf9M",
    "youtubeId": "eysws1zJf9M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5058",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 112 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sw64k455Eiw",
    "youtubeId": "sw64k455Eiw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5059",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 111 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M4u_0xqaDJI",
    "youtubeId": "M4u_0xqaDJI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5060",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 110 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zk_PjJWD78Y",
    "youtubeId": "zk_PjJWD78Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5061",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 109 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rD8ZZ2fK3w8",
    "youtubeId": "rD8ZZ2fK3w8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5062",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 108 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dr3bdSVI1bs",
    "youtubeId": "Dr3bdSVI1bs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5063",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 107 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cwud1fLEKmU",
    "youtubeId": "cwud1fLEKmU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5064",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 106 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jmh9d2o9FN4",
    "youtubeId": "Jmh9d2o9FN4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5065",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 105 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/64DhW3OaJwI",
    "youtubeId": "64DhW3OaJwI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5066",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 104 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AFO5RYYjISg",
    "youtubeId": "AFO5RYYjISg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5067",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 103 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/22zhn8pZSQQ",
    "youtubeId": "22zhn8pZSQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5068",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 102 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dwf7q9Lk7Rs",
    "youtubeId": "dwf7q9Lk7Rs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5069",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 101 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fein6OqfIUQ",
    "youtubeId": "fein6OqfIUQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5070",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 100 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8haXPyX_xMI",
    "youtubeId": "8haXPyX_xMI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5071",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 99 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HmoONt4G8As",
    "youtubeId": "HmoONt4G8As",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5072",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 98 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OVv08whdp1A",
    "youtubeId": "OVv08whdp1A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5073",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 97 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HB12DPAml7o",
    "youtubeId": "HB12DPAml7o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5074",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 96 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HZiW_mbt9sk",
    "youtubeId": "HZiW_mbt9sk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5075",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 95 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u6y1UC4bMKI",
    "youtubeId": "u6y1UC4bMKI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5076",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 94 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/peZTj7XD9tE",
    "youtubeId": "peZTj7XD9tE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5077",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 93 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Kh0skf4xow",
    "youtubeId": "0Kh0skf4xow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5078",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 92 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TY413it0cWw",
    "youtubeId": "TY413it0cWw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5079",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 91 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CyZ8fsRO08k",
    "youtubeId": "CyZ8fsRO08k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5080",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 90 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XTXHMpeMVNc",
    "youtubeId": "XTXHMpeMVNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5081",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 89 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aWWMikSDzbo",
    "youtubeId": "aWWMikSDzbo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5082",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 88 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xSak3__jAB8",
    "youtubeId": "xSak3__jAB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5083",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 87 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MzEW0d5GA6M",
    "youtubeId": "MzEW0d5GA6M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5084",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 86 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_XI9lXQfIa0",
    "youtubeId": "_XI9lXQfIa0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5085",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 85 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ivNAa1GfQnc",
    "youtubeId": "ivNAa1GfQnc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5086",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 84 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MG0V9LutZUc",
    "youtubeId": "MG0V9LutZUc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5087",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 83 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/287UI5jen4Y",
    "youtubeId": "287UI5jen4Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5088",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 82 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UEsybqnf27Q",
    "youtubeId": "UEsybqnf27Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5089",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 81 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FkG8sb-Lz_E",
    "youtubeId": "FkG8sb-Lz_E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5090",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 80 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6kGWtQq1P5c",
    "youtubeId": "6kGWtQq1P5c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5091",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 79 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U4DDsqiCWsk",
    "youtubeId": "U4DDsqiCWsk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5092",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 78 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HHz3MyYZ4s0",
    "youtubeId": "HHz3MyYZ4s0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5093",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 77 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WNxnRb9Oazg",
    "youtubeId": "WNxnRb9Oazg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5094",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 76 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aVTJSM1JL5I",
    "youtubeId": "aVTJSM1JL5I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5095",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 75 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IGKxocrrClM",
    "youtubeId": "IGKxocrrClM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5096",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 74 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MG9jQHjkZLU",
    "youtubeId": "MG9jQHjkZLU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5097",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 73 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9my99ps2cRE",
    "youtubeId": "9my99ps2cRE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5098",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 72 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G3thw30-C7I",
    "youtubeId": "G3thw30-C7I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5099",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 71 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pUjKTxJqGo4",
    "youtubeId": "pUjKTxJqGo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 70 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IjSVj-Pn-cU",
    "youtubeId": "IjSVj-Pn-cU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 69 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I46HFy7R0vs",
    "youtubeId": "I46HFy7R0vs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 68 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dmYchu_T168",
    "youtubeId": "dmYchu_T168",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 67 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/59UA-IpSJmQ",
    "youtubeId": "59UA-IpSJmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 66 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ylULywiss78",
    "youtubeId": "ylULywiss78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 65 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/canTb5c0BCs",
    "youtubeId": "canTb5c0BCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 64 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cCHRFmkYcvs",
    "youtubeId": "cCHRFmkYcvs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 63 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DpAtxLunoXQ",
    "youtubeId": "DpAtxLunoXQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 62 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FoaqrqoCoh0",
    "youtubeId": "FoaqrqoCoh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 61 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_zlCChdZFbM",
    "youtubeId": "_zlCChdZFbM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 60 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xFl_qoQjyyU",
    "youtubeId": "xFl_qoQjyyU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 59 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g7gljetDqa0",
    "youtubeId": "g7gljetDqa0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 58 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_lCIrUZaGTI",
    "youtubeId": "_lCIrUZaGTI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 57 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fxBoO6cIolI",
    "youtubeId": "fxBoO6cIolI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 56 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HffpduJnLBs",
    "youtubeId": "HffpduJnLBs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 55 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uKy32Qe-prA",
    "youtubeId": "uKy32Qe-prA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 54 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lW5rrJutpHw",
    "youtubeId": "lW5rrJutpHw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 53 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vOKjWvO-LhM",
    "youtubeId": "vOKjWvO-LhM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 52 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hOrQXuU-UP8",
    "youtubeId": "hOrQXuU-UP8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 51 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g5jS169Fd58",
    "youtubeId": "g5jS169Fd58",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 50 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bkghiodZ16s",
    "youtubeId": "bkghiodZ16s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 49 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bMMSSXvrgJg",
    "youtubeId": "bMMSSXvrgJg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5122",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 48 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xuMVuA9vXzE",
    "youtubeId": "xuMVuA9vXzE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5123",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 47 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2pcsJLxGxWY",
    "youtubeId": "2pcsJLxGxWY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5124",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 46 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GccppeYScYQ",
    "youtubeId": "GccppeYScYQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5125",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 45 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bT9n-AsookY",
    "youtubeId": "bT9n-AsookY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5126",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 44 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gL2qDzEyTtA",
    "youtubeId": "gL2qDzEyTtA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5127",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 43 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e3IDFvgYJQs",
    "youtubeId": "e3IDFvgYJQs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5128",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 42 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Eh-P4OTDv7Q",
    "youtubeId": "Eh-P4OTDv7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5129",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 41 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ohcvyHYJnTY",
    "youtubeId": "ohcvyHYJnTY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5130",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 40 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Grk3Y9froBg",
    "youtubeId": "Grk3Y9froBg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5131",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 39 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hKmi27iQ5Sk",
    "youtubeId": "hKmi27iQ5Sk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5132",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 38 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XQGmJ6OFAG8",
    "youtubeId": "XQGmJ6OFAG8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5133",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 37 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MCJraK0LFp4",
    "youtubeId": "MCJraK0LFp4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5134",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 36 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CLWcMKDJkzo",
    "youtubeId": "CLWcMKDJkzo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5135",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 35 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d-14hS2s5nY",
    "youtubeId": "d-14hS2s5nY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5136",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 34 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xE-7gSHLPLc",
    "youtubeId": "xE-7gSHLPLc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5137",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 33 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ocffhOoYsW8",
    "youtubeId": "ocffhOoYsW8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5138",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 32 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9bdfSwzoqb0",
    "youtubeId": "9bdfSwzoqb0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5139",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 31 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zF-aTOVTqj8",
    "youtubeId": "zF-aTOVTqj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5140",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 30 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TcMMHyhaXR8",
    "youtubeId": "TcMMHyhaXR8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5141",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 29 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AAuu6ZEt2Z0",
    "youtubeId": "AAuu6ZEt2Z0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5142",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 28 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZviPJjpqKUs",
    "youtubeId": "ZviPJjpqKUs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5143",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 27 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rUQ5PIn4ZSY",
    "youtubeId": "rUQ5PIn4ZSY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5144",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 26 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qyLmP9OPzjc",
    "youtubeId": "qyLmP9OPzjc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5145",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 25 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KoQzFelyjkE",
    "youtubeId": "KoQzFelyjkE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5146",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 24 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JK3eZZegWWI",
    "youtubeId": "JK3eZZegWWI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5147",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 23 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7X_LKwQpPiM",
    "youtubeId": "7X_LKwQpPiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5148",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 22 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/u1ybQW-sgbU",
    "youtubeId": "u1ybQW-sgbU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5149",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 21 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pz_zYHv_6H4",
    "youtubeId": "pz_zYHv_6H4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5150",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 20 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8sNTx6mxLgc",
    "youtubeId": "8sNTx6mxLgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5151",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 19 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/G5KrNa-o2fY",
    "youtubeId": "G5KrNa-o2fY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5152",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 18 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fqBfNu_UUJw",
    "youtubeId": "fqBfNu_UUJw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5153",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 17 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Itkrva1lrrY",
    "youtubeId": "Itkrva1lrrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5154",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 16 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/st5vzEDQbgk",
    "youtubeId": "st5vzEDQbgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5155",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 15 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZqLhgeSojWQ",
    "youtubeId": "ZqLhgeSojWQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5156",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 14 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OSzpdTf4UDI",
    "youtubeId": "OSzpdTf4UDI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5157",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 13 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/USqLNvuUEHg",
    "youtubeId": "USqLNvuUEHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5158",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 12 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iMNktdQ_Uvw",
    "youtubeId": "iMNktdQ_Uvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5159",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 11 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E6g9aaQL_UQ",
    "youtubeId": "E6g9aaQL_UQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5160",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 10 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T4qxMTlqxME",
    "youtubeId": "T4qxMTlqxME",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5161",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 9 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4kGMiM5asuM",
    "youtubeId": "4kGMiM5asuM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5162",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 8 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/983zc1z32xY",
    "youtubeId": "983zc1z32xY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5163",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 7 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oCkblbsIiS0",
    "youtubeId": "oCkblbsIiS0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5164",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 6 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/snMHMXGK-yo",
    "youtubeId": "snMHMXGK-yo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5165",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 5 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bsNhcEIvJu4",
    "youtubeId": "bsNhcEIvJu4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5166",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 4 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J8b4VGvOJm4",
    "youtubeId": "J8b4VGvOJm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5167",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 3 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gb_dGSWF858",
    "youtubeId": "Gb_dGSWF858",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5168",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 2 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ha-loR6XWEo",
    "youtubeId": "ha-loR6XWEo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5169",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 7 Ayat 1 Surah Araf Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hJQ6r4SXBKk",
    "youtubeId": "hJQ6r4SXBKk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5170",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 165 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/muBXdr3Up8A",
    "youtubeId": "muBXdr3Up8A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5171",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 164 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KJAODUik_KY",
    "youtubeId": "KJAODUik_KY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5172",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 163 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IiIzvyCj4gw",
    "youtubeId": "IiIzvyCj4gw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5173",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 162 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4oomZEp6vkM",
    "youtubeId": "4oomZEp6vkM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5174",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 161 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2mn1azjTomI",
    "youtubeId": "2mn1azjTomI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5175",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 160 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q9fqTFwBlCw",
    "youtubeId": "q9fqTFwBlCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5176",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 159 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g8RifgGeB-Y",
    "youtubeId": "g8RifgGeB-Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5177",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 158 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R_UIMWk7GoI",
    "youtubeId": "R_UIMWk7GoI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5178",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 157 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Kz0SzZCfhqs",
    "youtubeId": "Kz0SzZCfhqs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5179",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 156 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gjhz4oGa0xM",
    "youtubeId": "Gjhz4oGa0xM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5180",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 155 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X6mmaigUBe8",
    "youtubeId": "X6mmaigUBe8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5181",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 154 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rzjzjYgJlgc",
    "youtubeId": "rzjzjYgJlgc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5182",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 153 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QTneiUykvhA",
    "youtubeId": "QTneiUykvhA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5183",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 152 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3-96WFfWtsA",
    "youtubeId": "3-96WFfWtsA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5184",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 151 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qQnhfvoP8Zg",
    "youtubeId": "qQnhfvoP8Zg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5185",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 150 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RkCsooYOnho",
    "youtubeId": "RkCsooYOnho",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5186",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 149 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LMTBC3M40kM",
    "youtubeId": "LMTBC3M40kM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5187",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 148 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c_s66LKPlVg",
    "youtubeId": "c_s66LKPlVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5188",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 147 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/58pkkD92clo",
    "youtubeId": "58pkkD92clo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5189",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 146 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HJz0PydqNV0",
    "youtubeId": "HJz0PydqNV0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5190",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 145 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yNPTlzvBLSI",
    "youtubeId": "yNPTlzvBLSI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5191",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 144 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9262LBrNEk0",
    "youtubeId": "9262LBrNEk0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5192",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 143 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7KhOY78h6P8",
    "youtubeId": "7KhOY78h6P8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5193",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 142 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4URIctU6gcc",
    "youtubeId": "4URIctU6gcc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5194",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 141 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/68Fhp-STO8o",
    "youtubeId": "68Fhp-STO8o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5195",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 140 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HTiQDEIEG70",
    "youtubeId": "HTiQDEIEG70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5196",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 139 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cCHVfbROzYo",
    "youtubeId": "cCHVfbROzYo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5197",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 138 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hirUYICV6r4",
    "youtubeId": "hirUYICV6r4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5198",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 137 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pKx3Kq0tJrw",
    "youtubeId": "pKx3Kq0tJrw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5199",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 136 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMFFQGrsglo",
    "youtubeId": "cMFFQGrsglo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5200",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 135 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fVE6Be65V0c",
    "youtubeId": "fVE6Be65V0c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5201",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 134 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KnW2jxkLWHQ",
    "youtubeId": "KnW2jxkLWHQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5202",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 133 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hsAuUl4Un-Q",
    "youtubeId": "hsAuUl4Un-Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5203",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 132 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/spSvG2Hu4HU",
    "youtubeId": "spSvG2Hu4HU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5204",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 131 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R2IrhdAjTlI",
    "youtubeId": "R2IrhdAjTlI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5205",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 130 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DHwspWvOVm0",
    "youtubeId": "DHwspWvOVm0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5206",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 129 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5OamoochDJo",
    "youtubeId": "5OamoochDJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5207",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 128 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EUdb9So0H3o",
    "youtubeId": "EUdb9So0H3o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5208",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 127 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8ywWc34D4zA",
    "youtubeId": "8ywWc34D4zA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5209",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 126 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3FTuGnLnKxA",
    "youtubeId": "3FTuGnLnKxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5210",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 125 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kzRefA9-1ag",
    "youtubeId": "kzRefA9-1ag",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5211",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 124 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4QgHefXe7hs",
    "youtubeId": "4QgHefXe7hs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5212",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 123 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YXaP7YIQU2Q",
    "youtubeId": "YXaP7YIQU2Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5213",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 122 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2p0d3gxRlVA",
    "youtubeId": "2p0d3gxRlVA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5214",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 121 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DtPtKIHn1CQ",
    "youtubeId": "DtPtKIHn1CQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5215",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 120 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vbcDPwYtOHE",
    "youtubeId": "vbcDPwYtOHE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5216",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 119 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t-jJuiBRUfg",
    "youtubeId": "t-jJuiBRUfg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5217",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 118 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8TDB0y0MKZQ",
    "youtubeId": "8TDB0y0MKZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5218",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 117 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2-xkbVR9bcU",
    "youtubeId": "2-xkbVR9bcU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5219",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 116 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3WxLbVJIKGw",
    "youtubeId": "3WxLbVJIKGw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5220",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 115 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kXzVWu4pE_o",
    "youtubeId": "kXzVWu4pE_o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5221",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 114 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/03Mw2Iqc5J0",
    "youtubeId": "03Mw2Iqc5J0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5222",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 113 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U6CEyjI5n4Q",
    "youtubeId": "U6CEyjI5n4Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5223",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 112 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Flcb9LvI5Rw",
    "youtubeId": "Flcb9LvI5Rw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5224",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 111 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/en_oowetdzs",
    "youtubeId": "en_oowetdzs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5225",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 110 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BwXhoeqnwSk",
    "youtubeId": "BwXhoeqnwSk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5226",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 109 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5eOiyUBgYNk",
    "youtubeId": "5eOiyUBgYNk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5227",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 108 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sHxhS5Pbx70",
    "youtubeId": "sHxhS5Pbx70",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5228",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 107 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kQH2HRBRzFI",
    "youtubeId": "kQH2HRBRzFI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5229",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 106 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PKwBxb0Mv-w",
    "youtubeId": "PKwBxb0Mv-w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5230",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 105 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cgg1mb-g_M4",
    "youtubeId": "cgg1mb-g_M4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5231",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 104 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ES-bYwBqevA",
    "youtubeId": "ES-bYwBqevA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5232",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 103 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WdUFM6jqSiM",
    "youtubeId": "WdUFM6jqSiM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5233",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 102 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/I9x-qAbwb8U",
    "youtubeId": "I9x-qAbwb8U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5234",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 101 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/A59zYh3_dV8",
    "youtubeId": "A59zYh3_dV8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5235",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 100 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eHP5iTu5mPw",
    "youtubeId": "eHP5iTu5mPw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5236",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 99 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bZ-Chp5mtgk",
    "youtubeId": "bZ-Chp5mtgk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5237",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 98 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HBKQZror-iw",
    "youtubeId": "HBKQZror-iw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5238",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 97 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMa1KLCupkg",
    "youtubeId": "cMa1KLCupkg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5239",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 96 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gd9svaiEbzc",
    "youtubeId": "gd9svaiEbzc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5240",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 95 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3oYpNGFeyPE",
    "youtubeId": "3oYpNGFeyPE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5241",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 94 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JNqC5-h9RaY",
    "youtubeId": "JNqC5-h9RaY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5242",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 93 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mjM-gn6QtYU",
    "youtubeId": "mjM-gn6QtYU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5243",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 92 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kWzB9ADhss0",
    "youtubeId": "kWzB9ADhss0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5244",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 91 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qf-Kki_F4PM",
    "youtubeId": "Qf-Kki_F4PM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5245",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 90 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3Dw0SKuOWCg",
    "youtubeId": "3Dw0SKuOWCg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5246",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 89 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zPhC_Xxyf1I",
    "youtubeId": "zPhC_Xxyf1I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5247",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 88 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rM-tXjkVCdo",
    "youtubeId": "rM-tXjkVCdo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5248",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 87 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L_1DT2N93ZM",
    "youtubeId": "L_1DT2N93ZM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5249",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 86 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DcSAqxu71Ig",
    "youtubeId": "DcSAqxu71Ig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5250",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 85 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7GywQfOaGus",
    "youtubeId": "7GywQfOaGus",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5251",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 84 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sbC4tOYQVnc",
    "youtubeId": "sbC4tOYQVnc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5252",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 83 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QPAKlS_SF0o",
    "youtubeId": "QPAKlS_SF0o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5253",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 82 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AA5syizaIew",
    "youtubeId": "AA5syizaIew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5254",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 81 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i40gqpUDBiY",
    "youtubeId": "i40gqpUDBiY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5255",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 80 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cbCIiPCv2QE",
    "youtubeId": "cbCIiPCv2QE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5256",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 79 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5jwFVowDqYU",
    "youtubeId": "5jwFVowDqYU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5257",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 78 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wz5lEWb9Ioc",
    "youtubeId": "Wz5lEWb9Ioc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5258",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 77 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R0AE7xmqgHA",
    "youtubeId": "R0AE7xmqgHA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5259",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 76 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q1oDGNjIGBY",
    "youtubeId": "q1oDGNjIGBY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5260",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 75 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1bKJcjIoEIo",
    "youtubeId": "1bKJcjIoEIo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5261",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 74 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z24z6bRxs_c",
    "youtubeId": "Z24z6bRxs_c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5262",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 73 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lgujbbiXMdU",
    "youtubeId": "lgujbbiXMdU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5263",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 72 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/stPDlx8-I_8",
    "youtubeId": "stPDlx8-I_8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5264",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 71 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KL7wlmP9vCM",
    "youtubeId": "KL7wlmP9vCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5265",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 70 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q2VLjqdageA",
    "youtubeId": "q2VLjqdageA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5266",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 69 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iRQXQFRmwwo",
    "youtubeId": "iRQXQFRmwwo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5267",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 68 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XGNooSIssT4",
    "youtubeId": "XGNooSIssT4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5268",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 67 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PukrlYL9c24",
    "youtubeId": "PukrlYL9c24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5269",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 66 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FskKyFA2Ob0",
    "youtubeId": "FskKyFA2Ob0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5270",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 65 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JvUY2XQWxv8",
    "youtubeId": "JvUY2XQWxv8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5271",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 64 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HZ71LcG2jA8",
    "youtubeId": "HZ71LcG2jA8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5272",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 63 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OIjUAYEzJbw",
    "youtubeId": "OIjUAYEzJbw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5273",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 62 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dIGpZ5ZMjU4",
    "youtubeId": "dIGpZ5ZMjU4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5274",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 61 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IbJdhQA5ApA",
    "youtubeId": "IbJdhQA5ApA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5275",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 60 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BObPB9uiosk",
    "youtubeId": "BObPB9uiosk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5276",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 59 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JSpWNVJ5r-g",
    "youtubeId": "JSpWNVJ5r-g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5277",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 58 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NIXygpsU-DE",
    "youtubeId": "NIXygpsU-DE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5278",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 57 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JCMt_DSd56o",
    "youtubeId": "JCMt_DSd56o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5279",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 56 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bCrcmSQ926M",
    "youtubeId": "bCrcmSQ926M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5280",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 55 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1gD4Tg4q3T8",
    "youtubeId": "1gD4Tg4q3T8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5281",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 54 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cX6VsZfXwm4",
    "youtubeId": "cX6VsZfXwm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5282",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 53 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zepJU-RnETk",
    "youtubeId": "zepJU-RnETk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5283",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 52 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lzd4_QRyTkU",
    "youtubeId": "lzd4_QRyTkU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5284",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 51 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GLZAJTkRv4E",
    "youtubeId": "GLZAJTkRv4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5285",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 50 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wcCk9aiai8A",
    "youtubeId": "wcCk9aiai8A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5286",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 49 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nzgnwATUy-4",
    "youtubeId": "nzgnwATUy-4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5287",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 48 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pgmoAu8ugBE",
    "youtubeId": "pgmoAu8ugBE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5288",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 47 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EdCT7QoN_PE",
    "youtubeId": "EdCT7QoN_PE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5289",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 46 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZI4hH36ijpM",
    "youtubeId": "ZI4hH36ijpM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5290",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 45 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7KYBnZzh92I",
    "youtubeId": "7KYBnZzh92I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5291",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 44 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wbCPy2uqmD4",
    "youtubeId": "wbCPy2uqmD4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5292",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 43 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YLem3KV4ovQ",
    "youtubeId": "YLem3KV4ovQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5293",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 42 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/giGZCqwfmQ0",
    "youtubeId": "giGZCqwfmQ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5294",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 41 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l9VGf6yRPUA",
    "youtubeId": "l9VGf6yRPUA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5295",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 40 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ao3o9UduOCM",
    "youtubeId": "Ao3o9UduOCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5296",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 39 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5koY5mxU5cg",
    "youtubeId": "5koY5mxU5cg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5297",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 38 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AiQZTv4wYJo",
    "youtubeId": "AiQZTv4wYJo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5298",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 37 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yoN7nHa8Pms",
    "youtubeId": "yoN7nHa8Pms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5299",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 36 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8-1CjwUU9HM",
    "youtubeId": "8-1CjwUU9HM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5300",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 35 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xyLyn4k3ESg",
    "youtubeId": "xyLyn4k3ESg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5301",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 34 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1oL46QbFOAs",
    "youtubeId": "1oL46QbFOAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5302",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 33 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IGQYifcvuYE",
    "youtubeId": "IGQYifcvuYE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5303",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 32 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DKj7uV0D4gY",
    "youtubeId": "DKj7uV0D4gY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5304",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 31 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IdEkbfUNDac",
    "youtubeId": "IdEkbfUNDac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5305",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 30 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Iz-mU0m3s8o",
    "youtubeId": "Iz-mU0m3s8o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5306",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 29 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/llDPMsg799c",
    "youtubeId": "llDPMsg799c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5307",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 28 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1Ohfioqk0og",
    "youtubeId": "1Ohfioqk0og",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5308",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 27 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EHatCcs9yEc",
    "youtubeId": "EHatCcs9yEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5309",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 26 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wqj8LOrBtM0",
    "youtubeId": "Wqj8LOrBtM0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5310",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 25 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D3vtcwsshlI",
    "youtubeId": "D3vtcwsshlI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5311",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 24 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xuFKEb9jr1s",
    "youtubeId": "xuFKEb9jr1s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5312",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 23 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tf_kGLXlLXg",
    "youtubeId": "Tf_kGLXlLXg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5313",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 22 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BbPVPgGbcao",
    "youtubeId": "BbPVPgGbcao",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5314",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 21 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-1GnTAUIunw",
    "youtubeId": "-1GnTAUIunw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5315",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 20 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YrPGTCLBCqQ",
    "youtubeId": "YrPGTCLBCqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5316",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 19 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tQPjR_wixbY",
    "youtubeId": "tQPjR_wixbY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5317",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 18 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fiV2X6ptUDI",
    "youtubeId": "fiV2X6ptUDI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5318",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 17 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aX8wg91GDWk",
    "youtubeId": "aX8wg91GDWk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5319",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 16 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mz6m30MeQRI",
    "youtubeId": "Mz6m30MeQRI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5320",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 15 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yAxkMwDSlHg",
    "youtubeId": "yAxkMwDSlHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5321",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 14 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/35qptT4cWLI",
    "youtubeId": "35qptT4cWLI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5322",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 13 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ImnLEXnZ55w",
    "youtubeId": "ImnLEXnZ55w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5323",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 12 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rpOC1zXBqwc",
    "youtubeId": "rpOC1zXBqwc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5324",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 11 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i_4BHruFIdw",
    "youtubeId": "i_4BHruFIdw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5325",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 10 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7UcwtuM8Nvk",
    "youtubeId": "7UcwtuM8Nvk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5326",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 9 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Zh9YRgaaaA",
    "youtubeId": "5Zh9YRgaaaA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5327",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 8 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1KeR0N-4Wd8",
    "youtubeId": "1KeR0N-4Wd8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5328",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 7 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JjbLMqECgLA",
    "youtubeId": "JjbLMqECgLA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5329",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 6 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WwDTnCEhM9Y",
    "youtubeId": "WwDTnCEhM9Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5330",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 5 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4MPzF1bN9ww",
    "youtubeId": "4MPzF1bN9ww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5331",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 4 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VpDvX0ayn5M",
    "youtubeId": "VpDvX0ayn5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5332",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 3 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3YPVuGVmZgw",
    "youtubeId": "3YPVuGVmZgw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5333",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 2 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hoEjhvsPGvc",
    "youtubeId": "hoEjhvsPGvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5334",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 6 Ayat 1 Surah Anam Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P7lvzY2s32I",
    "youtubeId": "P7lvzY2s32I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5335",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 120 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GgmUqcltFqU",
    "youtubeId": "GgmUqcltFqU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5336",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 119 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oDRvOjfzM8M",
    "youtubeId": "oDRvOjfzM8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5337",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 118 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MhvOvMle_IY",
    "youtubeId": "MhvOvMle_IY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5338",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 117 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Wj7vFg-d8HE",
    "youtubeId": "Wj7vFg-d8HE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5339",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 116 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ToknPq0Rer0",
    "youtubeId": "ToknPq0Rer0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5340",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 115 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5-Np8tUcAtE",
    "youtubeId": "5-Np8tUcAtE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5341",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 114 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C1dgEa0tXU4",
    "youtubeId": "C1dgEa0tXU4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5342",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 113 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XkEEyPGDVjM",
    "youtubeId": "XkEEyPGDVjM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5343",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 112 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LBrhvC_3pFI",
    "youtubeId": "LBrhvC_3pFI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5344",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 111 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sMKs3XYZrQw",
    "youtubeId": "sMKs3XYZrQw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5345",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 110 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-yb_BhvJfxw",
    "youtubeId": "-yb_BhvJfxw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5346",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 109 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mJ37dn0EHuc",
    "youtubeId": "mJ37dn0EHuc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5347",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 108 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HXWSb1va98E",
    "youtubeId": "HXWSb1va98E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5348",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 107 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gplZSEQukok",
    "youtubeId": "gplZSEQukok",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5349",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 106 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hBinI9EicnI",
    "youtubeId": "hBinI9EicnI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5350",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 105 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IfIUr1JqSlA",
    "youtubeId": "IfIUr1JqSlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5351",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 104 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Sucmx8nFqAE",
    "youtubeId": "Sucmx8nFqAE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5352",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 103 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z6jnLJG_rto",
    "youtubeId": "Z6jnLJG_rto",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5353",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 102 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zojn1ydpw2E",
    "youtubeId": "zojn1ydpw2E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5354",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 101 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qw70CmzCEj8",
    "youtubeId": "Qw70CmzCEj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5355",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 100 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yXNRdXFl1j8",
    "youtubeId": "yXNRdXFl1j8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5356",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 99 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bo1_JtCxgKM",
    "youtubeId": "Bo1_JtCxgKM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5357",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 98 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2uUZdM051os",
    "youtubeId": "2uUZdM051os",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5358",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 97 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EPSTVaNmTNc",
    "youtubeId": "EPSTVaNmTNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5359",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 96 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RAyfQrX90Ms",
    "youtubeId": "RAyfQrX90Ms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5360",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 95 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NT90NzglYd0",
    "youtubeId": "NT90NzglYd0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5361",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 94 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RafzUDOe5Xo",
    "youtubeId": "RafzUDOe5Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5362",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 93 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4mdlCFeVWa0",
    "youtubeId": "4mdlCFeVWa0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5363",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 92 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lmw1hCuvpec",
    "youtubeId": "lmw1hCuvpec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5364",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 91 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vNNZ28RaBS0",
    "youtubeId": "vNNZ28RaBS0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5365",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 90 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D39b5IEIeNg",
    "youtubeId": "D39b5IEIeNg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5366",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 89 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F3KrR06tkGo",
    "youtubeId": "F3KrR06tkGo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5367",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 88 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HMu--9S920s",
    "youtubeId": "HMu--9S920s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5368",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 87 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VysRnYcO8tE",
    "youtubeId": "VysRnYcO8tE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5369",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 86 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ssY8ADiHjG8",
    "youtubeId": "ssY8ADiHjG8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5370",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 85 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AH0rirIKD6U",
    "youtubeId": "AH0rirIKD6U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5371",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 84 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OXXbwcY2LfI",
    "youtubeId": "OXXbwcY2LfI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5372",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 83 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4BY3zRxAAJE",
    "youtubeId": "4BY3zRxAAJE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5373",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 82 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NZ6ZZJWpIRM",
    "youtubeId": "NZ6ZZJWpIRM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5374",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 81 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EodguNNjPs4",
    "youtubeId": "EodguNNjPs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5375",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 80 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1rLSu9qPj8c",
    "youtubeId": "1rLSu9qPj8c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5376",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 79 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aqsx90XBWds",
    "youtubeId": "aqsx90XBWds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5377",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 78 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FPkoj6QmMp4",
    "youtubeId": "FPkoj6QmMp4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5378",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 77 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BF-_hQF71UE",
    "youtubeId": "BF-_hQF71UE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5379",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 76 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X1evQnTndEw",
    "youtubeId": "X1evQnTndEw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5380",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 75 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P4ICTtV7Gpk",
    "youtubeId": "P4ICTtV7Gpk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5381",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 74 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wIc1ghwcxGw",
    "youtubeId": "wIc1ghwcxGw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5382",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 73 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JTaaIy8ejKQ",
    "youtubeId": "JTaaIy8ejKQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5383",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 72 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4d3_6ZETzrk",
    "youtubeId": "4d3_6ZETzrk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5384",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 71 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e0zk2_G9dsA",
    "youtubeId": "e0zk2_G9dsA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5385",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 70 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t5Q0774ji-o",
    "youtubeId": "t5Q0774ji-o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5386",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 69 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1SQe9jBmfAo",
    "youtubeId": "1SQe9jBmfAo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5387",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 68 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a9CDg_8sijk",
    "youtubeId": "a9CDg_8sijk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5388",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 67 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BSI_yn4neHY",
    "youtubeId": "BSI_yn4neHY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5389",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 66 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZM9LtASQuP4",
    "youtubeId": "ZM9LtASQuP4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5390",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 65 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6X0dBqH5Kcc",
    "youtubeId": "6X0dBqH5Kcc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5391",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 64 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9tw5tOhyrSo",
    "youtubeId": "9tw5tOhyrSo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5392",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 63 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Mkb1LkpMt8",
    "youtubeId": "-Mkb1LkpMt8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5393",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 62 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4DEwxZuOq0s",
    "youtubeId": "4DEwxZuOq0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5394",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 61 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Ko9OETbgWw",
    "youtubeId": "-Ko9OETbgWw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5395",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 60 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GsuUbZykIUg",
    "youtubeId": "GsuUbZykIUg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5396",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 59 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6ynSDgcL1KQ",
    "youtubeId": "6ynSDgcL1KQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5397",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 58 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VziV5F68T28",
    "youtubeId": "VziV5F68T28",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5398",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 57 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/olCnbmY2bLA",
    "youtubeId": "olCnbmY2bLA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5399",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 56 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eNJ2wxfN2z4",
    "youtubeId": "eNJ2wxfN2z4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5400",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 55 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S7i5BFGcN80",
    "youtubeId": "S7i5BFGcN80",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5401",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 54 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aJky4xN9iOg",
    "youtubeId": "aJky4xN9iOg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5402",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 53 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jP0Hl1jhRqA",
    "youtubeId": "jP0Hl1jhRqA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5403",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 52 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cyUJuIiG8bo",
    "youtubeId": "cyUJuIiG8bo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5404",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 51 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nYezpzI02_Y",
    "youtubeId": "nYezpzI02_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5405",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 50 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MYYaOmScQBU",
    "youtubeId": "MYYaOmScQBU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5406",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 49 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lxz_pyCgzH0",
    "youtubeId": "Lxz_pyCgzH0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5407",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 48 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IpBpqx3QABY",
    "youtubeId": "IpBpqx3QABY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5408",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 47 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cvD3LA3zlmQ",
    "youtubeId": "cvD3LA3zlmQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5409",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 46 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OKh3yWNyYxA",
    "youtubeId": "OKh3yWNyYxA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5410",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 45 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QYogcIVJox0",
    "youtubeId": "QYogcIVJox0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5411",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 44 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YqqVeRpARcM",
    "youtubeId": "YqqVeRpARcM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5412",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 43 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o5bOpPbJ-ww",
    "youtubeId": "o5bOpPbJ-ww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5413",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 42 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CnuIF6yV0hE",
    "youtubeId": "CnuIF6yV0hE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5414",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 41 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/APZ6xOst95I",
    "youtubeId": "APZ6xOst95I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5415",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 40 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xYEVx-l6pjk",
    "youtubeId": "xYEVx-l6pjk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5416",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 39 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/meHQhnOCpcQ",
    "youtubeId": "meHQhnOCpcQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5417",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 38 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ejFyaz6U6sg",
    "youtubeId": "ejFyaz6U6sg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5418",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 37 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OkHdKMK-LHw",
    "youtubeId": "OkHdKMK-LHw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5419",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 36 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HIqaVIM5Qww",
    "youtubeId": "HIqaVIM5Qww",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5420",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 35 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lNkyB-BEexc",
    "youtubeId": "lNkyB-BEexc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5421",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 34 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3ZiR90ZLuBg",
    "youtubeId": "3ZiR90ZLuBg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5422",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 33 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LozjnzrTyCs",
    "youtubeId": "LozjnzrTyCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5423",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 32 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0B7J63fdEFk",
    "youtubeId": "0B7J63fdEFk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5424",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 31 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dkWdLnquL8k",
    "youtubeId": "dkWdLnquL8k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5425",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 30 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bdViySoygYc",
    "youtubeId": "bdViySoygYc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5426",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 29 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l4GTRkLqkNQ",
    "youtubeId": "l4GTRkLqkNQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5427",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 28 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/76qYwbhsqH0",
    "youtubeId": "76qYwbhsqH0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5428",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 27 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uKwfDdkPSWc",
    "youtubeId": "uKwfDdkPSWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5429",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 26 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uvt9q8521qo",
    "youtubeId": "uvt9q8521qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5430",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 25 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vHKbM4lo3B8",
    "youtubeId": "vHKbM4lo3B8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5431",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 24 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jIqb5tIFE9Y",
    "youtubeId": "jIqb5tIFE9Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5432",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 23 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Yi6RBmpFsp0",
    "youtubeId": "Yi6RBmpFsp0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5433",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 22 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IUCq4nQvu4E",
    "youtubeId": "IUCq4nQvu4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5434",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 21 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cuvmwswegac",
    "youtubeId": "cuvmwswegac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5435",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 20 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VAlSzHJjfP0",
    "youtubeId": "VAlSzHJjfP0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5436",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 19 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N-NwPnSiMug",
    "youtubeId": "N-NwPnSiMug",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5437",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 18 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ek-bvtgQrNc",
    "youtubeId": "ek-bvtgQrNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5438",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 17 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8uRffbxwymQ",
    "youtubeId": "8uRffbxwymQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5439",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 16 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NYox9poHPAI",
    "youtubeId": "NYox9poHPAI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5440",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 15 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XfQsaevpfoc",
    "youtubeId": "XfQsaevpfoc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5441",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 14 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T0jSLA6vyVc",
    "youtubeId": "T0jSLA6vyVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5442",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 13 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a90jxM-x4fQ",
    "youtubeId": "a90jxM-x4fQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5443",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 12 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O6Wlme09f5M",
    "youtubeId": "O6Wlme09f5M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5444",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 11 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3zs1HENP7VI",
    "youtubeId": "3zs1HENP7VI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5445",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 10 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WkPRqKdH9mE",
    "youtubeId": "WkPRqKdH9mE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5446",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 9 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fxo6MUZdgwg",
    "youtubeId": "fxo6MUZdgwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5447",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 8 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rEhxzhXcC-k",
    "youtubeId": "rEhxzhXcC-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5448",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 7 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/prqDQMacJ6E",
    "youtubeId": "prqDQMacJ6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5449",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 6 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZlNe6Cepi4A",
    "youtubeId": "ZlNe6Cepi4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5450",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 5 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Et7FxnB5XmM",
    "youtubeId": "Et7FxnB5XmM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5451",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 4 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OfjLenPHED8",
    "youtubeId": "OfjLenPHED8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5452",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 3 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jiEwRX-crb4",
    "youtubeId": "jiEwRX-crb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5453",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 2 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9_PDMvW3W14",
    "youtubeId": "9_PDMvW3W14",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5454",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 5 Ayat 1 Surah Maidah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4f6kzYeC6HI",
    "youtubeId": "4f6kzYeC6HI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5455",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 176 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3roRlGjGOZU",
    "youtubeId": "3roRlGjGOZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5456",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 175 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W9UVor0K2UA",
    "youtubeId": "W9UVor0K2UA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5457",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 174 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cHVEfiD5tcs",
    "youtubeId": "cHVEfiD5tcs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5458",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 173 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n6LCbxh2HTo",
    "youtubeId": "n6LCbxh2HTo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5459",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 172 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ybVQXpOyqJM",
    "youtubeId": "ybVQXpOyqJM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5460",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 171 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kmt-hWDNEvc",
    "youtubeId": "kmt-hWDNEvc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5461",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 170 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yXeW4rdlqjU",
    "youtubeId": "yXeW4rdlqjU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5462",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 169 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lCgCYY4esew",
    "youtubeId": "lCgCYY4esew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5463",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 168 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a5jsVkRdzWA",
    "youtubeId": "a5jsVkRdzWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5464",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 167 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l4t46cFAhzw",
    "youtubeId": "l4t46cFAhzw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5465",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 166 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jp52atYYu5Y",
    "youtubeId": "Jp52atYYu5Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5466",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 165 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1JhWuJ-aBaQ",
    "youtubeId": "1JhWuJ-aBaQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5467",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 164 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XAVlZ39OHlk",
    "youtubeId": "XAVlZ39OHlk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5468",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 163 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3KkGLsWl4cg",
    "youtubeId": "3KkGLsWl4cg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5469",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 162 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/61ax5yIf5_0",
    "youtubeId": "61ax5yIf5_0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5470",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 161 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4_eLeSd2ce0",
    "youtubeId": "4_eLeSd2ce0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5471",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 160 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wPh7ysoVs5g",
    "youtubeId": "wPh7ysoVs5g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5472",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 159 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yQYVmOe7wIM",
    "youtubeId": "yQYVmOe7wIM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5473",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 158 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8onZ0a-CZX8",
    "youtubeId": "8onZ0a-CZX8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5474",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 157 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oIiP9z0HPqo",
    "youtubeId": "oIiP9z0HPqo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5475",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 156 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NKRZ2HIokqU",
    "youtubeId": "NKRZ2HIokqU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5476",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 155 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jqUGoFrzWN0",
    "youtubeId": "jqUGoFrzWN0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5477",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 154 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YWaAz1IwueQ",
    "youtubeId": "YWaAz1IwueQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5478",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 153 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xCCfjU2VCmc",
    "youtubeId": "xCCfjU2VCmc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5479",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 152 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MALhUZUS6eM",
    "youtubeId": "MALhUZUS6eM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5480",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 151 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LfXO-skM-BE",
    "youtubeId": "LfXO-skM-BE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5481",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 150 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5eSaGbu7OI4",
    "youtubeId": "5eSaGbu7OI4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5482",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 149 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bkuXqx_xHBA",
    "youtubeId": "bkuXqx_xHBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5483",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 148 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6CPWHvHy84o",
    "youtubeId": "6CPWHvHy84o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5484",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 147 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zNNF3e2kJeQ",
    "youtubeId": "zNNF3e2kJeQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5485",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 146 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lEZMh5XxKqk",
    "youtubeId": "lEZMh5XxKqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5486",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 145 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-EX-F3-mMu0",
    "youtubeId": "-EX-F3-mMu0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5487",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 144 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hPRJlWW7ZsU",
    "youtubeId": "hPRJlWW7ZsU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5488",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 143 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LC1yUNcagBE",
    "youtubeId": "LC1yUNcagBE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5489",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 142 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/llvG83qRSk0",
    "youtubeId": "llvG83qRSk0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5490",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 141 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tfRZisOjMpY",
    "youtubeId": "tfRZisOjMpY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5491",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 140 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1hTlr9hu3Z0",
    "youtubeId": "1hTlr9hu3Z0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5492",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 139 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gr2GzRaElac",
    "youtubeId": "Gr2GzRaElac",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5493",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 138 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Zh00vDHNCQ",
    "youtubeId": "5Zh00vDHNCQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5494",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 137 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JyT9M34yy1w",
    "youtubeId": "JyT9M34yy1w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5495",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 136 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aMV072W68HY",
    "youtubeId": "aMV072W68HY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5496",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 135 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EpOjZmUVFB0",
    "youtubeId": "EpOjZmUVFB0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5497",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 134 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jIAuTG_n_1E",
    "youtubeId": "jIAuTG_n_1E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5498",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 133 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tMMvIjiKdEE",
    "youtubeId": "tMMvIjiKdEE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5499",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 132 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vlJzcwpvLSg",
    "youtubeId": "vlJzcwpvLSg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5500",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 131 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BOYsb_rqoNs",
    "youtubeId": "BOYsb_rqoNs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5501",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 130 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nfYNIgyeYhs",
    "youtubeId": "nfYNIgyeYhs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5502",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 129 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/x8_AiMitHbw",
    "youtubeId": "x8_AiMitHbw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5503",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 128 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VEoFaPNpNLc",
    "youtubeId": "VEoFaPNpNLc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5504",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 127 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3grZAnM-Vwc",
    "youtubeId": "3grZAnM-Vwc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5505",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 126 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WzNNiJKuqCY",
    "youtubeId": "WzNNiJKuqCY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5506",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 125 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vwZ6j-4alPI",
    "youtubeId": "vwZ6j-4alPI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5507",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 124 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fN4EySLtoqU",
    "youtubeId": "fN4EySLtoqU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5508",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 123 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kDymIjq_hE8",
    "youtubeId": "kDymIjq_hE8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5509",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 122 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8BPROblm_Hk",
    "youtubeId": "8BPROblm_Hk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5510",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 121 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4qqfuznp3iQ",
    "youtubeId": "4qqfuznp3iQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5511",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 120 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Czjy1yZrsVQ",
    "youtubeId": "Czjy1yZrsVQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5512",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 119 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UQV1zTcJJ_U",
    "youtubeId": "UQV1zTcJJ_U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5513",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 118 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ae2MU7aQ3sg",
    "youtubeId": "Ae2MU7aQ3sg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5514",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 117 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m7GkX07UGCM",
    "youtubeId": "m7GkX07UGCM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5515",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 116 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IFGExM8CPXs",
    "youtubeId": "IFGExM8CPXs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5516",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 115 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IPAzlTAh5HM",
    "youtubeId": "IPAzlTAh5HM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5517",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 114 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kDTXPwjtOLM",
    "youtubeId": "kDTXPwjtOLM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5518",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 113 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H2NyLI78QrE",
    "youtubeId": "H2NyLI78QrE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5519",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 112 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OM0If4ktgUc",
    "youtubeId": "OM0If4ktgUc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5520",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 111 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J0EWGJB_v-k",
    "youtubeId": "J0EWGJB_v-k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5521",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 110 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/md7Ph1qXrLw",
    "youtubeId": "md7Ph1qXrLw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5522",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 109 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4PLoZ8DetkM",
    "youtubeId": "4PLoZ8DetkM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5523",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 108 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lmf1c8PGFMg",
    "youtubeId": "lmf1c8PGFMg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5524",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 107 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ef5fZh1o-gs",
    "youtubeId": "Ef5fZh1o-gs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5525",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 106 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/k1dsx3lLzVY",
    "youtubeId": "k1dsx3lLzVY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5526",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 105 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/C6Fg0pMN8dk",
    "youtubeId": "C6Fg0pMN8dk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5527",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 104 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5_QIudRAMmE",
    "youtubeId": "5_QIudRAMmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5528",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 103 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1jbD-K7jHSA",
    "youtubeId": "1jbD-K7jHSA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5529",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 101 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KbJYo6ubyWo",
    "youtubeId": "KbJYo6ubyWo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5530",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 101 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9wyJycIoBPs",
    "youtubeId": "9wyJycIoBPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5531",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 100 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6E_nXbwz5s8",
    "youtubeId": "6E_nXbwz5s8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5532",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 99 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KjGPeQvUF2k",
    "youtubeId": "KjGPeQvUF2k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5533",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 98 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Jruw9ilHKbQ",
    "youtubeId": "Jruw9ilHKbQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5534",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 97 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OpqKx9c5-I8",
    "youtubeId": "OpqKx9c5-I8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5535",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 96 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bVs-uDQmR78",
    "youtubeId": "bVs-uDQmR78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5536",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 95 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RZYH200hE_M",
    "youtubeId": "RZYH200hE_M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5537",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 94 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9nthMPG9qaw",
    "youtubeId": "9nthMPG9qaw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5538",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 93 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mH9KI2RYg8k",
    "youtubeId": "mH9KI2RYg8k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5539",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 92 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7RLuYsQGbsw",
    "youtubeId": "7RLuYsQGbsw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5540",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 91 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-l2RbRHgIBU",
    "youtubeId": "-l2RbRHgIBU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5541",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 90 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PJqm9_t50_g",
    "youtubeId": "PJqm9_t50_g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5542",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 89 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vn4sy6DcnkQ",
    "youtubeId": "Vn4sy6DcnkQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5543",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 88 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TEQKoAH8TQI",
    "youtubeId": "TEQKoAH8TQI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5544",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 87 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NouYs7dtJCA",
    "youtubeId": "NouYs7dtJCA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5545",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 86 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/avc9kl4U3Yo",
    "youtubeId": "avc9kl4U3Yo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5546",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 85 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ll2DwS2bRAU",
    "youtubeId": "ll2DwS2bRAU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5547",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 84 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BtOPlzrOlBo",
    "youtubeId": "BtOPlzrOlBo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5548",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 83 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T0OUYexb1ak",
    "youtubeId": "T0OUYexb1ak",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5549",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 82 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g6UC17XI1uQ",
    "youtubeId": "g6UC17XI1uQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5550",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 81 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pKwdhN66HW4",
    "youtubeId": "pKwdhN66HW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5551",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 80 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cqje7xlLzPE",
    "youtubeId": "cqje7xlLzPE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5552",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 79 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-oHJ_7dnByo",
    "youtubeId": "-oHJ_7dnByo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5553",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 78 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0RGQ2TIvCjs",
    "youtubeId": "0RGQ2TIvCjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5554",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 77 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FVyaSG34OEc",
    "youtubeId": "FVyaSG34OEc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5555",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 76 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yg3HgpCqu8w",
    "youtubeId": "yg3HgpCqu8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5556",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 75 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xVJWucEiID8",
    "youtubeId": "xVJWucEiID8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5557",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 74 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UnBnUFWehhk",
    "youtubeId": "UnBnUFWehhk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5558",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 73 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tpiy387KQVE",
    "youtubeId": "Tpiy387KQVE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5559",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 72 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bOrXxc0S4XA",
    "youtubeId": "bOrXxc0S4XA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5560",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 71 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IK-zH7fYChg",
    "youtubeId": "IK-zH7fYChg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5561",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 70 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-UCj9rYG0Hs",
    "youtubeId": "-UCj9rYG0Hs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5562",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 69 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wtXtmGjd9w8",
    "youtubeId": "wtXtmGjd9w8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5563",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 68 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4RIebwjG50E",
    "youtubeId": "4RIebwjG50E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5564",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 67 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zXJ4f6GYuCs",
    "youtubeId": "zXJ4f6GYuCs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5565",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 66 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zLHQgc6hTLw",
    "youtubeId": "zLHQgc6hTLw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5566",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 65 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p8iOFtBDaZI",
    "youtubeId": "p8iOFtBDaZI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5567",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 64 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6jkMfqPu-Tc",
    "youtubeId": "6jkMfqPu-Tc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5568",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 63 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vIk1hUvbJAs",
    "youtubeId": "vIk1hUvbJAs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5569",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 62 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l7efCWYvFlE",
    "youtubeId": "l7efCWYvFlE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5570",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 61 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BxnFkidPGTg",
    "youtubeId": "BxnFkidPGTg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5571",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 60 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Tq6MQapMfdY",
    "youtubeId": "Tq6MQapMfdY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5572",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 59 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6SAm8wgyHCE",
    "youtubeId": "6SAm8wgyHCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5573",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 58 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U5-mbEixbh0",
    "youtubeId": "U5-mbEixbh0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5574",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 57 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/py--c82TnkY",
    "youtubeId": "py--c82TnkY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5575",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 56 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Gicx6jS9hRQ",
    "youtubeId": "Gicx6jS9hRQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5576",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 55 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VpVV8-oo4Ck",
    "youtubeId": "VpVV8-oo4Ck",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5577",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 54 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5bPW9d8bTIY",
    "youtubeId": "5bPW9d8bTIY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5578",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 53 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bxmbyYWJqXI",
    "youtubeId": "bxmbyYWJqXI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5579",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 52 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s7-88z5WrDE",
    "youtubeId": "s7-88z5WrDE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5580",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 51 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XIM5l7Ykybs",
    "youtubeId": "XIM5l7Ykybs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5581",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 50 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rIxqnMqUxks",
    "youtubeId": "rIxqnMqUxks",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5582",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 49 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m2NUuS-FMlI",
    "youtubeId": "m2NUuS-FMlI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5583",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 48 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kiaAQiK4i8w",
    "youtubeId": "kiaAQiK4i8w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5584",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 47 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vvp4uDnSZf0",
    "youtubeId": "vvp4uDnSZf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5585",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 46 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/toR8-EetBuA",
    "youtubeId": "toR8-EetBuA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5586",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 45 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IVvcMIVFt8M",
    "youtubeId": "IVvcMIVFt8M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5587",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 44 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dh62t-obzaI",
    "youtubeId": "Dh62t-obzaI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5588",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 43 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pRAV92o7Xj8",
    "youtubeId": "pRAV92o7Xj8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5589",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 42 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bHa3eLbuKQ4",
    "youtubeId": "bHa3eLbuKQ4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5590",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 41 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kEoPzbUh-04",
    "youtubeId": "kEoPzbUh-04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5591",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 40 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Li3EOG2Hu98",
    "youtubeId": "Li3EOG2Hu98",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5592",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 39 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FmfMZgMJG4Y",
    "youtubeId": "FmfMZgMJG4Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5593",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 38 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/imQ4Bqzo8Jo",
    "youtubeId": "imQ4Bqzo8Jo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5594",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 37 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/N5QhLi9U0Bg",
    "youtubeId": "N5QhLi9U0Bg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5595",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 36 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PJm_uP53FZU",
    "youtubeId": "PJm_uP53FZU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5596",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 35 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5m_124m1_F0",
    "youtubeId": "5m_124m1_F0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5597",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 34 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/37WA0WPmtNw",
    "youtubeId": "37WA0WPmtNw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5598",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 33 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gv6FOZZAYNI",
    "youtubeId": "gv6FOZZAYNI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5599",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 32 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xv7Nm5_4AwM",
    "youtubeId": "xv7Nm5_4AwM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5600",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 31 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vn6AlwE0Avo",
    "youtubeId": "vn6AlwE0Avo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5601",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 30 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4afBuegUDdQ",
    "youtubeId": "4afBuegUDdQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5602",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 29 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZY7eYi5xKvI",
    "youtubeId": "ZY7eYi5xKvI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5603",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 28 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xC1eYl3N2-8",
    "youtubeId": "xC1eYl3N2-8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5604",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 27 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n3O1wiHlh_M",
    "youtubeId": "n3O1wiHlh_M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5605",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 26 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DWgTxL_rldM",
    "youtubeId": "DWgTxL_rldM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5606",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 25 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M-LMPJtJtjE",
    "youtubeId": "M-LMPJtJtjE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5607",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 24 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/puEP4nvsl6c",
    "youtubeId": "puEP4nvsl6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5608",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 23 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9FBW_ZYVL_Y",
    "youtubeId": "9FBW_ZYVL_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5609",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 22 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PJir-EEflmE",
    "youtubeId": "PJir-EEflmE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5610",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 21 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pmeJOYDlWXg",
    "youtubeId": "pmeJOYDlWXg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5611",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 20 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7NSmPYhXZtk",
    "youtubeId": "7NSmPYhXZtk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5612",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 19 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ASRC7TwCU_k",
    "youtubeId": "ASRC7TwCU_k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5613",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 18 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3kO4bbFMECg",
    "youtubeId": "3kO4bbFMECg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5614",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 17 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oe-oBk584Fk",
    "youtubeId": "oe-oBk584Fk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5615",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 16 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7myekGD70oc",
    "youtubeId": "7myekGD70oc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5616",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 15 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bcKCD6SoCrA",
    "youtubeId": "bcKCD6SoCrA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5617",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 14 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/66wNg7IID2E",
    "youtubeId": "66wNg7IID2E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5618",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 13 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zk3AfCeVz0g",
    "youtubeId": "zk3AfCeVz0g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5619",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 12 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MgHeUCbTlvs",
    "youtubeId": "MgHeUCbTlvs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5620",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 11 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0VhDqEvAj18",
    "youtubeId": "0VhDqEvAj18",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5621",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 10 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RgzsAXnAunE",
    "youtubeId": "RgzsAXnAunE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5622",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 9 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/32gw0pZ-lPA",
    "youtubeId": "32gw0pZ-lPA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5623",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 8 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zJ2mVOAfsPY",
    "youtubeId": "zJ2mVOAfsPY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5624",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 7 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IjSbmmzbP1g",
    "youtubeId": "IjSbmmzbP1g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5625",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 6 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kukbyg2KQNc",
    "youtubeId": "kukbyg2KQNc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5626",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 5 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_YdS2_dlUA4",
    "youtubeId": "_YdS2_dlUA4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5627",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 4 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1-3zF9aDnX0",
    "youtubeId": "1-3zF9aDnX0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5628",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 3 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BItAJnKl9OA",
    "youtubeId": "BItAJnKl9OA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5629",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 2 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6kjGWBqXmcA",
    "youtubeId": "6kjGWBqXmcA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5630",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 4 Ayat 1 Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V-9AA8ll098",
    "youtubeId": "V-9AA8ll098",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5631",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction Surah Nisa Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1-pUYGW0Rb8",
    "youtubeId": "1-pUYGW0Rb8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5632",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 200 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Krq_aVsu-gE",
    "youtubeId": "Krq_aVsu-gE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5633",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 199 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NmAvcZtXGVg",
    "youtubeId": "NmAvcZtXGVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5634",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 198 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_K0ccjfBclc",
    "youtubeId": "_K0ccjfBclc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5635",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 197 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XryUpvL0A4A",
    "youtubeId": "XryUpvL0A4A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5636",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 196 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7E-wBwZzuE4",
    "youtubeId": "7E-wBwZzuE4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5637",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 195 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/arxNX66zRdU",
    "youtubeId": "arxNX66zRdU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5638",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 194 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nVqVLMDL25E",
    "youtubeId": "nVqVLMDL25E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5639",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 192 193 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eTJXwx2bt04",
    "youtubeId": "eTJXwx2bt04",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5640",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 191 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DIBzmRPRUN8",
    "youtubeId": "DIBzmRPRUN8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5641",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 190 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JXauVlnUT8Y",
    "youtubeId": "JXauVlnUT8Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5642",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 189 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LvTpxLN1NO4",
    "youtubeId": "LvTpxLN1NO4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5643",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 188 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j4QFFbmN-BA",
    "youtubeId": "j4QFFbmN-BA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5644",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 187 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AYTfd4b5maU",
    "youtubeId": "AYTfd4b5maU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5645",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 186 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6M7vv1bh5vs",
    "youtubeId": "6M7vv1bh5vs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5646",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 185 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bfN3ubu484Q",
    "youtubeId": "bfN3ubu484Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5647",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 184 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XusFZMpU1wU",
    "youtubeId": "XusFZMpU1wU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5648",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 183 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1gNlpr-aD0M",
    "youtubeId": "1gNlpr-aD0M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5649",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 182 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MTBWWc_XXNQ",
    "youtubeId": "MTBWWc_XXNQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5650",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 181 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/donI3HvkCJc",
    "youtubeId": "donI3HvkCJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5651",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 180 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GIPHKcyg8Qo",
    "youtubeId": "GIPHKcyg8Qo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5652",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 179 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nineOd9DuAk",
    "youtubeId": "nineOd9DuAk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5653",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 178 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4oxnpQQ8pwA",
    "youtubeId": "4oxnpQQ8pwA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5654",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 177 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/keAdBQ0SAPw",
    "youtubeId": "keAdBQ0SAPw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5655",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 176 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8zHdI8cMd2M",
    "youtubeId": "8zHdI8cMd2M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5656",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 175 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hSP4QhlpfPE",
    "youtubeId": "hSP4QhlpfPE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5657",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 174 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/q4e6eK7BemA",
    "youtubeId": "q4e6eK7BemA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5658",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 173 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EK7DyR0dHyQ",
    "youtubeId": "EK7DyR0dHyQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5659",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 172 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YHlnX8IE9ro",
    "youtubeId": "YHlnX8IE9ro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5660",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 171 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2HKNtgCLXjQ",
    "youtubeId": "2HKNtgCLXjQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5661",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 170 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4Xyg5lvozH8",
    "youtubeId": "4Xyg5lvozH8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5662",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 169 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d3oAnEpb63c",
    "youtubeId": "d3oAnEpb63c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5663",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 168 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mH2Gj0DjJyg",
    "youtubeId": "mH2Gj0DjJyg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5664",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 167 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/a-7ePOk6DOE",
    "youtubeId": "a-7ePOk6DOE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5665",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 166 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OSuL_D6YDPY",
    "youtubeId": "OSuL_D6YDPY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5666",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 165 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/K3VzbkNelr0",
    "youtubeId": "K3VzbkNelr0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5667",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 164 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h0xuQ9DVjMY",
    "youtubeId": "h0xuQ9DVjMY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5668",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 163 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mKo4GOXrpz0",
    "youtubeId": "mKo4GOXrpz0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5669",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 162 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RtkGiqsFCi0",
    "youtubeId": "RtkGiqsFCi0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5670",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 161 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2D5htyIL0ps",
    "youtubeId": "2D5htyIL0ps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5671",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 160 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DAcsX9e09PE",
    "youtubeId": "DAcsX9e09PE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5672",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 159 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tRna4d3Zb9M",
    "youtubeId": "tRna4d3Zb9M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5673",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 158 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M6AX2BlwNZ0",
    "youtubeId": "M6AX2BlwNZ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5674",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 157 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FzoJ9kGO1dc",
    "youtubeId": "FzoJ9kGO1dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5675",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 156 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gIMFfNmfnCA",
    "youtubeId": "gIMFfNmfnCA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5676",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 155 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0Go0nrO26dc",
    "youtubeId": "0Go0nrO26dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5677",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 154 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pMn210duXbM",
    "youtubeId": "pMn210duXbM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5678",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 153 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vTDG5xBcAQY",
    "youtubeId": "vTDG5xBcAQY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5679",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 152 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sToGb0VDeKc",
    "youtubeId": "sToGb0VDeKc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5680",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 151 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EZZHUZQ8TDA",
    "youtubeId": "EZZHUZQ8TDA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5681",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 150 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YG-iNE4Jmew",
    "youtubeId": "YG-iNE4Jmew",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5682",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 149 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vDCO_RWRelI",
    "youtubeId": "vDCO_RWRelI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5683",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 148 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Uu5jtMG80TQ",
    "youtubeId": "Uu5jtMG80TQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5684",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 147 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JP1cTqARhdY",
    "youtubeId": "JP1cTqARhdY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5685",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 146 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FJvsLYQsGrY",
    "youtubeId": "FJvsLYQsGrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5686",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 145 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-CL-AJ6OrCw",
    "youtubeId": "-CL-AJ6OrCw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5687",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 144 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eeCdYkGH97Q",
    "youtubeId": "eeCdYkGH97Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5688",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 143 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3tBmQUFMwN0",
    "youtubeId": "3tBmQUFMwN0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5689",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 142 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2WHfcUYQQ8Q",
    "youtubeId": "2WHfcUYQQ8Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5690",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 141 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2YzmkWFY7H8",
    "youtubeId": "2YzmkWFY7H8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5691",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 140 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1wjSX1J4yII",
    "youtubeId": "1wjSX1J4yII",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5692",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 139 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dj9sCNclW6k",
    "youtubeId": "dj9sCNclW6k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5693",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 138 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ygN5wYkihPs",
    "youtubeId": "ygN5wYkihPs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5694",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 137 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GcwVj-7HC7U",
    "youtubeId": "GcwVj-7HC7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5695",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 136 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/U7BIQmcEp0s",
    "youtubeId": "U7BIQmcEp0s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5696",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 135 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jg8K0J7Lo6Y",
    "youtubeId": "jg8K0J7Lo6Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5697",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 134 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TNbKuYRKC2U",
    "youtubeId": "TNbKuYRKC2U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5698",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 133 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gt3KYy2taFA",
    "youtubeId": "gt3KYy2taFA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5699",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 132 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sqrR9nzrszw",
    "youtubeId": "sqrR9nzrszw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5700",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 131 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pa4C5dLCigo",
    "youtubeId": "pa4C5dLCigo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5701",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 130 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/buccXsSmmtM",
    "youtubeId": "buccXsSmmtM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5702",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 129 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gxJl53nz59g",
    "youtubeId": "gxJl53nz59g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5703",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 128 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lTESvHH21dE",
    "youtubeId": "lTESvHH21dE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5704",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 127 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0GkWGEVRTbo",
    "youtubeId": "0GkWGEVRTbo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5705",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 126 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cebIF61Wacw",
    "youtubeId": "cebIF61Wacw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5706",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 125 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WHE1WYko6T4",
    "youtubeId": "WHE1WYko6T4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5707",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 124 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YYhNqLV6a1c",
    "youtubeId": "YYhNqLV6a1c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5708",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 123 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7F4UFzefNsU",
    "youtubeId": "7F4UFzefNsU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5709",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 122 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YI5Zn2qpiQQ",
    "youtubeId": "YI5Zn2qpiQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5710",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 121 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3m5KDGW3qLk",
    "youtubeId": "3m5KDGW3qLk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5711",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 120 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZdEuE2raM7U",
    "youtubeId": "ZdEuE2raM7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5712",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 119 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yXZPIWXkMcU",
    "youtubeId": "yXZPIWXkMcU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5713",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 118 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/n0QwyzM2GFo",
    "youtubeId": "n0QwyzM2GFo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5714",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 117 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9spX6Jzi-PQ",
    "youtubeId": "9spX6Jzi-PQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5715",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 116 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nAZJATu9GhU",
    "youtubeId": "nAZJATu9GhU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5716",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 115 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vjgZSSqB_kg",
    "youtubeId": "vjgZSSqB_kg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5717",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 114 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ChLhte84RTA",
    "youtubeId": "ChLhte84RTA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5718",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 113 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VcUpiaWfWuI",
    "youtubeId": "VcUpiaWfWuI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5719",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 112 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E9zjOSxDLHo",
    "youtubeId": "E9zjOSxDLHo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5720",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 111 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bxLJepOa-OU",
    "youtubeId": "bxLJepOa-OU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5721",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 110 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W6ZpfEbW8_Y",
    "youtubeId": "W6ZpfEbW8_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5722",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 109 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tp7iImHQP00",
    "youtubeId": "tp7iImHQP00",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5723",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 108 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6RWUf7VSOlk",
    "youtubeId": "6RWUf7VSOlk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5724",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 107 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yk_C6GunDrc",
    "youtubeId": "yk_C6GunDrc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5725",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 106 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P_rAq23NaYY",
    "youtubeId": "P_rAq23NaYY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5726",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 105 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MpBNBBAjpPg",
    "youtubeId": "MpBNBBAjpPg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5727",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 104 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w4R7yjPHKhY",
    "youtubeId": "w4R7yjPHKhY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5728",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 103 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jyzJSU1wq1U",
    "youtubeId": "jyzJSU1wq1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5729",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 102 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L6JwiejniY0",
    "youtubeId": "L6JwiejniY0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5730",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 101 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pDvTu_Trltw",
    "youtubeId": "pDvTu_Trltw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5731",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 100 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Qv7xbHTtIf0",
    "youtubeId": "Qv7xbHTtIf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5732",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 99 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dzHThaqogs8",
    "youtubeId": "dzHThaqogs8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5733",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 98 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IMGSoqzVYCY",
    "youtubeId": "IMGSoqzVYCY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5734",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 97 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EsxrISl5D4Y",
    "youtubeId": "EsxrISl5D4Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5735",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 96 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nBmOP7W5eZY",
    "youtubeId": "nBmOP7W5eZY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5736",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 95 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yuSug0L_ypE",
    "youtubeId": "yuSug0L_ypE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5737",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 94 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AqfL-rg4r4E",
    "youtubeId": "AqfL-rg4r4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5738",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 93 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M6IswXyErsg",
    "youtubeId": "M6IswXyErsg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5739",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 92 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/733ML-5xWzQ",
    "youtubeId": "733ML-5xWzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5740",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 91 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8c53SMRdk2I",
    "youtubeId": "8c53SMRdk2I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5741",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 90 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_-ew3tqYYik",
    "youtubeId": "_-ew3tqYYik",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5742",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 89 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eXhGIdgsUzQ",
    "youtubeId": "eXhGIdgsUzQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5743",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 88 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zCyqw-9kk2w",
    "youtubeId": "zCyqw-9kk2w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5744",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 87 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/npVWM7JhXNw",
    "youtubeId": "npVWM7JhXNw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5745",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 86 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AuFH8EwInU8",
    "youtubeId": "AuFH8EwInU8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5746",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 85 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ET6-YvWKj2k",
    "youtubeId": "ET6-YvWKj2k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5747",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 84 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w3q0TbvsyiE",
    "youtubeId": "w3q0TbvsyiE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5748",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 83 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/r-HqlhbVcuI",
    "youtubeId": "r-HqlhbVcuI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5749",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 82 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b-bQnCdU3z8",
    "youtubeId": "b-bQnCdU3z8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5750",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 81 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W98fx_o8HUY",
    "youtubeId": "W98fx_o8HUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5751",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 80 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TfYeIezA4hM",
    "youtubeId": "TfYeIezA4hM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5752",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 79 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7T1u9G5Huek",
    "youtubeId": "7T1u9G5Huek",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5753",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 78 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3ItmX6GZvJQ",
    "youtubeId": "3ItmX6GZvJQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5754",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 77 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GgPq1c95iwc",
    "youtubeId": "GgPq1c95iwc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5755",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 76 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XN-SQxslqX8",
    "youtubeId": "XN-SQxslqX8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5756",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 75 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y_tdZhMZY-I",
    "youtubeId": "y_tdZhMZY-I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5757",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 74 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jpT7BtzUTFo",
    "youtubeId": "jpT7BtzUTFo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5758",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 73 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/d9SUBkWb--Y",
    "youtubeId": "d9SUBkWb--Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5759",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 72 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fk4r1XaJDGE",
    "youtubeId": "fk4r1XaJDGE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5760",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 71 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pLYpx4w7e4o",
    "youtubeId": "pLYpx4w7e4o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5761",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 70 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gF6dZFXI5iw",
    "youtubeId": "gF6dZFXI5iw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5762",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 69 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kdz32_6Ehb8",
    "youtubeId": "kdz32_6Ehb8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5763",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 68 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FSjC8Y-yioY",
    "youtubeId": "FSjC8Y-yioY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5764",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 67 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TQecWrTxXxs",
    "youtubeId": "TQecWrTxXxs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5765",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 66 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/38pA_XVSEhI",
    "youtubeId": "38pA_XVSEhI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5766",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 65 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VNh8opkfNz8",
    "youtubeId": "VNh8opkfNz8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5767",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 64 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CiXuq8mYZUY",
    "youtubeId": "CiXuq8mYZUY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5768",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 63 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tGUAhJCDTig",
    "youtubeId": "tGUAhJCDTig",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5769",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 62 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PlHs70zijvE",
    "youtubeId": "PlHs70zijvE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5770",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 61 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8R0gmFstWws",
    "youtubeId": "8R0gmFstWws",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5771",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 60 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4QZGXtfy9UY",
    "youtubeId": "4QZGXtfy9UY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5772",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 59 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Knvy7wV8njY",
    "youtubeId": "Knvy7wV8njY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5773",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 58 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g_QGBymUF78",
    "youtubeId": "g_QGBymUF78",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5774",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 57 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TZdgdF4qRhI",
    "youtubeId": "TZdgdF4qRhI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5775",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 56 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1jKIBf7_8AU",
    "youtubeId": "1jKIBf7_8AU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5776",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 55 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bcXZU2XKE7M",
    "youtubeId": "bcXZU2XKE7M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5777",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 54 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o1WC6CE959Q",
    "youtubeId": "o1WC6CE959Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5778",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 53 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5ZwTLbMnqro",
    "youtubeId": "5ZwTLbMnqro",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5779",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 52 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/23eX4sW3vWc",
    "youtubeId": "23eX4sW3vWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5780",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 51 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ok2ZxwU0gjw",
    "youtubeId": "ok2ZxwU0gjw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5781",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 50 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nUvBp6AndD0",
    "youtubeId": "nUvBp6AndD0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5782",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 49 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S-tkQMvaRsg",
    "youtubeId": "S-tkQMvaRsg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5783",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 48 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KB5Zf4koJs4",
    "youtubeId": "KB5Zf4koJs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5784",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 47 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Chp6QX4TPeY",
    "youtubeId": "Chp6QX4TPeY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5785",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 46 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Bo0KOm4aNf0",
    "youtubeId": "Bo0KOm4aNf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5786",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 45 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Om4drsJb31s",
    "youtubeId": "Om4drsJb31s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5787",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 44 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5hRZi-Maq5o",
    "youtubeId": "5hRZi-Maq5o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5788",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 43 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t2NsfsZrPZQ",
    "youtubeId": "t2NsfsZrPZQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5789",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 42 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QiCzMQ4R3No",
    "youtubeId": "QiCzMQ4R3No",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5790",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 41 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LvtG1Y0bTTo",
    "youtubeId": "LvtG1Y0bTTo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5791",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 40 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/X8cYUDA85p8",
    "youtubeId": "X8cYUDA85p8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5792",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 39 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q2Ac3dgBjBI",
    "youtubeId": "Q2Ac3dgBjBI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5793",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 38 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mlezgd7nhNY",
    "youtubeId": "Mlezgd7nhNY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5794",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 37 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eZXwahsOMrY",
    "youtubeId": "eZXwahsOMrY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5795",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 36 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g-w2PsNSAas",
    "youtubeId": "g-w2PsNSAas",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5796",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 35 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dPi4Cxzquv0",
    "youtubeId": "dPi4Cxzquv0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5797",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 34 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AMJk5VTRWa8",
    "youtubeId": "AMJk5VTRWa8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5798",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 33 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UwiUvS78dwU",
    "youtubeId": "UwiUvS78dwU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5799",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 32 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/cMsW2tPYLb8",
    "youtubeId": "cMsW2tPYLb8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5800",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 31 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/et-ZGyyU4PM",
    "youtubeId": "et-ZGyyU4PM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5801",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 30 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MNQ4iWODEWc",
    "youtubeId": "MNQ4iWODEWc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5802",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 29 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-d4FJEDW5PY",
    "youtubeId": "-d4FJEDW5PY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5803",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 28 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J4VWzMkCbno",
    "youtubeId": "J4VWzMkCbno",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5804",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 27 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uLc6oEtJYFI",
    "youtubeId": "uLc6oEtJYFI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5805",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 26 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gUykwF_IdjE",
    "youtubeId": "gUykwF_IdjE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5806",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 25 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nfLU-n_acYc",
    "youtubeId": "nfLU-n_acYc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5807",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 24 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hp13ow0-4rg",
    "youtubeId": "hp13ow0-4rg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5808",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 23 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/zO5ygR7R0kE",
    "youtubeId": "zO5ygR7R0kE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5809",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 22 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GKf2YblL6tM",
    "youtubeId": "GKf2YblL6tM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5810",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 21 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KeTQ2oY2Xz0",
    "youtubeId": "KeTQ2oY2Xz0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5811",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 20 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NXbHdAUYdTc",
    "youtubeId": "NXbHdAUYdTc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5812",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 19 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ztf-tJLCd8E",
    "youtubeId": "Ztf-tJLCd8E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5813",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 18 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aTKCAg3pwzI",
    "youtubeId": "aTKCAg3pwzI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5814",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 17 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vezpNptaMx4",
    "youtubeId": "vezpNptaMx4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5815",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 16 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/uXt__fzsPhg",
    "youtubeId": "uXt__fzsPhg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5816",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 15 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b2_0byH6K-Q",
    "youtubeId": "b2_0byH6K-Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5817",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 14 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g31NAl27piw",
    "youtubeId": "g31NAl27piw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5818",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 13 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ql5ZoIRHVNQ",
    "youtubeId": "ql5ZoIRHVNQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5819",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 12 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LwEsTv336Dc",
    "youtubeId": "LwEsTv336Dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5820",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 11 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EfiVBIMrjGE",
    "youtubeId": "EfiVBIMrjGE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5821",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 10 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9YUq-gxdGd4",
    "youtubeId": "9YUq-gxdGd4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5822",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 9 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7ZaF3rhoKPA",
    "youtubeId": "7ZaF3rhoKPA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5823",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 8 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Im0jKS1-QjQ",
    "youtubeId": "Im0jKS1-QjQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5824",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 7 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vu2qXJ_BLYk",
    "youtubeId": "vu2qXJ_BLYk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5825",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 6 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M2Yvfy62rZw",
    "youtubeId": "M2Yvfy62rZw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5826",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 5 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/viaXDBlxFA8",
    "youtubeId": "viaXDBlxFA8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5827",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 3 & 4 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/08hkp9XyONU",
    "youtubeId": "08hkp9XyONU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5828",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 3 Ayat 1 2 Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Vh52QBVk1m0",
    "youtubeId": "Vh52QBVk1m0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5829",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Introduction Surah Aale Imran Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JfuyKlOItYs",
    "youtubeId": "JfuyKlOItYs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5830",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 286 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mj4r-IdbbLM",
    "youtubeId": "Mj4r-IdbbLM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5831",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 285 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nBYihG_VZms",
    "youtubeId": "nBYihG_VZms",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5832",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 284 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TqGp6nB9SaM",
    "youtubeId": "TqGp6nB9SaM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5833",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 283 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BVhM-KjWpo4",
    "youtubeId": "BVhM-KjWpo4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5834",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 282 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SPme1CBLqHo",
    "youtubeId": "SPme1CBLqHo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5835",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 281 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qk2kheSMb_0",
    "youtubeId": "qk2kheSMb_0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5836",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 280 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qtY4cp_dMXA",
    "youtubeId": "qtY4cp_dMXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5837",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 279 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WgbNhtfqQC0",
    "youtubeId": "WgbNhtfqQC0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5838",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 278 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g5yYbl5UOs4",
    "youtubeId": "g5yYbl5UOs4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5839",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 277 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7wgZs1oMurg",
    "youtubeId": "7wgZs1oMurg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5840",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 276 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iL9S7i9PhVc",
    "youtubeId": "iL9S7i9PhVc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5841",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 275 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Dndnvp33rps",
    "youtubeId": "Dndnvp33rps",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5842",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 274 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/V2a9usqnsLU",
    "youtubeId": "V2a9usqnsLU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5843",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 273 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CMT2g8zx1ow",
    "youtubeId": "CMT2g8zx1ow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5844",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 272 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H07yTHREPKg",
    "youtubeId": "H07yTHREPKg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5845",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 271 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lXNc3hrAw_Q",
    "youtubeId": "lXNc3hrAw_Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5846",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 270 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XQK68yOWIes",
    "youtubeId": "XQK68yOWIes",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5847",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 269 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/D1EWo4hROpU",
    "youtubeId": "D1EWo4hROpU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5848",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 268 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7XTAKshee3g",
    "youtubeId": "7XTAKshee3g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5849",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 267 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UVmmtU6-95g",
    "youtubeId": "UVmmtU6-95g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5850",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 266 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UEZlFxZfGy4",
    "youtubeId": "UEZlFxZfGy4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5851",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 265 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OlEljVqhdEU",
    "youtubeId": "OlEljVqhdEU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5852",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 264 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F_d760qop4U",
    "youtubeId": "F_d760qop4U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5853",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 263 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aM-VaBFupLI",
    "youtubeId": "aM-VaBFupLI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5854",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 262 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mjgk5IY9Jec",
    "youtubeId": "mjgk5IY9Jec",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5855",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 261 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OGc0-3ejR6A",
    "youtubeId": "OGc0-3ejR6A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5856",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 260 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3WFLe2NHK-Q",
    "youtubeId": "3WFLe2NHK-Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5857",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 259 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3oTVKdzoVGk",
    "youtubeId": "3oTVKdzoVGk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5858",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 258 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JUa6uPfzOhQ",
    "youtubeId": "JUa6uPfzOhQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5859",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 257 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6fRpbLq6-i0",
    "youtubeId": "6fRpbLq6-i0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5860",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 256 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4I_w_CUMEb0",
    "youtubeId": "4I_w_CUMEb0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5861",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 255 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HQaWN0a72gg",
    "youtubeId": "HQaWN0a72gg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5862",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 254 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H_CumHVy3bo",
    "youtubeId": "H_CumHVy3bo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5863",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 253 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nU9rHKYUWVg",
    "youtubeId": "nU9rHKYUWVg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5864",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 252 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TYNUnTsYP4I",
    "youtubeId": "TYNUnTsYP4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5865",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 251 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZQFsXRfn8nU",
    "youtubeId": "ZQFsXRfn8nU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5866",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 250 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CnD5Nesa-tw",
    "youtubeId": "CnD5Nesa-tw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5867",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 249 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/b571Xg3Lktw",
    "youtubeId": "b571Xg3Lktw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5868",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 248 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LMvagLS0qs8",
    "youtubeId": "LMvagLS0qs8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5869",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 247 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xpmTaFX78Gc",
    "youtubeId": "xpmTaFX78Gc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5870",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 246 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ptqD1DlfafY",
    "youtubeId": "ptqD1DlfafY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5871",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 245 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jAKXjRtBn1s",
    "youtubeId": "jAKXjRtBn1s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5872",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 244 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ymr06sCbDkY",
    "youtubeId": "Ymr06sCbDkY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5873",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 243 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mXPkUMeZl9o",
    "youtubeId": "mXPkUMeZl9o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5874",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 242 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Lk-znv9BS9k",
    "youtubeId": "Lk-znv9BS9k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5875",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 241 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Nh6ZDsoqzM8",
    "youtubeId": "Nh6ZDsoqzM8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5876",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 240 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RSqtQgHKI1M",
    "youtubeId": "RSqtQgHKI1M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5877",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 239 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NeO1QpcDBqk",
    "youtubeId": "NeO1QpcDBqk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5878",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 238 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YiWmDvQu4dc",
    "youtubeId": "YiWmDvQu4dc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5879",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 237 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rRD0Ye6Njbo",
    "youtubeId": "rRD0Ye6Njbo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5880",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 236 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wySP_SZwPx4",
    "youtubeId": "wySP_SZwPx4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5881",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 235 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rUf1slRXF9U",
    "youtubeId": "rUf1slRXF9U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5882",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 234 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aiOs4XwieA0",
    "youtubeId": "aiOs4XwieA0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5883",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 233 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6p_2qcn8oVU",
    "youtubeId": "6p_2qcn8oVU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5884",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 232 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GzXIbTbPw5Y",
    "youtubeId": "GzXIbTbPw5Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5885",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 231 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oZaBdNwHwm4",
    "youtubeId": "oZaBdNwHwm4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5886",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 230 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lhooIyWEqXc",
    "youtubeId": "lhooIyWEqXc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5887",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 229 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oOkjrjFNfZw",
    "youtubeId": "oOkjrjFNfZw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5888",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 228 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/s0SePFUnBa8",
    "youtubeId": "s0SePFUnBa8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5889",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 227 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h8xYvmKU2Ow",
    "youtubeId": "h8xYvmKU2Ow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5890",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 226 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FT3QPRf72kw",
    "youtubeId": "FT3QPRf72kw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5891",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 225 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/kvvNB--lbW4",
    "youtubeId": "kvvNB--lbW4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5892",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 224 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fyf_-ccn0tk",
    "youtubeId": "Fyf_-ccn0tk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5893",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 223 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9IDTR7odaOk",
    "youtubeId": "9IDTR7odaOk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5894",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 222 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iakFcdMFJlA",
    "youtubeId": "iakFcdMFJlA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5895",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 221 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TXXMxRTzFpE",
    "youtubeId": "TXXMxRTzFpE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5896",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 220 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vVUfmndYJdk",
    "youtubeId": "vVUfmndYJdk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5897",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 219 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oe8qx54CQoE",
    "youtubeId": "oe8qx54CQoE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5898",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 218 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vFhMGec8Eb4",
    "youtubeId": "vFhMGec8Eb4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5899",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 217 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/aiaaqoiCOvU",
    "youtubeId": "aiaaqoiCOvU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5900",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 216 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tnd2YhbM6WA",
    "youtubeId": "tnd2YhbM6WA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5901",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 215 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MKQnXZWgTmc",
    "youtubeId": "MKQnXZWgTmc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5902",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 214 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5Wqmjixir6E",
    "youtubeId": "5Wqmjixir6E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5903",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 213 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MaxMlK5DqFs",
    "youtubeId": "MaxMlK5DqFs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5904",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 212 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9o5QVESFi6k",
    "youtubeId": "9o5QVESFi6k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5905",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 211 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/S2q8JDcZzQU",
    "youtubeId": "S2q8JDcZzQU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5906",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 210 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/j0Ami6xZcD8",
    "youtubeId": "j0Ami6xZcD8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5907",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 209 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/J8nsE5EbWvw",
    "youtubeId": "J8nsE5EbWvw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5908",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 208 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Zmo5hShWznw",
    "youtubeId": "Zmo5hShWznw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5909",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 207 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/H_A8BgYQnz4",
    "youtubeId": "H_A8BgYQnz4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5910",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 206 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pmudjUQyERs",
    "youtubeId": "pmudjUQyERs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5911",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 205 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/W_qxiPBhxU0",
    "youtubeId": "W_qxiPBhxU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5912",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 204 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/01DmDFvpWuw",
    "youtubeId": "01DmDFvpWuw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5913",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 203 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xSW7yd2hyJc",
    "youtubeId": "xSW7yd2hyJc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5914",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 202 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DsKs3k8ik2s",
    "youtubeId": "DsKs3k8ik2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5915",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 201 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/crg7FGyX64w",
    "youtubeId": "crg7FGyX64w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5916",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 200 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6fe1J8wuDFI",
    "youtubeId": "6fe1J8wuDFI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5917",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 199 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-oEr1dy901g",
    "youtubeId": "-oEr1dy901g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5918",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 198 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y_iiyLpjsw8",
    "youtubeId": "Y_iiyLpjsw8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5919",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 197 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lRYq4skEHXg",
    "youtubeId": "lRYq4skEHXg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5920",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 196 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PErP-kfycVU",
    "youtubeId": "PErP-kfycVU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5921",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 195 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/avyctuPzSAQ",
    "youtubeId": "avyctuPzSAQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5922",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 194 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/c7Yvi3aNSLY",
    "youtubeId": "c7Yvi3aNSLY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5923",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 193 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8N6rGJ6wr4w",
    "youtubeId": "8N6rGJ6wr4w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5924",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 192 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YiHl9VwE_dk",
    "youtubeId": "YiHl9VwE_dk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5925",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 191 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/SdryyjPLixE",
    "youtubeId": "SdryyjPLixE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5926",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 190 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RHO_rwxvPh8",
    "youtubeId": "RHO_rwxvPh8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5927",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 189 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mRtDi2kHtw8",
    "youtubeId": "mRtDi2kHtw8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5928",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 188 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ALYGccC862M",
    "youtubeId": "ALYGccC862M",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5929",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 187 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/F-n8ry_GZwM",
    "youtubeId": "F-n8ry_GZwM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5930",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 186 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0jqiKT2yXQA",
    "youtubeId": "0jqiKT2yXQA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5931",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 185 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5tG4yVZcdow",
    "youtubeId": "5tG4yVZcdow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5932",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 184 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/O_rMyJ_RDr4",
    "youtubeId": "O_rMyJ_RDr4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5933",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 183 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/p3JD3AYwYJk",
    "youtubeId": "p3JD3AYwYJk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5934",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 182 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YcT3nqPsnQs",
    "youtubeId": "YcT3nqPsnQs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5935",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 181 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AuBAwWMWoS0",
    "youtubeId": "AuBAwWMWoS0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5936",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 180 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/llG0s8PfP2g",
    "youtubeId": "llG0s8PfP2g",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5937",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 179 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WCBGgN_npHg",
    "youtubeId": "WCBGgN_npHg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5938",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 178 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BNsBOlq3jq8",
    "youtubeId": "BNsBOlq3jq8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5939",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 177 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XWtV3Fcheis",
    "youtubeId": "XWtV3Fcheis",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5940",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 176 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vdKXAUMQ-Pk",
    "youtubeId": "vdKXAUMQ-Pk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5941",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 175 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m6QLRwETJpI",
    "youtubeId": "m6QLRwETJpI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5942",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 174 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UJsTdG9t1m8",
    "youtubeId": "UJsTdG9t1m8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5943",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 173 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lS_v3rZcktw",
    "youtubeId": "lS_v3rZcktw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5944",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 172 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Mu281q3FAHM",
    "youtubeId": "Mu281q3FAHM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5945",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 171 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tcq_dIdom5k",
    "youtubeId": "tcq_dIdom5k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5946",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 170 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pfsnf9wSVvE",
    "youtubeId": "pfsnf9wSVvE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5947",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 169 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/o_vwtfe1Kzk",
    "youtubeId": "o_vwtfe1Kzk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5948",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 168 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/96Blw19Onwg",
    "youtubeId": "96Blw19Onwg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5949",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 167 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MDnOVPcq60o",
    "youtubeId": "MDnOVPcq60o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5950",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 166 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ijhE4alOO24",
    "youtubeId": "ijhE4alOO24",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5951",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 165 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0crr8hZ2a6s",
    "youtubeId": "0crr8hZ2a6s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5952",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 164 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LUeZoT1G-QQ",
    "youtubeId": "LUeZoT1G-QQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5953",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 163 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qAIxOCofq5A",
    "youtubeId": "qAIxOCofq5A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5954",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 162 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/h18XI1muvJ8",
    "youtubeId": "h18XI1muvJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5955",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 161 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BLIdrGqMts8",
    "youtubeId": "BLIdrGqMts8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5956",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 160 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iXXBfwgt46E",
    "youtubeId": "iXXBfwgt46E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5957",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 159 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/At8hOdUSQNY",
    "youtubeId": "At8hOdUSQNY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5958",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 158 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9Ae3vFnqe84",
    "youtubeId": "9Ae3vFnqe84",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5959",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 157 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/0QFwo-61nCE",
    "youtubeId": "0QFwo-61nCE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5960",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 156 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ss24925SSwQ",
    "youtubeId": "ss24925SSwQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5961",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 155 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jGitTj0jnTM",
    "youtubeId": "jGitTj0jnTM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5962",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 154 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/DRfRxEBVb1Q",
    "youtubeId": "DRfRxEBVb1Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5963",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 153 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4Hmozht6gM4",
    "youtubeId": "4Hmozht6gM4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5964",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 152 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/M4Si_r8H0gI",
    "youtubeId": "M4Si_r8H0gI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5965",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 151 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tvAWkc3L0O0",
    "youtubeId": "tvAWkc3L0O0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5966",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 150 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4uo71sCb0WI",
    "youtubeId": "4uo71sCb0WI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5967",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 148 149 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_m_bSC5jh3k",
    "youtubeId": "_m_bSC5jh3k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5968",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 147 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4f6E4EaT0jg",
    "youtubeId": "4f6E4EaT0jg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5969",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 146 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yims6-pV4zg",
    "youtubeId": "yims6-pV4zg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5970",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 145 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ch4uOHdspQc",
    "youtubeId": "Ch4uOHdspQc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5971",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 144 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HJieKeM3hcE",
    "youtubeId": "HJieKeM3hcE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5972",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 143 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lZoznkGl_WI",
    "youtubeId": "lZoznkGl_WI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5973",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 142 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jLn82XOD6OU",
    "youtubeId": "jLn82XOD6OU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5974",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 141 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wDit4OZu72s",
    "youtubeId": "wDit4OZu72s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5975",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 140 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KOmzvsugcqE",
    "youtubeId": "KOmzvsugcqE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5976",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 139 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HdAaoMbrFb0",
    "youtubeId": "HdAaoMbrFb0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5977",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 138 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/WqPQS8vWPQQ",
    "youtubeId": "WqPQS8vWPQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5978",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 137 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dtBus73bKFA",
    "youtubeId": "dtBus73bKFA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5979",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 136 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6RvU8p28l0Y",
    "youtubeId": "6RvU8p28l0Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5980",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 135 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/etJnVogu_vM",
    "youtubeId": "etJnVogu_vM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5981",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 134 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_DeHQHc1miQ",
    "youtubeId": "_DeHQHc1miQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5982",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 133 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hXcli63iRJE",
    "youtubeId": "hXcli63iRJE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5983",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 132 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BykB6pixXE4",
    "youtubeId": "BykB6pixXE4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5984",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 131 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5DIczYr6d9Q",
    "youtubeId": "5DIczYr6d9Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5985",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 130 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wFxmY8hIfXY",
    "youtubeId": "wFxmY8hIfXY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5986",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 129 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jdCZ3EFoz4I",
    "youtubeId": "jdCZ3EFoz4I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5987",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 128 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/653CuifwhjQ",
    "youtubeId": "653CuifwhjQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5988",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 127 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VkUFO4AZtq8",
    "youtubeId": "VkUFO4AZtq8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5989",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 126 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/R_8H8AS0k58",
    "youtubeId": "R_8H8AS0k58",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5990",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 125 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/JunQgN8EP1w",
    "youtubeId": "JunQgN8EP1w",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5991",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 124 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/9vqqy-M_M4E",
    "youtubeId": "9vqqy-M_M4E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5992",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 123 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/VCrdQuYRkBI",
    "youtubeId": "VCrdQuYRkBI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5993",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 122 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/GVZZejbZEF0",
    "youtubeId": "GVZZejbZEF0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5994",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 121 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7LqRQ2iRf9c",
    "youtubeId": "7LqRQ2iRf9c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5995",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 120 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q79PekG-uDc",
    "youtubeId": "Q79PekG-uDc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5996",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 119 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/arRCrx09PjU",
    "youtubeId": "arRCrx09PjU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5997",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 118 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Csmjy9VEySU",
    "youtubeId": "Csmjy9VEySU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5998",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 117 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/RhVHen0dtKE",
    "youtubeId": "RhVHen0dtKE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-5999",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 116 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7wiz1Z8c540",
    "youtubeId": "7wiz1Z8c540",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6000",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 115 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_Y32zH_S5gk",
    "youtubeId": "_Y32zH_S5gk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6001",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 114 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vj__3uv-nD0",
    "youtubeId": "vj__3uv-nD0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6002",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 113 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/AfbnNR7pcXA",
    "youtubeId": "AfbnNR7pcXA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6003",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 112 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4DB-Lai7HS0",
    "youtubeId": "4DB-Lai7HS0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6004",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 111 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vTbOKE0BTPM",
    "youtubeId": "vTbOKE0BTPM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6005",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 110 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YyJzSDz-Yf0",
    "youtubeId": "YyJzSDz-Yf0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6006",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 109 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/EBansAa0-VU",
    "youtubeId": "EBansAa0-VU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6007",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 108 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MoDQs8IthsU",
    "youtubeId": "MoDQs8IthsU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6008",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 107 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bF5eaTT6ozs",
    "youtubeId": "bF5eaTT6ozs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6009",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 106 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/oaNscGZoYqM",
    "youtubeId": "oaNscGZoYqM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6010",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 105 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/LhSWTg9Y3_Y",
    "youtubeId": "LhSWTg9Y3_Y",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6011",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 104 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/E4H4GwJDxcA",
    "youtubeId": "E4H4GwJDxcA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6012",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 103 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/FiCzKo5BOB8",
    "youtubeId": "FiCzKo5BOB8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6013",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 102 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ATOC2Z3Bi6o",
    "youtubeId": "ATOC2Z3Bi6o",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6014",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 101 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZzhI2BxwrEo",
    "youtubeId": "ZzhI2BxwrEo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6015",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 100 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/KjMYoYEqht4",
    "youtubeId": "KjMYoYEqht4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6016",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 99 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PpXty0YREIo",
    "youtubeId": "PpXty0YREIo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6017",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 98 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/4Yc-0ct-PJ8",
    "youtubeId": "4Yc-0ct-PJ8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6018",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 97 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UBwis-N5E1A",
    "youtubeId": "UBwis-N5E1A",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6019",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 96 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/eJJpEy9F8Ss",
    "youtubeId": "eJJpEy9F8Ss",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6020",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 95 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_j9QnHKvFQQ",
    "youtubeId": "_j9QnHKvFQQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6021",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 94 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_uVtbdK0QyU",
    "youtubeId": "_uVtbdK0QyU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6022",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 93 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-HzZLctOddA",
    "youtubeId": "-HzZLctOddA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6023",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 92 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YbHdytsKhng",
    "youtubeId": "YbHdytsKhng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6024",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 91 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1rfd08zEIr4",
    "youtubeId": "1rfd08zEIr4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6025",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 90 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pWdGpAmq_k0",
    "youtubeId": "pWdGpAmq_k0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6026",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 89 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MtDz5NMBJvE",
    "youtubeId": "MtDz5NMBJvE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6027",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 88 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y6z6PnaoKBA",
    "youtubeId": "Y6z6PnaoKBA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6028",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 87 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5hox9XfY_Z8",
    "youtubeId": "5hox9XfY_Z8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6029",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 86 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/soSaQZ0kWJs",
    "youtubeId": "soSaQZ0kWJs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6030",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 85 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/gag2C6uwR4k",
    "youtubeId": "gag2C6uwR4k",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6031",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 84 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fxvv02oowow",
    "youtubeId": "Fxvv02oowow",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6032",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 83 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xqYIWgQO4_E",
    "youtubeId": "xqYIWgQO4_E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6033",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 82 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/iegfRmgVmeY",
    "youtubeId": "iegfRmgVmeY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6034",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 81 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sutD6H7pcFE",
    "youtubeId": "sutD6H7pcFE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6035",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 80 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vRVf21SGXWA",
    "youtubeId": "vRVf21SGXWA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6036",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 79 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BQ_DzLRB19E",
    "youtubeId": "BQ_DzLRB19E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6037",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 78 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/w-W_a9spWEs",
    "youtubeId": "w-W_a9spWEs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6038",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 77 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1FXwnjKOjAY",
    "youtubeId": "1FXwnjKOjAY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6039",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 76 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/OkF9XnHHAU0",
    "youtubeId": "OkF9XnHHAU0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6040",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 75 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/6SKuQeNLhyc",
    "youtubeId": "6SKuQeNLhyc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6041",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 74 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yThK3pnkNN4",
    "youtubeId": "yThK3pnkNN4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6042",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 73 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/e1WXjcMCX6c",
    "youtubeId": "e1WXjcMCX6c",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6043",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 72 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-Gg3FKkwWRs",
    "youtubeId": "-Gg3FKkwWRs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6044",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 71 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/7X4XVEXTWYo",
    "youtubeId": "7X4XVEXTWYo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6045",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 70 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/YlTB9M28qRM",
    "youtubeId": "YlTB9M28qRM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6046",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 69 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/HV_5snbxKQ0",
    "youtubeId": "HV_5snbxKQ0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6047",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 68 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/5WP5v3awygw",
    "youtubeId": "5WP5v3awygw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6048",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 67 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yOSRUWGvjmo",
    "youtubeId": "yOSRUWGvjmo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6049",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 66 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z7HakZQoHg8",
    "youtubeId": "Z7HakZQoHg8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6050",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 65 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Fcx7qE-ySzc",
    "youtubeId": "Fcx7qE-ySzc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6051",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 64 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qbSjF3Jp6Ng",
    "youtubeId": "qbSjF3Jp6Ng",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6052",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 63 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Y6fg2QSVrTY",
    "youtubeId": "Y6fg2QSVrTY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6053",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 62 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/f3Vo9L6cuFM",
    "youtubeId": "f3Vo9L6cuFM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6054",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 61 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3KgClePzkKo",
    "youtubeId": "3KgClePzkKo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6055",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 60 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XXcHYwQ9xf8",
    "youtubeId": "XXcHYwQ9xf8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6056",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 59 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IQIx0Aw9Zq4",
    "youtubeId": "IQIx0Aw9Zq4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6057",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 58 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ilKQoGRhggE",
    "youtubeId": "ilKQoGRhggE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6058",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 57 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/bVsvgIwt_6U",
    "youtubeId": "bVsvgIwt_6U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6059",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 56 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/t6buEFmfkjI",
    "youtubeId": "t6buEFmfkjI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6060",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 55 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sS01ZvY6TOg",
    "youtubeId": "sS01ZvY6TOg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6061",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 54 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/i-m1Kz0yP_0",
    "youtubeId": "i-m1Kz0yP_0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6062",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 53 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pflHiupqsjs",
    "youtubeId": "pflHiupqsjs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6063",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 52 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-sPydDzRl7I",
    "youtubeId": "-sPydDzRl7I",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6064",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 51 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fSgeqewoVHM",
    "youtubeId": "fSgeqewoVHM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6065",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 50 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2aluXTvWjr4",
    "youtubeId": "2aluXTvWjr4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6066",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 49 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q_mDP9QAz2s",
    "youtubeId": "Q_mDP9QAz2s",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6067",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 48 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NqwOyVZFF7U",
    "youtubeId": "NqwOyVZFF7U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6068",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 47 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/y-90Bkqmsy4",
    "youtubeId": "y-90Bkqmsy4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6069",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 46 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/TuGQquiO5Xo",
    "youtubeId": "TuGQquiO5Xo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6070",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 45 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/QzgInaGi29Q",
    "youtubeId": "QzgInaGi29Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6071",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 44 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/g2YLQ7S_jzA",
    "youtubeId": "g2YLQ7S_jzA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6072",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 43 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/NXEfu7_15Tc",
    "youtubeId": "NXEfu7_15Tc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6073",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 42 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lyb2uSTMi28",
    "youtubeId": "lyb2uSTMi28",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6074",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 41 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/sqOuiu9cBP0",
    "youtubeId": "sqOuiu9cBP0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6075",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 40 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T_h3pUiHMso",
    "youtubeId": "T_h3pUiHMso",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6076",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 39 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XZPB2WmwaEQ",
    "youtubeId": "XZPB2WmwaEQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6077",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 38 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/-lWiVz3A2Oc",
    "youtubeId": "-lWiVz3A2Oc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6078",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 37 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/CFRx61PlS_8",
    "youtubeId": "CFRx61PlS_8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6079",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 36 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/tuZUgALZ-rY",
    "youtubeId": "tuZUgALZ-rY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6080",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 35 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hPXH47hhoJY",
    "youtubeId": "hPXH47hhoJY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6081",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 34 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/2Sw3DlbO27E",
    "youtubeId": "2Sw3DlbO27E",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6082",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 33 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/m7Hla89kpi4",
    "youtubeId": "m7Hla89kpi4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6083",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 32 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/qKRVeRBFUIU",
    "youtubeId": "qKRVeRBFUIU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6084",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 31 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/l9sYqEkW9rQ",
    "youtubeId": "l9sYqEkW9rQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6085",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 30 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8PYVuw0zyqw",
    "youtubeId": "8PYVuw0zyqw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6086",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 29 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/yRezYMMIiQE",
    "youtubeId": "yRezYMMIiQE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6087",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 28 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/8iKbidqEhrE",
    "youtubeId": "8iKbidqEhrE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6088",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 27 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wy8ez4q-pfM",
    "youtubeId": "wy8ez4q-pfM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6089",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 26 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PRPw0SbHgN4",
    "youtubeId": "PRPw0SbHgN4",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6090",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 25 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/nvftSSlYszE",
    "youtubeId": "nvftSSlYszE",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6091",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 24 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/1_GSa9YCc1U",
    "youtubeId": "1_GSa9YCc1U",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6092",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 23 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/wQKniUcmRqQ",
    "youtubeId": "wQKniUcmRqQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6093",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 22 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/IjjROWq0aF0",
    "youtubeId": "IjjROWq0aF0",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6094",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 21 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mRt764hKgBU",
    "youtubeId": "mRt764hKgBU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6095",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 20 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/jo49tffTySU",
    "youtubeId": "jo49tffTySU",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6096",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 19 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/mHWUzsXcwMY",
    "youtubeId": "mHWUzsXcwMY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6097",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 18 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/vgpL28Z7Gsg",
    "youtubeId": "vgpL28Z7Gsg",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6098",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 17 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Z-8j4_VglTA",
    "youtubeId": "Z-8j4_VglTA",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6099",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 16 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/74XVtuiZPPI",
    "youtubeId": "74XVtuiZPPI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6100",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 15 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/P3mkmpVD7Bk",
    "youtubeId": "P3mkmpVD7Bk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6101",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 14 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/T6s9lyHcKzM",
    "youtubeId": "T6s9lyHcKzM",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6102",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 13 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Q62Apoag-PI",
    "youtubeId": "Q62Apoag-PI",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6103",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 12 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/MGtVur4Jb10",
    "youtubeId": "MGtVur4Jb10",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6104",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 11 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/rIPwxY5yRCc",
    "youtubeId": "rIPwxY5yRCc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6105",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 10 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/BmuCAjSi9zw",
    "youtubeId": "BmuCAjSi9zw",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6106",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 9 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/fY4RP72bjjQ",
    "youtubeId": "fY4RP72bjjQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6107",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 8 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/lA_fH2wwSYQ",
    "youtubeId": "lA_fH2wwSYQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6108",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 7 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dPmu3SUV8y8",
    "youtubeId": "dPmu3SUV8y8",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6109",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 6 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/hsCG-rh7YWo",
    "youtubeId": "hsCG-rh7YWo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6110",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 5 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/pEU96IxGJhc",
    "youtubeId": "pEU96IxGJhc",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6111",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 4 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ON2oA4f5uyo",
    "youtubeId": "ON2oA4f5uyo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6112",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 3 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/3keXEZm9Pbo",
    "youtubeId": "3keXEZm9Pbo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6113",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 2 Ayat 1& 2 Surah Baqarah Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/UUDn20Vprds",
    "youtubeId": "UUDn20Vprds",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6114",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Conclusion Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/ZYqj-TxnpKs",
    "youtubeId": "ZYqj-TxnpKs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6115",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 7 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/XyOIr6uhicY",
    "youtubeId": "XyOIr6uhicY",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6116",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 6 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/xT35rAmjpyo",
    "youtubeId": "xT35rAmjpyo",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6117",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 5 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/_-d0RsdG9Cs",
    "youtubeId": "_-d0RsdG9Cs",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6118",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 4 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/Ibbv1FwFx7Q",
    "youtubeId": "Ibbv1FwFx7Q",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6119",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 3 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/PuKjq4Ag0Uk",
    "youtubeId": "PuKjq4Ag0Uk",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6120",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 2 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/dpdXRysJpkQ",
    "youtubeId": "dpdXRysJpkQ",
    "date": "2026-04-14"
  },
  {
    "id": "israr-6121",
    "parentPath": "/Gallery/Dr Israr",
    "name": "Surah 1 Ayat 1 Surah Fatiha Dr Israr Ahmed Urdu",
    "type": "video",
    "url": "https://www.youtube.com/embed/L-SdBp4zy8E",
    "youtubeId": "L-SdBp4zy8E",
    "date": "2026-04-14"
  }
];
